if(typeof document!=="undefined"){const floralCSS=document.querySelector("[data-tactale-floral-css]")||document.createElement("link");floralCSS.rel="stylesheet";floralCSS.href=new URL("./tactale-floral-picker1103.css?v=20261103-horizontal-hint2",import.meta.url).href;floralCSS.dataset.tactaleFloralCss="";if(!floralCSS.parentNode)document.head.append(floralCSS); }
import {createFloralPicker,reconcileFloralDraft} from "./tactale-floral-picker1103.js";
import EditorialHome from "./tactale-editorial-home1018.js?v=3";
import StaticHero from "./tactale-static-hero1015.js";
import ProductCatalog, {HomeProducts,memoryProductCopy} from "./tactale-product-catalog1015.js";
import {SalePrice} from "./tactale-sale-price1015.js";
import { preparePhotoUpload } from "./tactale-photo-upload1014.js";
import { a as e, c as t, d as n, f as r, i, l as a, m as o, n as s, o as c, p as l, r as u, s as d, t as f, u as p } from "./tactale-navigation-DVgfilR6-sale1003-benefits1006b.js";
import { a as m, c as h, o as g, r as _, s as v, t as y } from "./tactale-config-CS-mPsET-sale1003-benefits1006b.js";
import { n as productSelectSignIn, l as productSelectAccount } from "./tactale-sign-in-gate-BcxvjMxI-sale1003-benefits1006b-agent1010c.js";
import { n as x, t as S } from "./tactale-exhibit-copy-BDv4Dtp4-sale1003-benefits1006b.js";
import { t as C } from "./tactale-assets-d7mn3EHg-sale1003-benefits1006b.js";
import { i as w, l as T, n as E, t as D } from "./tactale-sign-in-gate-BcxvjMxI-sale1003-benefits1006b-agent1010c.js";
import { C as O, S as k, _ as A, a as j, b as M, c as N, d as P, f as F, g as ee, h as te, i as I, l as ne, m as re, n as L, o as ie, p as ae, r as R, s as oe, t as se, u as ce, v as le, w as ue, x as de } from "./tactale-customization-XLjgziya-sale1003-benefits1006b.js";
import { c as fe, i as pe, n as me, o as he, r as ge, s as _e, t as ve, u as ye } from "./tactale-provider-Dm-hsaCB-sale1003-benefits1006b-agent1010c.js";
import { n as be, t as xe } from "./tactale-arrow-right-koEnlhHT-sale1003-benefits1006b.js";
import { n as Se, t as Ce } from "./tactale-check-DgjJ8VO7-sale1003-benefits1006b.js";
import { t as we } from "./tactale-plus-C2pmAAla-sale1003-benefits1006b.js";
import { i as Te, n as Ee, r as De } from "./tactale-catalogue-CvUSHmDe-sale1003-benefits1006b.js";
var z = o(r(), 1), B = t();
const B03FloralPicker=createFloralPicker(z);
function Oe({ active, children }) {
 const {locale}=n(),copy=locale==="zh-CN"?["注册会员领 10% 优惠券","西马包邮"]:locale==="ms"?["Daftar ahli, dapatkan kupon diskaun 10%","Penghantaran percuma ke Malaysia Barat"]:["Join as a member for a 10% off coupon","Free West Malaysia delivery"];
 return active?B.jsxs(B.Fragment,{children:[B.jsx("style",{children:"#tactale-shopify-root:has(>.tactale-home-announcement){display:flex;flex-direction:column}.tactale-home-announcement{order:-1}.tactale-home-announcement+.store-shell{display:contents}.tactale-home-announcement+.store-shell>.store-header{order:-2}.tactale-home-announcement{height:32px;min-height:32px;max-height:32px;overflow:hidden;background:#e9dfc9;color:#28251f;font-family:Manrope,Arial,sans-serif;font-size:13px;line-height:20px;padding:6px 0;box-sizing:border-box;white-space:nowrap}.tactale-announcement-track{display:flex;width:100%;justify-content:center}.tactale-announcement-group[aria-hidden=true]{display:none}.tactale-announcement-group{display:flex;flex:none;align-items:center;justify-content:center;min-width:0;gap:0;padding:0 24px;box-sizing:border-box}.tactale-announcement-group span{display:block;flex:none;white-space:nowrap}.tactale-home-announcement:hover .tactale-announcement-track,.tactale-home-announcement:focus-within .tactale-announcement-track{animation-play-state:paused}.tactale-home-announcement:focus-visible{outline:1px solid #28251f;outline-offset:-2px}@keyframes tactale-announcement-left{to{transform:translateX(-50%)}}@media(max-width:767px){.tactale-announcement-track{width:max-content;justify-content:flex-start;animation:tactale-announcement-left 28s linear infinite}.tactale-announcement-group{min-width:100vw}.tactale-announcement-group[aria-hidden=true]{display:flex}}@media(prefers-reduced-motion:reduce){.tactale-home-announcement{overflow-x:auto;scrollbar-width:none}.tactale-home-announcement::-webkit-scrollbar{display:none}.tactale-announcement-track{animation:none}.tactale-announcement-group[aria-hidden=true]{display:none}}"}),B.jsx("aside",{className:"tactale-home-announcement",tabIndex:0,"aria-label":copy.join(" ｜ "),children:B.jsxs("div",{className:"tactale-announcement-track","aria-hidden":true,children:[B.jsx("div",{className:"tactale-announcement-group",children:B.jsx("span",{children:copy.join(" ｜ ")})}),B.jsx("div",{className:"tactale-announcement-group","aria-hidden":true,children:B.jsx("span",{children:copy.join(" ｜ ")})})]})}),children]}):children;
}
var ke = l(((e5) => {
  function t2(e6, t3) {
    var n3 = e6.length;
    e6.push(t3);
    a: for (; 0 < n3; ) {
      var r3 = n3 - 1 >>> 1, a3 = e6[r3];
      if (0 < i2(a3, t3)) e6[r3] = t3, e6[n3] = a3, n3 = r3;
      else break a;
    }
  }
  function n2(e6) {
    return e6.length === 0 ? null : e6[0];
  }
  function r2(e6) {
    if (e6.length === 0) return null;
    var t3 = e6[0], n3 = e6.pop();
    if (n3 !== t3) {
      e6[0] = n3;
      a: for (var r3 = 0, a3 = e6.length, o3 = a3 >>> 1; r3 < o3; ) {
        var s3 = 2 * (r3 + 1) - 1, c3 = e6[s3], l3 = s3 + 1, u3 = e6[l3];
        if (0 > i2(c3, n3)) l3 < a3 && 0 > i2(u3, c3) ? (e6[r3] = u3, e6[l3] = n3, r3 = l3) : (e6[r3] = c3, e6[s3] = n3, r3 = s3);
        else if (l3 < a3 && 0 > i2(u3, n3)) e6[r3] = u3, e6[l3] = n3, r3 = l3;
        else break a;
      }
    }
    return t3;
  }
  function i2(e6, t3) {
    var n3 = e6.sortIndex - t3.sortIndex;
    return n3 === 0 ? e6.id - t3.id : n3;
  }
  if (e5.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
    var a2 = performance;
    e5.unstable_now = function() {
      return a2.now();
    };
  } else {
    var o2 = Date, s2 = o2.now();
    e5.unstable_now = function() {
      return o2.now() - s2;
    };
  }
  var c2 = [], l2 = [], u2 = 1, d2 = null, f2 = 3, p2 = false, m2 = false, h2 = false, g2 = false, _2 = typeof setTimeout == "function" ? setTimeout : null, v2 = typeof clearTimeout == "function" ? clearTimeout : null, y2 = typeof setImmediate < "u" ? setImmediate : null;
  function b2(e6) {
    for (var i3 = n2(l2); i3 !== null; ) {
      if (i3.callback === null) r2(l2);
      else if (i3.startTime <= e6) r2(l2), i3.sortIndex = i3.expirationTime, t2(c2, i3);
      else break;
      i3 = n2(l2);
    }
  }
  function x2(e6) {
    if (h2 = false, b2(e6), !m2) if (n2(c2) !== null) m2 = true, S2 || (S2 = true, O2());
    else {
      var t3 = n2(l2);
      t3 !== null && j2(x2, t3.startTime - e6);
    }
  }
  var S2 = false, C2 = -1, w2 = 5, T2 = -1;
  function E2() {
    return g2 ? true : !(e5.unstable_now() - T2 < w2);
  }
  function D2() {
    if (g2 = false, S2) {
      var t3 = e5.unstable_now();
      T2 = t3;
      var i3 = true;
      try {
        a: {
          m2 = false, h2 && (h2 = false, v2(C2), C2 = -1), p2 = true;
          var a3 = f2;
          try {
            b: {
              for (b2(t3), d2 = n2(c2); d2 !== null && !(d2.expirationTime > t3 && E2()); ) {
                var o3 = d2.callback;
                if (typeof o3 == "function") {
                  d2.callback = null, f2 = d2.priorityLevel;
                  var s3 = o3(d2.expirationTime <= t3);
                  if (t3 = e5.unstable_now(), typeof s3 == "function") {
                    d2.callback = s3, b2(t3), i3 = true;
                    break b;
                  }
                  d2 === n2(c2) && r2(c2), b2(t3);
                } else r2(c2);
                d2 = n2(c2);
              }
              if (d2 !== null) i3 = true;
              else {
                var u3 = n2(l2);
                u3 !== null && j2(x2, u3.startTime - t3), i3 = false;
              }
            }
            break a;
          } finally {
            d2 = null, f2 = a3, p2 = false;
          }
          i3 = void 0;
        }
      } finally {
        i3 ? O2() : S2 = false;
      }
    }
  }
  var O2;
  if (typeof y2 == "function") O2 = function() {
    y2(D2);
  };
  else if (typeof MessageChannel < "u") {
    var k2 = new MessageChannel(), A2 = k2.port2;
    k2.port1.onmessage = D2, O2 = function() {
      A2.postMessage(null);
    };
  } else O2 = function() {
    _2(D2, 0);
  };
  function j2(t3, n3) {
    C2 = _2(function() {
      t3(e5.unstable_now());
    }, n3);
  }
  e5.unstable_IdlePriority = 5, e5.unstable_ImmediatePriority = 1, e5.unstable_LowPriority = 4, e5.unstable_NormalPriority = 3, e5.unstable_Profiling = null, e5.unstable_UserBlockingPriority = 2, e5.unstable_cancelCallback = function(e6) {
    e6.callback = null;
  }, e5.unstable_forceFrameRate = function(e6) {
    0 > e6 || 125 < e6 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : w2 = 0 < e6 ? Math.floor(1e3 / e6) : 5;
  }, e5.unstable_getCurrentPriorityLevel = function() {
    return f2;
  }, e5.unstable_next = function(e6) {
    switch (f2) {
      case 1:
      case 2:
      case 3:
        var t3 = 3;
        break;
      default:
        t3 = f2;
    }
    var n3 = f2;
    f2 = t3;
    try {
      return e6();
    } finally {
      f2 = n3;
    }
  }, e5.unstable_requestPaint = function() {
    g2 = true;
  }, e5.unstable_runWithPriority = function(e6, t3) {
    switch (e6) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        e6 = 3;
    }
    var n3 = f2;
    f2 = e6;
    try {
      return t3();
    } finally {
      f2 = n3;
    }
  }, e5.unstable_scheduleCallback = function(r3, i3, a3) {
    var o3 = e5.unstable_now();
    switch (typeof a3 == "object" && a3 ? (a3 = a3.delay, a3 = typeof a3 == "number" && 0 < a3 ? o3 + a3 : o3) : a3 = o3, r3) {
      case 1:
        var s3 = -1;
        break;
      case 2:
        s3 = 250;
        break;
      case 5:
        s3 = 1073741823;
        break;
      case 4:
        s3 = 1e4;
        break;
      default:
        s3 = 5e3;
    }
    return s3 = a3 + s3, r3 = { id: u2++, callback: i3, priorityLevel: r3, startTime: a3, expirationTime: s3, sortIndex: -1 }, a3 > o3 ? (r3.sortIndex = a3, t2(l2, r3), n2(c2) === null && r3 === n2(l2) && (h2 ? (v2(C2), C2 = -1) : h2 = true, j2(x2, a3 - o3))) : (r3.sortIndex = s3, t2(c2, r3), m2 || p2 || (m2 = true, S2 || (S2 = true, O2()))), r3;
  }, e5.unstable_shouldYield = E2, e5.unstable_wrapCallback = function(e6) {
    var t3 = f2;
    return function() {
      var n3 = f2;
      f2 = t3;
      try {
        return e6.apply(this, arguments);
      } finally {
        f2 = n3;
      }
    };
  };
})), Ae = l(((e5, t2) => {
  t2.exports = ke();
})), je = l(((e5) => {
  var t2 = r();
  function n2(e6) {
    var t3 = "https://react.dev/errors/" + e6;
    if (1 < arguments.length) {
      t3 += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var n3 = 2; n3 < arguments.length; n3++) t3 += "&args[]=" + encodeURIComponent(arguments[n3]);
    }
    return "Minified React error #" + e6 + "; visit " + t3 + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function i2() {
  }
  var a2 = { d: { f: i2, r: function() {
    throw Error(n2(522));
  }, D: i2, C: i2, L: i2, m: i2, X: i2, S: i2, M: i2 }, p: 0, findDOMNode: null }, o2 = /* @__PURE__ */ Symbol.for("react.portal");
  function s2(e6, t3, n3) {
    var r2 = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: o2, key: r2 == null ? null : "" + r2, children: e6, containerInfo: t3, implementation: n3 };
  }
  var c2 = t2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function l2(e6, t3) {
    if (e6 === "font") return "";
    if (typeof t3 == "string") return t3 === "use-credentials" ? t3 : "";
  }
  e5.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = a2, e5.createPortal = function(e6, t3) {
    var r2 = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!t3 || t3.nodeType !== 1 && t3.nodeType !== 9 && t3.nodeType !== 11) throw Error(n2(299));
    return s2(e6, t3, null, r2);
  }, e5.flushSync = function(e6) {
    var t3 = c2.T, n3 = a2.p;
    try {
      if (c2.T = null, a2.p = 2, e6) return e6();
    } finally {
      c2.T = t3, a2.p = n3, a2.d.f();
    }
  }, e5.preconnect = function(e6, t3) {
    typeof e6 == "string" && (t3 ? (t3 = t3.crossOrigin, t3 = typeof t3 == "string" ? t3 === "use-credentials" ? t3 : "" : void 0) : t3 = null, a2.d.C(e6, t3));
  }, e5.prefetchDNS = function(e6) {
    typeof e6 == "string" && a2.d.D(e6);
  }, e5.preinit = function(e6, t3) {
    if (typeof e6 == "string" && t3 && typeof t3.as == "string") {
      var n3 = t3.as, r2 = l2(n3, t3.crossOrigin), i3 = typeof t3.integrity == "string" ? t3.integrity : void 0, o3 = typeof t3.fetchPriority == "string" ? t3.fetchPriority : void 0;
      n3 === "style" ? a2.d.S(e6, typeof t3.precedence == "string" ? t3.precedence : void 0, { crossOrigin: r2, integrity: i3, fetchPriority: o3 }) : n3 === "script" && a2.d.X(e6, { crossOrigin: r2, integrity: i3, fetchPriority: o3, nonce: typeof t3.nonce == "string" ? t3.nonce : void 0 });
    }
  }, e5.preinitModule = function(e6, t3) {
    if (typeof e6 == "string") if (typeof t3 == "object" && t3) {
      if (t3.as == null || t3.as === "script") {
        var n3 = l2(t3.as, t3.crossOrigin);
        a2.d.M(e6, { crossOrigin: n3, integrity: typeof t3.integrity == "string" ? t3.integrity : void 0, nonce: typeof t3.nonce == "string" ? t3.nonce : void 0 });
      }
    } else t3 ?? a2.d.M(e6);
  }, e5.preload = function(e6, t3) {
    if (typeof e6 == "string" && typeof t3 == "object" && t3 && typeof t3.as == "string") {
      var n3 = t3.as, r2 = l2(n3, t3.crossOrigin);
      a2.d.L(e6, n3, { crossOrigin: r2, integrity: typeof t3.integrity == "string" ? t3.integrity : void 0, nonce: typeof t3.nonce == "string" ? t3.nonce : void 0, type: typeof t3.type == "string" ? t3.type : void 0, fetchPriority: typeof t3.fetchPriority == "string" ? t3.fetchPriority : void 0, referrerPolicy: typeof t3.referrerPolicy == "string" ? t3.referrerPolicy : void 0, imageSrcSet: typeof t3.imageSrcSet == "string" ? t3.imageSrcSet : void 0, imageSizes: typeof t3.imageSizes == "string" ? t3.imageSizes : void 0, media: typeof t3.media == "string" ? t3.media : void 0 });
    }
  }, e5.preloadModule = function(e6, t3) {
    if (typeof e6 == "string") if (t3) {
      var n3 = l2(t3.as, t3.crossOrigin);
      a2.d.m(e6, { as: typeof t3.as == "string" && t3.as !== "script" ? t3.as : void 0, crossOrigin: n3, integrity: typeof t3.integrity == "string" ? t3.integrity : void 0 });
    } else a2.d.m(e6);
  }, e5.requestFormReset = function(e6) {
    a2.d.r(e6);
  }, e5.unstable_batchedUpdates = function(e6, t3) {
    return e6(t3);
  }, e5.useFormState = function(e6, t3, n3) {
    return c2.H.useFormState(e6, t3, n3);
  }, e5.useFormStatus = function() {
    return c2.H.useHostTransitionStatus();
  }, e5.version = "19.2.6";
})), Me = l(((e5, t2) => {
  function n2() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n2);
    } catch (e6) {
      console.error(e6);
    }
  }
  n2(), t2.exports = je();
})), Ne = l(((e5) => {
  var t2 = Ae(), n2 = r(), i2 = Me();
  function a2(e6) {
    var t3 = "https://react.dev/errors/" + e6;
    if (1 < arguments.length) {
      t3 += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var n3 = 2; n3 < arguments.length; n3++) t3 += "&args[]=" + encodeURIComponent(arguments[n3]);
    }
    return "Minified React error #" + e6 + "; visit " + t3 + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function o2(e6) {
    return !(!e6 || e6.nodeType !== 1 && e6.nodeType !== 9 && e6.nodeType !== 11);
  }
  function s2(e6) {
    var t3 = e6, n3 = e6;
    if (e6.alternate) for (; t3.return; ) t3 = t3.return;
    else {
      e6 = t3;
      do
        t3 = e6, t3.flags & 4098 && (n3 = t3.return), e6 = t3.return;
      while (e6);
    }
    return t3.tag === 3 ? n3 : null;
  }
  function c2(e6) {
    if (e6.tag === 13) {
      var t3 = e6.memoizedState;
      if (t3 === null && (e6 = e6.alternate, e6 !== null && (t3 = e6.memoizedState)), t3 !== null) return t3.dehydrated;
    }
    return null;
  }
  function l2(e6) {
    if (e6.tag === 31) {
      var t3 = e6.memoizedState;
      if (t3 === null && (e6 = e6.alternate, e6 !== null && (t3 = e6.memoizedState)), t3 !== null) return t3.dehydrated;
    }
    return null;
  }
  function u2(e6) {
    if (s2(e6) !== e6) throw Error(a2(188));
  }
  function d2(e6) {
    var t3 = e6.alternate;
    if (!t3) {
      if (t3 = s2(e6), t3 === null) throw Error(a2(188));
      return t3 === e6 ? e6 : null;
    }
    for (var n3 = e6, r2 = t3; ; ) {
      var i3 = n3.return;
      if (i3 === null) break;
      var o3 = i3.alternate;
      if (o3 === null) {
        if (r2 = i3.return, r2 !== null) {
          n3 = r2;
          continue;
        }
        break;
      }
      if (i3.child === o3.child) {
        for (o3 = i3.child; o3; ) {
          if (o3 === n3) return u2(i3), e6;
          if (o3 === r2) return u2(i3), t3;
          o3 = o3.sibling;
        }
        throw Error(a2(188));
      }
      if (n3.return !== r2.return) n3 = i3, r2 = o3;
      else {
        for (var c3 = false, l3 = i3.child; l3; ) {
          if (l3 === n3) {
            c3 = true, n3 = i3, r2 = o3;
            break;
          }
          if (l3 === r2) {
            c3 = true, r2 = i3, n3 = o3;
            break;
          }
          l3 = l3.sibling;
        }
        if (!c3) {
          for (l3 = o3.child; l3; ) {
            if (l3 === n3) {
              c3 = true, n3 = o3, r2 = i3;
              break;
            }
            if (l3 === r2) {
              c3 = true, r2 = o3, n3 = i3;
              break;
            }
            l3 = l3.sibling;
          }
          if (!c3) throw Error(a2(189));
        }
      }
      if (n3.alternate !== r2) throw Error(a2(190));
    }
    if (n3.tag !== 3) throw Error(a2(188));
    return n3.stateNode.current === n3 ? e6 : t3;
  }
  function f2(e6) {
    var t3 = e6.tag;
    if (t3 === 5 || t3 === 26 || t3 === 27 || t3 === 6) return e6;
    for (e6 = e6.child; e6 !== null; ) {
      if (t3 = f2(e6), t3 !== null) return t3;
      e6 = e6.sibling;
    }
    return null;
  }
  var p2 = Object.assign, m2 = /* @__PURE__ */ Symbol.for("react.element"), h2 = /* @__PURE__ */ Symbol.for("react.transitional.element"), g2 = /* @__PURE__ */ Symbol.for("react.portal"), _2 = /* @__PURE__ */ Symbol.for("react.fragment"), v2 = /* @__PURE__ */ Symbol.for("react.strict_mode"), y2 = /* @__PURE__ */ Symbol.for("react.profiler"), b2 = /* @__PURE__ */ Symbol.for("react.consumer"), x2 = /* @__PURE__ */ Symbol.for("react.context"), S2 = /* @__PURE__ */ Symbol.for("react.forward_ref"), C2 = /* @__PURE__ */ Symbol.for("react.suspense"), w2 = /* @__PURE__ */ Symbol.for("react.suspense_list"), T2 = /* @__PURE__ */ Symbol.for("react.memo"), E2 = /* @__PURE__ */ Symbol.for("react.lazy"), D2 = /* @__PURE__ */ Symbol.for("react.activity"), O2 = /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel"), k2 = Symbol.iterator;
  function A2(e6) {
    return typeof e6 != "object" || !e6 ? null : (e6 = k2 && e6[k2] || e6["@@iterator"], typeof e6 == "function" ? e6 : null);
  }
  var j2 = /* @__PURE__ */ Symbol.for("react.client.reference");
  function M2(e6) {
    if (e6 == null) return null;
    if (typeof e6 == "function") return e6.$$typeof === j2 ? null : e6.displayName || e6.name || null;
    if (typeof e6 == "string") return e6;
    switch (e6) {
      case _2:
        return "Fragment";
      case y2:
        return "Profiler";
      case v2:
        return "StrictMode";
      case C2:
        return "Suspense";
      case w2:
        return "SuspenseList";
      case D2:
        return "Activity";
    }
    if (typeof e6 == "object") switch (e6.$$typeof) {
      case g2:
        return "Portal";
      case x2:
        return e6.displayName || "Context";
      case b2:
        return (e6._context.displayName || "Context") + ".Consumer";
      case S2:
        var t3 = e6.render;
        return e6 = e6.displayName, e6 ||= (e6 = t3.displayName || t3.name || "", e6 === "" ? "ForwardRef" : "ForwardRef(" + e6 + ")"), e6;
      case T2:
        return t3 = e6.displayName || null, t3 === null ? M2(e6.type) || "Memo" : t3;
      case E2:
        t3 = e6._payload, e6 = e6._init;
        try {
          return M2(e6(t3));
        } catch {
        }
    }
    return null;
  }
  var N2 = Array.isArray, P2 = n2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, F2 = i2.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ee2 = { pending: false, data: null, method: null, action: null }, te2 = [], I2 = -1;
  function ne2(e6) {
    return { current: e6 };
  }
  function re2(e6) {
    0 > I2 || (e6.current = te2[I2], te2[I2] = null, I2--);
  }
  function L2(e6, t3) {
    I2++, te2[I2] = e6.current, e6.current = t3;
  }
  var ie2 = ne2(null), ae2 = ne2(null), R2 = ne2(null), oe2 = ne2(null);
  function se2(e6, t3) {
    switch (L2(R2, t3), L2(ae2, e6), L2(ie2, null), t3.nodeType) {
      case 9:
      case 11:
        e6 = (e6 = t3.documentElement) && (e6 = e6.namespaceURI) ? Vd(e6) : 0;
        break;
      default:
        if (e6 = t3.tagName, t3 = t3.namespaceURI) t3 = Vd(t3), e6 = Hd(t3, e6);
        else switch (e6) {
          case "svg":
            e6 = 1;
            break;
          case "math":
            e6 = 2;
            break;
          default:
            e6 = 0;
        }
    }
    re2(ie2), L2(ie2, e6);
  }
  function ce2() {
    re2(ie2), re2(ae2), re2(R2);
  }
  function le2(e6) {
    e6.memoizedState !== null && L2(oe2, e6);
    var t3 = ie2.current, n3 = Hd(t3, e6.type);
    t3 !== n3 && (L2(ae2, e6), L2(ie2, n3));
  }
  function ue2(e6) {
    ae2.current === e6 && (re2(ie2), re2(ae2)), oe2.current === e6 && (re2(oe2), Qf._currentValue = ee2);
  }
  var de2, fe2;
  function pe2(e6) {
    if (de2 === void 0) try {
      throw Error();
    } catch (e7) {
      var t3 = e7.stack.trim().match(/\n( *(at )?)/);
      de2 = t3 && t3[1] || "", fe2 = -1 < e7.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < e7.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return `
` + de2 + e6 + fe2;
  }
  var me2 = false;
  function he2(e6, t3) {
    if (!e6 || me2) return "";
    me2 = true;
    var n3 = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var r2 = { DetermineComponentFrameRoot: function() {
        try {
          if (t3) {
            var n4 = function() {
              throw Error();
            };
            if (Object.defineProperty(n4.prototype, "props", { set: function() {
              throw Error();
            } }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(n4, []);
              } catch (e7) {
                var r3 = e7;
              }
              Reflect.construct(e6, [], n4);
            } else {
              try {
                n4.call();
              } catch (e7) {
                r3 = e7;
              }
              e6.call(n4.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (e7) {
              r3 = e7;
            }
            (n4 = e6()) && typeof n4.catch == "function" && n4.catch(function() {
            });
          }
        } catch (e7) {
          if (e7 && r3 && typeof e7.stack == "string") return [e7.stack, r3.stack];
        }
        return [null, null];
      } };
      r2.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var i3 = Object.getOwnPropertyDescriptor(r2.DetermineComponentFrameRoot, "name");
      i3 && i3.configurable && Object.defineProperty(r2.DetermineComponentFrameRoot, "name", { value: "DetermineComponentFrameRoot" });
      var a3 = r2.DetermineComponentFrameRoot(), o3 = a3[0], s3 = a3[1];
      if (o3 && s3) {
        var c3 = o3.split(`
`), l3 = s3.split(`
`);
        for (i3 = r2 = 0; r2 < c3.length && !c3[r2].includes("DetermineComponentFrameRoot"); ) r2++;
        for (; i3 < l3.length && !l3[i3].includes("DetermineComponentFrameRoot"); ) i3++;
        if (r2 === c3.length || i3 === l3.length) for (r2 = c3.length - 1, i3 = l3.length - 1; 1 <= r2 && 0 <= i3 && c3[r2] !== l3[i3]; ) i3--;
        for (; 1 <= r2 && 0 <= i3; r2--, i3--) if (c3[r2] !== l3[i3]) {
          if (r2 !== 1 || i3 !== 1) do
            if (r2--, i3--, 0 > i3 || c3[r2] !== l3[i3]) {
              var u3 = `
` + c3[r2].replace(" at new ", " at ");
              return e6.displayName && u3.includes("<anonymous>") && (u3 = u3.replace("<anonymous>", e6.displayName)), u3;
            }
          while (1 <= r2 && 0 <= i3);
          break;
        }
      }
    } finally {
      me2 = false, Error.prepareStackTrace = n3;
    }
    return (n3 = e6 ? e6.displayName || e6.name : "") ? pe2(n3) : "";
  }
  function ge2(e6, t3) {
    switch (e6.tag) {
      case 26:
      case 27:
      case 5:
        return pe2(e6.type);
      case 16:
        return pe2("Lazy");
      case 13:
        return e6.child !== t3 && t3 !== null ? pe2("Suspense Fallback") : pe2("Suspense");
      case 19:
        return pe2("SuspenseList");
      case 0:
      case 15:
        return he2(e6.type, false);
      case 11:
        return he2(e6.type.render, false);
      case 1:
        return he2(e6.type, true);
      case 31:
        return pe2("Activity");
      default:
        return "";
    }
  }
  function _e2(e6) {
    try {
      var t3 = "", n3 = null;
      do
        t3 += ge2(e6, n3), n3 = e6, e6 = e6.return;
      while (e6);
      return t3;
    } catch (e7) {
      return `
Error generating stack: ` + e7.message + `
` + e7.stack;
    }
  }
  var ve2 = Object.prototype.hasOwnProperty, ye2 = t2.unstable_scheduleCallback, be2 = t2.unstable_cancelCallback, xe2 = t2.unstable_shouldYield, Se2 = t2.unstable_requestPaint, Ce2 = t2.unstable_now, we2 = t2.unstable_getCurrentPriorityLevel, Te2 = t2.unstable_ImmediatePriority, Ee2 = t2.unstable_UserBlockingPriority, De2 = t2.unstable_NormalPriority, z2 = t2.unstable_LowPriority, B2 = t2.unstable_IdlePriority, Oe2 = t2.log, ke2 = t2.unstable_setDisableYieldValue, je2 = null, Ne2 = null;
  function Pe2(e6) {
    if (typeof Oe2 == "function" && ke2(e6), Ne2 && typeof Ne2.setStrictMode == "function") try {
      Ne2.setStrictMode(je2, e6);
    } catch {
    }
  }
  var Fe2 = Math.clz32 ? Math.clz32 : Re2, Ie2 = Math.log, Le2 = Math.LN2;
  function Re2(e6) {
    return e6 >>>= 0, e6 === 0 ? 32 : 31 - (Ie2(e6) / Le2 | 0) | 0;
  }
  var ze2 = 256, Be2 = 262144, Ve2 = 4194304;
  function V2(e6) {
    var t3 = e6 & 42;
    if (t3 !== 0) return t3;
    switch (e6 & -e6) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return e6 & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return e6 & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return e6 & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return e6;
    }
  }
  function He2(e6, t3, n3) {
    var r2 = e6.pendingLanes;
    if (r2 === 0) return 0;
    var i3 = 0, a3 = e6.suspendedLanes, o3 = e6.pingedLanes;
    e6 = e6.warmLanes;
    var s3 = r2 & 134217727;
    return s3 === 0 ? (s3 = r2 & ~a3, s3 === 0 ? o3 === 0 ? n3 || (n3 = r2 & ~e6, n3 !== 0 && (i3 = V2(n3))) : i3 = V2(o3) : i3 = V2(s3)) : (r2 = s3 & ~a3, r2 === 0 ? (o3 &= s3, o3 === 0 ? n3 || (n3 = s3 & ~e6, n3 !== 0 && (i3 = V2(n3))) : i3 = V2(o3)) : i3 = V2(r2)), i3 === 0 ? 0 : t3 !== 0 && t3 !== i3 && (t3 & a3) === 0 && (a3 = i3 & -i3, n3 = t3 & -t3, a3 >= n3 || a3 === 32 && n3 & 4194048) ? t3 : i3;
  }
  function Ue2(e6, t3) {
    return (e6.pendingLanes & ~(e6.suspendedLanes & ~e6.pingedLanes) & t3) === 0;
  }
  function We2(e6, t3) {
    switch (e6) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return t3 + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t3 + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Ge2() {
    var e6 = Ve2;
    return Ve2 <<= 1, !(Ve2 & 62914560) && (Ve2 = 4194304), e6;
  }
  function Ke2(e6) {
    for (var t3 = [], n3 = 0; 31 > n3; n3++) t3.push(e6);
    return t3;
  }
  function qe2(e6, t3) {
    e6.pendingLanes |= t3, t3 !== 268435456 && (e6.suspendedLanes = 0, e6.pingedLanes = 0, e6.warmLanes = 0);
  }
  function Je2(e6, t3, n3, r2, i3, a3) {
    var o3 = e6.pendingLanes;
    e6.pendingLanes = n3, e6.suspendedLanes = 0, e6.pingedLanes = 0, e6.warmLanes = 0, e6.expiredLanes &= n3, e6.entangledLanes &= n3, e6.errorRecoveryDisabledLanes &= n3, e6.shellSuspendCounter = 0;
    var s3 = e6.entanglements, c3 = e6.expirationTimes, l3 = e6.hiddenUpdates;
    for (n3 = o3 & ~n3; 0 < n3; ) {
      var u3 = 31 - Fe2(n3), d3 = 1 << u3;
      s3[u3] = 0, c3[u3] = -1;
      var f3 = l3[u3];
      if (f3 !== null) for (l3[u3] = null, u3 = 0; u3 < f3.length; u3++) {
        var p3 = f3[u3];
        p3 !== null && (p3.lane &= -536870913);
      }
      n3 &= ~d3;
    }
    r2 !== 0 && Ye2(e6, r2, 0), a3 !== 0 && i3 === 0 && e6.tag !== 0 && (e6.suspendedLanes |= a3 & ~(o3 & ~t3));
  }
  function Ye2(e6, t3, n3) {
    e6.pendingLanes |= t3, e6.suspendedLanes &= ~t3;
    var r2 = 31 - Fe2(t3);
    e6.entangledLanes |= t3, e6.entanglements[r2] = e6.entanglements[r2] | 1073741824 | n3 & 261930;
  }
  function Xe2(e6, t3) {
    var n3 = e6.entangledLanes |= t3;
    for (e6 = e6.entanglements; n3; ) {
      var r2 = 31 - Fe2(n3), i3 = 1 << r2;
      i3 & t3 | e6[r2] & t3 && (e6[r2] |= t3), n3 &= ~i3;
    }
  }
  function Ze2(e6, t3) {
    var n3 = t3 & -t3;
    return n3 = n3 & 42 ? 1 : Qe2(n3), (n3 & (e6.suspendedLanes | t3)) === 0 ? n3 : 0;
  }
  function Qe2(e6) {
    switch (e6) {
      case 2:
        e6 = 1;
        break;
      case 8:
        e6 = 4;
        break;
      case 32:
        e6 = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        e6 = 128;
        break;
      case 268435456:
        e6 = 134217728;
        break;
      default:
        e6 = 0;
    }
    return e6;
  }
  function $e2(e6) {
    return e6 &= -e6, 2 < e6 ? 8 < e6 ? e6 & 134217727 ? 32 : 268435456 : 8 : 2;
  }
  function et2() {
    var e6 = F2.p;
    return e6 === 0 ? (e6 = window.event, e6 === void 0 ? 32 : mp(e6.type)) : e6;
  }
  function tt2(e6, t3) {
    var n3 = F2.p;
    try {
      return F2.p = e6, t3();
    } finally {
      F2.p = n3;
    }
  }
  var nt2 = Math.random().toString(36).slice(2), rt2 = "__reactFiber$" + nt2, it2 = "__reactProps$" + nt2, at2 = "__reactContainer$" + nt2, H2 = "__reactEvents$" + nt2, ot2 = "__reactListeners$" + nt2, st2 = "__reactHandles$" + nt2, ct2 = "__reactResources$" + nt2, lt2 = "__reactMarker$" + nt2;
  function ut2(e6) {
    delete e6[rt2], delete e6[it2], delete e6[H2], delete e6[ot2], delete e6[st2];
  }
  function dt2(e6) {
    var t3 = e6[rt2];
    if (t3) return t3;
    for (var n3 = e6.parentNode; n3; ) {
      if (t3 = n3[at2] || n3[rt2]) {
        if (n3 = t3.alternate, t3.child !== null || n3 !== null && n3.child !== null) for (e6 = df(e6); e6 !== null; ) {
          if (n3 = e6[rt2]) return n3;
          e6 = df(e6);
        }
        return t3;
      }
      e6 = n3, n3 = e6.parentNode;
    }
    return null;
  }
  function ft2(e6) {
    if (e6 = e6[rt2] || e6[at2]) {
      var t3 = e6.tag;
      if (t3 === 5 || t3 === 6 || t3 === 13 || t3 === 31 || t3 === 26 || t3 === 27 || t3 === 3) return e6;
    }
    return null;
  }
  function pt2(e6) {
    var t3 = e6.tag;
    if (t3 === 5 || t3 === 26 || t3 === 27 || t3 === 6) return e6.stateNode;
    throw Error(a2(33));
  }
  function mt2(e6) {
    var t3 = e6[ct2];
    return t3 ||= e6[ct2] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }, t3;
  }
  function ht2(e6) {
    e6[lt2] = true;
  }
  var gt2 = /* @__PURE__ */ new Set(), _t2 = {};
  function vt2(e6, t3) {
    yt2(e6, t3), yt2(e6 + "Capture", t3);
  }
  function yt2(e6, t3) {
    for (_t2[e6] = t3, e6 = 0; e6 < t3.length; e6++) gt2.add(t3[e6]);
  }
  var bt2 = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), xt2 = {}, St2 = {};
  function Ct2(e6) {
    return ve2.call(St2, e6) ? true : ve2.call(xt2, e6) ? false : bt2.test(e6) ? St2[e6] = true : (xt2[e6] = true, false);
  }
  function wt2(e6, t3, n3) {
    if (Ct2(t3)) if (n3 === null) e6.removeAttribute(t3);
    else {
      switch (typeof n3) {
        case "undefined":
        case "function":
        case "symbol":
          e6.removeAttribute(t3);
          return;
        case "boolean":
          var r2 = t3.toLowerCase().slice(0, 5);
          if (r2 !== "data-" && r2 !== "aria-") {
            e6.removeAttribute(t3);
            return;
          }
      }
      e6.setAttribute(t3, "" + n3);
    }
  }
  function Tt2(e6, t3, n3) {
    if (n3 === null) e6.removeAttribute(t3);
    else {
      switch (typeof n3) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          e6.removeAttribute(t3);
          return;
      }
      e6.setAttribute(t3, "" + n3);
    }
  }
  function Et2(e6, t3, n3, r2) {
    if (r2 === null) e6.removeAttribute(n3);
    else {
      switch (typeof r2) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          e6.removeAttribute(n3);
          return;
      }
      e6.setAttributeNS(t3, n3, "" + r2);
    }
  }
  function Dt2(e6) {
    switch (typeof e6) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return e6;
      case "object":
        return e6;
      default:
        return "";
    }
  }
  function Ot2(e6) {
    var t3 = e6.type;
    return (e6 = e6.nodeName) && e6.toLowerCase() === "input" && (t3 === "checkbox" || t3 === "radio");
  }
  function kt2(e6, t3, n3) {
    var r2 = Object.getOwnPropertyDescriptor(e6.constructor.prototype, t3);
    if (!e6.hasOwnProperty(t3) && r2 !== void 0 && typeof r2.get == "function" && typeof r2.set == "function") {
      var i3 = r2.get, a3 = r2.set;
      return Object.defineProperty(e6, t3, { configurable: true, get: function() {
        return i3.call(this);
      }, set: function(e7) {
        n3 = "" + e7, a3.call(this, e7);
      } }), Object.defineProperty(e6, t3, { enumerable: r2.enumerable }), { getValue: function() {
        return n3;
      }, setValue: function(e7) {
        n3 = "" + e7;
      }, stopTracking: function() {
        e6._valueTracker = null, delete e6[t3];
      } };
    }
  }
  function At2(e6) {
    if (!e6._valueTracker) {
      var t3 = Ot2(e6) ? "checked" : "value";
      e6._valueTracker = kt2(e6, t3, "" + e6[t3]);
    }
  }
  function U2(e6) {
    if (!e6) return false;
    var t3 = e6._valueTracker;
    if (!t3) return true;
    var n3 = t3.getValue(), r2 = "";
    return e6 && (r2 = Ot2(e6) ? e6.checked ? "true" : "false" : e6.value), e6 = r2, e6 === n3 ? false : (t3.setValue(e6), true);
  }
  function jt2(e6) {
    if (e6 ||= typeof document < "u" ? document : void 0, e6 === void 0) return null;
    try {
      return e6.activeElement || e6.body;
    } catch {
      return e6.body;
    }
  }
  var Mt2 = /[\n"\\]/g;
  function Nt2(e6) {
    return e6.replace(Mt2, function(e7) {
      return "\\" + e7.charCodeAt(0).toString(16) + " ";
    });
  }
  function Pt2(e6, t3, n3, r2, i3, a3, o3, s3) {
    e6.name = "", o3 != null && typeof o3 != "function" && typeof o3 != "symbol" && typeof o3 != "boolean" ? e6.type = o3 : e6.removeAttribute("type"), t3 == null ? o3 !== "submit" && o3 !== "reset" || e6.removeAttribute("value") : o3 === "number" ? (t3 === 0 && e6.value === "" || e6.value != t3) && (e6.value = "" + Dt2(t3)) : e6.value !== "" + Dt2(t3) && (e6.value = "" + Dt2(t3)), t3 == null ? n3 == null ? r2 != null && e6.removeAttribute("value") : It2(e6, o3, Dt2(n3)) : It2(e6, o3, Dt2(t3)), i3 == null && a3 != null && (e6.defaultChecked = !!a3), i3 != null && (e6.checked = i3 && typeof i3 != "function" && typeof i3 != "symbol"), s3 != null && typeof s3 != "function" && typeof s3 != "symbol" && typeof s3 != "boolean" ? e6.name = "" + Dt2(s3) : e6.removeAttribute("name");
  }
  function Ft2(e6, t3, n3, r2, i3, a3, o3, s3) {
    if (a3 != null && typeof a3 != "function" && typeof a3 != "symbol" && typeof a3 != "boolean" && (e6.type = a3), t3 != null || n3 != null) {
      if (!(a3 !== "submit" && a3 !== "reset" || t3 != null)) {
        At2(e6);
        return;
      }
      n3 = n3 == null ? "" : "" + Dt2(n3), t3 = t3 == null ? n3 : "" + Dt2(t3), s3 || t3 === e6.value || (e6.value = t3), e6.defaultValue = t3;
    }
    r2 ??= i3, r2 = typeof r2 != "function" && typeof r2 != "symbol" && !!r2, e6.checked = s3 ? e6.checked : !!r2, e6.defaultChecked = !!r2, o3 != null && typeof o3 != "function" && typeof o3 != "symbol" && typeof o3 != "boolean" && (e6.name = o3), At2(e6);
  }
  function It2(e6, t3, n3) {
    t3 === "number" && jt2(e6.ownerDocument) === e6 || e6.defaultValue === "" + n3 || (e6.defaultValue = "" + n3);
  }
  function Lt2(e6, t3, n3, r2) {
    if (e6 = e6.options, t3) {
      t3 = {};
      for (var i3 = 0; i3 < n3.length; i3++) t3["$" + n3[i3]] = true;
      for (n3 = 0; n3 < e6.length; n3++) i3 = t3.hasOwnProperty("$" + e6[n3].value), e6[n3].selected !== i3 && (e6[n3].selected = i3), i3 && r2 && (e6[n3].defaultSelected = true);
    } else {
      for (n3 = "" + Dt2(n3), t3 = null, i3 = 0; i3 < e6.length; i3++) {
        if (e6[i3].value === n3) {
          e6[i3].selected = true, r2 && (e6[i3].defaultSelected = true);
          return;
        }
        t3 !== null || e6[i3].disabled || (t3 = e6[i3]);
      }
      t3 !== null && (t3.selected = true);
    }
  }
  function Rt2(e6, t3, n3) {
    if (t3 != null && (t3 = "" + Dt2(t3), t3 !== e6.value && (e6.value = t3), n3 == null)) {
      e6.defaultValue !== t3 && (e6.defaultValue = t3);
      return;
    }
    e6.defaultValue = n3 == null ? "" : "" + Dt2(n3);
  }
  function zt2(e6, t3, n3, r2) {
    if (t3 == null) {
      if (r2 != null) {
        if (n3 != null) throw Error(a2(92));
        if (N2(r2)) {
          if (1 < r2.length) throw Error(a2(93));
          r2 = r2[0];
        }
        n3 = r2;
      }
      n3 ??= "", t3 = n3;
    }
    n3 = Dt2(t3), e6.defaultValue = n3, r2 = e6.textContent, r2 === n3 && r2 !== "" && r2 !== null && (e6.value = r2), At2(e6);
  }
  function Bt2(e6, t3) {
    if (t3) {
      var n3 = e6.firstChild;
      if (n3 && n3 === e6.lastChild && n3.nodeType === 3) {
        n3.nodeValue = t3;
        return;
      }
    }
    e6.textContent = t3;
  }
  var Vt2 = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
  function Ht2(e6, t3, n3) {
    var r2 = t3.indexOf("--") === 0;
    n3 == null || typeof n3 == "boolean" || n3 === "" ? r2 ? e6.setProperty(t3, "") : t3 === "float" ? e6.cssFloat = "" : e6[t3] = "" : r2 ? e6.setProperty(t3, n3) : typeof n3 != "number" || n3 === 0 || Vt2.has(t3) ? t3 === "float" ? e6.cssFloat = n3 : e6[t3] = ("" + n3).trim() : e6[t3] = n3 + "px";
  }
  function Ut2(e6, t3, n3) {
    if (t3 != null && typeof t3 != "object") throw Error(a2(62));
    if (e6 = e6.style, n3 != null) {
      for (var r2 in n3) !n3.hasOwnProperty(r2) || t3 != null && t3.hasOwnProperty(r2) || (r2.indexOf("--") === 0 ? e6.setProperty(r2, "") : r2 === "float" ? e6.cssFloat = "" : e6[r2] = "");
      for (var i3 in t3) r2 = t3[i3], t3.hasOwnProperty(i3) && n3[i3] !== r2 && Ht2(e6, i3, r2);
    } else for (var o3 in t3) t3.hasOwnProperty(o3) && Ht2(e6, o3, t3[o3]);
  }
  function Wt2(e6) {
    if (e6.indexOf("-") === -1) return false;
    switch (e6) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return false;
      default:
        return true;
    }
  }
  var Gt2 = /* @__PURE__ */ new Map([["acceptCharset", "accept-charset"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"], ["crossOrigin", "crossorigin"], ["accentHeight", "accent-height"], ["alignmentBaseline", "alignment-baseline"], ["arabicForm", "arabic-form"], ["baselineShift", "baseline-shift"], ["capHeight", "cap-height"], ["clipPath", "clip-path"], ["clipRule", "clip-rule"], ["colorInterpolation", "color-interpolation"], ["colorInterpolationFilters", "color-interpolation-filters"], ["colorProfile", "color-profile"], ["colorRendering", "color-rendering"], ["dominantBaseline", "dominant-baseline"], ["enableBackground", "enable-background"], ["fillOpacity", "fill-opacity"], ["fillRule", "fill-rule"], ["floodColor", "flood-color"], ["floodOpacity", "flood-opacity"], ["fontFamily", "font-family"], ["fontSize", "font-size"], ["fontSizeAdjust", "font-size-adjust"], ["fontStretch", "font-stretch"], ["fontStyle", "font-style"], ["fontVariant", "font-variant"], ["fontWeight", "font-weight"], ["glyphName", "glyph-name"], ["glyphOrientationHorizontal", "glyph-orientation-horizontal"], ["glyphOrientationVertical", "glyph-orientation-vertical"], ["horizAdvX", "horiz-adv-x"], ["horizOriginX", "horiz-origin-x"], ["imageRendering", "image-rendering"], ["letterSpacing", "letter-spacing"], ["lightingColor", "lighting-color"], ["markerEnd", "marker-end"], ["markerMid", "marker-mid"], ["markerStart", "marker-start"], ["overlinePosition", "overline-position"], ["overlineThickness", "overline-thickness"], ["paintOrder", "paint-order"], ["panose-1", "panose-1"], ["pointerEvents", "pointer-events"], ["renderingIntent", "rendering-intent"], ["shapeRendering", "shape-rendering"], ["stopColor", "stop-color"], ["stopOpacity", "stop-opacity"], ["strikethroughPosition", "strikethrough-position"], ["strikethroughThickness", "strikethrough-thickness"], ["strokeDasharray", "stroke-dasharray"], ["strokeDashoffset", "stroke-dashoffset"], ["strokeLinecap", "stroke-linecap"], ["strokeLinejoin", "stroke-linejoin"], ["strokeMiterlimit", "stroke-miterlimit"], ["strokeOpacity", "stroke-opacity"], ["strokeWidth", "stroke-width"], ["textAnchor", "text-anchor"], ["textDecoration", "text-decoration"], ["textRendering", "text-rendering"], ["transformOrigin", "transform-origin"], ["underlinePosition", "underline-position"], ["underlineThickness", "underline-thickness"], ["unicodeBidi", "unicode-bidi"], ["unicodeRange", "unicode-range"], ["unitsPerEm", "units-per-em"], ["vAlphabetic", "v-alphabetic"], ["vHanging", "v-hanging"], ["vIdeographic", "v-ideographic"], ["vMathematical", "v-mathematical"], ["vectorEffect", "vector-effect"], ["vertAdvY", "vert-adv-y"], ["vertOriginX", "vert-origin-x"], ["vertOriginY", "vert-origin-y"], ["wordSpacing", "word-spacing"], ["writingMode", "writing-mode"], ["xmlnsXlink", "xmlns:xlink"], ["xHeight", "x-height"]]), Kt2 = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function qt2(e6) {
    return Kt2.test("" + e6) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e6;
  }
  function Jt2() {
  }
  var Yt2 = null;
  function Xt2(e6) {
    return e6 = e6.target || e6.srcElement || window, e6.correspondingUseElement && (e6 = e6.correspondingUseElement), e6.nodeType === 3 ? e6.parentNode : e6;
  }
  var Zt2 = null, Qt2 = null;
  function W2(e6) {
    var t3 = ft2(e6);
    if (t3 && (e6 = t3.stateNode)) {
      var n3 = e6[it2] || null;
      a: switch (e6 = t3.stateNode, t3.type) {
        case "input":
          if (Pt2(e6, n3.value, n3.defaultValue, n3.defaultValue, n3.checked, n3.defaultChecked, n3.type, n3.name), t3 = n3.name, n3.type === "radio" && t3 != null) {
            for (n3 = e6; n3.parentNode; ) n3 = n3.parentNode;
            for (n3 = n3.querySelectorAll('input[name="' + Nt2("" + t3) + '"][type="radio"]'), t3 = 0; t3 < n3.length; t3++) {
              var r2 = n3[t3];
              if (r2 !== e6 && r2.form === e6.form) {
                var i3 = r2[it2] || null;
                if (!i3) throw Error(a2(90));
                Pt2(r2, i3.value, i3.defaultValue, i3.defaultValue, i3.checked, i3.defaultChecked, i3.type, i3.name);
              }
            }
            for (t3 = 0; t3 < n3.length; t3++) r2 = n3[t3], r2.form === e6.form && U2(r2);
          }
          break a;
        case "textarea":
          Rt2(e6, n3.value, n3.defaultValue);
          break a;
        case "select":
          t3 = n3.value, t3 != null && Lt2(e6, !!n3.multiple, t3, false);
      }
    }
  }
  var $t2 = false;
  function en2(e6, t3, n3) {
    if ($t2) return e6(t3, n3);
    $t2 = true;
    try {
      return e6(t3);
    } finally {
      if ($t2 = false, (Zt2 !== null || Qt2 !== null) && (vu(), Zt2 && (t3 = Zt2, e6 = Qt2, Qt2 = Zt2 = null, W2(t3), e6))) for (t3 = 0; t3 < e6.length; t3++) W2(e6[t3]);
    }
  }
  function tn2(e6, t3) {
    var n3 = e6.stateNode;
    if (n3 === null) return null;
    var r2 = n3[it2] || null;
    if (r2 === null) return null;
    n3 = r2[t3];
    a: switch (t3) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (r2 = !r2.disabled) || (e6 = e6.type, r2 = !(e6 === "button" || e6 === "input" || e6 === "select" || e6 === "textarea")), e6 = !r2;
        break a;
      default:
        e6 = false;
    }
    if (e6) return null;
    if (n3 && typeof n3 != "function") throw Error(a2(231, t3, typeof n3));
    return n3;
  }
  var nn2 = !(typeof window > "u" || window.document === void 0 || window.document.createElement === void 0), rn2 = false;
  if (nn2) try {
    var an2 = {};
    Object.defineProperty(an2, "passive", { get: function() {
      rn2 = true;
    } }), window.addEventListener("test", an2, an2), window.removeEventListener("test", an2, an2);
  } catch {
    rn2 = false;
  }
  var on2 = null, sn2 = null, cn2 = null;
  function ln2() {
    if (cn2) return cn2;
    var e6, t3 = sn2, n3 = t3.length, r2, i3 = "value" in on2 ? on2.value : on2.textContent, a3 = i3.length;
    for (e6 = 0; e6 < n3 && t3[e6] === i3[e6]; e6++) ;
    var o3 = n3 - e6;
    for (r2 = 1; r2 <= o3 && t3[n3 - r2] === i3[a3 - r2]; r2++) ;
    return cn2 = i3.slice(e6, 1 < r2 ? 1 - r2 : void 0);
  }
  function un2(e6) {
    var t3 = e6.keyCode;
    return "charCode" in e6 ? (e6 = e6.charCode, e6 === 0 && t3 === 13 && (e6 = 13)) : e6 = t3, e6 === 10 && (e6 = 13), 32 <= e6 || e6 === 13 ? e6 : 0;
  }
  function dn2() {
    return true;
  }
  function fn2() {
    return false;
  }
  function pn2(e6) {
    function t3(t4, n3, r2, i3, a3) {
      for (var o3 in this._reactName = t4, this._targetInst = r2, this.type = n3, this.nativeEvent = i3, this.target = a3, this.currentTarget = null, e6) e6.hasOwnProperty(o3) && (t4 = e6[o3], this[o3] = t4 ? t4(i3) : i3[o3]);
      return this.isDefaultPrevented = (i3.defaultPrevented == null ? i3.returnValue === false : i3.defaultPrevented) ? dn2 : fn2, this.isPropagationStopped = fn2, this;
    }
    return p2(t3.prototype, { preventDefault: function() {
      this.defaultPrevented = true;
      var e7 = this.nativeEvent;
      e7 && (e7.preventDefault ? e7.preventDefault() : typeof e7.returnValue != "unknown" && (e7.returnValue = false), this.isDefaultPrevented = dn2);
    }, stopPropagation: function() {
      var e7 = this.nativeEvent;
      e7 && (e7.stopPropagation ? e7.stopPropagation() : typeof e7.cancelBubble != "unknown" && (e7.cancelBubble = true), this.isPropagationStopped = dn2);
    }, persist: function() {
    }, isPersistent: dn2 }), t3;
  }
  var mn2 = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(e6) {
    return e6.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, hn2 = pn2(mn2), gn2 = p2({}, mn2, { view: 0, detail: 0 }), _n2 = pn2(gn2), vn2, yn2, bn2, xn2 = p2({}, gn2, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: jn2, button: 0, buttons: 0, relatedTarget: function(e6) {
    return e6.relatedTarget === void 0 ? e6.fromElement === e6.srcElement ? e6.toElement : e6.fromElement : e6.relatedTarget;
  }, movementX: function(e6) {
    return "movementX" in e6 ? e6.movementX : (e6 !== bn2 && (bn2 && e6.type === "mousemove" ? (vn2 = e6.screenX - bn2.screenX, yn2 = e6.screenY - bn2.screenY) : yn2 = vn2 = 0, bn2 = e6), vn2);
  }, movementY: function(e6) {
    return "movementY" in e6 ? e6.movementY : yn2;
  } }), G2 = pn2(xn2), Sn2 = pn2(p2({}, xn2, { dataTransfer: 0 })), Cn2 = pn2(p2({}, gn2, { relatedTarget: 0 })), wn2 = pn2(p2({}, mn2, { animationName: 0, elapsedTime: 0, pseudoElement: 0 })), Tn2 = pn2(p2({}, mn2, { clipboardData: function(e6) {
    return "clipboardData" in e6 ? e6.clipboardData : window.clipboardData;
  } })), En2 = pn2(p2({}, mn2, { data: 0 })), Dn2 = { Esc: "Escape", Spacebar: " ", Left: "ArrowLeft", Up: "ArrowUp", Right: "ArrowRight", Down: "ArrowDown", Del: "Delete", Win: "OS", Menu: "ContextMenu", Apps: "ContextMenu", Scroll: "ScrollLock", MozPrintableKey: "Unidentified" }, On2 = { 8: "Backspace", 9: "Tab", 12: "Clear", 13: "Enter", 16: "Shift", 17: "Control", 18: "Alt", 19: "Pause", 20: "CapsLock", 27: "Escape", 32: " ", 33: "PageUp", 34: "PageDown", 35: "End", 36: "Home", 37: "ArrowLeft", 38: "ArrowUp", 39: "ArrowRight", 40: "ArrowDown", 45: "Insert", 46: "Delete", 112: "F1", 113: "F2", 114: "F3", 115: "F4", 116: "F5", 117: "F6", 118: "F7", 119: "F8", 120: "F9", 121: "F10", 122: "F11", 123: "F12", 144: "NumLock", 145: "ScrollLock", 224: "Meta" }, kn2 = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function An2(e6) {
    var t3 = this.nativeEvent;
    return t3.getModifierState ? t3.getModifierState(e6) : (e6 = kn2[e6]) ? !!t3[e6] : false;
  }
  function jn2() {
    return An2;
  }
  var Mn2 = pn2(p2({}, gn2, { key: function(e6) {
    if (e6.key) {
      var t3 = Dn2[e6.key] || e6.key;
      if (t3 !== "Unidentified") return t3;
    }
    return e6.type === "keypress" ? (e6 = un2(e6), e6 === 13 ? "Enter" : String.fromCharCode(e6)) : e6.type === "keydown" || e6.type === "keyup" ? On2[e6.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: jn2, charCode: function(e6) {
    return e6.type === "keypress" ? un2(e6) : 0;
  }, keyCode: function(e6) {
    return e6.type === "keydown" || e6.type === "keyup" ? e6.keyCode : 0;
  }, which: function(e6) {
    return e6.type === "keypress" ? un2(e6) : e6.type === "keydown" || e6.type === "keyup" ? e6.keyCode : 0;
  } })), Nn2 = pn2(p2({}, xn2, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 })), K2 = pn2(p2({}, gn2, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: jn2 })), Pn2 = pn2(p2({}, mn2, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 })), Fn2 = pn2(p2({}, xn2, { deltaX: function(e6) {
    return "deltaX" in e6 ? e6.deltaX : "wheelDeltaX" in e6 ? -e6.wheelDeltaX : 0;
  }, deltaY: function(e6) {
    return "deltaY" in e6 ? e6.deltaY : "wheelDeltaY" in e6 ? -e6.wheelDeltaY : "wheelDelta" in e6 ? -e6.wheelDelta : 0;
  }, deltaZ: 0, deltaMode: 0 })), In2 = pn2(p2({}, mn2, { newState: 0, oldState: 0 })), Ln2 = [9, 13, 27, 32], Rn2 = nn2 && "CompositionEvent" in window, zn2 = null;
  nn2 && "documentMode" in document && (zn2 = document.documentMode);
  var Bn2 = nn2 && "TextEvent" in window && !zn2, Vn2 = nn2 && (!Rn2 || zn2 && 8 < zn2 && 11 >= zn2), Hn2 = " ", Un2 = false;
  function Wn2(e6, t3) {
    switch (e6) {
      case "keyup":
        return Ln2.indexOf(t3.keyCode) !== -1;
      case "keydown":
        return t3.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return true;
      default:
        return false;
    }
  }
  function Gn2(e6) {
    return e6 = e6.detail, typeof e6 == "object" && "data" in e6 ? e6.data : null;
  }
  var Kn2 = false;
  function qn2(e6, t3) {
    switch (e6) {
      case "compositionend":
        return Gn2(t3);
      case "keypress":
        return t3.which === 32 ? (Un2 = true, Hn2) : null;
      case "textInput":
        return e6 = t3.data, e6 === Hn2 && Un2 ? null : e6;
      default:
        return null;
    }
  }
  function Jn2(e6, t3) {
    if (Kn2) return e6 === "compositionend" || !Rn2 && Wn2(e6, t3) ? (e6 = ln2(), cn2 = sn2 = on2 = null, Kn2 = false, e6) : null;
    switch (e6) {
      case "paste":
        return null;
      case "keypress":
        if (!(t3.ctrlKey || t3.altKey || t3.metaKey) || t3.ctrlKey && t3.altKey) {
          if (t3.char && 1 < t3.char.length) return t3.char;
          if (t3.which) return String.fromCharCode(t3.which);
        }
        return null;
      case "compositionend":
        return Vn2 && t3.locale !== "ko" ? null : t3.data;
      default:
        return null;
    }
  }
  var Yn2 = { color: true, date: true, datetime: true, "datetime-local": true, email: true, month: true, number: true, password: true, range: true, search: true, tel: true, text: true, time: true, url: true, week: true };
  function Xn2(e6) {
    var t3 = e6 && e6.nodeName && e6.nodeName.toLowerCase();
    return t3 === "input" ? !!Yn2[e6.type] : t3 === "textarea";
  }
  function Zn2(e6, t3, n3, r2) {
    Zt2 ? Qt2 ? Qt2.push(r2) : Qt2 = [r2] : Zt2 = r2, t3 = Td(t3, "onChange"), 0 < t3.length && (n3 = new hn2("onChange", "change", null, n3, r2), e6.push({ event: n3, listeners: t3 }));
  }
  var Qn2 = null, $n2 = null;
  function er2(e6) {
    vd(e6, 0);
  }
  function tr2(e6) {
    if (U2(pt2(e6))) return e6;
  }
  function nr2(e6, t3) {
    if (e6 === "change") return t3;
  }
  var rr2 = false;
  if (nn2) {
    var ir2;
    if (nn2) {
      var ar2 = "oninput" in document;
      if (!ar2) {
        var or2 = document.createElement("div");
        or2.setAttribute("oninput", "return;"), ar2 = typeof or2.oninput == "function";
      }
      ir2 = ar2;
    } else ir2 = false;
    rr2 = ir2 && (!document.documentMode || 9 < document.documentMode);
  }
  function sr2() {
    Qn2 && (Qn2.detachEvent("onpropertychange", cr2), $n2 = Qn2 = null);
  }
  function cr2(e6) {
    if (e6.propertyName === "value" && tr2($n2)) {
      var t3 = [];
      Zn2(t3, $n2, e6, Xt2(e6)), en2(er2, t3);
    }
  }
  function lr2(e6, t3, n3) {
    e6 === "focusin" ? (sr2(), Qn2 = t3, $n2 = n3, Qn2.attachEvent("onpropertychange", cr2)) : e6 === "focusout" && sr2();
  }
  function ur2(e6) {
    if (e6 === "selectionchange" || e6 === "keyup" || e6 === "keydown") return tr2($n2);
  }
  function dr2(e6, t3) {
    if (e6 === "click") return tr2(t3);
  }
  function fr2(e6, t3) {
    if (e6 === "input" || e6 === "change") return tr2(t3);
  }
  function pr2(e6, t3) {
    return e6 === t3 && (e6 !== 0 || 1 / e6 == 1 / t3) || e6 !== e6 && t3 !== t3;
  }
  var mr2 = typeof Object.is == "function" ? Object.is : pr2;
  function hr2(e6, t3) {
    if (mr2(e6, t3)) return true;
    if (typeof e6 != "object" || !e6 || typeof t3 != "object" || !t3) return false;
    var n3 = Object.keys(e6), r2 = Object.keys(t3);
    if (n3.length !== r2.length) return false;
    for (r2 = 0; r2 < n3.length; r2++) {
      var i3 = n3[r2];
      if (!ve2.call(t3, i3) || !mr2(e6[i3], t3[i3])) return false;
    }
    return true;
  }
  function gr2(e6) {
    for (; e6 && e6.firstChild; ) e6 = e6.firstChild;
    return e6;
  }
  function _r2(e6, t3) {
    var n3 = gr2(e6);
    e6 = 0;
    for (var r2; n3; ) {
      if (n3.nodeType === 3) {
        if (r2 = e6 + n3.textContent.length, e6 <= t3 && r2 >= t3) return { node: n3, offset: t3 - e6 };
        e6 = r2;
      }
      a: {
        for (; n3; ) {
          if (n3.nextSibling) {
            n3 = n3.nextSibling;
            break a;
          }
          n3 = n3.parentNode;
        }
        n3 = void 0;
      }
      n3 = gr2(n3);
    }
  }
  function vr2(e6, t3) {
    return e6 && t3 ? e6 === t3 ? true : e6 && e6.nodeType === 3 ? false : t3 && t3.nodeType === 3 ? vr2(e6, t3.parentNode) : "contains" in e6 ? e6.contains(t3) : e6.compareDocumentPosition ? !!(e6.compareDocumentPosition(t3) & 16) : false : false;
  }
  function yr2(e6) {
    e6 = e6 != null && e6.ownerDocument != null && e6.ownerDocument.defaultView != null ? e6.ownerDocument.defaultView : window;
    for (var t3 = jt2(e6.document); t3 instanceof e6.HTMLIFrameElement; ) {
      try {
        var n3 = typeof t3.contentWindow.location.href == "string";
      } catch {
        n3 = false;
      }
      if (n3) e6 = t3.contentWindow;
      else break;
      t3 = jt2(e6.document);
    }
    return t3;
  }
  function br2(e6) {
    var t3 = e6 && e6.nodeName && e6.nodeName.toLowerCase();
    return t3 && (t3 === "input" && (e6.type === "text" || e6.type === "search" || e6.type === "tel" || e6.type === "url" || e6.type === "password") || t3 === "textarea" || e6.contentEditable === "true");
  }
  var xr2 = nn2 && "documentMode" in document && 11 >= document.documentMode, Sr2 = null, Cr2 = null, wr2 = null, Tr2 = false;
  function Er2(e6, t3, n3) {
    var r2 = n3.window === n3 ? n3.document : n3.nodeType === 9 ? n3 : n3.ownerDocument;
    Tr2 || Sr2 == null || Sr2 !== jt2(r2) || (r2 = Sr2, "selectionStart" in r2 && br2(r2) ? r2 = { start: r2.selectionStart, end: r2.selectionEnd } : (r2 = (r2.ownerDocument && r2.ownerDocument.defaultView || window).getSelection(), r2 = { anchorNode: r2.anchorNode, anchorOffset: r2.anchorOffset, focusNode: r2.focusNode, focusOffset: r2.focusOffset }), wr2 && hr2(wr2, r2) || (wr2 = r2, r2 = Td(Cr2, "onSelect"), 0 < r2.length && (t3 = new hn2("onSelect", "select", null, t3, n3), e6.push({ event: t3, listeners: r2 }), t3.target = Sr2)));
  }
  function Dr2(e6, t3) {
    var n3 = {};
    return n3[e6.toLowerCase()] = t3.toLowerCase(), n3["Webkit" + e6] = "webkit" + t3, n3["Moz" + e6] = "moz" + t3, n3;
  }
  var Or2 = { animationend: Dr2("Animation", "AnimationEnd"), animationiteration: Dr2("Animation", "AnimationIteration"), animationstart: Dr2("Animation", "AnimationStart"), transitionrun: Dr2("Transition", "TransitionRun"), transitionstart: Dr2("Transition", "TransitionStart"), transitioncancel: Dr2("Transition", "TransitionCancel"), transitionend: Dr2("Transition", "TransitionEnd") }, kr2 = {}, Ar2 = {};
  nn2 && (Ar2 = document.createElement("div").style, "AnimationEvent" in window || (delete Or2.animationend.animation, delete Or2.animationiteration.animation, delete Or2.animationstart.animation), "TransitionEvent" in window || delete Or2.transitionend.transition);
  function jr2(e6) {
    if (kr2[e6]) return kr2[e6];
    if (!Or2[e6]) return e6;
    var t3 = Or2[e6], n3;
    for (n3 in t3) if (t3.hasOwnProperty(n3) && n3 in Ar2) return kr2[e6] = t3[n3];
    return e6;
  }
  var Mr2 = jr2("animationend"), Nr2 = jr2("animationiteration"), Pr2 = jr2("animationstart"), Fr2 = jr2("transitionrun"), Ir2 = jr2("transitionstart"), Lr2 = jr2("transitioncancel"), Rr2 = jr2("transitionend"), zr2 = /* @__PURE__ */ new Map(), Br2 = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  Br2.push("scrollEnd");
  function Vr2(e6, t3) {
    zr2.set(e6, t3), vt2(t3, [e6]);
  }
  var Hr2 = typeof reportError == "function" ? reportError : function(e6) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var t3 = new window.ErrorEvent("error", { bubbles: true, cancelable: true, message: typeof e6 == "object" && e6 && typeof e6.message == "string" ? String(e6.message) : String(e6), error: e6 });
      if (!window.dispatchEvent(t3)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", e6);
      return;
    }
    console.error(e6);
  }, Ur2 = [], Wr2 = 0, Gr2 = 0;
  function Kr2() {
    for (var e6 = Wr2, t3 = Gr2 = Wr2 = 0; t3 < e6; ) {
      var n3 = Ur2[t3];
      Ur2[t3++] = null;
      var r2 = Ur2[t3];
      Ur2[t3++] = null;
      var i3 = Ur2[t3];
      Ur2[t3++] = null;
      var a3 = Ur2[t3];
      if (Ur2[t3++] = null, r2 !== null && i3 !== null) {
        var o3 = r2.pending;
        o3 === null ? i3.next = i3 : (i3.next = o3.next, o3.next = i3), r2.pending = i3;
      }
      a3 !== 0 && Xr2(n3, i3, a3);
    }
  }
  function qr2(e6, t3, n3, r2) {
    Ur2[Wr2++] = e6, Ur2[Wr2++] = t3, Ur2[Wr2++] = n3, Ur2[Wr2++] = r2, Gr2 |= r2, e6.lanes |= r2, e6 = e6.alternate, e6 !== null && (e6.lanes |= r2);
  }
  function Jr2(e6, t3, n3, r2) {
    return qr2(e6, t3, n3, r2), Zr2(e6);
  }
  function Yr2(e6, t3) {
    return qr2(e6, null, null, t3), Zr2(e6);
  }
  function Xr2(e6, t3, n3) {
    e6.lanes |= n3;
    var r2 = e6.alternate;
    r2 !== null && (r2.lanes |= n3);
    for (var i3 = false, a3 = e6.return; a3 !== null; ) a3.childLanes |= n3, r2 = a3.alternate, r2 !== null && (r2.childLanes |= n3), a3.tag === 22 && (e6 = a3.stateNode, e6 === null || e6._visibility & 1 || (i3 = true)), e6 = a3, a3 = a3.return;
    return e6.tag === 3 ? (a3 = e6.stateNode, i3 && t3 !== null && (i3 = 31 - Fe2(n3), e6 = a3.hiddenUpdates, r2 = e6[i3], r2 === null ? e6[i3] = [t3] : r2.push(t3), t3.lane = n3 | 536870912), a3) : null;
  }
  function Zr2(e6) {
    if (50 < lu) throw lu = 0, uu = null, Error(a2(185));
    for (var t3 = e6.return; t3 !== null; ) e6 = t3, t3 = e6.return;
    return e6.tag === 3 ? e6.stateNode : null;
  }
  var Qr2 = {};
  function $r2(e6, t3, n3, r2) {
    this.tag = e6, this.key = n3, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t3, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r2, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function ei2(e6, t3, n3, r2) {
    return new $r2(e6, t3, n3, r2);
  }
  function ti2(e6) {
    return e6 = e6.prototype, !(!e6 || !e6.isReactComponent);
  }
  function ni2(e6, t3) {
    var n3 = e6.alternate;
    return n3 === null ? (n3 = ei2(e6.tag, t3, e6.key, e6.mode), n3.elementType = e6.elementType, n3.type = e6.type, n3.stateNode = e6.stateNode, n3.alternate = e6, e6.alternate = n3) : (n3.pendingProps = t3, n3.type = e6.type, n3.flags = 0, n3.subtreeFlags = 0, n3.deletions = null), n3.flags = e6.flags & 65011712, n3.childLanes = e6.childLanes, n3.lanes = e6.lanes, n3.child = e6.child, n3.memoizedProps = e6.memoizedProps, n3.memoizedState = e6.memoizedState, n3.updateQueue = e6.updateQueue, t3 = e6.dependencies, n3.dependencies = t3 === null ? null : { lanes: t3.lanes, firstContext: t3.firstContext }, n3.sibling = e6.sibling, n3.index = e6.index, n3.ref = e6.ref, n3.refCleanup = e6.refCleanup, n3;
  }
  function ri2(e6, t3) {
    e6.flags &= 65011714;
    var n3 = e6.alternate;
    return n3 === null ? (e6.childLanes = 0, e6.lanes = t3, e6.child = null, e6.subtreeFlags = 0, e6.memoizedProps = null, e6.memoizedState = null, e6.updateQueue = null, e6.dependencies = null, e6.stateNode = null) : (e6.childLanes = n3.childLanes, e6.lanes = n3.lanes, e6.child = n3.child, e6.subtreeFlags = 0, e6.deletions = null, e6.memoizedProps = n3.memoizedProps, e6.memoizedState = n3.memoizedState, e6.updateQueue = n3.updateQueue, e6.type = n3.type, t3 = n3.dependencies, e6.dependencies = t3 === null ? null : { lanes: t3.lanes, firstContext: t3.firstContext }), e6;
  }
  function ii2(e6, t3, n3, r2, i3, o3) {
    var s3 = 0;
    if (r2 = e6, typeof e6 == "function") ti2(e6) && (s3 = 1);
    else if (typeof e6 == "string") s3 = Uf(e6, n3, ie2.current) ? 26 : e6 === "html" || e6 === "head" || e6 === "body" ? 27 : 5;
    else a: switch (e6) {
      case D2:
        return e6 = ei2(31, n3, t3, i3), e6.elementType = D2, e6.lanes = o3, e6;
      case _2:
        return ai2(n3.children, i3, o3, t3);
      case v2:
        s3 = 8, i3 |= 24;
        break;
      case y2:
        return e6 = ei2(12, n3, t3, i3 | 2), e6.elementType = y2, e6.lanes = o3, e6;
      case C2:
        return e6 = ei2(13, n3, t3, i3), e6.elementType = C2, e6.lanes = o3, e6;
      case w2:
        return e6 = ei2(19, n3, t3, i3), e6.elementType = w2, e6.lanes = o3, e6;
      default:
        if (typeof e6 == "object" && e6) switch (e6.$$typeof) {
          case x2:
            s3 = 10;
            break a;
          case b2:
            s3 = 9;
            break a;
          case S2:
            s3 = 11;
            break a;
          case T2:
            s3 = 14;
            break a;
          case E2:
            s3 = 16, r2 = null;
            break a;
        }
        s3 = 29, n3 = Error(a2(130, e6 === null ? "null" : typeof e6, "")), r2 = null;
    }
    return t3 = ei2(s3, n3, t3, i3), t3.elementType = e6, t3.type = r2, t3.lanes = o3, t3;
  }
  function ai2(e6, t3, n3, r2) {
    return e6 = ei2(7, e6, r2, t3), e6.lanes = n3, e6;
  }
  function oi2(e6, t3, n3) {
    return e6 = ei2(6, e6, null, t3), e6.lanes = n3, e6;
  }
  function si2(e6) {
    var t3 = ei2(18, null, null, 0);
    return t3.stateNode = e6, t3;
  }
  function ci2(e6, t3, n3) {
    return t3 = ei2(4, e6.children === null ? [] : e6.children, e6.key, t3), t3.lanes = n3, t3.stateNode = { containerInfo: e6.containerInfo, pendingChildren: null, implementation: e6.implementation }, t3;
  }
  var li2 = /* @__PURE__ */ new WeakMap();
  function ui2(e6, t3) {
    if (typeof e6 == "object" && e6) {
      var n3 = li2.get(e6);
      return n3 === void 0 ? (t3 = { value: e6, source: t3, stack: _e2(t3) }, li2.set(e6, t3), t3) : n3;
    }
    return { value: e6, source: t3, stack: _e2(t3) };
  }
  var di2 = [], fi2 = 0, pi2 = null, mi2 = 0, hi2 = [], gi2 = 0, _i2 = null, vi2 = 1, yi2 = "";
  function bi2(e6, t3) {
    di2[fi2++] = mi2, di2[fi2++] = pi2, pi2 = e6, mi2 = t3;
  }
  function xi2(e6, t3, n3) {
    hi2[gi2++] = vi2, hi2[gi2++] = yi2, hi2[gi2++] = _i2, _i2 = e6;
    var r2 = vi2;
    e6 = yi2;
    var i3 = 32 - Fe2(r2) - 1;
    r2 &= ~(1 << i3), n3 += 1;
    var a3 = 32 - Fe2(t3) + i3;
    if (30 < a3) {
      var o3 = i3 - i3 % 5;
      a3 = (r2 & (1 << o3) - 1).toString(32), r2 >>= o3, i3 -= o3, vi2 = 1 << 32 - Fe2(t3) + i3 | n3 << i3 | r2, yi2 = a3 + e6;
    } else vi2 = 1 << a3 | n3 << i3 | r2, yi2 = e6;
  }
  function Si2(e6) {
    e6.return !== null && (bi2(e6, 1), xi2(e6, 1, 0));
  }
  function Ci2(e6) {
    for (; e6 === pi2; ) pi2 = di2[--fi2], di2[fi2] = null, mi2 = di2[--fi2], di2[fi2] = null;
    for (; e6 === _i2; ) _i2 = hi2[--gi2], hi2[gi2] = null, yi2 = hi2[--gi2], hi2[gi2] = null, vi2 = hi2[--gi2], hi2[gi2] = null;
  }
  function wi2(e6, t3) {
    hi2[gi2++] = vi2, hi2[gi2++] = yi2, hi2[gi2++] = _i2, vi2 = t3.id, yi2 = t3.overflow, _i2 = e6;
  }
  var Ti2 = null, Ei2 = null, q2 = false, Di2 = null, Oi2 = false, ki2 = Error(a2(519));
  function Ai2(e6) {
    throw Ii2(ui2(Error(a2(418, 1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML", "")), e6)), ki2;
  }
  function ji2(e6) {
    var t3 = e6.stateNode, n3 = e6.type, r2 = e6.memoizedProps;
    switch (t3[rt2] = e6, t3[it2] = r2, n3) {
      case "dialog":
        $("cancel", t3), $("close", t3);
        break;
      case "iframe":
      case "object":
      case "embed":
        $("load", t3);
        break;
      case "video":
      case "audio":
        for (n3 = 0; n3 < gd.length; n3++) $(gd[n3], t3);
        break;
      case "source":
        $("error", t3);
        break;
      case "img":
      case "image":
      case "link":
        $("error", t3), $("load", t3);
        break;
      case "details":
        $("toggle", t3);
        break;
      case "input":
        $("invalid", t3), Ft2(t3, r2.value, r2.defaultValue, r2.checked, r2.defaultChecked, r2.type, r2.name, true);
        break;
      case "select":
        $("invalid", t3);
        break;
      case "textarea":
        $("invalid", t3), zt2(t3, r2.value, r2.defaultValue, r2.children);
    }
    n3 = r2.children, typeof n3 != "string" && typeof n3 != "number" && typeof n3 != "bigint" || t3.textContent === "" + n3 || r2.suppressHydrationWarning === true || jd(t3.textContent, n3) ? (r2.popover != null && ($("beforetoggle", t3), $("toggle", t3)), r2.onScroll != null && $("scroll", t3), r2.onScrollEnd != null && $("scrollend", t3), r2.onClick != null && (t3.onclick = Jt2), t3 = true) : t3 = false, t3 || Ai2(e6, true);
  }
  function Mi2(e6) {
    for (Ti2 = e6.return; Ti2; ) switch (Ti2.tag) {
      case 5:
      case 31:
      case 13:
        Oi2 = false;
        return;
      case 27:
      case 3:
        Oi2 = true;
        return;
      default:
        Ti2 = Ti2.return;
    }
  }
  function Ni2(e6) {
    if (e6 !== Ti2) return false;
    if (!q2) return Mi2(e6), q2 = true, false;
    var t3 = e6.tag, n3;
    if ((n3 = t3 !== 3 && t3 !== 27) && ((n3 = t3 === 5) && (n3 = e6.type, n3 = !(n3 !== "form" && n3 !== "button") || Ud(e6.type, e6.memoizedProps)), n3 = !n3), n3 && Ei2 && Ai2(e6), Mi2(e6), t3 === 13) {
      if (e6 = e6.memoizedState, e6 = e6 === null ? null : e6.dehydrated, !e6) throw Error(a2(317));
      Ei2 = uf(e6);
    } else if (t3 === 31) {
      if (e6 = e6.memoizedState, e6 = e6 === null ? null : e6.dehydrated, !e6) throw Error(a2(317));
      Ei2 = uf(e6);
    } else t3 === 27 ? (t3 = Ei2, Zd(e6.type) ? (e6 = lf, lf = null, Ei2 = e6) : Ei2 = t3) : Ei2 = Ti2 ? cf(e6.stateNode.nextSibling) : null;
    return true;
  }
  function Pi2() {
    Ei2 = Ti2 = null, q2 = false;
  }
  function Fi2() {
    var e6 = Di2;
    return e6 !== null && (Yl === null ? Yl = e6 : Yl.push.apply(Yl, e6), Di2 = null), e6;
  }
  function Ii2(e6) {
    Di2 === null ? Di2 = [e6] : Di2.push(e6);
  }
  var Li2 = ne2(null), Ri2 = null, zi2 = null;
  function Bi2(e6, t3, n3) {
    L2(Li2, t3._currentValue), t3._currentValue = n3;
  }
  function Vi2(e6) {
    e6._currentValue = Li2.current, re2(Li2);
  }
  function Hi2(e6, t3, n3) {
    for (; e6 !== null; ) {
      var r2 = e6.alternate;
      if ((e6.childLanes & t3) === t3 ? r2 !== null && (r2.childLanes & t3) !== t3 && (r2.childLanes |= t3) : (e6.childLanes |= t3, r2 !== null && (r2.childLanes |= t3)), e6 === n3) break;
      e6 = e6.return;
    }
  }
  function Ui2(e6, t3, n3, r2) {
    var i3 = e6.child;
    for (i3 !== null && (i3.return = e6); i3 !== null; ) {
      var o3 = i3.dependencies;
      if (o3 !== null) {
        var s3 = i3.child;
        o3 = o3.firstContext;
        a: for (; o3 !== null; ) {
          var c3 = o3;
          o3 = i3;
          for (var l3 = 0; l3 < t3.length; l3++) if (c3.context === t3[l3]) {
            o3.lanes |= n3, c3 = o3.alternate, c3 !== null && (c3.lanes |= n3), Hi2(o3.return, n3, e6), r2 || (s3 = null);
            break a;
          }
          o3 = c3.next;
        }
      } else if (i3.tag === 18) {
        if (s3 = i3.return, s3 === null) throw Error(a2(341));
        s3.lanes |= n3, o3 = s3.alternate, o3 !== null && (o3.lanes |= n3), Hi2(s3, n3, e6), s3 = null;
      } else s3 = i3.child;
      if (s3 !== null) s3.return = i3;
      else for (s3 = i3; s3 !== null; ) {
        if (s3 === e6) {
          s3 = null;
          break;
        }
        if (i3 = s3.sibling, i3 !== null) {
          i3.return = s3.return, s3 = i3;
          break;
        }
        s3 = s3.return;
      }
      i3 = s3;
    }
  }
  function Wi2(e6, t3, n3, r2) {
    e6 = null;
    for (var i3 = t3, o3 = false; i3 !== null; ) {
      if (!o3) {
        if (i3.flags & 524288) o3 = true;
        else if (i3.flags & 262144) break;
      }
      if (i3.tag === 10) {
        var s3 = i3.alternate;
        if (s3 === null) throw Error(a2(387));
        if (s3 = s3.memoizedProps, s3 !== null) {
          var c3 = i3.type;
          mr2(i3.pendingProps.value, s3.value) || (e6 === null ? e6 = [c3] : e6.push(c3));
        }
      } else if (i3 === oe2.current) {
        if (s3 = i3.alternate, s3 === null) throw Error(a2(387));
        s3.memoizedState.memoizedState !== i3.memoizedState.memoizedState && (e6 === null ? e6 = [Qf] : e6.push(Qf));
      }
      i3 = i3.return;
    }
    e6 !== null && Ui2(t3, e6, n3, r2), t3.flags |= 262144;
  }
  function Gi2(e6) {
    for (e6 = e6.firstContext; e6 !== null; ) {
      if (!mr2(e6.context._currentValue, e6.memoizedValue)) return true;
      e6 = e6.next;
    }
    return false;
  }
  function Ki2(e6) {
    Ri2 = e6, zi2 = null, e6 = e6.dependencies, e6 !== null && (e6.firstContext = null);
  }
  function qi2(e6) {
    return Yi2(Ri2, e6);
  }
  function Ji2(e6, t3) {
    return Ri2 === null && Ki2(e6), Yi2(e6, t3);
  }
  function Yi2(e6, t3) {
    var n3 = t3._currentValue;
    if (t3 = { context: t3, memoizedValue: n3, next: null }, zi2 === null) {
      if (e6 === null) throw Error(a2(308));
      zi2 = t3, e6.dependencies = { lanes: 0, firstContext: t3 }, e6.flags |= 524288;
    } else zi2 = zi2.next = t3;
    return n3;
  }
  var Xi2 = typeof AbortController < "u" ? AbortController : function() {
    var e6 = [], t3 = this.signal = { aborted: false, addEventListener: function(t4, n3) {
      e6.push(n3);
    } };
    this.abort = function() {
      t3.aborted = true, e6.forEach(function(e7) {
        return e7();
      });
    };
  }, Zi2 = t2.unstable_scheduleCallback, Qi2 = t2.unstable_NormalPriority, $i2 = { $$typeof: x2, Consumer: null, Provider: null, _currentValue: null, _currentValue2: null, _threadCount: 0 };
  function ea2() {
    return { controller: new Xi2(), data: /* @__PURE__ */ new Map(), refCount: 0 };
  }
  function ta2(e6) {
    e6.refCount--, e6.refCount === 0 && Zi2(Qi2, function() {
      e6.controller.abort();
    });
  }
  var na2 = null, ra2 = 0, ia2 = 0, aa2 = null;
  function oa2(e6, t3) {
    if (na2 === null) {
      var n3 = na2 = [];
      ra2 = 0, ia2 = ud(), aa2 = { status: "pending", value: void 0, then: function(e7) {
        n3.push(e7);
      } };
    }
    return ra2++, t3.then(sa2, sa2), t3;
  }
  function sa2() {
    if (--ra2 === 0 && na2 !== null) {
      aa2 !== null && (aa2.status = "fulfilled");
      var e6 = na2;
      na2 = null, ia2 = 0, aa2 = null;
      for (var t3 = 0; t3 < e6.length; t3++) (0, e6[t3])();
    }
  }
  function ca2(e6, t3) {
    var n3 = [], r2 = { status: "pending", value: null, reason: null, then: function(e7) {
      n3.push(e7);
    } };
    return e6.then(function() {
      r2.status = "fulfilled", r2.value = t3;
      for (var e7 = 0; e7 < n3.length; e7++) (0, n3[e7])(t3);
    }, function(e7) {
      for (r2.status = "rejected", r2.reason = e7, e7 = 0; e7 < n3.length; e7++) (0, n3[e7])(void 0);
    }), r2;
  }
  var la2 = P2.S;
  P2.S = function(e6, t3) {
    Ql = Ce2(), typeof t3 == "object" && t3 && typeof t3.then == "function" && oa2(e6, t3), la2 !== null && la2(e6, t3);
  };
  var ua2 = ne2(null);
  function da2() {
    var e6 = ua2.current;
    return e6 === null ? Il2.pooledCache : e6;
  }
  function fa2(e6, t3) {
    t3 === null ? L2(ua2, ua2.current) : L2(ua2, t3.pool);
  }
  function pa2() {
    var e6 = da2();
    return e6 === null ? null : { parent: $i2._currentValue, pool: e6 };
  }
  var ma2 = Error(a2(460)), ha2 = Error(a2(474)), ga2 = Error(a2(542)), _a2 = { then: function() {
  } };
  function va2(e6) {
    return e6 = e6.status, e6 === "fulfilled" || e6 === "rejected";
  }
  function ya2(e6, t3, n3) {
    switch (n3 = e6[n3], n3 === void 0 ? e6.push(t3) : n3 !== t3 && (t3.then(Jt2, Jt2), t3 = n3), t3.status) {
      case "fulfilled":
        return t3.value;
      case "rejected":
        throw e6 = t3.reason, Ca2(e6), e6;
      default:
        if (typeof t3.status == "string") t3.then(Jt2, Jt2);
        else {
          if (e6 = Il2, e6 !== null && 100 < e6.shellSuspendCounter) throw Error(a2(482));
          e6 = t3, e6.status = "pending", e6.then(function(e7) {
            if (t3.status === "pending") {
              var n4 = t3;
              n4.status = "fulfilled", n4.value = e7;
            }
          }, function(e7) {
            if (t3.status === "pending") {
              var n4 = t3;
              n4.status = "rejected", n4.reason = e7;
            }
          });
        }
        switch (t3.status) {
          case "fulfilled":
            return t3.value;
          case "rejected":
            throw e6 = t3.reason, Ca2(e6), e6;
        }
        throw xa2 = t3, ma2;
    }
  }
  function ba2(e6) {
    try {
      var t3 = e6._init;
      return t3(e6._payload);
    } catch (e7) {
      throw typeof e7 == "object" && e7 && typeof e7.then == "function" ? (xa2 = e7, ma2) : e7;
    }
  }
  var xa2 = null;
  function Sa2() {
    if (xa2 === null) throw Error(a2(459));
    var e6 = xa2;
    return xa2 = null, e6;
  }
  function Ca2(e6) {
    if (e6 === ma2 || e6 === ga2) throw Error(a2(483));
  }
  var wa2 = null, Ta2 = 0;
  function Ea2(e6) {
    var t3 = Ta2;
    return Ta2 += 1, wa2 === null && (wa2 = []), ya2(wa2, e6, t3);
  }
  function Da2(e6, t3) {
    t3 = t3.props.ref, e6.ref = t3 === void 0 ? null : t3;
  }
  function Oa2(e6, t3) {
    throw t3.$$typeof === m2 ? Error(a2(525)) : (e6 = Object.prototype.toString.call(t3), Error(a2(31, e6 === "[object Object]" ? "object with keys {" + Object.keys(t3).join(", ") + "}" : e6)));
  }
  function ka2(e6) {
    function t3(t4, n4) {
      if (e6) {
        var r3 = t4.deletions;
        r3 === null ? (t4.deletions = [n4], t4.flags |= 16) : r3.push(n4);
      }
    }
    function n3(n4, r3) {
      if (!e6) return null;
      for (; r3 !== null; ) t3(n4, r3), r3 = r3.sibling;
      return null;
    }
    function r2(e7) {
      for (var t4 = /* @__PURE__ */ new Map(); e7 !== null; ) e7.key === null ? t4.set(e7.index, e7) : t4.set(e7.key, e7), e7 = e7.sibling;
      return t4;
    }
    function i3(e7, t4) {
      return e7 = ni2(e7, t4), e7.index = 0, e7.sibling = null, e7;
    }
    function o3(t4, n4, r3) {
      return t4.index = r3, e6 ? (r3 = t4.alternate, r3 === null ? (t4.flags |= 67108866, n4) : (r3 = r3.index, r3 < n4 ? (t4.flags |= 67108866, n4) : r3)) : (t4.flags |= 1048576, n4);
    }
    function s3(t4) {
      return e6 && t4.alternate === null && (t4.flags |= 67108866), t4;
    }
    function c3(e7, t4, n4, r3) {
      return t4 === null || t4.tag !== 6 ? (t4 = oi2(n4, e7.mode, r3), t4.return = e7, t4) : (t4 = i3(t4, n4), t4.return = e7, t4);
    }
    function l3(e7, t4, n4, r3) {
      var a3 = n4.type;
      return a3 === _2 ? d3(e7, t4, n4.props.children, r3, n4.key) : t4 !== null && (t4.elementType === a3 || typeof a3 == "object" && a3 && a3.$$typeof === E2 && ba2(a3) === t4.type) ? (t4 = i3(t4, n4.props), Da2(t4, n4), t4.return = e7, t4) : (t4 = ii2(n4.type, n4.key, n4.props, null, e7.mode, r3), Da2(t4, n4), t4.return = e7, t4);
    }
    function u3(e7, t4, n4, r3) {
      return t4 === null || t4.tag !== 4 || t4.stateNode.containerInfo !== n4.containerInfo || t4.stateNode.implementation !== n4.implementation ? (t4 = ci2(n4, e7.mode, r3), t4.return = e7, t4) : (t4 = i3(t4, n4.children || []), t4.return = e7, t4);
    }
    function d3(e7, t4, n4, r3, a3) {
      return t4 === null || t4.tag !== 7 ? (t4 = ai2(n4, e7.mode, r3, a3), t4.return = e7, t4) : (t4 = i3(t4, n4), t4.return = e7, t4);
    }
    function f3(e7, t4, n4) {
      if (typeof t4 == "string" && t4 !== "" || typeof t4 == "number" || typeof t4 == "bigint") return t4 = oi2("" + t4, e7.mode, n4), t4.return = e7, t4;
      if (typeof t4 == "object" && t4) {
        switch (t4.$$typeof) {
          case h2:
            return n4 = ii2(t4.type, t4.key, t4.props, null, e7.mode, n4), Da2(n4, t4), n4.return = e7, n4;
          case g2:
            return t4 = ci2(t4, e7.mode, n4), t4.return = e7, t4;
          case E2:
            return t4 = ba2(t4), f3(e7, t4, n4);
        }
        if (N2(t4) || A2(t4)) return t4 = ai2(t4, e7.mode, n4, null), t4.return = e7, t4;
        if (typeof t4.then == "function") return f3(e7, Ea2(t4), n4);
        if (t4.$$typeof === x2) return f3(e7, Ji2(e7, t4), n4);
        Oa2(e7, t4);
      }
      return null;
    }
    function p3(e7, t4, n4, r3) {
      var i4 = t4 === null ? null : t4.key;
      if (typeof n4 == "string" && n4 !== "" || typeof n4 == "number" || typeof n4 == "bigint") return i4 === null ? c3(e7, t4, "" + n4, r3) : null;
      if (typeof n4 == "object" && n4) {
        switch (n4.$$typeof) {
          case h2:
            return n4.key === i4 ? l3(e7, t4, n4, r3) : null;
          case g2:
            return n4.key === i4 ? u3(e7, t4, n4, r3) : null;
          case E2:
            return n4 = ba2(n4), p3(e7, t4, n4, r3);
        }
        if (N2(n4) || A2(n4)) return i4 === null ? d3(e7, t4, n4, r3, null) : null;
        if (typeof n4.then == "function") return p3(e7, t4, Ea2(n4), r3);
        if (n4.$$typeof === x2) return p3(e7, t4, Ji2(e7, n4), r3);
        Oa2(e7, n4);
      }
      return null;
    }
    function m3(e7, t4, n4, r3, i4) {
      if (typeof r3 == "string" && r3 !== "" || typeof r3 == "number" || typeof r3 == "bigint") return e7 = e7.get(n4) || null, c3(t4, e7, "" + r3, i4);
      if (typeof r3 == "object" && r3) {
        switch (r3.$$typeof) {
          case h2:
            return e7 = e7.get(r3.key === null ? n4 : r3.key) || null, l3(t4, e7, r3, i4);
          case g2:
            return e7 = e7.get(r3.key === null ? n4 : r3.key) || null, u3(t4, e7, r3, i4);
          case E2:
            return r3 = ba2(r3), m3(e7, t4, n4, r3, i4);
        }
        if (N2(r3) || A2(r3)) return e7 = e7.get(n4) || null, d3(t4, e7, r3, i4, null);
        if (typeof r3.then == "function") return m3(e7, t4, n4, Ea2(r3), i4);
        if (r3.$$typeof === x2) return m3(e7, t4, n4, Ji2(t4, r3), i4);
        Oa2(t4, r3);
      }
      return null;
    }
    function v3(i4, a3, s4, c4) {
      for (var l4 = null, u4 = null, d4 = a3, h3 = a3 = 0, g3 = null; d4 !== null && h3 < s4.length; h3++) {
        d4.index > h3 ? (g3 = d4, d4 = null) : g3 = d4.sibling;
        var _3 = p3(i4, d4, s4[h3], c4);
        if (_3 === null) {
          d4 === null && (d4 = g3);
          break;
        }
        e6 && d4 && _3.alternate === null && t3(i4, d4), a3 = o3(_3, a3, h3), u4 === null ? l4 = _3 : u4.sibling = _3, u4 = _3, d4 = g3;
      }
      if (h3 === s4.length) return n3(i4, d4), q2 && bi2(i4, h3), l4;
      if (d4 === null) {
        for (; h3 < s4.length; h3++) d4 = f3(i4, s4[h3], c4), d4 !== null && (a3 = o3(d4, a3, h3), u4 === null ? l4 = d4 : u4.sibling = d4, u4 = d4);
        return q2 && bi2(i4, h3), l4;
      }
      for (d4 = r2(d4); h3 < s4.length; h3++) g3 = m3(d4, i4, h3, s4[h3], c4), g3 !== null && (e6 && g3.alternate !== null && d4.delete(g3.key === null ? h3 : g3.key), a3 = o3(g3, a3, h3), u4 === null ? l4 = g3 : u4.sibling = g3, u4 = g3);
      return e6 && d4.forEach(function(e7) {
        return t3(i4, e7);
      }), q2 && bi2(i4, h3), l4;
    }
    function y3(i4, s4, c4, l4) {
      if (c4 == null) throw Error(a2(151));
      for (var u4 = null, d4 = null, h3 = s4, g3 = s4 = 0, _3 = null, v4 = c4.next(); h3 !== null && !v4.done; g3++, v4 = c4.next()) {
        h3.index > g3 ? (_3 = h3, h3 = null) : _3 = h3.sibling;
        var y4 = p3(i4, h3, v4.value, l4);
        if (y4 === null) {
          h3 === null && (h3 = _3);
          break;
        }
        e6 && h3 && y4.alternate === null && t3(i4, h3), s4 = o3(y4, s4, g3), d4 === null ? u4 = y4 : d4.sibling = y4, d4 = y4, h3 = _3;
      }
      if (v4.done) return n3(i4, h3), q2 && bi2(i4, g3), u4;
      if (h3 === null) {
        for (; !v4.done; g3++, v4 = c4.next()) v4 = f3(i4, v4.value, l4), v4 !== null && (s4 = o3(v4, s4, g3), d4 === null ? u4 = v4 : d4.sibling = v4, d4 = v4);
        return q2 && bi2(i4, g3), u4;
      }
      for (h3 = r2(h3); !v4.done; g3++, v4 = c4.next()) v4 = m3(h3, i4, g3, v4.value, l4), v4 !== null && (e6 && v4.alternate !== null && h3.delete(v4.key === null ? g3 : v4.key), s4 = o3(v4, s4, g3), d4 === null ? u4 = v4 : d4.sibling = v4, d4 = v4);
      return e6 && h3.forEach(function(e7) {
        return t3(i4, e7);
      }), q2 && bi2(i4, g3), u4;
    }
    function b3(e7, r3, o4, c4) {
      if (typeof o4 == "object" && o4 && o4.type === _2 && o4.key === null && (o4 = o4.props.children), typeof o4 == "object" && o4) {
        switch (o4.$$typeof) {
          case h2:
            a: {
              for (var l4 = o4.key; r3 !== null; ) {
                if (r3.key === l4) {
                  if (l4 = o4.type, l4 === _2) {
                    if (r3.tag === 7) {
                      n3(e7, r3.sibling), c4 = i3(r3, o4.props.children), c4.return = e7, e7 = c4;
                      break a;
                    }
                  } else if (r3.elementType === l4 || typeof l4 == "object" && l4 && l4.$$typeof === E2 && ba2(l4) === r3.type) {
                    n3(e7, r3.sibling), c4 = i3(r3, o4.props), Da2(c4, o4), c4.return = e7, e7 = c4;
                    break a;
                  }
                  n3(e7, r3);
                  break;
                } else t3(e7, r3);
                r3 = r3.sibling;
              }
              o4.type === _2 ? (c4 = ai2(o4.props.children, e7.mode, c4, o4.key), c4.return = e7, e7 = c4) : (c4 = ii2(o4.type, o4.key, o4.props, null, e7.mode, c4), Da2(c4, o4), c4.return = e7, e7 = c4);
            }
            return s3(e7);
          case g2:
            a: {
              for (l4 = o4.key; r3 !== null; ) {
                if (r3.key === l4) if (r3.tag === 4 && r3.stateNode.containerInfo === o4.containerInfo && r3.stateNode.implementation === o4.implementation) {
                  n3(e7, r3.sibling), c4 = i3(r3, o4.children || []), c4.return = e7, e7 = c4;
                  break a;
                } else {
                  n3(e7, r3);
                  break;
                }
                else t3(e7, r3);
                r3 = r3.sibling;
              }
              c4 = ci2(o4, e7.mode, c4), c4.return = e7, e7 = c4;
            }
            return s3(e7);
          case E2:
            return o4 = ba2(o4), b3(e7, r3, o4, c4);
        }
        if (N2(o4)) return v3(e7, r3, o4, c4);
        if (A2(o4)) {
          if (l4 = A2(o4), typeof l4 != "function") throw Error(a2(150));
          return o4 = l4.call(o4), y3(e7, r3, o4, c4);
        }
        if (typeof o4.then == "function") return b3(e7, r3, Ea2(o4), c4);
        if (o4.$$typeof === x2) return b3(e7, r3, Ji2(e7, o4), c4);
        Oa2(e7, o4);
      }
      return typeof o4 == "string" && o4 !== "" || typeof o4 == "number" || typeof o4 == "bigint" ? (o4 = "" + o4, r3 !== null && r3.tag === 6 ? (n3(e7, r3.sibling), c4 = i3(r3, o4), c4.return = e7, e7 = c4) : (n3(e7, r3), c4 = oi2(o4, e7.mode, c4), c4.return = e7, e7 = c4), s3(e7)) : n3(e7, r3);
    }
    return function(e7, t4, n4, r3) {
      try {
        Ta2 = 0;
        var i4 = b3(e7, t4, n4, r3);
        return wa2 = null, i4;
      } catch (t5) {
        if (t5 === ma2 || t5 === ga2) throw t5;
        var a3 = ei2(29, t5, null, e7.mode);
        return a3.lanes = r3, a3.return = e7, a3;
      }
    };
  }
  var Aa2 = ka2(true), ja2 = ka2(false), Ma2 = false;
  function Na2(e6) {
    e6.updateQueue = { baseState: e6.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, lanes: 0, hiddenCallbacks: null }, callbacks: null };
  }
  function Pa2(e6, t3) {
    e6 = e6.updateQueue, t3.updateQueue === e6 && (t3.updateQueue = { baseState: e6.baseState, firstBaseUpdate: e6.firstBaseUpdate, lastBaseUpdate: e6.lastBaseUpdate, shared: e6.shared, callbacks: null });
  }
  function Fa2(e6) {
    return { lane: e6, tag: 0, payload: null, callback: null, next: null };
  }
  function Ia2(e6, t3, n3) {
    var r2 = e6.updateQueue;
    if (r2 === null) return null;
    if (r2 = r2.shared, Y2 & 2) {
      var i3 = r2.pending;
      return i3 === null ? t3.next = t3 : (t3.next = i3.next, i3.next = t3), r2.pending = t3, t3 = Zr2(e6), Xr2(e6, null, n3), t3;
    }
    return qr2(e6, r2, t3, n3), Zr2(e6);
  }
  function La2(e6, t3, n3) {
    if (t3 = t3.updateQueue, t3 !== null && (t3 = t3.shared, n3 & 4194048)) {
      var r2 = t3.lanes;
      r2 &= e6.pendingLanes, n3 |= r2, t3.lanes = n3, Xe2(e6, n3);
    }
  }
  function Ra2(e6, t3) {
    var n3 = e6.updateQueue, r2 = e6.alternate;
    if (r2 !== null && (r2 = r2.updateQueue, n3 === r2)) {
      var i3 = null, a3 = null;
      if (n3 = n3.firstBaseUpdate, n3 !== null) {
        do {
          var o3 = { lane: n3.lane, tag: n3.tag, payload: n3.payload, callback: null, next: null };
          a3 === null ? i3 = a3 = o3 : a3 = a3.next = o3, n3 = n3.next;
        } while (n3 !== null);
        a3 === null ? i3 = a3 = t3 : a3 = a3.next = t3;
      } else i3 = a3 = t3;
      n3 = { baseState: r2.baseState, firstBaseUpdate: i3, lastBaseUpdate: a3, shared: r2.shared, callbacks: r2.callbacks }, e6.updateQueue = n3;
      return;
    }
    e6 = n3.lastBaseUpdate, e6 === null ? n3.firstBaseUpdate = t3 : e6.next = t3, n3.lastBaseUpdate = t3;
  }
  var za2 = false;
  function Ba2() {
    if (za2) {
      var e6 = aa2;
      if (e6 !== null) throw e6;
    }
  }
  function Va2(e6, t3, n3, r2) {
    za2 = false;
    var i3 = e6.updateQueue;
    Ma2 = false;
    var a3 = i3.firstBaseUpdate, o3 = i3.lastBaseUpdate, s3 = i3.shared.pending;
    if (s3 !== null) {
      i3.shared.pending = null;
      var c3 = s3, l3 = c3.next;
      c3.next = null, o3 === null ? a3 = l3 : o3.next = l3, o3 = c3;
      var u3 = e6.alternate;
      u3 !== null && (u3 = u3.updateQueue, s3 = u3.lastBaseUpdate, s3 !== o3 && (s3 === null ? u3.firstBaseUpdate = l3 : s3.next = l3, u3.lastBaseUpdate = c3));
    }
    if (a3 !== null) {
      var d3 = i3.baseState;
      o3 = 0, u3 = l3 = c3 = null, s3 = a3;
      do {
        var f3 = s3.lane & -536870913, m3 = f3 !== s3.lane;
        if (m3 ? (Z2 & f3) === f3 : (r2 & f3) === f3) {
          f3 !== 0 && f3 === ia2 && (za2 = true), u3 !== null && (u3 = u3.next = { lane: 0, tag: s3.tag, payload: s3.payload, callback: null, next: null });
          a: {
            var h3 = e6, g3 = s3;
            f3 = t3;
            var _3 = n3;
            switch (g3.tag) {
              case 1:
                if (h3 = g3.payload, typeof h3 == "function") {
                  d3 = h3.call(_3, d3, f3);
                  break a;
                }
                d3 = h3;
                break a;
              case 3:
                h3.flags = h3.flags & -65537 | 128;
              case 0:
                if (h3 = g3.payload, f3 = typeof h3 == "function" ? h3.call(_3, d3, f3) : h3, f3 == null) break a;
                d3 = p2({}, d3, f3);
                break a;
              case 2:
                Ma2 = true;
            }
          }
          f3 = s3.callback, f3 !== null && (e6.flags |= 64, m3 && (e6.flags |= 8192), m3 = i3.callbacks, m3 === null ? i3.callbacks = [f3] : m3.push(f3));
        } else m3 = { lane: f3, tag: s3.tag, payload: s3.payload, callback: s3.callback, next: null }, u3 === null ? (l3 = u3 = m3, c3 = d3) : u3 = u3.next = m3, o3 |= f3;
        if (s3 = s3.next, s3 === null) {
          if (s3 = i3.shared.pending, s3 === null) break;
          m3 = s3, s3 = m3.next, m3.next = null, i3.lastBaseUpdate = m3, i3.shared.pending = null;
        }
      } while (true);
      u3 === null && (c3 = d3), i3.baseState = c3, i3.firstBaseUpdate = l3, i3.lastBaseUpdate = u3, a3 === null && (i3.shared.lanes = 0), Ul2 |= o3, e6.lanes = o3, e6.memoizedState = d3;
    }
  }
  function Ha2(e6, t3) {
    if (typeof e6 != "function") throw Error(a2(191, e6));
    e6.call(t3);
  }
  function Ua2(e6, t3) {
    var n3 = e6.callbacks;
    if (n3 !== null) for (e6.callbacks = null, e6 = 0; e6 < n3.length; e6++) Ha2(n3[e6], t3);
  }
  var Wa2 = ne2(null), Ga2 = ne2(0);
  function Ka2(e6, t3) {
    e6 = Vl2, L2(Ga2, e6), L2(Wa2, t3), Vl2 = e6 | t3.baseLanes;
  }
  function qa2() {
    L2(Ga2, Vl2), L2(Wa2, Wa2.current);
  }
  function Ja2() {
    Vl2 = Ga2.current, re2(Wa2), re2(Ga2);
  }
  var Ya2 = ne2(null), Xa2 = null;
  function Za2(e6) {
    var t3 = e6.alternate;
    L2(no2, no2.current & 1), L2(Ya2, e6), Xa2 === null && (t3 === null || Wa2.current !== null || t3.memoizedState !== null) && (Xa2 = e6);
  }
  function Qa2(e6) {
    L2(no2, no2.current), L2(Ya2, e6), Xa2 === null && (Xa2 = e6);
  }
  function $a2(e6) {
    e6.tag === 22 ? (L2(no2, no2.current), L2(Ya2, e6), Xa2 === null && (Xa2 = e6)) : eo2(e6);
  }
  function eo2() {
    L2(no2, no2.current), L2(Ya2, Ya2.current);
  }
  function to2(e6) {
    re2(Ya2), Xa2 === e6 && (Xa2 = null), re2(no2);
  }
  var no2 = ne2(0);
  function ro2(e6) {
    for (var t3 = e6; t3 !== null; ) {
      if (t3.tag === 13) {
        var n3 = t3.memoizedState;
        if (n3 !== null && (n3 = n3.dehydrated, n3 === null || af(n3) || of(n3))) return t3;
      } else if (t3.tag === 19 && (t3.memoizedProps.revealOrder === "forwards" || t3.memoizedProps.revealOrder === "backwards" || t3.memoizedProps.revealOrder === "unstable_legacy-backwards" || t3.memoizedProps.revealOrder === "together")) {
        if (t3.flags & 128) return t3;
      } else if (t3.child !== null) {
        t3.child.return = t3, t3 = t3.child;
        continue;
      }
      if (t3 === e6) break;
      for (; t3.sibling === null; ) {
        if (t3.return === null || t3.return === e6) return null;
        t3 = t3.return;
      }
      t3.sibling.return = t3.return, t3 = t3.sibling;
    }
    return null;
  }
  var io2 = 0, J2 = null, ao2 = null, oo2 = null, so2 = false, co2 = false, lo2 = false, uo2 = 0, fo2 = 0, po2 = null, mo2 = 0;
  function ho2() {
    throw Error(a2(321));
  }
  function go2(e6, t3) {
    if (t3 === null) return false;
    for (var n3 = 0; n3 < t3.length && n3 < e6.length; n3++) if (!mr2(e6[n3], t3[n3])) return false;
    return true;
  }
  function _o2(e6, t3, n3, r2, i3, a3) {
    return io2 = a3, J2 = t3, t3.memoizedState = null, t3.updateQueue = null, t3.lanes = 0, P2.H = e6 === null || e6.memoizedState === null ? Ps2 : Fs2, lo2 = false, a3 = n3(r2, i3), lo2 = false, co2 && (a3 = yo2(t3, n3, r2, i3)), vo2(e6), a3;
  }
  function vo2(e6) {
    P2.H = Ns2;
    var t3 = ao2 !== null && ao2.next !== null;
    if (io2 = 0, oo2 = ao2 = J2 = null, so2 = false, fo2 = 0, po2 = null, t3) throw Error(a2(300));
    e6 === null || Qs2 || (e6 = e6.dependencies, e6 !== null && Gi2(e6) && (Qs2 = true));
  }
  function yo2(e6, t3, n3, r2) {
    J2 = e6;
    var i3 = 0;
    do {
      if (co2 && (po2 = null), fo2 = 0, co2 = false, 25 <= i3) throw Error(a2(301));
      if (i3 += 1, oo2 = ao2 = null, e6.updateQueue != null) {
        var o3 = e6.updateQueue;
        o3.lastEffect = null, o3.events = null, o3.stores = null, o3.memoCache != null && (o3.memoCache.index = 0);
      }
      P2.H = Is2, o3 = t3(n3, r2);
    } while (co2);
    return o3;
  }
  function bo2() {
    var e6 = P2.H, t3 = e6.useState()[0];
    return t3 = typeof t3.then == "function" ? Do2(t3) : t3, e6 = e6.useState()[0], (ao2 === null ? null : ao2.memoizedState) !== e6 && (J2.flags |= 1024), t3;
  }
  function xo2() {
    var e6 = uo2 !== 0;
    return uo2 = 0, e6;
  }
  function So2(e6, t3, n3) {
    t3.updateQueue = e6.updateQueue, t3.flags &= -2053, e6.lanes &= ~n3;
  }
  function Co2(e6) {
    if (so2) {
      for (e6 = e6.memoizedState; e6 !== null; ) {
        var t3 = e6.queue;
        t3 !== null && (t3.pending = null), e6 = e6.next;
      }
      so2 = false;
    }
    io2 = 0, oo2 = ao2 = J2 = null, co2 = false, fo2 = uo2 = 0, po2 = null;
  }
  function wo2() {
    var e6 = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return oo2 === null ? J2.memoizedState = oo2 = e6 : oo2 = oo2.next = e6, oo2;
  }
  function To2() {
    if (ao2 === null) {
      var e6 = J2.alternate;
      e6 = e6 === null ? null : e6.memoizedState;
    } else e6 = ao2.next;
    var t3 = oo2 === null ? J2.memoizedState : oo2.next;
    if (t3 !== null) oo2 = t3, ao2 = e6;
    else {
      if (e6 === null) throw J2.alternate === null ? Error(a2(467)) : Error(a2(310));
      ao2 = e6, e6 = { memoizedState: ao2.memoizedState, baseState: ao2.baseState, baseQueue: ao2.baseQueue, queue: ao2.queue, next: null }, oo2 === null ? J2.memoizedState = oo2 = e6 : oo2 = oo2.next = e6;
    }
    return oo2;
  }
  function Eo2() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function Do2(e6) {
    var t3 = fo2;
    return fo2 += 1, po2 === null && (po2 = []), e6 = ya2(po2, e6, t3), t3 = J2, (oo2 === null ? t3.memoizedState : oo2.next) === null && (t3 = t3.alternate, P2.H = t3 === null || t3.memoizedState === null ? Ps2 : Fs2), e6;
  }
  function Oo2(e6) {
    if (typeof e6 == "object" && e6) {
      if (typeof e6.then == "function") return Do2(e6);
      if (e6.$$typeof === x2) return qi2(e6);
    }
    throw Error(a2(438, String(e6)));
  }
  function ko2(e6) {
    var t3 = null, n3 = J2.updateQueue;
    if (n3 !== null && (t3 = n3.memoCache), t3 == null) {
      var r2 = J2.alternate;
      r2 !== null && (r2 = r2.updateQueue, r2 !== null && (r2 = r2.memoCache, r2 != null && (t3 = { data: r2.data.map(function(e7) {
        return e7.slice();
      }), index: 0 })));
    }
    if (t3 ??= { data: [], index: 0 }, n3 === null && (n3 = Eo2(), J2.updateQueue = n3), n3.memoCache = t3, n3 = t3.data[t3.index], n3 === void 0) for (n3 = t3.data[t3.index] = Array(e6), r2 = 0; r2 < e6; r2++) n3[r2] = O2;
    return t3.index++, n3;
  }
  function Ao2(e6, t3) {
    return typeof t3 == "function" ? t3(e6) : t3;
  }
  function jo2(e6) {
    return Mo2(To2(), ao2, e6);
  }
  function Mo2(e6, t3, n3) {
    var r2 = e6.queue;
    if (r2 === null) throw Error(a2(311));
    r2.lastRenderedReducer = n3;
    var i3 = e6.baseQueue, o3 = r2.pending;
    if (o3 !== null) {
      if (i3 !== null) {
        var s3 = i3.next;
        i3.next = o3.next, o3.next = s3;
      }
      t3.baseQueue = i3 = o3, r2.pending = null;
    }
    if (o3 = e6.baseState, i3 === null) e6.memoizedState = o3;
    else {
      t3 = i3.next;
      var c3 = s3 = null, l3 = null, u3 = t3, d3 = false;
      do {
        var f3 = u3.lane & -536870913;
        if (f3 === u3.lane ? (io2 & f3) === f3 : (Z2 & f3) === f3) {
          var p3 = u3.revertLane;
          if (p3 === 0) l3 !== null && (l3 = l3.next = { lane: 0, revertLane: 0, gesture: null, action: u3.action, hasEagerState: u3.hasEagerState, eagerState: u3.eagerState, next: null }), f3 === ia2 && (d3 = true);
          else if ((io2 & p3) === p3) {
            u3 = u3.next, p3 === ia2 && (d3 = true);
            continue;
          } else f3 = { lane: 0, revertLane: u3.revertLane, gesture: null, action: u3.action, hasEagerState: u3.hasEagerState, eagerState: u3.eagerState, next: null }, l3 === null ? (c3 = l3 = f3, s3 = o3) : l3 = l3.next = f3, J2.lanes |= p3, Ul2 |= p3;
          f3 = u3.action, lo2 && n3(o3, f3), o3 = u3.hasEagerState ? u3.eagerState : n3(o3, f3);
        } else p3 = { lane: f3, revertLane: u3.revertLane, gesture: u3.gesture, action: u3.action, hasEagerState: u3.hasEagerState, eagerState: u3.eagerState, next: null }, l3 === null ? (c3 = l3 = p3, s3 = o3) : l3 = l3.next = p3, J2.lanes |= f3, Ul2 |= f3;
        u3 = u3.next;
      } while (u3 !== null && u3 !== t3);
      if (l3 === null ? s3 = o3 : l3.next = c3, !mr2(o3, e6.memoizedState) && (Qs2 = true, d3 && (n3 = aa2, n3 !== null))) throw n3;
      e6.memoizedState = o3, e6.baseState = s3, e6.baseQueue = l3, r2.lastRenderedState = o3;
    }
    return i3 === null && (r2.lanes = 0), [e6.memoizedState, r2.dispatch];
  }
  function No2(e6) {
    var t3 = To2(), n3 = t3.queue;
    if (n3 === null) throw Error(a2(311));
    n3.lastRenderedReducer = e6;
    var r2 = n3.dispatch, i3 = n3.pending, o3 = t3.memoizedState;
    if (i3 !== null) {
      n3.pending = null;
      var s3 = i3 = i3.next;
      do
        o3 = e6(o3, s3.action), s3 = s3.next;
      while (s3 !== i3);
      mr2(o3, t3.memoizedState) || (Qs2 = true), t3.memoizedState = o3, t3.baseQueue === null && (t3.baseState = o3), n3.lastRenderedState = o3;
    }
    return [o3, r2];
  }
  function Po2(e6, t3, n3) {
    var r2 = J2, i3 = To2(), o3 = q2;
    if (o3) {
      if (n3 === void 0) throw Error(a2(407));
      n3 = n3();
    } else n3 = t3();
    var s3 = !mr2((ao2 || i3).memoizedState, n3);
    if (s3 && (i3.memoizedState = n3, Qs2 = true), i3 = i3.queue, as2(Lo2.bind(null, r2, i3, e6), [e6]), i3.getSnapshot !== t3 || s3 || oo2 !== null && oo2.memoizedState.tag & 1) {
      if (r2.flags |= 2048, es2(9, { destroy: void 0 }, Io2.bind(null, r2, i3, n3, t3), null), Il2 === null) throw Error(a2(349));
      o3 || io2 & 127 || Fo2(r2, t3, n3);
    }
    return n3;
  }
  function Fo2(e6, t3, n3) {
    e6.flags |= 16384, e6 = { getSnapshot: t3, value: n3 }, t3 = J2.updateQueue, t3 === null ? (t3 = Eo2(), J2.updateQueue = t3, t3.stores = [e6]) : (n3 = t3.stores, n3 === null ? t3.stores = [e6] : n3.push(e6));
  }
  function Io2(e6, t3, n3, r2) {
    t3.value = n3, t3.getSnapshot = r2, Ro2(t3) && zo2(e6);
  }
  function Lo2(e6, t3, n3) {
    return n3(function() {
      Ro2(t3) && zo2(e6);
    });
  }
  function Ro2(e6) {
    var t3 = e6.getSnapshot;
    e6 = e6.value;
    try {
      var n3 = t3();
      return !mr2(e6, n3);
    } catch {
      return true;
    }
  }
  function zo2(e6) {
    var t3 = Yr2(e6, 2);
    t3 !== null && pu(t3, e6, 2);
  }
  function Bo2(e6) {
    var t3 = wo2();
    if (typeof e6 == "function") {
      var n3 = e6;
      if (e6 = n3(), lo2) {
        Pe2(true);
        try {
          n3();
        } finally {
          Pe2(false);
        }
      }
    }
    return t3.memoizedState = t3.baseState = e6, t3.queue = { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: Ao2, lastRenderedState: e6 }, t3;
  }
  function Vo2(e6, t3, n3, r2) {
    return e6.baseState = n3, Mo2(e6, ao2, typeof r2 == "function" ? r2 : Ao2);
  }
  function Ho2(e6, t3, n3, r2, i3) {
    if (As2(e6)) throw Error(a2(485));
    if (e6 = t3.action, e6 !== null) {
      var o3 = { payload: i3, action: e6, next: null, isTransition: true, status: "pending", value: null, reason: null, listeners: [], then: function(e7) {
        o3.listeners.push(e7);
      } };
      P2.T === null ? o3.isTransition = false : n3(true), r2(o3), n3 = t3.pending, n3 === null ? (o3.next = t3.pending = o3, Uo2(t3, o3)) : (o3.next = n3.next, t3.pending = n3.next = o3);
    }
  }
  function Uo2(e6, t3) {
    var n3 = t3.action, r2 = t3.payload, i3 = e6.state;
    if (t3.isTransition) {
      var a3 = P2.T, o3 = {};
      P2.T = o3;
      try {
        var s3 = n3(i3, r2), c3 = P2.S;
        c3 !== null && c3(o3, s3), Wo2(e6, t3, s3);
      } catch (n4) {
        Ko2(e6, t3, n4);
      } finally {
        a3 !== null && o3.types !== null && (a3.types = o3.types), P2.T = a3;
      }
    } else try {
      a3 = n3(i3, r2), Wo2(e6, t3, a3);
    } catch (n4) {
      Ko2(e6, t3, n4);
    }
  }
  function Wo2(e6, t3, n3) {
    typeof n3 == "object" && n3 && typeof n3.then == "function" ? n3.then(function(n4) {
      Go2(e6, t3, n4);
    }, function(n4) {
      return Ko2(e6, t3, n4);
    }) : Go2(e6, t3, n3);
  }
  function Go2(e6, t3, n3) {
    t3.status = "fulfilled", t3.value = n3, qo2(t3), e6.state = n3, t3 = e6.pending, t3 !== null && (n3 = t3.next, n3 === t3 ? e6.pending = null : (n3 = n3.next, t3.next = n3, Uo2(e6, n3)));
  }
  function Ko2(e6, t3, n3) {
    var r2 = e6.pending;
    if (e6.pending = null, r2 !== null) {
      r2 = r2.next;
      do
        t3.status = "rejected", t3.reason = n3, qo2(t3), t3 = t3.next;
      while (t3 !== r2);
    }
    e6.action = null;
  }
  function qo2(e6) {
    e6 = e6.listeners;
    for (var t3 = 0; t3 < e6.length; t3++) (0, e6[t3])();
  }
  function Jo2(e6, t3) {
    return t3;
  }
  function Yo2(e6, t3) {
    if (q2) {
      var n3 = Il2.formState;
      if (n3 !== null) {
        a: {
          var r2 = J2;
          if (q2) {
            if (Ei2) {
              b: {
                for (var i3 = Ei2, a3 = Oi2; i3.nodeType !== 8; ) {
                  if (!a3) {
                    i3 = null;
                    break b;
                  }
                  if (i3 = cf(i3.nextSibling), i3 === null) {
                    i3 = null;
                    break b;
                  }
                }
                a3 = i3.data, i3 = a3 === "F!" || a3 === "F" ? i3 : null;
              }
              if (i3) {
                Ei2 = cf(i3.nextSibling), r2 = i3.data === "F!";
                break a;
              }
            }
            Ai2(r2);
          }
          r2 = false;
        }
        r2 && (t3 = n3[0]);
      }
    }
    return n3 = wo2(), n3.memoizedState = n3.baseState = t3, r2 = { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: Jo2, lastRenderedState: t3 }, n3.queue = r2, n3 = Ds2.bind(null, J2, r2), r2.dispatch = n3, r2 = Bo2(false), a3 = ks2.bind(null, J2, false, r2.queue), r2 = wo2(), i3 = { state: t3, dispatch: null, action: e6, pending: null }, r2.queue = i3, n3 = Ho2.bind(null, J2, i3, a3, n3), i3.dispatch = n3, r2.memoizedState = e6, [t3, n3, false];
  }
  function Xo2(e6) {
    return Zo2(To2(), ao2, e6);
  }
  function Zo2(e6, t3, n3) {
    if (t3 = Mo2(e6, t3, Jo2)[0], e6 = jo2(Ao2)[0], typeof t3 == "object" && t3 && typeof t3.then == "function") try {
      var r2 = Do2(t3);
    } catch (e7) {
      throw e7 === ma2 ? ga2 : e7;
    }
    else r2 = t3;
    t3 = To2();
    var i3 = t3.queue, a3 = i3.dispatch;
    return n3 !== t3.memoizedState && (J2.flags |= 2048, es2(9, { destroy: void 0 }, Qo2.bind(null, i3, n3), null)), [r2, a3, e6];
  }
  function Qo2(e6, t3) {
    e6.action = t3;
  }
  function $o2(e6) {
    var t3 = To2(), n3 = ao2;
    if (n3 !== null) return Zo2(t3, n3, e6);
    To2(), t3 = t3.memoizedState, n3 = To2();
    var r2 = n3.queue.dispatch;
    return n3.memoizedState = e6, [t3, r2, false];
  }
  function es2(e6, t3, n3, r2) {
    return e6 = { tag: e6, create: n3, deps: r2, inst: t3, next: null }, t3 = J2.updateQueue, t3 === null && (t3 = Eo2(), J2.updateQueue = t3), n3 = t3.lastEffect, n3 === null ? t3.lastEffect = e6.next = e6 : (r2 = n3.next, n3.next = e6, e6.next = r2, t3.lastEffect = e6), e6;
  }
  function ts2() {
    return To2().memoizedState;
  }
  function ns2(e6, t3, n3, r2) {
    var i3 = wo2();
    J2.flags |= e6, i3.memoizedState = es2(1 | t3, { destroy: void 0 }, n3, r2 === void 0 ? null : r2);
  }
  function rs2(e6, t3, n3, r2) {
    var i3 = To2();
    r2 = r2 === void 0 ? null : r2;
    var a3 = i3.memoizedState.inst;
    ao2 !== null && r2 !== null && go2(r2, ao2.memoizedState.deps) ? i3.memoizedState = es2(t3, a3, n3, r2) : (J2.flags |= e6, i3.memoizedState = es2(1 | t3, a3, n3, r2));
  }
  function is2(e6, t3) {
    ns2(8390656, 8, e6, t3);
  }
  function as2(e6, t3) {
    rs2(2048, 8, e6, t3);
  }
  function os2(e6) {
    J2.flags |= 4;
    var t3 = J2.updateQueue;
    if (t3 === null) t3 = Eo2(), J2.updateQueue = t3, t3.events = [e6];
    else {
      var n3 = t3.events;
      n3 === null ? t3.events = [e6] : n3.push(e6);
    }
  }
  function ss2(e6) {
    var t3 = To2().memoizedState;
    return os2({ ref: t3, nextImpl: e6 }), function() {
      if (Y2 & 2) throw Error(a2(440));
      return t3.impl.apply(void 0, arguments);
    };
  }
  function cs2(e6, t3) {
    return rs2(4, 2, e6, t3);
  }
  function ls2(e6, t3) {
    return rs2(4, 4, e6, t3);
  }
  function us2(e6, t3) {
    if (typeof t3 == "function") {
      e6 = e6();
      var n3 = t3(e6);
      return function() {
        typeof n3 == "function" ? n3() : t3(null);
      };
    }
    if (t3 != null) return e6 = e6(), t3.current = e6, function() {
      t3.current = null;
    };
  }
  function ds2(e6, t3, n3) {
    n3 = n3 == null ? null : n3.concat([e6]), rs2(4, 4, us2.bind(null, t3, e6), n3);
  }
  function fs2() {
  }
  function ps2(e6, t3) {
    var n3 = To2();
    t3 = t3 === void 0 ? null : t3;
    var r2 = n3.memoizedState;
    return t3 !== null && go2(t3, r2[1]) ? r2[0] : (n3.memoizedState = [e6, t3], e6);
  }
  function ms2(e6, t3) {
    var n3 = To2();
    t3 = t3 === void 0 ? null : t3;
    var r2 = n3.memoizedState;
    if (t3 !== null && go2(t3, r2[1])) return r2[0];
    if (r2 = e6(), lo2) {
      Pe2(true);
      try {
        e6();
      } finally {
        Pe2(false);
      }
    }
    return n3.memoizedState = [r2, t3], r2;
  }
  function hs2(e6, t3, n3) {
    return n3 === void 0 || io2 & 1073741824 && !(Z2 & 261930) ? e6.memoizedState = t3 : (e6.memoizedState = n3, e6 = fu(), J2.lanes |= e6, Ul2 |= e6, n3);
  }
  function gs2(e6, t3, n3, r2) {
    return mr2(n3, t3) ? n3 : Wa2.current === null ? !(io2 & 42) || io2 & 1073741824 && !(Z2 & 261930) ? (Qs2 = true, e6.memoizedState = n3) : (e6 = fu(), J2.lanes |= e6, Ul2 |= e6, t3) : (e6 = hs2(e6, n3, r2), mr2(e6, t3) || (Qs2 = true), e6);
  }
  function _s2(e6, t3, n3, r2, i3) {
    var a3 = F2.p;
    F2.p = a3 !== 0 && 8 > a3 ? a3 : 8;
    var o3 = P2.T, s3 = {};
    P2.T = s3, ks2(e6, false, t3, n3);
    try {
      var c3 = i3(), l3 = P2.S;
      l3 !== null && l3(s3, c3), typeof c3 == "object" && c3 && typeof c3.then == "function" ? Os2(e6, t3, ca2(c3, r2), du(e6)) : Os2(e6, t3, r2, du(e6));
    } catch (n4) {
      Os2(e6, t3, { then: function() {
      }, status: "rejected", reason: n4 }, du());
    } finally {
      F2.p = a3, o3 !== null && s3.types !== null && (o3.types = s3.types), P2.T = o3;
    }
  }
  function vs2() {
  }
  function ys2(e6, t3, n3, r2) {
    if (e6.tag !== 5) throw Error(a2(476));
    var i3 = bs2(e6).queue;
    _s2(e6, i3, t3, ee2, n3 === null ? vs2 : function() {
      return xs2(e6), n3(r2);
    });
  }
  function bs2(e6) {
    var t3 = e6.memoizedState;
    if (t3 !== null) return t3;
    t3 = { memoizedState: ee2, baseState: ee2, baseQueue: null, queue: { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: Ao2, lastRenderedState: ee2 }, next: null };
    var n3 = {};
    return t3.next = { memoizedState: n3, baseState: n3, baseQueue: null, queue: { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: Ao2, lastRenderedState: n3 }, next: null }, e6.memoizedState = t3, e6 = e6.alternate, e6 !== null && (e6.memoizedState = t3), t3;
  }
  function xs2(e6) {
    var t3 = bs2(e6);
    t3.next === null && (t3 = e6.alternate.memoizedState), Os2(e6, t3.next.queue, {}, du());
  }
  function Ss2() {
    return qi2(Qf);
  }
  function Cs2() {
    return To2().memoizedState;
  }
  function ws2() {
    return To2().memoizedState;
  }
  function Ts2(e6) {
    for (var t3 = e6.return; t3 !== null; ) {
      switch (t3.tag) {
        case 24:
        case 3:
          var n3 = du();
          e6 = Fa2(n3);
          var r2 = Ia2(t3, e6, n3);
          r2 !== null && (pu(r2, t3, n3), La2(r2, t3, n3)), t3 = { cache: ea2() }, e6.payload = t3;
          return;
      }
      t3 = t3.return;
    }
  }
  function Es2(e6, t3, n3) {
    var r2 = du();
    n3 = { lane: r2, revertLane: 0, gesture: null, action: n3, hasEagerState: false, eagerState: null, next: null }, As2(e6) ? js2(t3, n3) : (n3 = Jr2(e6, t3, n3, r2), n3 !== null && (pu(n3, e6, r2), Ms2(n3, t3, r2)));
  }
  function Ds2(e6, t3, n3) {
    Os2(e6, t3, n3, du());
  }
  function Os2(e6, t3, n3, r2) {
    var i3 = { lane: r2, revertLane: 0, gesture: null, action: n3, hasEagerState: false, eagerState: null, next: null };
    if (As2(e6)) js2(t3, i3);
    else {
      var a3 = e6.alternate;
      if (e6.lanes === 0 && (a3 === null || a3.lanes === 0) && (a3 = t3.lastRenderedReducer, a3 !== null)) try {
        var o3 = t3.lastRenderedState, s3 = a3(o3, n3);
        if (i3.hasEagerState = true, i3.eagerState = s3, mr2(s3, o3)) return qr2(e6, t3, i3, 0), Il2 === null && Kr2(), false;
      } catch {
      }
      if (n3 = Jr2(e6, t3, i3, r2), n3 !== null) return pu(n3, e6, r2), Ms2(n3, t3, r2), true;
    }
    return false;
  }
  function ks2(e6, t3, n3, r2) {
    if (r2 = { lane: 2, revertLane: ud(), gesture: null, action: r2, hasEagerState: false, eagerState: null, next: null }, As2(e6)) {
      if (t3) throw Error(a2(479));
    } else t3 = Jr2(e6, n3, r2, 2), t3 !== null && pu(t3, e6, 2);
  }
  function As2(e6) {
    var t3 = e6.alternate;
    return e6 === J2 || t3 !== null && t3 === J2;
  }
  function js2(e6, t3) {
    co2 = so2 = true;
    var n3 = e6.pending;
    n3 === null ? t3.next = t3 : (t3.next = n3.next, n3.next = t3), e6.pending = t3;
  }
  function Ms2(e6, t3, n3) {
    if (n3 & 4194048) {
      var r2 = t3.lanes;
      r2 &= e6.pendingLanes, n3 |= r2, t3.lanes = n3, Xe2(e6, n3);
    }
  }
  var Ns2 = { readContext: qi2, use: Oo2, useCallback: ho2, useContext: ho2, useEffect: ho2, useImperativeHandle: ho2, useLayoutEffect: ho2, useInsertionEffect: ho2, useMemo: ho2, useReducer: ho2, useRef: ho2, useState: ho2, useDebugValue: ho2, useDeferredValue: ho2, useTransition: ho2, useSyncExternalStore: ho2, useId: ho2, useHostTransitionStatus: ho2, useFormState: ho2, useActionState: ho2, useOptimistic: ho2, useMemoCache: ho2, useCacheRefresh: ho2 };
  Ns2.useEffectEvent = ho2;
  var Ps2 = { readContext: qi2, use: Oo2, useCallback: function(e6, t3) {
    return wo2().memoizedState = [e6, t3 === void 0 ? null : t3], e6;
  }, useContext: qi2, useEffect: is2, useImperativeHandle: function(e6, t3, n3) {
    n3 = n3 == null ? null : n3.concat([e6]), ns2(4194308, 4, us2.bind(null, t3, e6), n3);
  }, useLayoutEffect: function(e6, t3) {
    return ns2(4194308, 4, e6, t3);
  }, useInsertionEffect: function(e6, t3) {
    ns2(4, 2, e6, t3);
  }, useMemo: function(e6, t3) {
    var n3 = wo2();
    t3 = t3 === void 0 ? null : t3;
    var r2 = e6();
    if (lo2) {
      Pe2(true);
      try {
        e6();
      } finally {
        Pe2(false);
      }
    }
    return n3.memoizedState = [r2, t3], r2;
  }, useReducer: function(e6, t3, n3) {
    var r2 = wo2();
    if (n3 !== void 0) {
      var i3 = n3(t3);
      if (lo2) {
        Pe2(true);
        try {
          n3(t3);
        } finally {
          Pe2(false);
        }
      }
    } else i3 = t3;
    return r2.memoizedState = r2.baseState = i3, e6 = { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: e6, lastRenderedState: i3 }, r2.queue = e6, e6 = e6.dispatch = Es2.bind(null, J2, e6), [r2.memoizedState, e6];
  }, useRef: function(e6) {
    var t3 = wo2();
    return e6 = { current: e6 }, t3.memoizedState = e6;
  }, useState: function(e6) {
    e6 = Bo2(e6);
    var t3 = e6.queue, n3 = Ds2.bind(null, J2, t3);
    return t3.dispatch = n3, [e6.memoizedState, n3];
  }, useDebugValue: fs2, useDeferredValue: function(e6, t3) {
    return hs2(wo2(), e6, t3);
  }, useTransition: function() {
    var e6 = Bo2(false);
    return e6 = _s2.bind(null, J2, e6.queue, true, false), wo2().memoizedState = e6, [false, e6];
  }, useSyncExternalStore: function(e6, t3, n3) {
    var r2 = J2, i3 = wo2();
    if (q2) {
      if (n3 === void 0) throw Error(a2(407));
      n3 = n3();
    } else {
      if (n3 = t3(), Il2 === null) throw Error(a2(349));
      Z2 & 127 || Fo2(r2, t3, n3);
    }
    i3.memoizedState = n3;
    var o3 = { value: n3, getSnapshot: t3 };
    return i3.queue = o3, is2(Lo2.bind(null, r2, o3, e6), [e6]), r2.flags |= 2048, es2(9, { destroy: void 0 }, Io2.bind(null, r2, o3, n3, t3), null), n3;
  }, useId: function() {
    var e6 = wo2(), t3 = Il2.identifierPrefix;
    if (q2) {
      var n3 = yi2, r2 = vi2;
      n3 = (r2 & ~(1 << 32 - Fe2(r2) - 1)).toString(32) + n3, t3 = "_" + t3 + "R_" + n3, n3 = uo2++, 0 < n3 && (t3 += "H" + n3.toString(32)), t3 += "_";
    } else n3 = mo2++, t3 = "_" + t3 + "r_" + n3.toString(32) + "_";
    return e6.memoizedState = t3;
  }, useHostTransitionStatus: Ss2, useFormState: Yo2, useActionState: Yo2, useOptimistic: function(e6) {
    var t3 = wo2();
    t3.memoizedState = t3.baseState = e6;
    var n3 = { pending: null, lanes: 0, dispatch: null, lastRenderedReducer: null, lastRenderedState: null };
    return t3.queue = n3, t3 = ks2.bind(null, J2, true, n3), n3.dispatch = t3, [e6, t3];
  }, useMemoCache: ko2, useCacheRefresh: function() {
    return wo2().memoizedState = Ts2.bind(null, J2);
  }, useEffectEvent: function(e6) {
    var t3 = wo2(), n3 = { impl: e6 };
    return t3.memoizedState = n3, function() {
      if (Y2 & 2) throw Error(a2(440));
      return n3.impl.apply(void 0, arguments);
    };
  } }, Fs2 = { readContext: qi2, use: Oo2, useCallback: ps2, useContext: qi2, useEffect: as2, useImperativeHandle: ds2, useInsertionEffect: cs2, useLayoutEffect: ls2, useMemo: ms2, useReducer: jo2, useRef: ts2, useState: function() {
    return jo2(Ao2);
  }, useDebugValue: fs2, useDeferredValue: function(e6, t3) {
    return gs2(To2(), ao2.memoizedState, e6, t3);
  }, useTransition: function() {
    var e6 = jo2(Ao2)[0], t3 = To2().memoizedState;
    return [typeof e6 == "boolean" ? e6 : Do2(e6), t3];
  }, useSyncExternalStore: Po2, useId: Cs2, useHostTransitionStatus: Ss2, useFormState: Xo2, useActionState: Xo2, useOptimistic: function(e6, t3) {
    return Vo2(To2(), ao2, e6, t3);
  }, useMemoCache: ko2, useCacheRefresh: ws2 };
  Fs2.useEffectEvent = ss2;
  var Is2 = { readContext: qi2, use: Oo2, useCallback: ps2, useContext: qi2, useEffect: as2, useImperativeHandle: ds2, useInsertionEffect: cs2, useLayoutEffect: ls2, useMemo: ms2, useReducer: No2, useRef: ts2, useState: function() {
    return No2(Ao2);
  }, useDebugValue: fs2, useDeferredValue: function(e6, t3) {
    var n3 = To2();
    return ao2 === null ? hs2(n3, e6, t3) : gs2(n3, ao2.memoizedState, e6, t3);
  }, useTransition: function() {
    var e6 = No2(Ao2)[0], t3 = To2().memoizedState;
    return [typeof e6 == "boolean" ? e6 : Do2(e6), t3];
  }, useSyncExternalStore: Po2, useId: Cs2, useHostTransitionStatus: Ss2, useFormState: $o2, useActionState: $o2, useOptimistic: function(e6, t3) {
    var n3 = To2();
    return ao2 === null ? (n3.baseState = e6, [e6, n3.queue.dispatch]) : Vo2(n3, ao2, e6, t3);
  }, useMemoCache: ko2, useCacheRefresh: ws2 };
  Is2.useEffectEvent = ss2;
  function Ls2(e6, t3, n3, r2) {
    t3 = e6.memoizedState, n3 = n3(r2, t3), n3 = n3 == null ? t3 : p2({}, t3, n3), e6.memoizedState = n3, e6.lanes === 0 && (e6.updateQueue.baseState = n3);
  }
  var Rs2 = { enqueueSetState: function(e6, t3, n3) {
    e6 = e6._reactInternals;
    var r2 = du(), i3 = Fa2(r2);
    i3.payload = t3, n3 != null && (i3.callback = n3), t3 = Ia2(e6, i3, r2), t3 !== null && (pu(t3, e6, r2), La2(t3, e6, r2));
  }, enqueueReplaceState: function(e6, t3, n3) {
    e6 = e6._reactInternals;
    var r2 = du(), i3 = Fa2(r2);
    i3.tag = 1, i3.payload = t3, n3 != null && (i3.callback = n3), t3 = Ia2(e6, i3, r2), t3 !== null && (pu(t3, e6, r2), La2(t3, e6, r2));
  }, enqueueForceUpdate: function(e6, t3) {
    e6 = e6._reactInternals;
    var n3 = du(), r2 = Fa2(n3);
    r2.tag = 2, t3 != null && (r2.callback = t3), t3 = Ia2(e6, r2, n3), t3 !== null && (pu(t3, e6, n3), La2(t3, e6, n3));
  } };
  function zs2(e6, t3, n3, r2, i3, a3, o3) {
    return e6 = e6.stateNode, typeof e6.shouldComponentUpdate == "function" ? e6.shouldComponentUpdate(r2, a3, o3) : t3.prototype && t3.prototype.isPureReactComponent ? !hr2(n3, r2) || !hr2(i3, a3) : true;
  }
  function Bs2(e6, t3, n3, r2) {
    e6 = t3.state, typeof t3.componentWillReceiveProps == "function" && t3.componentWillReceiveProps(n3, r2), typeof t3.UNSAFE_componentWillReceiveProps == "function" && t3.UNSAFE_componentWillReceiveProps(n3, r2), t3.state !== e6 && Rs2.enqueueReplaceState(t3, t3.state, null);
  }
  function Vs2(e6, t3) {
    var n3 = t3;
    if ("ref" in t3) for (var r2 in n3 = {}, t3) r2 !== "ref" && (n3[r2] = t3[r2]);
    if (e6 = e6.defaultProps) for (var i3 in n3 === t3 && (n3 = p2({}, n3)), e6) n3[i3] === void 0 && (n3[i3] = e6[i3]);
    return n3;
  }
  function Hs2(e6) {
    Hr2(e6);
  }
  function Us2(e6) {
    console.error(e6);
  }
  function Ws2(e6) {
    Hr2(e6);
  }
  function Gs2(e6, t3) {
    try {
      var n3 = e6.onUncaughtError;
      n3(t3.value, { componentStack: t3.stack });
    } catch (e7) {
      setTimeout(function() {
        throw e7;
      });
    }
  }
  function Ks2(e6, t3, n3) {
    try {
      var r2 = e6.onCaughtError;
      r2(n3.value, { componentStack: n3.stack, errorBoundary: t3.tag === 1 ? t3.stateNode : null });
    } catch (e7) {
      setTimeout(function() {
        throw e7;
      });
    }
  }
  function qs2(e6, t3, n3) {
    return n3 = Fa2(n3), n3.tag = 3, n3.payload = { element: null }, n3.callback = function() {
      Gs2(e6, t3);
    }, n3;
  }
  function Js2(e6) {
    return e6 = Fa2(e6), e6.tag = 3, e6;
  }
  function Ys2(e6, t3, n3, r2) {
    var i3 = n3.type.getDerivedStateFromError;
    if (typeof i3 == "function") {
      var a3 = r2.value;
      e6.payload = function() {
        return i3(a3);
      }, e6.callback = function() {
        Ks2(t3, n3, r2);
      };
    }
    var o3 = n3.stateNode;
    o3 !== null && typeof o3.componentDidCatch == "function" && (e6.callback = function() {
      Ks2(t3, n3, r2), typeof i3 != "function" && (tu === null ? tu = /* @__PURE__ */ new Set([this]) : tu.add(this));
      var e7 = r2.stack;
      this.componentDidCatch(r2.value, { componentStack: e7 === null ? "" : e7 });
    });
  }
  function Xs2(e6, t3, n3, r2, i3) {
    if (n3.flags |= 32768, typeof r2 == "object" && r2 && typeof r2.then == "function") {
      if (t3 = n3.alternate, t3 !== null && Wi2(t3, n3, i3, true), n3 = Ya2.current, n3 !== null) {
        switch (n3.tag) {
          case 31:
          case 13:
            return Xa2 === null ? Tu() : n3.alternate === null && Hl2 === 0 && (Hl2 = 3), n3.flags &= -257, n3.flags |= 65536, n3.lanes = i3, r2 === _a2 ? n3.flags |= 16384 : (t3 = n3.updateQueue, t3 === null ? n3.updateQueue = /* @__PURE__ */ new Set([r2]) : t3.add(r2), Wu(e6, r2, i3)), false;
          case 22:
            return n3.flags |= 65536, r2 === _a2 ? n3.flags |= 16384 : (t3 = n3.updateQueue, t3 === null ? (t3 = { transitions: null, markerInstances: null, retryQueue: /* @__PURE__ */ new Set([r2]) }, n3.updateQueue = t3) : (n3 = t3.retryQueue, n3 === null ? t3.retryQueue = /* @__PURE__ */ new Set([r2]) : n3.add(r2)), Wu(e6, r2, i3)), false;
        }
        throw Error(a2(435, n3.tag));
      }
      return Wu(e6, r2, i3), Tu(), false;
    }
    if (q2) return t3 = Ya2.current, t3 === null ? (r2 !== ki2 && (t3 = Error(a2(423), { cause: r2 }), Ii2(ui2(t3, n3))), e6 = e6.current.alternate, e6.flags |= 65536, i3 &= -i3, e6.lanes |= i3, r2 = ui2(r2, n3), i3 = qs2(e6.stateNode, r2, i3), Ra2(e6, i3), Hl2 !== 4 && (Hl2 = 2)) : (!(t3.flags & 65536) && (t3.flags |= 256), t3.flags |= 65536, t3.lanes = i3, r2 !== ki2 && (e6 = Error(a2(422), { cause: r2 }), Ii2(ui2(e6, n3)))), false;
    var o3 = Error(a2(520), { cause: r2 });
    if (o3 = ui2(o3, n3), Jl === null ? Jl = [o3] : Jl.push(o3), Hl2 !== 4 && (Hl2 = 2), t3 === null) return true;
    r2 = ui2(r2, n3), n3 = t3;
    do {
      switch (n3.tag) {
        case 3:
          return n3.flags |= 65536, e6 = i3 & -i3, n3.lanes |= e6, e6 = qs2(n3.stateNode, r2, e6), Ra2(n3, e6), false;
        case 1:
          if (t3 = n3.type, o3 = n3.stateNode, !(n3.flags & 128) && (typeof t3.getDerivedStateFromError == "function" || o3 !== null && typeof o3.componentDidCatch == "function" && (tu === null || !tu.has(o3)))) return n3.flags |= 65536, i3 &= -i3, n3.lanes |= i3, i3 = Js2(i3), Ys2(i3, e6, n3, r2), Ra2(n3, i3), false;
      }
      n3 = n3.return;
    } while (n3 !== null);
    return false;
  }
  var Zs2 = Error(a2(461)), Qs2 = false;
  function $s2(e6, t3, n3, r2) {
    t3.child = e6 === null ? ja2(t3, null, n3, r2) : Aa2(t3, e6.child, n3, r2);
  }
  function ec2(e6, t3, n3, r2, i3) {
    n3 = n3.render;
    var a3 = t3.ref;
    if ("ref" in r2) {
      var o3 = {};
      for (var s3 in r2) s3 !== "ref" && (o3[s3] = r2[s3]);
    } else o3 = r2;
    return Ki2(t3), r2 = _o2(e6, t3, n3, o3, a3, i3), s3 = xo2(), e6 !== null && !Qs2 ? (So2(e6, t3, i3), wc2(e6, t3, i3)) : (q2 && s3 && Si2(t3), t3.flags |= 1, $s2(e6, t3, r2, i3), t3.child);
  }
  function tc2(e6, t3, n3, r2, i3) {
    if (e6 === null) {
      var a3 = n3.type;
      return typeof a3 == "function" && !ti2(a3) && a3.defaultProps === void 0 && n3.compare === null ? (t3.tag = 15, t3.type = a3, nc2(e6, t3, a3, r2, i3)) : (e6 = ii2(n3.type, null, r2, t3, t3.mode, i3), e6.ref = t3.ref, e6.return = t3, t3.child = e6);
    }
    if (a3 = e6.child, !Tc2(e6, i3)) {
      var o3 = a3.memoizedProps;
      if (n3 = n3.compare, n3 = n3 === null ? hr2 : n3, n3(o3, r2) && e6.ref === t3.ref) return wc2(e6, t3, i3);
    }
    return t3.flags |= 1, e6 = ni2(a3, r2), e6.ref = t3.ref, e6.return = t3, t3.child = e6;
  }
  function nc2(e6, t3, n3, r2, i3) {
    if (e6 !== null) {
      var a3 = e6.memoizedProps;
      if (hr2(a3, r2) && e6.ref === t3.ref) if (Qs2 = false, t3.pendingProps = r2 = a3, Tc2(e6, i3)) e6.flags & 131072 && (Qs2 = true);
      else return t3.lanes = e6.lanes, wc2(e6, t3, i3);
    }
    return uc2(e6, t3, n3, r2, i3);
  }
  function rc2(e6, t3, n3, r2) {
    var i3 = r2.children, a3 = e6 === null ? null : e6.memoizedState;
    if (e6 === null && t3.stateNode === null && (t3.stateNode = { _visibility: 1, _pendingMarkers: null, _retryCache: null, _transitions: null }), r2.mode === "hidden") {
      if (t3.flags & 128) {
        if (a3 = a3 === null ? n3 : a3.baseLanes | n3, e6 !== null) {
          for (r2 = t3.child = e6.child, i3 = 0; r2 !== null; ) i3 = i3 | r2.lanes | r2.childLanes, r2 = r2.sibling;
          r2 = i3 & ~a3;
        } else r2 = 0, t3.child = null;
        return ac2(e6, t3, a3, n3, r2);
      }
      if (n3 & 536870912) t3.memoizedState = { baseLanes: 0, cachePool: null }, e6 !== null && fa2(t3, a3 === null ? null : a3.cachePool), a3 === null ? qa2() : Ka2(t3, a3), $a2(t3);
      else return r2 = t3.lanes = 536870912, ac2(e6, t3, a3 === null ? n3 : a3.baseLanes | n3, n3, r2);
    } else a3 === null ? (e6 !== null && fa2(t3, null), qa2(), eo2(t3)) : (fa2(t3, a3.cachePool), Ka2(t3, a3), eo2(t3), t3.memoizedState = null);
    return $s2(e6, t3, i3, n3), t3.child;
  }
  function ic2(e6, t3) {
    return e6 !== null && e6.tag === 22 || t3.stateNode !== null || (t3.stateNode = { _visibility: 1, _pendingMarkers: null, _retryCache: null, _transitions: null }), t3.sibling;
  }
  function ac2(e6, t3, n3, r2, i3) {
    var a3 = da2();
    return a3 = a3 === null ? null : { parent: $i2._currentValue, pool: a3 }, t3.memoizedState = { baseLanes: n3, cachePool: a3 }, e6 !== null && fa2(t3, null), qa2(), $a2(t3), e6 !== null && Wi2(e6, t3, r2, true), t3.childLanes = i3, null;
  }
  function oc2(e6, t3) {
    return t3 = yc2({ mode: t3.mode, children: t3.children }, e6.mode), t3.ref = e6.ref, e6.child = t3, t3.return = e6, t3;
  }
  function sc2(e6, t3, n3) {
    return Aa2(t3, e6.child, null, n3), e6 = oc2(t3, t3.pendingProps), e6.flags |= 2, to2(t3), t3.memoizedState = null, e6;
  }
  function cc2(e6, t3, n3) {
    var r2 = t3.pendingProps, i3 = (t3.flags & 128) != 0;
    if (t3.flags &= -129, e6 === null) {
      if (q2) {
        if (r2.mode === "hidden") return e6 = oc2(t3, r2), t3.lanes = 536870912, ic2(null, e6);
        if (Qa2(t3), (e6 = Ei2) ? (e6 = rf(e6, Oi2), e6 = e6 !== null && e6.data === "&" ? e6 : null, e6 !== null && (t3.memoizedState = { dehydrated: e6, treeContext: _i2 === null ? null : { id: vi2, overflow: yi2 }, retryLane: 536870912, hydrationErrors: null }, n3 = si2(e6), n3.return = t3, t3.child = n3, Ti2 = t3, Ei2 = null)) : e6 = null, e6 === null) throw Ai2(t3);
        return t3.lanes = 536870912, null;
      }
      return oc2(t3, r2);
    }
    var o3 = e6.memoizedState;
    if (o3 !== null) {
      var s3 = o3.dehydrated;
      if (Qa2(t3), i3) if (t3.flags & 256) t3.flags &= -257, t3 = sc2(e6, t3, n3);
      else if (t3.memoizedState !== null) t3.child = e6.child, t3.flags |= 128, t3 = null;
      else throw Error(a2(558));
      else if (Qs2 || Wi2(e6, t3, n3, false), i3 = (n3 & e6.childLanes) !== 0, Qs2 || i3) {
        if (r2 = Il2, r2 !== null && (s3 = Ze2(r2, n3), s3 !== 0 && s3 !== o3.retryLane)) throw o3.retryLane = s3, Yr2(e6, s3), pu(r2, e6, s3), Zs2;
        Tu(), t3 = sc2(e6, t3, n3);
      } else e6 = o3.treeContext, Ei2 = cf(s3.nextSibling), Ti2 = t3, q2 = true, Di2 = null, Oi2 = false, e6 !== null && wi2(t3, e6), t3 = oc2(t3, r2), t3.flags |= 4096;
      return t3;
    }
    return e6 = ni2(e6.child, { mode: r2.mode, children: r2.children }), e6.ref = t3.ref, t3.child = e6, e6.return = t3, e6;
  }
  function lc2(e6, t3) {
    var n3 = t3.ref;
    if (n3 === null) e6 !== null && e6.ref !== null && (t3.flags |= 4194816);
    else {
      if (typeof n3 != "function" && typeof n3 != "object") throw Error(a2(284));
      (e6 === null || e6.ref !== n3) && (t3.flags |= 4194816);
    }
  }
  function uc2(e6, t3, n3, r2, i3) {
    return Ki2(t3), n3 = _o2(e6, t3, n3, r2, void 0, i3), r2 = xo2(), e6 !== null && !Qs2 ? (So2(e6, t3, i3), wc2(e6, t3, i3)) : (q2 && r2 && Si2(t3), t3.flags |= 1, $s2(e6, t3, n3, i3), t3.child);
  }
  function dc2(e6, t3, n3, r2, i3, a3) {
    return Ki2(t3), t3.updateQueue = null, n3 = yo2(t3, r2, n3, i3), vo2(e6), r2 = xo2(), e6 !== null && !Qs2 ? (So2(e6, t3, a3), wc2(e6, t3, a3)) : (q2 && r2 && Si2(t3), t3.flags |= 1, $s2(e6, t3, n3, a3), t3.child);
  }
  function fc2(e6, t3, n3, r2, i3) {
    if (Ki2(t3), t3.stateNode === null) {
      var a3 = Qr2, o3 = n3.contextType;
      typeof o3 == "object" && o3 && (a3 = qi2(o3)), a3 = new n3(r2, a3), t3.memoizedState = a3.state !== null && a3.state !== void 0 ? a3.state : null, a3.updater = Rs2, t3.stateNode = a3, a3._reactInternals = t3, a3 = t3.stateNode, a3.props = r2, a3.state = t3.memoizedState, a3.refs = {}, Na2(t3), o3 = n3.contextType, a3.context = typeof o3 == "object" && o3 ? qi2(o3) : Qr2, a3.state = t3.memoizedState, o3 = n3.getDerivedStateFromProps, typeof o3 == "function" && (Ls2(t3, n3, o3, r2), a3.state = t3.memoizedState), typeof n3.getDerivedStateFromProps == "function" || typeof a3.getSnapshotBeforeUpdate == "function" || typeof a3.UNSAFE_componentWillMount != "function" && typeof a3.componentWillMount != "function" || (o3 = a3.state, typeof a3.componentWillMount == "function" && a3.componentWillMount(), typeof a3.UNSAFE_componentWillMount == "function" && a3.UNSAFE_componentWillMount(), o3 !== a3.state && Rs2.enqueueReplaceState(a3, a3.state, null), Va2(t3, r2, a3, i3), Ba2(), a3.state = t3.memoizedState), typeof a3.componentDidMount == "function" && (t3.flags |= 4194308), r2 = true;
    } else if (e6 === null) {
      a3 = t3.stateNode;
      var s3 = t3.memoizedProps, c3 = Vs2(n3, s3);
      a3.props = c3;
      var l3 = a3.context, u3 = n3.contextType;
      o3 = Qr2, typeof u3 == "object" && u3 && (o3 = qi2(u3));
      var d3 = n3.getDerivedStateFromProps;
      u3 = typeof d3 == "function" || typeof a3.getSnapshotBeforeUpdate == "function", s3 = t3.pendingProps !== s3, u3 || typeof a3.UNSAFE_componentWillReceiveProps != "function" && typeof a3.componentWillReceiveProps != "function" || (s3 || l3 !== o3) && Bs2(t3, a3, r2, o3), Ma2 = false;
      var f3 = t3.memoizedState;
      a3.state = f3, Va2(t3, r2, a3, i3), Ba2(), l3 = t3.memoizedState, s3 || f3 !== l3 || Ma2 ? (typeof d3 == "function" && (Ls2(t3, n3, d3, r2), l3 = t3.memoizedState), (c3 = Ma2 || zs2(t3, n3, c3, r2, f3, l3, o3)) ? (u3 || typeof a3.UNSAFE_componentWillMount != "function" && typeof a3.componentWillMount != "function" || (typeof a3.componentWillMount == "function" && a3.componentWillMount(), typeof a3.UNSAFE_componentWillMount == "function" && a3.UNSAFE_componentWillMount()), typeof a3.componentDidMount == "function" && (t3.flags |= 4194308)) : (typeof a3.componentDidMount == "function" && (t3.flags |= 4194308), t3.memoizedProps = r2, t3.memoizedState = l3), a3.props = r2, a3.state = l3, a3.context = o3, r2 = c3) : (typeof a3.componentDidMount == "function" && (t3.flags |= 4194308), r2 = false);
    } else {
      a3 = t3.stateNode, Pa2(e6, t3), o3 = t3.memoizedProps, u3 = Vs2(n3, o3), a3.props = u3, d3 = t3.pendingProps, f3 = a3.context, l3 = n3.contextType, c3 = Qr2, typeof l3 == "object" && l3 && (c3 = qi2(l3)), s3 = n3.getDerivedStateFromProps, (l3 = typeof s3 == "function" || typeof a3.getSnapshotBeforeUpdate == "function") || typeof a3.UNSAFE_componentWillReceiveProps != "function" && typeof a3.componentWillReceiveProps != "function" || (o3 !== d3 || f3 !== c3) && Bs2(t3, a3, r2, c3), Ma2 = false, f3 = t3.memoizedState, a3.state = f3, Va2(t3, r2, a3, i3), Ba2();
      var p3 = t3.memoizedState;
      o3 !== d3 || f3 !== p3 || Ma2 || e6 !== null && e6.dependencies !== null && Gi2(e6.dependencies) ? (typeof s3 == "function" && (Ls2(t3, n3, s3, r2), p3 = t3.memoizedState), (u3 = Ma2 || zs2(t3, n3, u3, r2, f3, p3, c3) || e6 !== null && e6.dependencies !== null && Gi2(e6.dependencies)) ? (l3 || typeof a3.UNSAFE_componentWillUpdate != "function" && typeof a3.componentWillUpdate != "function" || (typeof a3.componentWillUpdate == "function" && a3.componentWillUpdate(r2, p3, c3), typeof a3.UNSAFE_componentWillUpdate == "function" && a3.UNSAFE_componentWillUpdate(r2, p3, c3)), typeof a3.componentDidUpdate == "function" && (t3.flags |= 4), typeof a3.getSnapshotBeforeUpdate == "function" && (t3.flags |= 1024)) : (typeof a3.componentDidUpdate != "function" || o3 === e6.memoizedProps && f3 === e6.memoizedState || (t3.flags |= 4), typeof a3.getSnapshotBeforeUpdate != "function" || o3 === e6.memoizedProps && f3 === e6.memoizedState || (t3.flags |= 1024), t3.memoizedProps = r2, t3.memoizedState = p3), a3.props = r2, a3.state = p3, a3.context = c3, r2 = u3) : (typeof a3.componentDidUpdate != "function" || o3 === e6.memoizedProps && f3 === e6.memoizedState || (t3.flags |= 4), typeof a3.getSnapshotBeforeUpdate != "function" || o3 === e6.memoizedProps && f3 === e6.memoizedState || (t3.flags |= 1024), r2 = false);
    }
    return a3 = r2, lc2(e6, t3), r2 = (t3.flags & 128) != 0, a3 || r2 ? (a3 = t3.stateNode, n3 = r2 && typeof n3.getDerivedStateFromError != "function" ? null : a3.render(), t3.flags |= 1, e6 !== null && r2 ? (t3.child = Aa2(t3, e6.child, null, i3), t3.child = Aa2(t3, null, n3, i3)) : $s2(e6, t3, n3, i3), t3.memoizedState = a3.state, e6 = t3.child) : e6 = wc2(e6, t3, i3), e6;
  }
  function pc2(e6, t3, n3, r2) {
    return Pi2(), t3.flags |= 256, $s2(e6, t3, n3, r2), t3.child;
  }
  var mc2 = { dehydrated: null, treeContext: null, retryLane: 0, hydrationErrors: null };
  function hc2(e6) {
    return { baseLanes: e6, cachePool: pa2() };
  }
  function gc2(e6, t3, n3) {
    return e6 = e6 === null ? 0 : e6.childLanes & ~n3, t3 && (e6 |= Kl), e6;
  }
  function _c2(e6, t3, n3) {
    var r2 = t3.pendingProps, i3 = false, o3 = (t3.flags & 128) != 0, s3;
    if ((s3 = o3) || (s3 = e6 !== null && e6.memoizedState === null ? false : (no2.current & 2) != 0), s3 && (i3 = true, t3.flags &= -129), s3 = (t3.flags & 32) != 0, t3.flags &= -33, e6 === null) {
      if (q2) {
        if (i3 ? Za2(t3) : eo2(t3), (e6 = Ei2) ? (e6 = rf(e6, Oi2), e6 = e6 !== null && e6.data !== "&" ? e6 : null, e6 !== null && (t3.memoizedState = { dehydrated: e6, treeContext: _i2 === null ? null : { id: vi2, overflow: yi2 }, retryLane: 536870912, hydrationErrors: null }, n3 = si2(e6), n3.return = t3, t3.child = n3, Ti2 = t3, Ei2 = null)) : e6 = null, e6 === null) throw Ai2(t3);
        return of(e6) ? t3.lanes = 32 : t3.lanes = 536870912, null;
      }
      var c3 = r2.children;
      return r2 = r2.fallback, i3 ? (eo2(t3), i3 = t3.mode, c3 = yc2({ mode: "hidden", children: c3 }, i3), r2 = ai2(r2, i3, n3, null), c3.return = t3, r2.return = t3, c3.sibling = r2, t3.child = c3, r2 = t3.child, r2.memoizedState = hc2(n3), r2.childLanes = gc2(e6, s3, n3), t3.memoizedState = mc2, ic2(null, r2)) : (Za2(t3), vc2(t3, c3));
    }
    var l3 = e6.memoizedState;
    if (l3 !== null && (c3 = l3.dehydrated, c3 !== null)) {
      if (o3) t3.flags & 256 ? (Za2(t3), t3.flags &= -257, t3 = bc2(e6, t3, n3)) : t3.memoizedState === null ? (eo2(t3), c3 = r2.fallback, i3 = t3.mode, r2 = yc2({ mode: "visible", children: r2.children }, i3), c3 = ai2(c3, i3, n3, null), c3.flags |= 2, r2.return = t3, c3.return = t3, r2.sibling = c3, t3.child = r2, Aa2(t3, e6.child, null, n3), r2 = t3.child, r2.memoizedState = hc2(n3), r2.childLanes = gc2(e6, s3, n3), t3.memoizedState = mc2, t3 = ic2(null, r2)) : (eo2(t3), t3.child = e6.child, t3.flags |= 128, t3 = null);
      else if (Za2(t3), of(c3)) {
        if (s3 = c3.nextSibling && c3.nextSibling.dataset, s3) var u3 = s3.dgst;
        s3 = u3, r2 = Error(a2(419)), r2.stack = "", r2.digest = s3, Ii2({ value: r2, source: null, stack: null }), t3 = bc2(e6, t3, n3);
      } else if (Qs2 || Wi2(e6, t3, n3, false), s3 = (n3 & e6.childLanes) !== 0, Qs2 || s3) {
        if (s3 = Il2, s3 !== null && (r2 = Ze2(s3, n3), r2 !== 0 && r2 !== l3.retryLane)) throw l3.retryLane = r2, Yr2(e6, r2), pu(s3, e6, r2), Zs2;
        af(c3) || Tu(), t3 = bc2(e6, t3, n3);
      } else af(c3) ? (t3.flags |= 192, t3.child = e6.child, t3 = null) : (e6 = l3.treeContext, Ei2 = cf(c3.nextSibling), Ti2 = t3, q2 = true, Di2 = null, Oi2 = false, e6 !== null && wi2(t3, e6), t3 = vc2(t3, r2.children), t3.flags |= 4096);
      return t3;
    }
    return i3 ? (eo2(t3), c3 = r2.fallback, i3 = t3.mode, l3 = e6.child, u3 = l3.sibling, r2 = ni2(l3, { mode: "hidden", children: r2.children }), r2.subtreeFlags = l3.subtreeFlags & 65011712, u3 === null ? (c3 = ai2(c3, i3, n3, null), c3.flags |= 2) : c3 = ni2(u3, c3), c3.return = t3, r2.return = t3, r2.sibling = c3, t3.child = r2, ic2(null, r2), r2 = t3.child, c3 = e6.child.memoizedState, c3 === null ? c3 = hc2(n3) : (i3 = c3.cachePool, i3 === null ? i3 = pa2() : (l3 = $i2._currentValue, i3 = i3.parent === l3 ? i3 : { parent: l3, pool: l3 }), c3 = { baseLanes: c3.baseLanes | n3, cachePool: i3 }), r2.memoizedState = c3, r2.childLanes = gc2(e6, s3, n3), t3.memoizedState = mc2, ic2(e6.child, r2)) : (Za2(t3), n3 = e6.child, e6 = n3.sibling, n3 = ni2(n3, { mode: "visible", children: r2.children }), n3.return = t3, n3.sibling = null, e6 !== null && (s3 = t3.deletions, s3 === null ? (t3.deletions = [e6], t3.flags |= 16) : s3.push(e6)), t3.child = n3, t3.memoizedState = null, n3);
  }
  function vc2(e6, t3) {
    return t3 = yc2({ mode: "visible", children: t3 }, e6.mode), t3.return = e6, e6.child = t3;
  }
  function yc2(e6, t3) {
    return e6 = ei2(22, e6, null, t3), e6.lanes = 0, e6;
  }
  function bc2(e6, t3, n3) {
    return Aa2(t3, e6.child, null, n3), e6 = vc2(t3, t3.pendingProps.children), e6.flags |= 2, t3.memoizedState = null, e6;
  }
  function xc2(e6, t3, n3) {
    e6.lanes |= t3;
    var r2 = e6.alternate;
    r2 !== null && (r2.lanes |= t3), Hi2(e6.return, t3, n3);
  }
  function Sc2(e6, t3, n3, r2, i3, a3) {
    var o3 = e6.memoizedState;
    o3 === null ? e6.memoizedState = { isBackwards: t3, rendering: null, renderingStartTime: 0, last: r2, tail: n3, tailMode: i3, treeForkCount: a3 } : (o3.isBackwards = t3, o3.rendering = null, o3.renderingStartTime = 0, o3.last = r2, o3.tail = n3, o3.tailMode = i3, o3.treeForkCount = a3);
  }
  function Cc2(e6, t3, n3) {
    var r2 = t3.pendingProps, i3 = r2.revealOrder, a3 = r2.tail;
    r2 = r2.children;
    var o3 = no2.current, s3 = (o3 & 2) != 0;
    if (s3 ? (o3 = o3 & 1 | 2, t3.flags |= 128) : o3 &= 1, L2(no2, o3), $s2(e6, t3, r2, n3), r2 = q2 ? mi2 : 0, !s3 && e6 !== null && e6.flags & 128) a: for (e6 = t3.child; e6 !== null; ) {
      if (e6.tag === 13) e6.memoizedState !== null && xc2(e6, n3, t3);
      else if (e6.tag === 19) xc2(e6, n3, t3);
      else if (e6.child !== null) {
        e6.child.return = e6, e6 = e6.child;
        continue;
      }
      if (e6 === t3) break a;
      for (; e6.sibling === null; ) {
        if (e6.return === null || e6.return === t3) break a;
        e6 = e6.return;
      }
      e6.sibling.return = e6.return, e6 = e6.sibling;
    }
    switch (i3) {
      case "forwards":
        for (n3 = t3.child, i3 = null; n3 !== null; ) e6 = n3.alternate, e6 !== null && ro2(e6) === null && (i3 = n3), n3 = n3.sibling;
        n3 = i3, n3 === null ? (i3 = t3.child, t3.child = null) : (i3 = n3.sibling, n3.sibling = null), Sc2(t3, false, i3, n3, a3, r2);
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (n3 = null, i3 = t3.child, t3.child = null; i3 !== null; ) {
          if (e6 = i3.alternate, e6 !== null && ro2(e6) === null) {
            t3.child = i3;
            break;
          }
          e6 = i3.sibling, i3.sibling = n3, n3 = i3, i3 = e6;
        }
        Sc2(t3, true, n3, null, a3, r2);
        break;
      case "together":
        Sc2(t3, false, null, null, void 0, r2);
        break;
      default:
        t3.memoizedState = null;
    }
    return t3.child;
  }
  function wc2(e6, t3, n3) {
    if (e6 !== null && (t3.dependencies = e6.dependencies), Ul2 |= t3.lanes, (n3 & t3.childLanes) === 0) if (e6 !== null) {
      if (Wi2(e6, t3, n3, false), (n3 & t3.childLanes) === 0) return null;
    } else return null;
    if (e6 !== null && t3.child !== e6.child) throw Error(a2(153));
    if (t3.child !== null) {
      for (e6 = t3.child, n3 = ni2(e6, e6.pendingProps), t3.child = n3, n3.return = t3; e6.sibling !== null; ) e6 = e6.sibling, n3 = n3.sibling = ni2(e6, e6.pendingProps), n3.return = t3;
      n3.sibling = null;
    }
    return t3.child;
  }
  function Tc2(e6, t3) {
    return (e6.lanes & t3) === 0 ? (e6 = e6.dependencies, !!(e6 !== null && Gi2(e6))) : true;
  }
  function Ec2(e6, t3, n3) {
    switch (t3.tag) {
      case 3:
        se2(t3, t3.stateNode.containerInfo), Bi2(t3, $i2, e6.memoizedState.cache), Pi2();
        break;
      case 27:
      case 5:
        le2(t3);
        break;
      case 4:
        se2(t3, t3.stateNode.containerInfo);
        break;
      case 10:
        Bi2(t3, t3.type, t3.memoizedProps.value);
        break;
      case 31:
        if (t3.memoizedState !== null) return t3.flags |= 128, Qa2(t3), null;
        break;
      case 13:
        var r2 = t3.memoizedState;
        if (r2 !== null) return r2.dehydrated === null ? (n3 & t3.child.childLanes) === 0 ? (Za2(t3), e6 = wc2(e6, t3, n3), e6 === null ? null : e6.sibling) : _c2(e6, t3, n3) : (Za2(t3), t3.flags |= 128, null);
        Za2(t3);
        break;
      case 19:
        var i3 = (e6.flags & 128) != 0;
        if (r2 = (n3 & t3.childLanes) !== 0, r2 ||= (Wi2(e6, t3, n3, false), (n3 & t3.childLanes) !== 0), i3) {
          if (r2) return Cc2(e6, t3, n3);
          t3.flags |= 128;
        }
        if (i3 = t3.memoizedState, i3 !== null && (i3.rendering = null, i3.tail = null, i3.lastEffect = null), L2(no2, no2.current), r2) break;
        return null;
      case 22:
        return t3.lanes = 0, rc2(e6, t3, n3, t3.pendingProps);
      case 24:
        Bi2(t3, $i2, e6.memoizedState.cache);
    }
    return wc2(e6, t3, n3);
  }
  function Dc2(e6, t3, n3) {
    if (e6 !== null) if (e6.memoizedProps !== t3.pendingProps) Qs2 = true;
    else {
      if (!Tc2(e6, n3) && !(t3.flags & 128)) return Qs2 = false, Ec2(e6, t3, n3);
      Qs2 = !!(e6.flags & 131072);
    }
    else Qs2 = false, q2 && t3.flags & 1048576 && xi2(t3, mi2, t3.index);
    switch (t3.lanes = 0, t3.tag) {
      case 16:
        a: {
          var r2 = t3.pendingProps;
          if (e6 = ba2(t3.elementType), t3.type = e6, typeof e6 == "function") ti2(e6) ? (r2 = Vs2(e6, r2), t3.tag = 1, t3 = fc2(null, t3, e6, r2, n3)) : (t3.tag = 0, t3 = uc2(null, t3, e6, r2, n3));
          else {
            if (e6 != null) {
              var i3 = e6.$$typeof;
              if (i3 === S2) {
                t3.tag = 11, t3 = ec2(null, t3, e6, r2, n3);
                break a;
              } else if (i3 === T2) {
                t3.tag = 14, t3 = tc2(null, t3, e6, r2, n3);
                break a;
              }
            }
            throw t3 = M2(e6) || e6, Error(a2(306, t3, ""));
          }
        }
        return t3;
      case 0:
        return uc2(e6, t3, t3.type, t3.pendingProps, n3);
      case 1:
        return r2 = t3.type, i3 = Vs2(r2, t3.pendingProps), fc2(e6, t3, r2, i3, n3);
      case 3:
        a: {
          if (se2(t3, t3.stateNode.containerInfo), e6 === null) throw Error(a2(387));
          r2 = t3.pendingProps;
          var o3 = t3.memoizedState;
          i3 = o3.element, Pa2(e6, t3), Va2(t3, r2, null, n3);
          var s3 = t3.memoizedState;
          if (r2 = s3.cache, Bi2(t3, $i2, r2), r2 !== o3.cache && Ui2(t3, [$i2], n3, true), Ba2(), r2 = s3.element, o3.isDehydrated) if (o3 = { element: r2, isDehydrated: false, cache: s3.cache }, t3.updateQueue.baseState = o3, t3.memoizedState = o3, t3.flags & 256) {
            t3 = pc2(e6, t3, r2, n3);
            break a;
          } else if (r2 !== i3) {
            i3 = ui2(Error(a2(424)), t3), Ii2(i3), t3 = pc2(e6, t3, r2, n3);
            break a;
          } else for ((e6 = t3.stateNode.containerInfo, e6.nodeType) === 9 ? e6 = e6.body : e6 = e6.nodeName === "HTML" ? e6.ownerDocument.body : e6, Ei2 = cf(e6.firstChild), Ti2 = t3, q2 = true, Di2 = null, Oi2 = true, n3 = ja2(t3, null, r2, n3), t3.child = n3; n3; ) n3.flags = n3.flags & -3 | 4096, n3 = n3.sibling;
          else {
            if (Pi2(), r2 === i3) {
              t3 = wc2(e6, t3, n3);
              break a;
            }
            $s2(e6, t3, r2, n3);
          }
          t3 = t3.child;
        }
        return t3;
      case 26:
        return lc2(e6, t3), e6 === null ? (n3 = kf(t3.type, null, t3.pendingProps, null)) ? t3.memoizedState = n3 : q2 || (n3 = t3.type, e6 = t3.pendingProps, r2 = Bd(R2.current).createElement(n3), r2[rt2] = t3, r2[it2] = e6, Pd(r2, n3, e6), ht2(r2), t3.stateNode = r2) : t3.memoizedState = kf(t3.type, e6.memoizedProps, t3.pendingProps, e6.memoizedState), null;
      case 27:
        return le2(t3), e6 === null && q2 && (r2 = t3.stateNode = ff(t3.type, t3.pendingProps, R2.current), Ti2 = t3, Oi2 = true, i3 = Ei2, Zd(t3.type) ? (lf = i3, Ei2 = cf(r2.firstChild)) : Ei2 = i3), $s2(e6, t3, t3.pendingProps.children, n3), lc2(e6, t3), e6 === null && (t3.flags |= 4194304), t3.child;
      case 5:
        return e6 === null && q2 && ((i3 = r2 = Ei2) && (r2 = tf(r2, t3.type, t3.pendingProps, Oi2), r2 === null ? i3 = false : (t3.stateNode = r2, Ti2 = t3, Ei2 = cf(r2.firstChild), Oi2 = false, i3 = true)), i3 || Ai2(t3)), le2(t3), i3 = t3.type, o3 = t3.pendingProps, s3 = e6 === null ? null : e6.memoizedProps, r2 = o3.children, Ud(i3, o3) ? r2 = null : s3 !== null && Ud(i3, s3) && (t3.flags |= 32), t3.memoizedState !== null && (i3 = _o2(e6, t3, bo2, null, null, n3), Qf._currentValue = i3), lc2(e6, t3), $s2(e6, t3, r2, n3), t3.child;
      case 6:
        return e6 === null && q2 && ((e6 = n3 = Ei2) && (n3 = nf(n3, t3.pendingProps, Oi2), n3 === null ? e6 = false : (t3.stateNode = n3, Ti2 = t3, Ei2 = null, e6 = true)), e6 || Ai2(t3)), null;
      case 13:
        return _c2(e6, t3, n3);
      case 4:
        return se2(t3, t3.stateNode.containerInfo), r2 = t3.pendingProps, e6 === null ? t3.child = Aa2(t3, null, r2, n3) : $s2(e6, t3, r2, n3), t3.child;
      case 11:
        return ec2(e6, t3, t3.type, t3.pendingProps, n3);
      case 7:
        return $s2(e6, t3, t3.pendingProps, n3), t3.child;
      case 8:
        return $s2(e6, t3, t3.pendingProps.children, n3), t3.child;
      case 12:
        return $s2(e6, t3, t3.pendingProps.children, n3), t3.child;
      case 10:
        return r2 = t3.pendingProps, Bi2(t3, t3.type, r2.value), $s2(e6, t3, r2.children, n3), t3.child;
      case 9:
        return i3 = t3.type._context, r2 = t3.pendingProps.children, Ki2(t3), i3 = qi2(i3), r2 = r2(i3), t3.flags |= 1, $s2(e6, t3, r2, n3), t3.child;
      case 14:
        return tc2(e6, t3, t3.type, t3.pendingProps, n3);
      case 15:
        return nc2(e6, t3, t3.type, t3.pendingProps, n3);
      case 19:
        return Cc2(e6, t3, n3);
      case 31:
        return cc2(e6, t3, n3);
      case 22:
        return rc2(e6, t3, n3, t3.pendingProps);
      case 24:
        return Ki2(t3), r2 = qi2($i2), e6 === null ? (i3 = da2(), i3 === null && (i3 = Il2, o3 = ea2(), i3.pooledCache = o3, o3.refCount++, o3 !== null && (i3.pooledCacheLanes |= n3), i3 = o3), t3.memoizedState = { parent: r2, cache: i3 }, Na2(t3), Bi2(t3, $i2, i3)) : ((e6.lanes & n3) !== 0 && (Pa2(e6, t3), Va2(t3, null, null, n3), Ba2()), i3 = e6.memoizedState, o3 = t3.memoizedState, i3.parent === r2 ? (r2 = o3.cache, Bi2(t3, $i2, r2), r2 !== i3.cache && Ui2(t3, [$i2], n3, true)) : (i3 = { parent: r2, cache: r2 }, t3.memoizedState = i3, t3.lanes === 0 && (t3.memoizedState = t3.updateQueue.baseState = i3), Bi2(t3, $i2, r2))), $s2(e6, t3, t3.pendingProps.children, n3), t3.child;
      case 29:
        throw t3.pendingProps;
    }
    throw Error(a2(156, t3.tag));
  }
  function Oc2(e6) {
    e6.flags |= 4;
  }
  function kc2(e6, t3, n3, r2, i3) {
    if ((t3 = (e6.mode & 32) != 0) && (t3 = false), t3) {
      if (e6.flags |= 16777216, (i3 & 335544128) === i3) if (e6.stateNode.complete) e6.flags |= 8192;
      else if (Su()) e6.flags |= 8192;
      else throw xa2 = _a2, ha2;
    } else e6.flags &= -16777217;
  }
  function Ac2(e6, t3) {
    if (t3.type !== "stylesheet" || t3.state.loading & 4) e6.flags &= -16777217;
    else if (e6.flags |= 16777216, !Wf(t3)) if (Su()) e6.flags |= 8192;
    else throw xa2 = _a2, ha2;
  }
  function jc2(e6, t3) {
    t3 !== null && (e6.flags |= 4), e6.flags & 16384 && (t3 = e6.tag === 22 ? 536870912 : Ge2(), e6.lanes |= t3, ql |= t3);
  }
  function Mc2(e6, t3) {
    if (!q2) switch (e6.tailMode) {
      case "hidden":
        t3 = e6.tail;
        for (var n3 = null; t3 !== null; ) t3.alternate !== null && (n3 = t3), t3 = t3.sibling;
        n3 === null ? e6.tail = null : n3.sibling = null;
        break;
      case "collapsed":
        n3 = e6.tail;
        for (var r2 = null; n3 !== null; ) n3.alternate !== null && (r2 = n3), n3 = n3.sibling;
        r2 === null ? t3 || e6.tail === null ? e6.tail = null : e6.tail.sibling = null : r2.sibling = null;
    }
  }
  function Nc2(e6) {
    var t3 = e6.alternate !== null && e6.alternate.child === e6.child, n3 = 0, r2 = 0;
    if (t3) for (var i3 = e6.child; i3 !== null; ) n3 |= i3.lanes | i3.childLanes, r2 |= i3.subtreeFlags & 65011712, r2 |= i3.flags & 65011712, i3.return = e6, i3 = i3.sibling;
    else for (i3 = e6.child; i3 !== null; ) n3 |= i3.lanes | i3.childLanes, r2 |= i3.subtreeFlags, r2 |= i3.flags, i3.return = e6, i3 = i3.sibling;
    return e6.subtreeFlags |= r2, e6.childLanes = n3, t3;
  }
  function Pc2(e6, t3, n3) {
    var r2 = t3.pendingProps;
    switch (Ci2(t3), t3.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Nc2(t3), null;
      case 1:
        return Nc2(t3), null;
      case 3:
        return n3 = t3.stateNode, r2 = null, e6 !== null && (r2 = e6.memoizedState.cache), t3.memoizedState.cache !== r2 && (t3.flags |= 2048), Vi2($i2), ce2(), n3.pendingContext && (n3.context = n3.pendingContext, n3.pendingContext = null), (e6 === null || e6.child === null) && (Ni2(t3) ? Oc2(t3) : e6 === null || e6.memoizedState.isDehydrated && !(t3.flags & 256) || (t3.flags |= 1024, Fi2())), Nc2(t3), null;
      case 26:
        var i3 = t3.type, o3 = t3.memoizedState;
        return e6 === null ? (Oc2(t3), o3 === null ? (Nc2(t3), kc2(t3, i3, null, r2, n3)) : (Nc2(t3), Ac2(t3, o3))) : o3 ? o3 === e6.memoizedState ? (Nc2(t3), t3.flags &= -16777217) : (Oc2(t3), Nc2(t3), Ac2(t3, o3)) : (e6 = e6.memoizedProps, e6 !== r2 && Oc2(t3), Nc2(t3), kc2(t3, i3, e6, r2, n3)), null;
      case 27:
        if (ue2(t3), n3 = R2.current, i3 = t3.type, e6 !== null && t3.stateNode != null) e6.memoizedProps !== r2 && Oc2(t3);
        else {
          if (!r2) {
            if (t3.stateNode === null) throw Error(a2(166));
            return Nc2(t3), null;
          }
          e6 = ie2.current, Ni2(t3) ? ji2(t3, e6) : (e6 = ff(i3, r2, n3), t3.stateNode = e6, Oc2(t3));
        }
        return Nc2(t3), null;
      case 5:
        if (ue2(t3), i3 = t3.type, e6 !== null && t3.stateNode != null) e6.memoizedProps !== r2 && Oc2(t3);
        else {
          if (!r2) {
            if (t3.stateNode === null) throw Error(a2(166));
            return Nc2(t3), null;
          }
          if (o3 = ie2.current, Ni2(t3)) ji2(t3, o3);
          else {
            var s3 = Bd(R2.current);
            switch (o3) {
              case 1:
                o3 = s3.createElementNS("http://www.w3.org/2000/svg", i3);
                break;
              case 2:
                o3 = s3.createElementNS("http://www.w3.org/1998/Math/MathML", i3);
                break;
              default:
                switch (i3) {
                  case "svg":
                    o3 = s3.createElementNS("http://www.w3.org/2000/svg", i3);
                    break;
                  case "math":
                    o3 = s3.createElementNS("http://www.w3.org/1998/Math/MathML", i3);
                    break;
                  case "script":
                    o3 = s3.createElement("div"), o3.innerHTML = "<script><\/script>", o3 = o3.removeChild(o3.firstChild);
                    break;
                  case "select":
                    o3 = typeof r2.is == "string" ? s3.createElement("select", { is: r2.is }) : s3.createElement("select"), r2.multiple ? o3.multiple = true : r2.size && (o3.size = r2.size);
                    break;
                  default:
                    o3 = typeof r2.is == "string" ? s3.createElement(i3, { is: r2.is }) : s3.createElement(i3);
                }
            }
            o3[rt2] = t3, o3[it2] = r2;
            a: for (s3 = t3.child; s3 !== null; ) {
              if (s3.tag === 5 || s3.tag === 6) o3.appendChild(s3.stateNode);
              else if (s3.tag !== 4 && s3.tag !== 27 && s3.child !== null) {
                s3.child.return = s3, s3 = s3.child;
                continue;
              }
              if (s3 === t3) break a;
              for (; s3.sibling === null; ) {
                if (s3.return === null || s3.return === t3) break a;
                s3 = s3.return;
              }
              s3.sibling.return = s3.return, s3 = s3.sibling;
            }
            t3.stateNode = o3;
            a: switch (Pd(o3, i3, r2), i3) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                r2 = !!r2.autoFocus;
                break a;
              case "img":
                r2 = true;
                break a;
              default:
                r2 = false;
            }
            r2 && Oc2(t3);
          }
        }
        return Nc2(t3), kc2(t3, t3.type, e6 === null ? null : e6.memoizedProps, t3.pendingProps, n3), null;
      case 6:
        if (e6 && t3.stateNode != null) e6.memoizedProps !== r2 && Oc2(t3);
        else {
          if (typeof r2 != "string" && t3.stateNode === null) throw Error(a2(166));
          if (e6 = R2.current, Ni2(t3)) {
            if (e6 = t3.stateNode, n3 = t3.memoizedProps, r2 = null, i3 = Ti2, i3 !== null) switch (i3.tag) {
              case 27:
              case 5:
                r2 = i3.memoizedProps;
            }
            e6[rt2] = t3, e6 = !!(e6.nodeValue === n3 || r2 !== null && r2.suppressHydrationWarning === true || jd(e6.nodeValue, n3)), e6 || Ai2(t3, true);
          } else e6 = Bd(e6).createTextNode(r2), e6[rt2] = t3, t3.stateNode = e6;
        }
        return Nc2(t3), null;
      case 31:
        if (n3 = t3.memoizedState, e6 === null || e6.memoizedState !== null) {
          if (r2 = Ni2(t3), n3 !== null) {
            if (e6 === null) {
              if (!r2) throw Error(a2(318));
              if (e6 = t3.memoizedState, e6 = e6 === null ? null : e6.dehydrated, !e6) throw Error(a2(557));
              e6[rt2] = t3;
            } else Pi2(), !(t3.flags & 128) && (t3.memoizedState = null), t3.flags |= 4;
            Nc2(t3), e6 = false;
          } else n3 = Fi2(), e6 !== null && e6.memoizedState !== null && (e6.memoizedState.hydrationErrors = n3), e6 = true;
          if (!e6) return t3.flags & 256 ? (to2(t3), t3) : (to2(t3), null);
          if (t3.flags & 128) throw Error(a2(558));
        }
        return Nc2(t3), null;
      case 13:
        if (r2 = t3.memoizedState, e6 === null || e6.memoizedState !== null && e6.memoizedState.dehydrated !== null) {
          if (i3 = Ni2(t3), r2 !== null && r2.dehydrated !== null) {
            if (e6 === null) {
              if (!i3) throw Error(a2(318));
              if (i3 = t3.memoizedState, i3 = i3 === null ? null : i3.dehydrated, !i3) throw Error(a2(317));
              i3[rt2] = t3;
            } else Pi2(), !(t3.flags & 128) && (t3.memoizedState = null), t3.flags |= 4;
            Nc2(t3), i3 = false;
          } else i3 = Fi2(), e6 !== null && e6.memoizedState !== null && (e6.memoizedState.hydrationErrors = i3), i3 = true;
          if (!i3) return t3.flags & 256 ? (to2(t3), t3) : (to2(t3), null);
        }
        return to2(t3), t3.flags & 128 ? (t3.lanes = n3, t3) : (n3 = r2 !== null, e6 = e6 !== null && e6.memoizedState !== null, n3 && (r2 = t3.child, i3 = null, r2.alternate !== null && r2.alternate.memoizedState !== null && r2.alternate.memoizedState.cachePool !== null && (i3 = r2.alternate.memoizedState.cachePool.pool), o3 = null, r2.memoizedState !== null && r2.memoizedState.cachePool !== null && (o3 = r2.memoizedState.cachePool.pool), o3 !== i3 && (r2.flags |= 2048)), n3 !== e6 && n3 && (t3.child.flags |= 8192), jc2(t3, t3.updateQueue), Nc2(t3), null);
      case 4:
        return ce2(), e6 === null && xd(t3.stateNode.containerInfo), Nc2(t3), null;
      case 10:
        return Vi2(t3.type), Nc2(t3), null;
      case 19:
        if (re2(no2), r2 = t3.memoizedState, r2 === null) return Nc2(t3), null;
        if (i3 = (t3.flags & 128) != 0, o3 = r2.rendering, o3 === null) if (i3) Mc2(r2, false);
        else {
          if (Hl2 !== 0 || e6 !== null && e6.flags & 128) for (e6 = t3.child; e6 !== null; ) {
            if (o3 = ro2(e6), o3 !== null) {
              for (t3.flags |= 128, Mc2(r2, false), e6 = o3.updateQueue, t3.updateQueue = e6, jc2(t3, e6), t3.subtreeFlags = 0, e6 = n3, n3 = t3.child; n3 !== null; ) ri2(n3, e6), n3 = n3.sibling;
              return L2(no2, no2.current & 1 | 2), q2 && bi2(t3, r2.treeForkCount), t3.child;
            }
            e6 = e6.sibling;
          }
          r2.tail !== null && Ce2() > $l && (t3.flags |= 128, i3 = true, Mc2(r2, false), t3.lanes = 4194304);
        }
        else {
          if (!i3) if (e6 = ro2(o3), e6 !== null) {
            if (t3.flags |= 128, i3 = true, e6 = e6.updateQueue, t3.updateQueue = e6, jc2(t3, e6), Mc2(r2, true), r2.tail === null && r2.tailMode === "hidden" && !o3.alternate && !q2) return Nc2(t3), null;
          } else 2 * Ce2() - r2.renderingStartTime > $l && n3 !== 536870912 && (t3.flags |= 128, i3 = true, Mc2(r2, false), t3.lanes = 4194304);
          r2.isBackwards ? (o3.sibling = t3.child, t3.child = o3) : (e6 = r2.last, e6 === null ? t3.child = o3 : e6.sibling = o3, r2.last = o3);
        }
        return r2.tail === null ? (Nc2(t3), null) : (e6 = r2.tail, r2.rendering = e6, r2.tail = e6.sibling, r2.renderingStartTime = Ce2(), e6.sibling = null, n3 = no2.current, L2(no2, i3 ? n3 & 1 | 2 : n3 & 1), q2 && bi2(t3, r2.treeForkCount), e6);
      case 22:
      case 23:
        return to2(t3), Ja2(), r2 = t3.memoizedState !== null, e6 === null ? r2 && (t3.flags |= 8192) : e6.memoizedState !== null !== r2 && (t3.flags |= 8192), r2 ? n3 & 536870912 && !(t3.flags & 128) && (Nc2(t3), t3.subtreeFlags & 6 && (t3.flags |= 8192)) : Nc2(t3), n3 = t3.updateQueue, n3 !== null && jc2(t3, n3.retryQueue), n3 = null, e6 !== null && e6.memoizedState !== null && e6.memoizedState.cachePool !== null && (n3 = e6.memoizedState.cachePool.pool), r2 = null, t3.memoizedState !== null && t3.memoizedState.cachePool !== null && (r2 = t3.memoizedState.cachePool.pool), r2 !== n3 && (t3.flags |= 2048), e6 !== null && re2(ua2), null;
      case 24:
        return n3 = null, e6 !== null && (n3 = e6.memoizedState.cache), t3.memoizedState.cache !== n3 && (t3.flags |= 2048), Vi2($i2), Nc2(t3), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(a2(156, t3.tag));
  }
  function Fc2(e6, t3) {
    switch (Ci2(t3), t3.tag) {
      case 1:
        return e6 = t3.flags, e6 & 65536 ? (t3.flags = e6 & -65537 | 128, t3) : null;
      case 3:
        return Vi2($i2), ce2(), e6 = t3.flags, e6 & 65536 && !(e6 & 128) ? (t3.flags = e6 & -65537 | 128, t3) : null;
      case 26:
      case 27:
      case 5:
        return ue2(t3), null;
      case 31:
        if (t3.memoizedState !== null) {
          if (to2(t3), t3.alternate === null) throw Error(a2(340));
          Pi2();
        }
        return e6 = t3.flags, e6 & 65536 ? (t3.flags = e6 & -65537 | 128, t3) : null;
      case 13:
        if (to2(t3), e6 = t3.memoizedState, e6 !== null && e6.dehydrated !== null) {
          if (t3.alternate === null) throw Error(a2(340));
          Pi2();
        }
        return e6 = t3.flags, e6 & 65536 ? (t3.flags = e6 & -65537 | 128, t3) : null;
      case 19:
        return re2(no2), null;
      case 4:
        return ce2(), null;
      case 10:
        return Vi2(t3.type), null;
      case 22:
      case 23:
        return to2(t3), Ja2(), e6 !== null && re2(ua2), e6 = t3.flags, e6 & 65536 ? (t3.flags = e6 & -65537 | 128, t3) : null;
      case 24:
        return Vi2($i2), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function Ic2(e6, t3) {
    switch (Ci2(t3), t3.tag) {
      case 3:
        Vi2($i2), ce2();
        break;
      case 26:
      case 27:
      case 5:
        ue2(t3);
        break;
      case 4:
        ce2();
        break;
      case 31:
        t3.memoizedState !== null && to2(t3);
        break;
      case 13:
        to2(t3);
        break;
      case 19:
        re2(no2);
        break;
      case 10:
        Vi2(t3.type);
        break;
      case 22:
      case 23:
        to2(t3), Ja2(), e6 !== null && re2(ua2);
        break;
      case 24:
        Vi2($i2);
    }
  }
  function Lc2(e6, t3) {
    try {
      var n3 = t3.updateQueue, r2 = n3 === null ? null : n3.lastEffect;
      if (r2 !== null) {
        var i3 = r2.next;
        n3 = i3;
        do {
          if ((n3.tag & e6) === e6) {
            r2 = void 0;
            var a3 = n3.create, o3 = n3.inst;
            r2 = a3(), o3.destroy = r2;
          }
          n3 = n3.next;
        } while (n3 !== i3);
      }
    } catch (e7) {
      Uu(t3, t3.return, e7);
    }
  }
  function Rc2(e6, t3, n3) {
    try {
      var r2 = t3.updateQueue, i3 = r2 === null ? null : r2.lastEffect;
      if (i3 !== null) {
        var a3 = i3.next;
        r2 = a3;
        do {
          if ((r2.tag & e6) === e6) {
            var o3 = r2.inst, s3 = o3.destroy;
            if (s3 !== void 0) {
              o3.destroy = void 0, i3 = t3;
              var c3 = n3, l3 = s3;
              try {
                l3();
              } catch (e7) {
                Uu(i3, c3, e7);
              }
            }
          }
          r2 = r2.next;
        } while (r2 !== a3);
      }
    } catch (e7) {
      Uu(t3, t3.return, e7);
    }
  }
  function zc2(e6) {
    var t3 = e6.updateQueue;
    if (t3 !== null) {
      var n3 = e6.stateNode;
      try {
        Ua2(t3, n3);
      } catch (t4) {
        Uu(e6, e6.return, t4);
      }
    }
  }
  function Bc2(e6, t3, n3) {
    n3.props = Vs2(e6.type, e6.memoizedProps), n3.state = e6.memoizedState;
    try {
      n3.componentWillUnmount();
    } catch (n4) {
      Uu(e6, t3, n4);
    }
  }
  function Vc2(e6, t3) {
    try {
      var n3 = e6.ref;
      if (n3 !== null) {
        switch (e6.tag) {
          case 26:
          case 27:
          case 5:
            var r2 = e6.stateNode;
            break;
          case 30:
            r2 = e6.stateNode;
            break;
          default:
            r2 = e6.stateNode;
        }
        typeof n3 == "function" ? e6.refCleanup = n3(r2) : n3.current = r2;
      }
    } catch (n4) {
      Uu(e6, t3, n4);
    }
  }
  function Hc2(e6, t3) {
    var n3 = e6.ref, r2 = e6.refCleanup;
    if (n3 !== null) if (typeof r2 == "function") try {
      r2();
    } catch (n4) {
      Uu(e6, t3, n4);
    } finally {
      e6.refCleanup = null, e6 = e6.alternate, e6 != null && (e6.refCleanup = null);
    }
    else if (typeof n3 == "function") try {
      n3(null);
    } catch (n4) {
      Uu(e6, t3, n4);
    }
    else n3.current = null;
  }
  function Uc2(e6) {
    var t3 = e6.type, n3 = e6.memoizedProps, r2 = e6.stateNode;
    try {
      a: switch (t3) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          n3.autoFocus && r2.focus();
          break a;
        case "img":
          n3.src ? r2.src = n3.src : n3.srcSet && (r2.srcset = n3.srcSet);
      }
    } catch (t4) {
      Uu(e6, e6.return, t4);
    }
  }
  function Wc2(e6, t3, n3) {
    try {
      var r2 = e6.stateNode;
      Fd(r2, e6.type, n3, t3), r2[it2] = t3;
    } catch (t4) {
      Uu(e6, e6.return, t4);
    }
  }
  function Gc2(e6) {
    return e6.tag === 5 || e6.tag === 3 || e6.tag === 26 || e6.tag === 27 && Zd(e6.type) || e6.tag === 4;
  }
  function Kc2(e6) {
    a: for (; ; ) {
      for (; e6.sibling === null; ) {
        if (e6.return === null || Gc2(e6.return)) return null;
        e6 = e6.return;
      }
      for (e6.sibling.return = e6.return, e6 = e6.sibling; e6.tag !== 5 && e6.tag !== 6 && e6.tag !== 18; ) {
        if (e6.tag === 27 && Zd(e6.type) || e6.flags & 2 || e6.child === null || e6.tag === 4) continue a;
        e6.child.return = e6, e6 = e6.child;
      }
      if (!(e6.flags & 2)) return e6.stateNode;
    }
  }
  function qc2(e6, t3, n3) {
    var r2 = e6.tag;
    if (r2 === 5 || r2 === 6) e6 = e6.stateNode, t3 ? (n3.nodeType === 9 ? n3.body : n3.nodeName === "HTML" ? n3.ownerDocument.body : n3).insertBefore(e6, t3) : (t3 = n3.nodeType === 9 ? n3.body : n3.nodeName === "HTML" ? n3.ownerDocument.body : n3, t3.appendChild(e6), n3 = n3._reactRootContainer, n3 != null || t3.onclick !== null || (t3.onclick = Jt2));
    else if (r2 !== 4 && (r2 === 27 && Zd(e6.type) && (n3 = e6.stateNode, t3 = null), e6 = e6.child, e6 !== null)) for (qc2(e6, t3, n3), e6 = e6.sibling; e6 !== null; ) qc2(e6, t3, n3), e6 = e6.sibling;
  }
  function Jc2(e6, t3, n3) {
    var r2 = e6.tag;
    if (r2 === 5 || r2 === 6) e6 = e6.stateNode, t3 ? n3.insertBefore(e6, t3) : n3.appendChild(e6);
    else if (r2 !== 4 && (r2 === 27 && Zd(e6.type) && (n3 = e6.stateNode), e6 = e6.child, e6 !== null)) for (Jc2(e6, t3, n3), e6 = e6.sibling; e6 !== null; ) Jc2(e6, t3, n3), e6 = e6.sibling;
  }
  function Yc2(e6) {
    var t3 = e6.stateNode, n3 = e6.memoizedProps;
    try {
      for (var r2 = e6.type, i3 = t3.attributes; i3.length; ) t3.removeAttributeNode(i3[0]);
      Pd(t3, r2, n3), t3[rt2] = e6, t3[it2] = n3;
    } catch (t4) {
      Uu(e6, e6.return, t4);
    }
  }
  var Xc2 = false, Zc2 = false, Qc2 = false, $c2 = typeof WeakSet == "function" ? WeakSet : Set, el2 = null;
  function tl2(e6, t3) {
    if (e6 = e6.containerInfo, Rd = sp, e6 = yr2(e6), br2(e6)) {
      if ("selectionStart" in e6) var n3 = { start: e6.selectionStart, end: e6.selectionEnd };
      else a: {
        n3 = (n3 = e6.ownerDocument) && n3.defaultView || window;
        var r2 = n3.getSelection && n3.getSelection();
        if (r2 && r2.rangeCount !== 0) {
          n3 = r2.anchorNode;
          var i3 = r2.anchorOffset, o3 = r2.focusNode;
          r2 = r2.focusOffset;
          try {
            n3.nodeType, o3.nodeType;
          } catch {
            n3 = null;
            break a;
          }
          var s3 = 0, c3 = -1, l3 = -1, u3 = 0, d3 = 0, f3 = e6, p3 = null;
          b: for (; ; ) {
            for (var m3; f3 !== n3 || i3 !== 0 && f3.nodeType !== 3 || (c3 = s3 + i3), f3 !== o3 || r2 !== 0 && f3.nodeType !== 3 || (l3 = s3 + r2), f3.nodeType === 3 && (s3 += f3.nodeValue.length), (m3 = f3.firstChild) !== null; ) p3 = f3, f3 = m3;
            for (; ; ) {
              if (f3 === e6) break b;
              if (p3 === n3 && ++u3 === i3 && (c3 = s3), p3 === o3 && ++d3 === r2 && (l3 = s3), (m3 = f3.nextSibling) !== null) break;
              f3 = p3, p3 = f3.parentNode;
            }
            f3 = m3;
          }
          n3 = c3 === -1 || l3 === -1 ? null : { start: c3, end: l3 };
        } else n3 = null;
      }
      n3 ||= { start: 0, end: 0 };
    } else n3 = null;
    for (zd = { focusedElem: e6, selectionRange: n3 }, sp = false, el2 = t3; el2 !== null; ) if (t3 = el2, e6 = t3.child, t3.subtreeFlags & 1028 && e6 !== null) e6.return = t3, el2 = e6;
    else for (; el2 !== null; ) {
      switch (t3 = el2, o3 = t3.alternate, e6 = t3.flags, t3.tag) {
        case 0:
          if (e6 & 4 && (e6 = t3.updateQueue, e6 = e6 === null ? null : e6.events, e6 !== null)) for (n3 = 0; n3 < e6.length; n3++) i3 = e6[n3], i3.ref.impl = i3.nextImpl;
          break;
        case 11:
        case 15:
          break;
        case 1:
          if (e6 & 1024 && o3 !== null) {
            e6 = void 0, n3 = t3, i3 = o3.memoizedProps, o3 = o3.memoizedState, r2 = n3.stateNode;
            try {
              var h3 = Vs2(n3.type, i3);
              e6 = r2.getSnapshotBeforeUpdate(h3, o3), r2.__reactInternalSnapshotBeforeUpdate = e6;
            } catch (e7) {
              Uu(n3, n3.return, e7);
            }
          }
          break;
        case 3:
          if (e6 & 1024) {
            if (e6 = t3.stateNode.containerInfo, n3 = e6.nodeType, n3 === 9) ef(e6);
            else if (n3 === 1) switch (e6.nodeName) {
              case "HEAD":
              case "HTML":
              case "BODY":
                ef(e6);
                break;
              default:
                e6.textContent = "";
            }
          }
          break;
        case 5:
        case 26:
        case 27:
        case 6:
        case 4:
        case 17:
          break;
        default:
          if (e6 & 1024) throw Error(a2(163));
      }
      if (e6 = t3.sibling, e6 !== null) {
        e6.return = t3.return, el2 = e6;
        break;
      }
      el2 = t3.return;
    }
  }
  function nl2(e6, t3, n3) {
    var r2 = n3.flags;
    switch (n3.tag) {
      case 0:
      case 11:
      case 15:
        _l2(e6, n3), r2 & 4 && Lc2(5, n3);
        break;
      case 1:
        if (_l2(e6, n3), r2 & 4) if (e6 = n3.stateNode, t3 === null) try {
          e6.componentDidMount();
        } catch (e7) {
          Uu(n3, n3.return, e7);
        }
        else {
          var i3 = Vs2(n3.type, t3.memoizedProps);
          t3 = t3.memoizedState;
          try {
            e6.componentDidUpdate(i3, t3, e6.__reactInternalSnapshotBeforeUpdate);
          } catch (e7) {
            Uu(n3, n3.return, e7);
          }
        }
        r2 & 64 && zc2(n3), r2 & 512 && Vc2(n3, n3.return);
        break;
      case 3:
        if (_l2(e6, n3), r2 & 64 && (e6 = n3.updateQueue, e6 !== null)) {
          if (t3 = null, n3.child !== null) switch (n3.child.tag) {
            case 27:
            case 5:
              t3 = n3.child.stateNode;
              break;
            case 1:
              t3 = n3.child.stateNode;
          }
          try {
            Ua2(e6, t3);
          } catch (e7) {
            Uu(n3, n3.return, e7);
          }
        }
        break;
      case 27:
        t3 === null && r2 & 4 && Yc2(n3);
      case 26:
      case 5:
        _l2(e6, n3), t3 === null && r2 & 4 && Uc2(n3), r2 & 512 && Vc2(n3, n3.return);
        break;
      case 12:
        _l2(e6, n3);
        break;
      case 31:
        _l2(e6, n3), r2 & 4 && cl2(e6, n3);
        break;
      case 13:
        _l2(e6, n3), r2 & 4 && ll2(e6, n3), r2 & 64 && (e6 = n3.memoizedState, e6 !== null && (e6 = e6.dehydrated, e6 !== null && (n3 = qu.bind(null, n3), sf(e6, n3))));
        break;
      case 22:
        if (r2 = n3.memoizedState !== null || Xc2, !r2) {
          t3 = t3 !== null && t3.memoizedState !== null || Zc2, i3 = Xc2;
          var a3 = Zc2;
          Xc2 = r2, (Zc2 = t3) && !a3 ? yl2(e6, n3, (n3.subtreeFlags & 8772) != 0) : _l2(e6, n3), Xc2 = i3, Zc2 = a3;
        }
        break;
      case 30:
        break;
      default:
        _l2(e6, n3);
    }
  }
  function rl2(e6) {
    var t3 = e6.alternate;
    t3 !== null && (e6.alternate = null, rl2(t3)), e6.child = null, e6.deletions = null, e6.sibling = null, e6.tag === 5 && (t3 = e6.stateNode, t3 !== null && ut2(t3)), e6.stateNode = null, e6.return = null, e6.dependencies = null, e6.memoizedProps = null, e6.memoizedState = null, e6.pendingProps = null, e6.stateNode = null, e6.updateQueue = null;
  }
  var il2 = null, al2 = false;
  function ol2(e6, t3, n3) {
    for (n3 = n3.child; n3 !== null; ) sl2(e6, t3, n3), n3 = n3.sibling;
  }
  function sl2(e6, t3, n3) {
    if (Ne2 && typeof Ne2.onCommitFiberUnmount == "function") try {
      Ne2.onCommitFiberUnmount(je2, n3);
    } catch {
    }
    switch (n3.tag) {
      case 26:
        Zc2 || Hc2(n3, t3), ol2(e6, t3, n3), n3.memoizedState ? n3.memoizedState.count-- : n3.stateNode && (n3 = n3.stateNode, n3.parentNode.removeChild(n3));
        break;
      case 27:
        Zc2 || Hc2(n3, t3);
        var r2 = il2, i3 = al2;
        Zd(n3.type) && (il2 = n3.stateNode, al2 = false), ol2(e6, t3, n3), pf(n3.stateNode), il2 = r2, al2 = i3;
        break;
      case 5:
        Zc2 || Hc2(n3, t3);
      case 6:
        if (r2 = il2, i3 = al2, il2 = null, ol2(e6, t3, n3), il2 = r2, al2 = i3, il2 !== null) if (al2) try {
          (il2.nodeType === 9 ? il2.body : il2.nodeName === "HTML" ? il2.ownerDocument.body : il2).removeChild(n3.stateNode);
        } catch (e7) {
          Uu(n3, t3, e7);
        }
        else try {
          il2.removeChild(n3.stateNode);
        } catch (e7) {
          Uu(n3, t3, e7);
        }
        break;
      case 18:
        il2 !== null && (al2 ? (e6 = il2, Qd(e6.nodeType === 9 ? e6.body : e6.nodeName === "HTML" ? e6.ownerDocument.body : e6, n3.stateNode), Np(e6)) : Qd(il2, n3.stateNode));
        break;
      case 4:
        r2 = il2, i3 = al2, il2 = n3.stateNode.containerInfo, al2 = true, ol2(e6, t3, n3), il2 = r2, al2 = i3;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        Rc2(2, n3, t3), Zc2 || Rc2(4, n3, t3), ol2(e6, t3, n3);
        break;
      case 1:
        Zc2 || (Hc2(n3, t3), r2 = n3.stateNode, typeof r2.componentWillUnmount == "function" && Bc2(n3, t3, r2)), ol2(e6, t3, n3);
        break;
      case 21:
        ol2(e6, t3, n3);
        break;
      case 22:
        Zc2 = (r2 = Zc2) || n3.memoizedState !== null, ol2(e6, t3, n3), Zc2 = r2;
        break;
      default:
        ol2(e6, t3, n3);
    }
  }
  function cl2(e6, t3) {
    if (t3.memoizedState === null && (e6 = t3.alternate, e6 !== null && (e6 = e6.memoizedState, e6 !== null))) {
      e6 = e6.dehydrated;
      try {
        Np(e6);
      } catch (e7) {
        Uu(t3, t3.return, e7);
      }
    }
  }
  function ll2(e6, t3) {
    if (t3.memoizedState === null && (e6 = t3.alternate, e6 !== null && (e6 = e6.memoizedState, e6 !== null && (e6 = e6.dehydrated, e6 !== null)))) try {
      Np(e6);
    } catch (e7) {
      Uu(t3, t3.return, e7);
    }
  }
  function ul2(e6) {
    switch (e6.tag) {
      case 31:
      case 13:
      case 19:
        var t3 = e6.stateNode;
        return t3 === null && (t3 = e6.stateNode = new $c2()), t3;
      case 22:
        return e6 = e6.stateNode, t3 = e6._retryCache, t3 === null && (t3 = e6._retryCache = new $c2()), t3;
      default:
        throw Error(a2(435, e6.tag));
    }
  }
  function dl2(e6, t3) {
    var n3 = ul2(e6);
    t3.forEach(function(t4) {
      if (!n3.has(t4)) {
        n3.add(t4);
        var r2 = Ju.bind(null, e6, t4);
        t4.then(r2, r2);
      }
    });
  }
  function fl2(e6, t3) {
    var n3 = t3.deletions;
    if (n3 !== null) for (var r2 = 0; r2 < n3.length; r2++) {
      var i3 = n3[r2], o3 = e6, s3 = t3, c3 = s3;
      a: for (; c3 !== null; ) {
        switch (c3.tag) {
          case 27:
            if (Zd(c3.type)) {
              il2 = c3.stateNode, al2 = false;
              break a;
            }
            break;
          case 5:
            il2 = c3.stateNode, al2 = false;
            break a;
          case 3:
          case 4:
            il2 = c3.stateNode.containerInfo, al2 = true;
            break a;
        }
        c3 = c3.return;
      }
      if (il2 === null) throw Error(a2(160));
      sl2(o3, s3, i3), il2 = null, al2 = false, o3 = i3.alternate, o3 !== null && (o3.return = null), i3.return = null;
    }
    if (t3.subtreeFlags & 13886) for (t3 = t3.child; t3 !== null; ) ml2(t3, e6), t3 = t3.sibling;
  }
  var pl2 = null;
  function ml2(e6, t3) {
    var n3 = e6.alternate, r2 = e6.flags;
    switch (e6.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        fl2(t3, e6), hl2(e6), r2 & 4 && (Rc2(3, e6, e6.return), Lc2(3, e6), Rc2(5, e6, e6.return));
        break;
      case 1:
        fl2(t3, e6), hl2(e6), r2 & 512 && (Zc2 || n3 === null || Hc2(n3, n3.return)), r2 & 64 && Xc2 && (e6 = e6.updateQueue, e6 !== null && (r2 = e6.callbacks, r2 !== null && (n3 = e6.shared.hiddenCallbacks, e6.shared.hiddenCallbacks = n3 === null ? r2 : n3.concat(r2))));
        break;
      case 26:
        var i3 = pl2;
        if (fl2(t3, e6), hl2(e6), r2 & 512 && (Zc2 || n3 === null || Hc2(n3, n3.return)), r2 & 4) {
          var o3 = n3 === null ? null : n3.memoizedState;
          if (r2 = e6.memoizedState, n3 === null) if (r2 === null) if (e6.stateNode === null) {
            a: {
              r2 = e6.type, n3 = e6.memoizedProps, i3 = i3.ownerDocument || i3;
              b: switch (r2) {
                case "title":
                  o3 = i3.getElementsByTagName("title")[0], (!o3 || o3[lt2] || o3[rt2] || o3.namespaceURI === "http://www.w3.org/2000/svg" || o3.hasAttribute("itemprop")) && (o3 = i3.createElement(r2), i3.head.insertBefore(o3, i3.querySelector("head > title"))), Pd(o3, r2, n3), o3[rt2] = e6, ht2(o3), r2 = o3;
                  break a;
                case "link":
                  var s3 = Vf("link", "href", i3).get(r2 + (n3.href || ""));
                  if (s3) {
                    for (var c3 = 0; c3 < s3.length; c3++) if (o3 = s3[c3], o3.getAttribute("href") === (n3.href == null || n3.href === "" ? null : n3.href) && o3.getAttribute("rel") === (n3.rel == null ? null : n3.rel) && o3.getAttribute("title") === (n3.title == null ? null : n3.title) && o3.getAttribute("crossorigin") === (n3.crossOrigin == null ? null : n3.crossOrigin)) {
                      s3.splice(c3, 1);
                      break b;
                    }
                  }
                  o3 = i3.createElement(r2), Pd(o3, r2, n3), i3.head.appendChild(o3);
                  break;
                case "meta":
                  if (s3 = Vf("meta", "content", i3).get(r2 + (n3.content || ""))) {
                    for (c3 = 0; c3 < s3.length; c3++) if (o3 = s3[c3], o3.getAttribute("content") === (n3.content == null ? null : "" + n3.content) && o3.getAttribute("name") === (n3.name == null ? null : n3.name) && o3.getAttribute("property") === (n3.property == null ? null : n3.property) && o3.getAttribute("http-equiv") === (n3.httpEquiv == null ? null : n3.httpEquiv) && o3.getAttribute("charset") === (n3.charSet == null ? null : n3.charSet)) {
                      s3.splice(c3, 1);
                      break b;
                    }
                  }
                  o3 = i3.createElement(r2), Pd(o3, r2, n3), i3.head.appendChild(o3);
                  break;
                default:
                  throw Error(a2(468, r2));
              }
              o3[rt2] = e6, ht2(o3), r2 = o3;
            }
            e6.stateNode = r2;
          } else Hf(i3, e6.type, e6.stateNode);
          else e6.stateNode = If(i3, r2, e6.memoizedProps);
          else o3 === r2 ? r2 === null && e6.stateNode !== null && Wc2(e6, e6.memoizedProps, n3.memoizedProps) : (o3 === null ? n3.stateNode !== null && (n3 = n3.stateNode, n3.parentNode.removeChild(n3)) : o3.count--, r2 === null ? Hf(i3, e6.type, e6.stateNode) : If(i3, r2, e6.memoizedProps));
        }
        break;
      case 27:
        fl2(t3, e6), hl2(e6), r2 & 512 && (Zc2 || n3 === null || Hc2(n3, n3.return)), n3 !== null && r2 & 4 && Wc2(e6, e6.memoizedProps, n3.memoizedProps);
        break;
      case 5:
        if (fl2(t3, e6), hl2(e6), r2 & 512 && (Zc2 || n3 === null || Hc2(n3, n3.return)), e6.flags & 32) {
          i3 = e6.stateNode;
          try {
            Bt2(i3, "");
          } catch (t4) {
            Uu(e6, e6.return, t4);
          }
        }
        r2 & 4 && e6.stateNode != null && (i3 = e6.memoizedProps, Wc2(e6, i3, n3 === null ? i3 : n3.memoizedProps)), r2 & 1024 && (Qc2 = true);
        break;
      case 6:
        if (fl2(t3, e6), hl2(e6), r2 & 4) {
          if (e6.stateNode === null) throw Error(a2(162));
          r2 = e6.memoizedProps, n3 = e6.stateNode;
          try {
            n3.nodeValue = r2;
          } catch (t4) {
            Uu(e6, e6.return, t4);
          }
        }
        break;
      case 3:
        if (Bf = null, i3 = pl2, pl2 = gf(t3.containerInfo), fl2(t3, e6), pl2 = i3, hl2(e6), r2 & 4 && n3 !== null && n3.memoizedState.isDehydrated) try {
          Np(t3.containerInfo);
        } catch (t4) {
          Uu(e6, e6.return, t4);
        }
        Qc2 && (Qc2 = false, gl2(e6));
        break;
      case 4:
        r2 = pl2, pl2 = gf(e6.stateNode.containerInfo), fl2(t3, e6), hl2(e6), pl2 = r2;
        break;
      case 12:
        fl2(t3, e6), hl2(e6);
        break;
      case 31:
        fl2(t3, e6), hl2(e6), r2 & 4 && (r2 = e6.updateQueue, r2 !== null && (e6.updateQueue = null, dl2(e6, r2)));
        break;
      case 13:
        fl2(t3, e6), hl2(e6), e6.child.flags & 8192 && e6.memoizedState !== null != (n3 !== null && n3.memoizedState !== null) && (Zl = Ce2()), r2 & 4 && (r2 = e6.updateQueue, r2 !== null && (e6.updateQueue = null, dl2(e6, r2)));
        break;
      case 22:
        i3 = e6.memoizedState !== null;
        var l3 = n3 !== null && n3.memoizedState !== null, u3 = Xc2, d3 = Zc2;
        if (Xc2 = u3 || i3, Zc2 = d3 || l3, fl2(t3, e6), Zc2 = d3, Xc2 = u3, hl2(e6), r2 & 8192) a: for (t3 = e6.stateNode, t3._visibility = i3 ? t3._visibility & -2 : t3._visibility | 1, i3 && (n3 === null || l3 || Xc2 || Zc2 || vl2(e6)), n3 = null, t3 = e6; ; ) {
          if (t3.tag === 5 || t3.tag === 26) {
            if (n3 === null) {
              l3 = n3 = t3;
              try {
                if (o3 = l3.stateNode, i3) s3 = o3.style, typeof s3.setProperty == "function" ? s3.setProperty("display", "none", "important") : s3.display = "none";
                else {
                  c3 = l3.stateNode;
                  var f3 = l3.memoizedProps.style, p3 = f3 != null && f3.hasOwnProperty("display") ? f3.display : null;
                  c3.style.display = p3 == null || typeof p3 == "boolean" ? "" : ("" + p3).trim();
                }
              } catch (e7) {
                Uu(l3, l3.return, e7);
              }
            }
          } else if (t3.tag === 6) {
            if (n3 === null) {
              l3 = t3;
              try {
                l3.stateNode.nodeValue = i3 ? "" : l3.memoizedProps;
              } catch (e7) {
                Uu(l3, l3.return, e7);
              }
            }
          } else if (t3.tag === 18) {
            if (n3 === null) {
              l3 = t3;
              try {
                var m3 = l3.stateNode;
                i3 ? $d(m3, true) : $d(l3.stateNode, false);
              } catch (e7) {
                Uu(l3, l3.return, e7);
              }
            }
          } else if ((t3.tag !== 22 && t3.tag !== 23 || t3.memoizedState === null || t3 === e6) && t3.child !== null) {
            t3.child.return = t3, t3 = t3.child;
            continue;
          }
          if (t3 === e6) break a;
          for (; t3.sibling === null; ) {
            if (t3.return === null || t3.return === e6) break a;
            n3 === t3 && (n3 = null), t3 = t3.return;
          }
          n3 === t3 && (n3 = null), t3.sibling.return = t3.return, t3 = t3.sibling;
        }
        r2 & 4 && (r2 = e6.updateQueue, r2 !== null && (n3 = r2.retryQueue, n3 !== null && (r2.retryQueue = null, dl2(e6, n3))));
        break;
      case 19:
        fl2(t3, e6), hl2(e6), r2 & 4 && (r2 = e6.updateQueue, r2 !== null && (e6.updateQueue = null, dl2(e6, r2)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        fl2(t3, e6), hl2(e6);
    }
  }
  function hl2(e6) {
    var t3 = e6.flags;
    if (t3 & 2) {
      try {
        for (var n3, r2 = e6.return; r2 !== null; ) {
          if (Gc2(r2)) {
            n3 = r2;
            break;
          }
          r2 = r2.return;
        }
        if (n3 == null) throw Error(a2(160));
        switch (n3.tag) {
          case 27:
            var i3 = n3.stateNode;
            Jc2(e6, Kc2(e6), i3);
            break;
          case 5:
            var o3 = n3.stateNode;
            n3.flags & 32 && (Bt2(o3, ""), n3.flags &= -33), Jc2(e6, Kc2(e6), o3);
            break;
          case 3:
          case 4:
            var s3 = n3.stateNode.containerInfo;
            qc2(e6, Kc2(e6), s3);
            break;
          default:
            throw Error(a2(161));
        }
      } catch (t4) {
        Uu(e6, e6.return, t4);
      }
      e6.flags &= -3;
    }
    t3 & 4096 && (e6.flags &= -4097);
  }
  function gl2(e6) {
    if (e6.subtreeFlags & 1024) for (e6 = e6.child; e6 !== null; ) {
      var t3 = e6;
      gl2(t3), t3.tag === 5 && t3.flags & 1024 && t3.stateNode.reset(), e6 = e6.sibling;
    }
  }
  function _l2(e6, t3) {
    if (t3.subtreeFlags & 8772) for (t3 = t3.child; t3 !== null; ) nl2(e6, t3.alternate, t3), t3 = t3.sibling;
  }
  function vl2(e6) {
    for (e6 = e6.child; e6 !== null; ) {
      var t3 = e6;
      switch (t3.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Rc2(4, t3, t3.return), vl2(t3);
          break;
        case 1:
          Hc2(t3, t3.return);
          var n3 = t3.stateNode;
          typeof n3.componentWillUnmount == "function" && Bc2(t3, t3.return, n3), vl2(t3);
          break;
        case 27:
          pf(t3.stateNode);
        case 26:
        case 5:
          Hc2(t3, t3.return), vl2(t3);
          break;
        case 22:
          t3.memoizedState === null && vl2(t3);
          break;
        case 30:
          vl2(t3);
          break;
        default:
          vl2(t3);
      }
      e6 = e6.sibling;
    }
  }
  function yl2(e6, t3, n3) {
    for (n3 &&= (t3.subtreeFlags & 8772) != 0, t3 = t3.child; t3 !== null; ) {
      var r2 = t3.alternate, i3 = e6, a3 = t3, o3 = a3.flags;
      switch (a3.tag) {
        case 0:
        case 11:
        case 15:
          yl2(i3, a3, n3), Lc2(4, a3);
          break;
        case 1:
          if (yl2(i3, a3, n3), r2 = a3, i3 = r2.stateNode, typeof i3.componentDidMount == "function") try {
            i3.componentDidMount();
          } catch (e7) {
            Uu(r2, r2.return, e7);
          }
          if (r2 = a3, i3 = r2.updateQueue, i3 !== null) {
            var s3 = r2.stateNode;
            try {
              var c3 = i3.shared.hiddenCallbacks;
              if (c3 !== null) for (i3.shared.hiddenCallbacks = null, i3 = 0; i3 < c3.length; i3++) Ha2(c3[i3], s3);
            } catch (e7) {
              Uu(r2, r2.return, e7);
            }
          }
          n3 && o3 & 64 && zc2(a3), Vc2(a3, a3.return);
          break;
        case 27:
          Yc2(a3);
        case 26:
        case 5:
          yl2(i3, a3, n3), n3 && r2 === null && o3 & 4 && Uc2(a3), Vc2(a3, a3.return);
          break;
        case 12:
          yl2(i3, a3, n3);
          break;
        case 31:
          yl2(i3, a3, n3), n3 && o3 & 4 && cl2(i3, a3);
          break;
        case 13:
          yl2(i3, a3, n3), n3 && o3 & 4 && ll2(i3, a3);
          break;
        case 22:
          a3.memoizedState === null && yl2(i3, a3, n3), Vc2(a3, a3.return);
          break;
        case 30:
          break;
        default:
          yl2(i3, a3, n3);
      }
      t3 = t3.sibling;
    }
  }
  function bl2(e6, t3) {
    var n3 = null;
    e6 !== null && e6.memoizedState !== null && e6.memoizedState.cachePool !== null && (n3 = e6.memoizedState.cachePool.pool), e6 = null, t3.memoizedState !== null && t3.memoizedState.cachePool !== null && (e6 = t3.memoizedState.cachePool.pool), e6 !== n3 && (e6 != null && e6.refCount++, n3 != null && ta2(n3));
  }
  function xl2(e6, t3) {
    e6 = null, t3.alternate !== null && (e6 = t3.alternate.memoizedState.cache), t3 = t3.memoizedState.cache, t3 !== e6 && (t3.refCount++, e6 != null && ta2(e6));
  }
  function Sl2(e6, t3, n3, r2) {
    if (t3.subtreeFlags & 10256) for (t3 = t3.child; t3 !== null; ) Cl2(e6, t3, n3, r2), t3 = t3.sibling;
  }
  function Cl2(e6, t3, n3, r2) {
    var i3 = t3.flags;
    switch (t3.tag) {
      case 0:
      case 11:
      case 15:
        Sl2(e6, t3, n3, r2), i3 & 2048 && Lc2(9, t3);
        break;
      case 1:
        Sl2(e6, t3, n3, r2);
        break;
      case 3:
        Sl2(e6, t3, n3, r2), i3 & 2048 && (e6 = null, t3.alternate !== null && (e6 = t3.alternate.memoizedState.cache), t3 = t3.memoizedState.cache, t3 !== e6 && (t3.refCount++, e6 != null && ta2(e6)));
        break;
      case 12:
        if (i3 & 2048) {
          Sl2(e6, t3, n3, r2), e6 = t3.stateNode;
          try {
            var a3 = t3.memoizedProps, o3 = a3.id, s3 = a3.onPostCommit;
            typeof s3 == "function" && s3(o3, t3.alternate === null ? "mount" : "update", e6.passiveEffectDuration, -0);
          } catch (e7) {
            Uu(t3, t3.return, e7);
          }
        } else Sl2(e6, t3, n3, r2);
        break;
      case 31:
        Sl2(e6, t3, n3, r2);
        break;
      case 13:
        Sl2(e6, t3, n3, r2);
        break;
      case 23:
        break;
      case 22:
        a3 = t3.stateNode, o3 = t3.alternate, t3.memoizedState === null ? a3._visibility & 2 ? Sl2(e6, t3, n3, r2) : (a3._visibility |= 2, wl2(e6, t3, n3, r2, (t3.subtreeFlags & 10256) != 0 || false)) : a3._visibility & 2 ? Sl2(e6, t3, n3, r2) : Tl2(e6, t3), i3 & 2048 && bl2(o3, t3);
        break;
      case 24:
        Sl2(e6, t3, n3, r2), i3 & 2048 && xl2(t3.alternate, t3);
        break;
      default:
        Sl2(e6, t3, n3, r2);
    }
  }
  function wl2(e6, t3, n3, r2, i3) {
    for (i3 &&= (t3.subtreeFlags & 10256) != 0 || false, t3 = t3.child; t3 !== null; ) {
      var a3 = e6, o3 = t3, s3 = n3, c3 = r2, l3 = o3.flags;
      switch (o3.tag) {
        case 0:
        case 11:
        case 15:
          wl2(a3, o3, s3, c3, i3), Lc2(8, o3);
          break;
        case 23:
          break;
        case 22:
          var u3 = o3.stateNode;
          o3.memoizedState === null ? (u3._visibility |= 2, wl2(a3, o3, s3, c3, i3)) : u3._visibility & 2 ? wl2(a3, o3, s3, c3, i3) : Tl2(a3, o3), i3 && l3 & 2048 && bl2(o3.alternate, o3);
          break;
        case 24:
          wl2(a3, o3, s3, c3, i3), i3 && l3 & 2048 && xl2(o3.alternate, o3);
          break;
        default:
          wl2(a3, o3, s3, c3, i3);
      }
      t3 = t3.sibling;
    }
  }
  function Tl2(e6, t3) {
    if (t3.subtreeFlags & 10256) for (t3 = t3.child; t3 !== null; ) {
      var n3 = e6, r2 = t3, i3 = r2.flags;
      switch (r2.tag) {
        case 22:
          Tl2(n3, r2), i3 & 2048 && bl2(r2.alternate, r2);
          break;
        case 24:
          Tl2(n3, r2), i3 & 2048 && xl2(r2.alternate, r2);
          break;
        default:
          Tl2(n3, r2);
      }
      t3 = t3.sibling;
    }
  }
  var El2 = 8192;
  function Dl2(e6, t3, n3) {
    if (e6.subtreeFlags & El2) for (e6 = e6.child; e6 !== null; ) Ol2(e6, t3, n3), e6 = e6.sibling;
  }
  function Ol2(e6, t3, n3) {
    switch (e6.tag) {
      case 26:
        Dl2(e6, t3, n3), e6.flags & El2 && e6.memoizedState !== null && Gf(n3, pl2, e6.memoizedState, e6.memoizedProps);
        break;
      case 5:
        Dl2(e6, t3, n3);
        break;
      case 3:
      case 4:
        var r2 = pl2;
        pl2 = gf(e6.stateNode.containerInfo), Dl2(e6, t3, n3), pl2 = r2;
        break;
      case 22:
        e6.memoizedState === null && (r2 = e6.alternate, r2 !== null && r2.memoizedState !== null ? (r2 = El2, El2 = 16777216, Dl2(e6, t3, n3), El2 = r2) : Dl2(e6, t3, n3));
        break;
      default:
        Dl2(e6, t3, n3);
    }
  }
  function kl2(e6) {
    var t3 = e6.alternate;
    if (t3 !== null && (e6 = t3.child, e6 !== null)) {
      t3.child = null;
      do
        t3 = e6.sibling, e6.sibling = null, e6 = t3;
      while (e6 !== null);
    }
  }
  function Al2(e6) {
    var t3 = e6.deletions;
    if (e6.flags & 16) {
      if (t3 !== null) for (var n3 = 0; n3 < t3.length; n3++) {
        var r2 = t3[n3];
        el2 = r2, Nl2(r2, e6);
      }
      kl2(e6);
    }
    if (e6.subtreeFlags & 10256) for (e6 = e6.child; e6 !== null; ) jl2(e6), e6 = e6.sibling;
  }
  function jl2(e6) {
    switch (e6.tag) {
      case 0:
      case 11:
      case 15:
        Al2(e6), e6.flags & 2048 && Rc2(9, e6, e6.return);
        break;
      case 3:
        Al2(e6);
        break;
      case 12:
        Al2(e6);
        break;
      case 22:
        var t3 = e6.stateNode;
        e6.memoizedState !== null && t3._visibility & 2 && (e6.return === null || e6.return.tag !== 13) ? (t3._visibility &= -3, Ml2(e6)) : Al2(e6);
        break;
      default:
        Al2(e6);
    }
  }
  function Ml2(e6) {
    var t3 = e6.deletions;
    if (e6.flags & 16) {
      if (t3 !== null) for (var n3 = 0; n3 < t3.length; n3++) {
        var r2 = t3[n3];
        el2 = r2, Nl2(r2, e6);
      }
      kl2(e6);
    }
    for (e6 = e6.child; e6 !== null; ) {
      switch (t3 = e6, t3.tag) {
        case 0:
        case 11:
        case 15:
          Rc2(8, t3, t3.return), Ml2(t3);
          break;
        case 22:
          n3 = t3.stateNode, n3._visibility & 2 && (n3._visibility &= -3, Ml2(t3));
          break;
        default:
          Ml2(t3);
      }
      e6 = e6.sibling;
    }
  }
  function Nl2(e6, t3) {
    for (; el2 !== null; ) {
      var n3 = el2;
      switch (n3.tag) {
        case 0:
        case 11:
        case 15:
          Rc2(8, n3, t3);
          break;
        case 23:
        case 22:
          if (n3.memoizedState !== null && n3.memoizedState.cachePool !== null) {
            var r2 = n3.memoizedState.cachePool.pool;
            r2 != null && r2.refCount++;
          }
          break;
        case 24:
          ta2(n3.memoizedState.cache);
      }
      if (r2 = n3.child, r2 !== null) r2.return = n3, el2 = r2;
      else a: for (n3 = e6; el2 !== null; ) {
        r2 = el2;
        var i3 = r2.sibling, a3 = r2.return;
        if (rl2(r2), r2 === n3) {
          el2 = null;
          break a;
        }
        if (i3 !== null) {
          i3.return = a3, el2 = i3;
          break a;
        }
        el2 = a3;
      }
    }
  }
  var Pl2 = { getCacheForType: function(e6) {
    var t3 = qi2($i2), n3 = t3.data.get(e6);
    return n3 === void 0 && (n3 = e6(), t3.data.set(e6, n3)), n3;
  }, cacheSignal: function() {
    return qi2($i2).controller.signal;
  } }, Fl2 = typeof WeakMap == "function" ? WeakMap : Map, Y2 = 0, Il2 = null, X2 = null, Z2 = 0, Q2 = 0, Ll2 = null, Rl2 = false, zl2 = false, Bl2 = false, Vl2 = 0, Hl2 = 0, Ul2 = 0, Wl2 = 0, Gl = 0, Kl = 0, ql = 0, Jl = null, Yl = null, Xl = false, Zl = 0, Ql = 0, $l = 1 / 0, eu = null, tu = null, nu = 0, ru = null, iu = null, au = 0, ou = 0, su = null, cu = null, lu = 0, uu = null;
  function du() {
    return Y2 & 2 && Z2 !== 0 ? Z2 & -Z2 : P2.T === null ? et2() : ud();
  }
  function fu() {
    if (Kl === 0) if (!(Z2 & 536870912) || q2) {
      var e6 = Be2;
      Be2 <<= 1, !(Be2 & 3932160) && (Be2 = 262144), Kl = e6;
    } else Kl = 536870912;
    return e6 = Ya2.current, e6 !== null && (e6.flags |= 32), Kl;
  }
  function pu(e6, t3, n3) {
    (e6 === Il2 && (Q2 === 2 || Q2 === 9) || e6.cancelPendingCommit !== null) && (bu(e6, 0), _u(e6, Z2, Kl, false)), qe2(e6, n3), (!(Y2 & 2) || e6 !== Il2) && (e6 === Il2 && (!(Y2 & 2) && (Wl2 |= n3), Hl2 === 4 && _u(e6, Z2, Kl, false)), nd(e6));
  }
  function mu(e6, t3, n3) {
    if (Y2 & 6) throw Error(a2(327));
    var r2 = !n3 && (t3 & 127) == 0 && (t3 & e6.expiredLanes) === 0 || Ue2(e6, t3), i3 = r2 ? Ou(e6, t3) : Eu(e6, t3, true), o3 = r2;
    do {
      if (i3 === 0) {
        zl2 && !r2 && _u(e6, t3, 0, false);
        break;
      } else {
        if (n3 = e6.current.alternate, o3 && !gu(n3)) {
          i3 = Eu(e6, t3, false), o3 = false;
          continue;
        }
        if (i3 === 2) {
          if (o3 = t3, e6.errorRecoveryDisabledLanes & o3) var s3 = 0;
          else s3 = e6.pendingLanes & -536870913, s3 = s3 === 0 ? s3 & 536870912 ? 536870912 : 0 : s3;
          if (s3 !== 0) {
            t3 = s3;
            a: {
              var c3 = e6;
              i3 = Jl;
              var l3 = c3.current.memoizedState.isDehydrated;
              if (l3 && (bu(c3, s3).flags |= 256), s3 = Eu(c3, s3, false), s3 !== 2) {
                if (Bl2 && !l3) {
                  c3.errorRecoveryDisabledLanes |= o3, Wl2 |= o3, i3 = 4;
                  break a;
                }
                o3 = Yl, Yl = i3, o3 !== null && (Yl === null ? Yl = o3 : Yl.push.apply(Yl, o3));
              }
              i3 = s3;
            }
            if (o3 = false, i3 !== 2) continue;
          }
        }
        if (i3 === 1) {
          bu(e6, 0), _u(e6, t3, 0, true);
          break;
        }
        a: {
          switch (r2 = e6, o3 = i3, o3) {
            case 0:
            case 1:
              throw Error(a2(345));
            case 4:
              if ((t3 & 4194048) !== t3) break;
            case 6:
              _u(r2, t3, Kl, !Rl2);
              break a;
            case 2:
              Yl = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(a2(329));
          }
          if ((t3 & 62914560) === t3 && (i3 = Zl + 300 - Ce2(), 10 < i3)) {
            if (_u(r2, t3, Kl, !Rl2), He2(r2, 0, true) !== 0) break a;
            au = t3, r2.timeoutHandle = Kd(hu.bind(null, r2, n3, Yl, eu, Xl, t3, Kl, Wl2, ql, Rl2, o3, "Throttled", -0, 0), i3);
            break a;
          }
          hu(r2, n3, Yl, eu, Xl, t3, Kl, Wl2, ql, Rl2, o3, null, -0, 0);
        }
      }
      break;
    } while (true);
    nd(e6);
  }
  function hu(e6, t3, n3, r2, i3, a3, o3, s3, c3, l3, u3, d3, f3, p3) {
    if (e6.timeoutHandle = -1, d3 = t3.subtreeFlags, d3 & 8192 || (d3 & 16785408) == 16785408) {
      d3 = { stylesheets: null, count: 0, imgCount: 0, imgBytes: 0, suspenseyImages: [], waitingForImages: true, waitingForViewTransition: false, unsuspend: Jt2 }, Ol2(t3, a3, d3);
      var m3 = (a3 & 62914560) === a3 ? Zl - Ce2() : (a3 & 4194048) === a3 ? Ql - Ce2() : 0;
      if (m3 = qf(d3, m3), m3 !== null) {
        au = a3, e6.cancelPendingCommit = m3(Fu.bind(null, e6, t3, a3, n3, r2, i3, o3, s3, c3, u3, d3, null, f3, p3)), _u(e6, a3, o3, !l3);
        return;
      }
    }
    Fu(e6, t3, a3, n3, r2, i3, o3, s3, c3);
  }
  function gu(e6) {
    for (var t3 = e6; ; ) {
      var n3 = t3.tag;
      if ((n3 === 0 || n3 === 11 || n3 === 15) && t3.flags & 16384 && (n3 = t3.updateQueue, n3 !== null && (n3 = n3.stores, n3 !== null))) for (var r2 = 0; r2 < n3.length; r2++) {
        var i3 = n3[r2], a3 = i3.getSnapshot;
        i3 = i3.value;
        try {
          if (!mr2(a3(), i3)) return false;
        } catch {
          return false;
        }
      }
      if (n3 = t3.child, t3.subtreeFlags & 16384 && n3 !== null) n3.return = t3, t3 = n3;
      else {
        if (t3 === e6) break;
        for (; t3.sibling === null; ) {
          if (t3.return === null || t3.return === e6) return true;
          t3 = t3.return;
        }
        t3.sibling.return = t3.return, t3 = t3.sibling;
      }
    }
    return true;
  }
  function _u(e6, t3, n3, r2) {
    t3 &= ~Gl, t3 &= ~Wl2, e6.suspendedLanes |= t3, e6.pingedLanes &= ~t3, r2 && (e6.warmLanes |= t3), r2 = e6.expirationTimes;
    for (var i3 = t3; 0 < i3; ) {
      var a3 = 31 - Fe2(i3), o3 = 1 << a3;
      r2[a3] = -1, i3 &= ~o3;
    }
    n3 !== 0 && Ye2(e6, n3, t3);
  }
  function vu() {
    return Y2 & 6 ? true : (rd(0, false), false);
  }
  function yu() {
    if (X2 !== null) {
      if (Q2 === 0) var e6 = X2.return;
      else e6 = X2, zi2 = Ri2 = null, Co2(e6), wa2 = null, Ta2 = 0, e6 = X2;
      for (; e6 !== null; ) Ic2(e6.alternate, e6), e6 = e6.return;
      X2 = null;
    }
  }
  function bu(e6, t3) {
    var n3 = e6.timeoutHandle;
    n3 !== -1 && (e6.timeoutHandle = -1, qd(n3)), n3 = e6.cancelPendingCommit, n3 !== null && (e6.cancelPendingCommit = null, n3()), au = 0, yu(), Il2 = e6, X2 = n3 = ni2(e6.current, null), Z2 = t3, Q2 = 0, Ll2 = null, Rl2 = false, zl2 = Ue2(e6, t3), Bl2 = false, ql = Kl = Gl = Wl2 = Ul2 = Hl2 = 0, Yl = Jl = null, Xl = false, t3 & 8 && (t3 |= t3 & 32);
    var r2 = e6.entangledLanes;
    if (r2 !== 0) for (e6 = e6.entanglements, r2 &= t3; 0 < r2; ) {
      var i3 = 31 - Fe2(r2), a3 = 1 << i3;
      t3 |= e6[i3], r2 &= ~a3;
    }
    return Vl2 = t3, Kr2(), n3;
  }
  function xu(e6, t3) {
    J2 = null, P2.H = Ns2, t3 === ma2 || t3 === ga2 ? (t3 = Sa2(), Q2 = 3) : t3 === ha2 ? (t3 = Sa2(), Q2 = 4) : Q2 = t3 === Zs2 ? 8 : typeof t3 == "object" && t3 && typeof t3.then == "function" ? 6 : 1, Ll2 = t3, X2 === null && (Hl2 = 1, Gs2(e6, ui2(t3, e6.current)));
  }
  function Su() {
    var e6 = Ya2.current;
    return e6 === null ? true : (Z2 & 4194048) === Z2 ? Xa2 === null : (Z2 & 62914560) === Z2 || Z2 & 536870912 ? e6 === Xa2 : false;
  }
  function Cu() {
    var e6 = P2.H;
    return P2.H = Ns2, e6 === null ? Ns2 : e6;
  }
  function wu() {
    var e6 = P2.A;
    return P2.A = Pl2, e6;
  }
  function Tu() {
    Hl2 = 4, Rl2 || (Z2 & 4194048) !== Z2 && Ya2.current !== null || (zl2 = true), !(Ul2 & 134217727) && !(Wl2 & 134217727) || Il2 === null || _u(Il2, Z2, Kl, false);
  }
  function Eu(e6, t3, n3) {
    var r2 = Y2;
    Y2 |= 2;
    var i3 = Cu(), a3 = wu();
    (Il2 !== e6 || Z2 !== t3) && (eu = null, bu(e6, t3)), t3 = false;
    var o3 = Hl2;
    a: do
      try {
        if (Q2 !== 0 && X2 !== null) {
          var s3 = X2, c3 = Ll2;
          switch (Q2) {
            case 8:
              yu(), o3 = 6;
              break a;
            case 3:
            case 2:
            case 9:
            case 6:
              Ya2.current === null && (t3 = true);
              var l3 = Q2;
              if (Q2 = 0, Ll2 = null, Mu(e6, s3, c3, l3), n3 && zl2) {
                o3 = 0;
                break a;
              }
              break;
            default:
              l3 = Q2, Q2 = 0, Ll2 = null, Mu(e6, s3, c3, l3);
          }
        }
        Du(), o3 = Hl2;
        break;
      } catch (t4) {
        xu(e6, t4);
      }
    while (true);
    return t3 && e6.shellSuspendCounter++, zi2 = Ri2 = null, Y2 = r2, P2.H = i3, P2.A = a3, X2 === null && (Il2 = null, Z2 = 0, Kr2()), o3;
  }
  function Du() {
    for (; X2 !== null; ) Au(X2);
  }
  function Ou(e6, t3) {
    var n3 = Y2;
    Y2 |= 2;
    var r2 = Cu(), i3 = wu();
    Il2 !== e6 || Z2 !== t3 ? (eu = null, $l = Ce2() + 500, bu(e6, t3)) : zl2 = Ue2(e6, t3);
    a: do
      try {
        if (Q2 !== 0 && X2 !== null) {
          t3 = X2;
          var o3 = Ll2;
          b: switch (Q2) {
            case 1:
              Q2 = 0, Ll2 = null, Mu(e6, t3, o3, 1);
              break;
            case 2:
            case 9:
              if (va2(o3)) {
                Q2 = 0, Ll2 = null, ju(t3);
                break;
              }
              t3 = function() {
                Q2 !== 2 && Q2 !== 9 || Il2 !== e6 || (Q2 = 7), nd(e6);
              }, o3.then(t3, t3);
              break a;
            case 3:
              Q2 = 7;
              break a;
            case 4:
              Q2 = 5;
              break a;
            case 7:
              va2(o3) ? (Q2 = 0, Ll2 = null, ju(t3)) : (Q2 = 0, Ll2 = null, Mu(e6, t3, o3, 7));
              break;
            case 5:
              var s3 = null;
              switch (X2.tag) {
                case 26:
                  s3 = X2.memoizedState;
                case 5:
                case 27:
                  var c3 = X2;
                  if (s3 ? Wf(s3) : c3.stateNode.complete) {
                    Q2 = 0, Ll2 = null;
                    var l3 = c3.sibling;
                    if (l3 !== null) X2 = l3;
                    else {
                      var u3 = c3.return;
                      u3 === null ? X2 = null : (X2 = u3, Nu(u3));
                    }
                    break b;
                  }
              }
              Q2 = 0, Ll2 = null, Mu(e6, t3, o3, 5);
              break;
            case 6:
              Q2 = 0, Ll2 = null, Mu(e6, t3, o3, 6);
              break;
            case 8:
              yu(), Hl2 = 6;
              break a;
            default:
              throw Error(a2(462));
          }
        }
        ku();
        break;
      } catch (t4) {
        xu(e6, t4);
      }
    while (true);
    return zi2 = Ri2 = null, P2.H = r2, P2.A = i3, Y2 = n3, X2 === null ? (Il2 = null, Z2 = 0, Kr2(), Hl2) : 0;
  }
  function ku() {
    for (; X2 !== null && !xe2(); ) Au(X2);
  }
  function Au(e6) {
    var t3 = Dc2(e6.alternate, e6, Vl2);
    e6.memoizedProps = e6.pendingProps, t3 === null ? Nu(e6) : X2 = t3;
  }
  function ju(e6) {
    var t3 = e6, n3 = t3.alternate;
    switch (t3.tag) {
      case 15:
      case 0:
        t3 = dc2(n3, t3, t3.pendingProps, t3.type, void 0, Z2);
        break;
      case 11:
        t3 = dc2(n3, t3, t3.pendingProps, t3.type.render, t3.ref, Z2);
        break;
      case 5:
        Co2(t3);
      default:
        Ic2(n3, t3), t3 = X2 = ri2(t3, Vl2), t3 = Dc2(n3, t3, Vl2);
    }
    e6.memoizedProps = e6.pendingProps, t3 === null ? Nu(e6) : X2 = t3;
  }
  function Mu(e6, t3, n3, r2) {
    zi2 = Ri2 = null, Co2(t3), wa2 = null, Ta2 = 0;
    var i3 = t3.return;
    try {
      if (Xs2(e6, i3, t3, n3, Z2)) {
        Hl2 = 1, Gs2(e6, ui2(n3, e6.current)), X2 = null;
        return;
      }
    } catch (t4) {
      if (i3 !== null) throw X2 = i3, t4;
      Hl2 = 1, Gs2(e6, ui2(n3, e6.current)), X2 = null;
      return;
    }
    t3.flags & 32768 ? (q2 || r2 === 1 ? e6 = true : zl2 || Z2 & 536870912 ? e6 = false : (Rl2 = e6 = true, (r2 === 2 || r2 === 9 || r2 === 3 || r2 === 6) && (r2 = Ya2.current, r2 !== null && r2.tag === 13 && (r2.flags |= 16384))), Pu(t3, e6)) : Nu(t3);
  }
  function Nu(e6) {
    var t3 = e6;
    do {
      if (t3.flags & 32768) {
        Pu(t3, Rl2);
        return;
      }
      e6 = t3.return;
      var n3 = Pc2(t3.alternate, t3, Vl2);
      if (n3 !== null) {
        X2 = n3;
        return;
      }
      if (t3 = t3.sibling, t3 !== null) {
        X2 = t3;
        return;
      }
      X2 = t3 = e6;
    } while (t3 !== null);
    Hl2 === 0 && (Hl2 = 5);
  }
  function Pu(e6, t3) {
    do {
      var n3 = Fc2(e6.alternate, e6);
      if (n3 !== null) {
        n3.flags &= 32767, X2 = n3;
        return;
      }
      if (n3 = e6.return, n3 !== null && (n3.flags |= 32768, n3.subtreeFlags = 0, n3.deletions = null), !t3 && (e6 = e6.sibling, e6 !== null)) {
        X2 = e6;
        return;
      }
      X2 = e6 = n3;
    } while (e6 !== null);
    Hl2 = 6, X2 = null;
  }
  function Fu(e6, t3, n3, r2, i3, o3, s3, c3, l3) {
    e6.cancelPendingCommit = null;
    do
      Bu();
    while (nu !== 0);
    if (Y2 & 6) throw Error(a2(327));
    if (t3 !== null) {
      if (t3 === e6.current) throw Error(a2(177));
      if (o3 = t3.lanes | t3.childLanes, o3 |= Gr2, Je2(e6, n3, o3, s3, c3, l3), e6 === Il2 && (X2 = Il2 = null, Z2 = 0), iu = t3, ru = e6, au = n3, ou = o3, su = i3, cu = r2, t3.subtreeFlags & 10256 || t3.flags & 10256 ? (e6.callbackNode = null, e6.callbackPriority = 0, Yu(De2, function() {
        return Vu(), null;
      })) : (e6.callbackNode = null, e6.callbackPriority = 0), r2 = (t3.flags & 13878) != 0, t3.subtreeFlags & 13878 || r2) {
        r2 = P2.T, P2.T = null, i3 = F2.p, F2.p = 2, s3 = Y2, Y2 |= 4;
        try {
          tl2(e6, t3, n3);
        } finally {
          Y2 = s3, F2.p = i3, P2.T = r2;
        }
      }
      nu = 1, Iu(), Lu(), Ru();
    }
  }
  function Iu() {
    if (nu === 1) {
      nu = 0;
      var e6 = ru, t3 = iu, n3 = (t3.flags & 13878) != 0;
      if (t3.subtreeFlags & 13878 || n3) {
        n3 = P2.T, P2.T = null;
        var r2 = F2.p;
        F2.p = 2;
        var i3 = Y2;
        Y2 |= 4;
        try {
          ml2(t3, e6);
          var a3 = zd, o3 = yr2(e6.containerInfo), s3 = a3.focusedElem, c3 = a3.selectionRange;
          if (o3 !== s3 && s3 && s3.ownerDocument && vr2(s3.ownerDocument.documentElement, s3)) {
            if (c3 !== null && br2(s3)) {
              var l3 = c3.start, u3 = c3.end;
              if (u3 === void 0 && (u3 = l3), "selectionStart" in s3) s3.selectionStart = l3, s3.selectionEnd = Math.min(u3, s3.value.length);
              else {
                var d3 = s3.ownerDocument || document, f3 = d3 && d3.defaultView || window;
                if (f3.getSelection) {
                  var p3 = f3.getSelection(), m3 = s3.textContent.length, h3 = Math.min(c3.start, m3), g3 = c3.end === void 0 ? h3 : Math.min(c3.end, m3);
                  !p3.extend && h3 > g3 && (o3 = g3, g3 = h3, h3 = o3);
                  var _3 = _r2(s3, h3), v3 = _r2(s3, g3);
                  if (_3 && v3 && (p3.rangeCount !== 1 || p3.anchorNode !== _3.node || p3.anchorOffset !== _3.offset || p3.focusNode !== v3.node || p3.focusOffset !== v3.offset)) {
                    var y3 = d3.createRange();
                    y3.setStart(_3.node, _3.offset), p3.removeAllRanges(), h3 > g3 ? (p3.addRange(y3), p3.extend(v3.node, v3.offset)) : (y3.setEnd(v3.node, v3.offset), p3.addRange(y3));
                  }
                }
              }
            }
            for (d3 = [], p3 = s3; p3 = p3.parentNode; ) p3.nodeType === 1 && d3.push({ element: p3, left: p3.scrollLeft, top: p3.scrollTop });
            for (typeof s3.focus == "function" && s3.focus(), s3 = 0; s3 < d3.length; s3++) {
              var b3 = d3[s3];
              b3.element.scrollLeft = b3.left, b3.element.scrollTop = b3.top;
            }
          }
          sp = !!Rd, zd = Rd = null;
        } finally {
          Y2 = i3, F2.p = r2, P2.T = n3;
        }
      }
      e6.current = t3, nu = 2;
    }
  }
  function Lu() {
    if (nu === 2) {
      nu = 0;
      var e6 = ru, t3 = iu, n3 = (t3.flags & 8772) != 0;
      if (t3.subtreeFlags & 8772 || n3) {
        n3 = P2.T, P2.T = null;
        var r2 = F2.p;
        F2.p = 2;
        var i3 = Y2;
        Y2 |= 4;
        try {
          nl2(e6, t3.alternate, t3);
        } finally {
          Y2 = i3, F2.p = r2, P2.T = n3;
        }
      }
      nu = 3;
    }
  }
  function Ru() {
    if (nu === 4 || nu === 3) {
      nu = 0, Se2();
      var e6 = ru, t3 = iu, n3 = au, r2 = cu;
      t3.subtreeFlags & 10256 || t3.flags & 10256 ? nu = 5 : (nu = 0, iu = ru = null, zu(e6, e6.pendingLanes));
      var i3 = e6.pendingLanes;
      if (i3 === 0 && (tu = null), $e2(n3), t3 = t3.stateNode, Ne2 && typeof Ne2.onCommitFiberRoot == "function") try {
        Ne2.onCommitFiberRoot(je2, t3, void 0, (t3.current.flags & 128) == 128);
      } catch {
      }
      if (r2 !== null) {
        t3 = P2.T, i3 = F2.p, F2.p = 2, P2.T = null;
        try {
          for (var a3 = e6.onRecoverableError, o3 = 0; o3 < r2.length; o3++) {
            var s3 = r2[o3];
            a3(s3.value, { componentStack: s3.stack });
          }
        } finally {
          P2.T = t3, F2.p = i3;
        }
      }
      au & 3 && Bu(), nd(e6), i3 = e6.pendingLanes, n3 & 261930 && i3 & 42 ? e6 === uu ? lu++ : (lu = 0, uu = e6) : lu = 0, rd(0, false);
    }
  }
  function zu(e6, t3) {
    (e6.pooledCacheLanes &= t3) === 0 && (t3 = e6.pooledCache, t3 != null && (e6.pooledCache = null, ta2(t3)));
  }
  function Bu() {
    return Iu(), Lu(), Ru(), Vu();
  }
  function Vu() {
    if (nu !== 5) return false;
    var e6 = ru, t3 = ou;
    ou = 0;
    var n3 = $e2(au), r2 = P2.T, i3 = F2.p;
    try {
      F2.p = 32 > n3 ? 32 : n3, P2.T = null, n3 = su, su = null;
      var o3 = ru, s3 = au;
      if (nu = 0, iu = ru = null, au = 0, Y2 & 6) throw Error(a2(331));
      var c3 = Y2;
      if (Y2 |= 4, jl2(o3.current), Cl2(o3, o3.current, s3, n3), Y2 = c3, rd(0, false), Ne2 && typeof Ne2.onPostCommitFiberRoot == "function") try {
        Ne2.onPostCommitFiberRoot(je2, o3);
      } catch {
      }
      return true;
    } finally {
      F2.p = i3, P2.T = r2, zu(e6, t3);
    }
  }
  function Hu(e6, t3, n3) {
    t3 = ui2(n3, t3), t3 = qs2(e6.stateNode, t3, 2), e6 = Ia2(e6, t3, 2), e6 !== null && (qe2(e6, 2), nd(e6));
  }
  function Uu(e6, t3, n3) {
    if (e6.tag === 3) Hu(e6, e6, n3);
    else for (; t3 !== null; ) {
      if (t3.tag === 3) {
        Hu(t3, e6, n3);
        break;
      } else if (t3.tag === 1) {
        var r2 = t3.stateNode;
        if (typeof t3.type.getDerivedStateFromError == "function" || typeof r2.componentDidCatch == "function" && (tu === null || !tu.has(r2))) {
          e6 = ui2(n3, e6), n3 = Js2(2), r2 = Ia2(t3, n3, 2), r2 !== null && (Ys2(n3, r2, t3, e6), qe2(r2, 2), nd(r2));
          break;
        }
      }
      t3 = t3.return;
    }
  }
  function Wu(e6, t3, n3) {
    var r2 = e6.pingCache;
    if (r2 === null) {
      r2 = e6.pingCache = new Fl2();
      var i3 = /* @__PURE__ */ new Set();
      r2.set(t3, i3);
    } else i3 = r2.get(t3), i3 === void 0 && (i3 = /* @__PURE__ */ new Set(), r2.set(t3, i3));
    i3.has(n3) || (Bl2 = true, i3.add(n3), e6 = Gu.bind(null, e6, t3, n3), t3.then(e6, e6));
  }
  function Gu(e6, t3, n3) {
    var r2 = e6.pingCache;
    r2 !== null && r2.delete(t3), e6.pingedLanes |= e6.suspendedLanes & n3, e6.warmLanes &= ~n3, Il2 === e6 && (Z2 & n3) === n3 && (Hl2 === 4 || Hl2 === 3 && (Z2 & 62914560) === Z2 && 300 > Ce2() - Zl ? !(Y2 & 2) && bu(e6, 0) : Gl |= n3, ql === Z2 && (ql = 0)), nd(e6);
  }
  function Ku(e6, t3) {
    t3 === 0 && (t3 = Ge2()), e6 = Yr2(e6, t3), e6 !== null && (qe2(e6, t3), nd(e6));
  }
  function qu(e6) {
    var t3 = e6.memoizedState, n3 = 0;
    t3 !== null && (n3 = t3.retryLane), Ku(e6, n3);
  }
  function Ju(e6, t3) {
    var n3 = 0;
    switch (e6.tag) {
      case 31:
      case 13:
        var r2 = e6.stateNode, i3 = e6.memoizedState;
        i3 !== null && (n3 = i3.retryLane);
        break;
      case 19:
        r2 = e6.stateNode;
        break;
      case 22:
        r2 = e6.stateNode._retryCache;
        break;
      default:
        throw Error(a2(314));
    }
    r2 !== null && r2.delete(t3), Ku(e6, n3);
  }
  function Yu(e6, t3) {
    return ye2(e6, t3);
  }
  var Xu = null, Zu = null, Qu = false, $u = false, ed = false, td = 0;
  function nd(e6) {
    e6 !== Zu && e6.next === null && (Zu === null ? Xu = Zu = e6 : Zu = Zu.next = e6), $u = true, Qu || (Qu = true, ld());
  }
  function rd(e6, t3) {
    if (!ed && $u) {
      ed = true;
      do
        for (var n3 = false, r2 = Xu; r2 !== null; ) {
          if (!t3) if (e6 !== 0) {
            var i3 = r2.pendingLanes;
            if (i3 === 0) var a3 = 0;
            else {
              var o3 = r2.suspendedLanes, s3 = r2.pingedLanes;
              a3 = (1 << 31 - Fe2(42 | e6) + 1) - 1, a3 &= i3 & ~(o3 & ~s3), a3 = a3 & 201326741 ? a3 & 201326741 | 1 : a3 ? a3 | 2 : 0;
            }
            a3 !== 0 && (n3 = true, cd(r2, a3));
          } else a3 = Z2, a3 = He2(r2, r2 === Il2 ? a3 : 0, r2.cancelPendingCommit !== null || r2.timeoutHandle !== -1), !(a3 & 3) || Ue2(r2, a3) || (n3 = true, cd(r2, a3));
          r2 = r2.next;
        }
      while (n3);
      ed = false;
    }
  }
  function id() {
    ad();
  }
  function ad() {
    $u = Qu = false;
    var e6 = 0;
    td !== 0 && Gd() && (e6 = td);
    for (var t3 = Ce2(), n3 = null, r2 = Xu; r2 !== null; ) {
      var i3 = r2.next, a3 = od(r2, t3);
      a3 === 0 ? (r2.next = null, n3 === null ? Xu = i3 : n3.next = i3, i3 === null && (Zu = n3)) : (n3 = r2, (e6 !== 0 || a3 & 3) && ($u = true)), r2 = i3;
    }
    nu !== 0 && nu !== 5 || rd(e6, false), td !== 0 && (td = 0);
  }
  function od(e6, t3) {
    for (var n3 = e6.suspendedLanes, r2 = e6.pingedLanes, i3 = e6.expirationTimes, a3 = e6.pendingLanes & -62914561; 0 < a3; ) {
      var o3 = 31 - Fe2(a3), s3 = 1 << o3, c3 = i3[o3];
      c3 === -1 ? ((s3 & n3) === 0 || (s3 & r2) !== 0) && (i3[o3] = We2(s3, t3)) : c3 <= t3 && (e6.expiredLanes |= s3), a3 &= ~s3;
    }
    if (t3 = Il2, n3 = Z2, n3 = He2(e6, e6 === t3 ? n3 : 0, e6.cancelPendingCommit !== null || e6.timeoutHandle !== -1), r2 = e6.callbackNode, n3 === 0 || e6 === t3 && (Q2 === 2 || Q2 === 9) || e6.cancelPendingCommit !== null) return r2 !== null && r2 !== null && be2(r2), e6.callbackNode = null, e6.callbackPriority = 0;
    if (!(n3 & 3) || Ue2(e6, n3)) {
      if (t3 = n3 & -n3, t3 === e6.callbackPriority) return t3;
      switch (r2 !== null && be2(r2), $e2(n3)) {
        case 2:
        case 8:
          n3 = Ee2;
          break;
        case 32:
          n3 = De2;
          break;
        case 268435456:
          n3 = B2;
          break;
        default:
          n3 = De2;
      }
      return r2 = sd.bind(null, e6), n3 = ye2(n3, r2), e6.callbackPriority = t3, e6.callbackNode = n3, t3;
    }
    return r2 !== null && r2 !== null && be2(r2), e6.callbackPriority = 2, e6.callbackNode = null, 2;
  }
  function sd(e6, t3) {
    if (nu !== 0 && nu !== 5) return e6.callbackNode = null, e6.callbackPriority = 0, null;
    var n3 = e6.callbackNode;
    if (Bu() && e6.callbackNode !== n3) return null;
    var r2 = Z2;
    return r2 = He2(e6, e6 === Il2 ? r2 : 0, e6.cancelPendingCommit !== null || e6.timeoutHandle !== -1), r2 === 0 ? null : (mu(e6, r2, t3), od(e6, Ce2()), e6.callbackNode != null && e6.callbackNode === n3 ? sd.bind(null, e6) : null);
  }
  function cd(e6, t3) {
    if (Bu()) return null;
    mu(e6, t3, true);
  }
  function ld() {
    Yd(function() {
      Y2 & 6 ? ye2(Te2, id) : ad();
    });
  }
  function ud() {
    if (td === 0) {
      var e6 = ia2;
      e6 === 0 && (e6 = ze2, ze2 <<= 1, !(ze2 & 261888) && (ze2 = 256)), td = e6;
    }
    return td;
  }
  function dd(e6) {
    return e6 == null || typeof e6 == "symbol" || typeof e6 == "boolean" ? null : typeof e6 == "function" ? e6 : qt2("" + e6);
  }
  function fd(e6, t3) {
    var n3 = t3.ownerDocument.createElement("input");
    return n3.name = t3.name, n3.value = t3.value, e6.id && n3.setAttribute("form", e6.id), t3.parentNode.insertBefore(n3, t3), e6 = new FormData(e6), n3.parentNode.removeChild(n3), e6;
  }
  function pd(e6, t3, n3, r2, i3) {
    if (t3 === "submit" && n3 && n3.stateNode === i3) {
      var a3 = dd((i3[it2] || null).action), o3 = r2.submitter;
      o3 && (t3 = (t3 = o3[it2] || null) ? dd(t3.formAction) : o3.getAttribute("formAction"), t3 !== null && (a3 = t3, o3 = null));
      var s3 = new hn2("action", "action", null, r2, i3);
      e6.push({ event: s3, listeners: [{ instance: null, listener: function() {
        if (r2.defaultPrevented) {
          if (td !== 0) {
            var e7 = o3 ? fd(i3, o3) : new FormData(i3);
            ys2(n3, { pending: true, data: e7, method: i3.method, action: a3 }, null, e7);
          }
        } else typeof a3 == "function" && (s3.preventDefault(), e7 = o3 ? fd(i3, o3) : new FormData(i3), ys2(n3, { pending: true, data: e7, method: i3.method, action: a3 }, a3, e7));
      }, currentTarget: i3 }] });
    }
  }
  for (var md = 0; md < Br2.length; md++) {
    var hd = Br2[md];
    Vr2(hd.toLowerCase(), "on" + (hd[0].toUpperCase() + hd.slice(1)));
  }
  Vr2(Mr2, "onAnimationEnd"), Vr2(Nr2, "onAnimationIteration"), Vr2(Pr2, "onAnimationStart"), Vr2("dblclick", "onDoubleClick"), Vr2("focusin", "onFocus"), Vr2("focusout", "onBlur"), Vr2(Fr2, "onTransitionRun"), Vr2(Ir2, "onTransitionStart"), Vr2(Lr2, "onTransitionCancel"), Vr2(Rr2, "onTransitionEnd"), yt2("onMouseEnter", ["mouseout", "mouseover"]), yt2("onMouseLeave", ["mouseout", "mouseover"]), yt2("onPointerEnter", ["pointerout", "pointerover"]), yt2("onPointerLeave", ["pointerout", "pointerover"]), vt2("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), vt2("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), vt2("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), vt2("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), vt2("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), vt2("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var gd = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), _d = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(gd));
  function vd(e6, t3) {
    t3 = (t3 & 4) != 0;
    for (var n3 = 0; n3 < e6.length; n3++) {
      var r2 = e6[n3], i3 = r2.event;
      r2 = r2.listeners;
      a: {
        var a3 = void 0;
        if (t3) for (var o3 = r2.length - 1; 0 <= o3; o3--) {
          var s3 = r2[o3], c3 = s3.instance, l3 = s3.currentTarget;
          if (s3 = s3.listener, c3 !== a3 && i3.isPropagationStopped()) break a;
          a3 = s3, i3.currentTarget = l3;
          try {
            a3(i3);
          } catch (e7) {
            Hr2(e7);
          }
          i3.currentTarget = null, a3 = c3;
        }
        else for (o3 = 0; o3 < r2.length; o3++) {
          if (s3 = r2[o3], c3 = s3.instance, l3 = s3.currentTarget, s3 = s3.listener, c3 !== a3 && i3.isPropagationStopped()) break a;
          a3 = s3, i3.currentTarget = l3;
          try {
            a3(i3);
          } catch (e7) {
            Hr2(e7);
          }
          i3.currentTarget = null, a3 = c3;
        }
      }
    }
  }
  function $(e6, t3) {
    var n3 = t3[H2];
    n3 === void 0 && (n3 = t3[H2] = /* @__PURE__ */ new Set());
    var r2 = e6 + "__bubble";
    n3.has(r2) || (Sd(t3, e6, 2, false), n3.add(r2));
  }
  function yd(e6, t3, n3) {
    var r2 = 0;
    t3 && (r2 |= 4), Sd(n3, e6, r2, t3);
  }
  var bd = "_reactListening" + Math.random().toString(36).slice(2);
  function xd(e6) {
    if (!e6[bd]) {
      e6[bd] = true, gt2.forEach(function(t4) {
        t4 !== "selectionchange" && (_d.has(t4) || yd(t4, false, e6), yd(t4, true, e6));
      });
      var t3 = e6.nodeType === 9 ? e6 : e6.ownerDocument;
      t3 === null || t3[bd] || (t3[bd] = true, yd("selectionchange", false, t3));
    }
  }
  function Sd(e6, t3, n3, r2) {
    switch (mp(t3)) {
      case 2:
        var i3 = cp;
        break;
      case 8:
        i3 = lp;
        break;
      default:
        i3 = up;
    }
    n3 = i3.bind(null, t3, n3, e6), i3 = void 0, !rn2 || t3 !== "touchstart" && t3 !== "touchmove" && t3 !== "wheel" || (i3 = true), r2 ? i3 === void 0 ? e6.addEventListener(t3, n3, true) : e6.addEventListener(t3, n3, { capture: true, passive: i3 }) : i3 === void 0 ? e6.addEventListener(t3, n3, false) : e6.addEventListener(t3, n3, { passive: i3 });
  }
  function Cd(e6, t3, n3, r2, i3) {
    var a3 = r2;
    if (!(t3 & 1) && !(t3 & 2) && r2 !== null) a: for (; ; ) {
      if (r2 === null) return;
      var o3 = r2.tag;
      if (o3 === 3 || o3 === 4) {
        var c3 = r2.stateNode.containerInfo;
        if (c3 === i3) break;
        if (o3 === 4) for (o3 = r2.return; o3 !== null; ) {
          var l3 = o3.tag;
          if ((l3 === 3 || l3 === 4) && o3.stateNode.containerInfo === i3) return;
          o3 = o3.return;
        }
        for (; c3 !== null; ) {
          if (o3 = dt2(c3), o3 === null) return;
          if (l3 = o3.tag, l3 === 5 || l3 === 6 || l3 === 26 || l3 === 27) {
            r2 = a3 = o3;
            continue a;
          }
          c3 = c3.parentNode;
        }
      }
      r2 = r2.return;
    }
    en2(function() {
      var r3 = a3, i4 = Xt2(n3), o4 = [];
      a: {
        var c4 = zr2.get(e6);
        if (c4 !== void 0) {
          var l4 = hn2, u3 = e6;
          switch (e6) {
            case "keypress":
              if (un2(n3) === 0) break a;
            case "keydown":
            case "keyup":
              l4 = Mn2;
              break;
            case "focusin":
              u3 = "focus", l4 = Cn2;
              break;
            case "focusout":
              u3 = "blur", l4 = Cn2;
              break;
            case "beforeblur":
            case "afterblur":
              l4 = Cn2;
              break;
            case "click":
              if (n3.button === 2) break a;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              l4 = G2;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              l4 = Sn2;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              l4 = K2;
              break;
            case Mr2:
            case Nr2:
            case Pr2:
              l4 = wn2;
              break;
            case Rr2:
              l4 = Pn2;
              break;
            case "scroll":
            case "scrollend":
              l4 = _n2;
              break;
            case "wheel":
              l4 = Fn2;
              break;
            case "copy":
            case "cut":
            case "paste":
              l4 = Tn2;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              l4 = Nn2;
              break;
            case "toggle":
            case "beforetoggle":
              l4 = In2;
          }
          var d3 = (t3 & 4) != 0, f3 = !d3 && (e6 === "scroll" || e6 === "scrollend"), p3 = d3 ? c4 === null ? null : c4 + "Capture" : c4;
          d3 = [];
          for (var m3 = r3, h3; m3 !== null; ) {
            var g3 = m3;
            if (h3 = g3.stateNode, g3 = g3.tag, g3 !== 5 && g3 !== 26 && g3 !== 27 || h3 === null || p3 === null || (g3 = tn2(m3, p3), g3 != null && d3.push(wd(m3, g3, h3))), f3) break;
            m3 = m3.return;
          }
          0 < d3.length && (c4 = new l4(c4, u3, null, n3, i4), o4.push({ event: c4, listeners: d3 }));
        }
      }
      if (!(t3 & 7)) {
        a: {
          if (c4 = e6 === "mouseover" || e6 === "pointerover", l4 = e6 === "mouseout" || e6 === "pointerout", c4 && n3 !== Yt2 && (u3 = n3.relatedTarget || n3.fromElement) && (dt2(u3) || u3[at2])) break a;
          if ((l4 || c4) && (c4 = i4.window === i4 ? i4 : (c4 = i4.ownerDocument) ? c4.defaultView || c4.parentWindow : window, l4 ? (u3 = n3.relatedTarget || n3.toElement, l4 = r3, u3 = u3 ? dt2(u3) : null, u3 !== null && (f3 = s2(u3), d3 = u3.tag, u3 !== f3 || d3 !== 5 && d3 !== 27 && d3 !== 6) && (u3 = null)) : (l4 = null, u3 = r3), l4 !== u3)) {
            if (d3 = G2, g3 = "onMouseLeave", p3 = "onMouseEnter", m3 = "mouse", (e6 === "pointerout" || e6 === "pointerover") && (d3 = Nn2, g3 = "onPointerLeave", p3 = "onPointerEnter", m3 = "pointer"), f3 = l4 == null ? c4 : pt2(l4), h3 = u3 == null ? c4 : pt2(u3), c4 = new d3(g3, m3 + "leave", l4, n3, i4), c4.target = f3, c4.relatedTarget = h3, g3 = null, dt2(i4) === r3 && (d3 = new d3(p3, m3 + "enter", u3, n3, i4), d3.target = h3, d3.relatedTarget = f3, g3 = d3), f3 = g3, l4 && u3) b: {
              for (d3 = Ed, p3 = l4, m3 = u3, h3 = 0, g3 = p3; g3; g3 = d3(g3)) h3++;
              g3 = 0;
              for (var _3 = m3; _3; _3 = d3(_3)) g3++;
              for (; 0 < h3 - g3; ) p3 = d3(p3), h3--;
              for (; 0 < g3 - h3; ) m3 = d3(m3), g3--;
              for (; h3--; ) {
                if (p3 === m3 || m3 !== null && p3 === m3.alternate) {
                  d3 = p3;
                  break b;
                }
                p3 = d3(p3), m3 = d3(m3);
              }
              d3 = null;
            }
            else d3 = null;
            l4 !== null && Dd(o4, c4, l4, d3, false), u3 !== null && f3 !== null && Dd(o4, f3, u3, d3, true);
          }
        }
        a: {
          if (c4 = r3 ? pt2(r3) : window, l4 = c4.nodeName && c4.nodeName.toLowerCase(), l4 === "select" || l4 === "input" && c4.type === "file") var v3 = nr2;
          else if (Xn2(c4)) if (rr2) v3 = fr2;
          else {
            v3 = ur2;
            var y3 = lr2;
          }
          else l4 = c4.nodeName, !l4 || l4.toLowerCase() !== "input" || c4.type !== "checkbox" && c4.type !== "radio" ? r3 && Wt2(r3.elementType) && (v3 = nr2) : v3 = dr2;
          if (v3 &&= v3(e6, r3)) {
            Zn2(o4, v3, n3, i4);
            break a;
          }
          y3 && y3(e6, c4, r3), e6 === "focusout" && r3 && c4.type === "number" && r3.memoizedProps.value != null && It2(c4, "number", c4.value);
        }
        switch (y3 = r3 ? pt2(r3) : window, e6) {
          case "focusin":
            (Xn2(y3) || y3.contentEditable === "true") && (Sr2 = y3, Cr2 = r3, wr2 = null);
            break;
          case "focusout":
            wr2 = Cr2 = Sr2 = null;
            break;
          case "mousedown":
            Tr2 = true;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Tr2 = false, Er2(o4, n3, i4);
            break;
          case "selectionchange":
            if (xr2) break;
          case "keydown":
          case "keyup":
            Er2(o4, n3, i4);
        }
        var b3;
        if (Rn2) b: {
          switch (e6) {
            case "compositionstart":
              var x3 = "onCompositionStart";
              break b;
            case "compositionend":
              x3 = "onCompositionEnd";
              break b;
            case "compositionupdate":
              x3 = "onCompositionUpdate";
              break b;
          }
          x3 = void 0;
        }
        else Kn2 ? Wn2(e6, n3) && (x3 = "onCompositionEnd") : e6 === "keydown" && n3.keyCode === 229 && (x3 = "onCompositionStart");
        x3 && (Vn2 && n3.locale !== "ko" && (Kn2 || x3 !== "onCompositionStart" ? x3 === "onCompositionEnd" && Kn2 && (b3 = ln2()) : (on2 = i4, sn2 = "value" in on2 ? on2.value : on2.textContent, Kn2 = true)), y3 = Td(r3, x3), 0 < y3.length && (x3 = new En2(x3, e6, null, n3, i4), o4.push({ event: x3, listeners: y3 }), b3 ? x3.data = b3 : (b3 = Gn2(n3), b3 !== null && (x3.data = b3)))), (b3 = Bn2 ? qn2(e6, n3) : Jn2(e6, n3)) && (x3 = Td(r3, "onBeforeInput"), 0 < x3.length && (y3 = new En2("onBeforeInput", "beforeinput", null, n3, i4), o4.push({ event: y3, listeners: x3 }), y3.data = b3)), pd(o4, e6, r3, n3, i4);
      }
      vd(o4, t3);
    });
  }
  function wd(e6, t3, n3) {
    return { instance: e6, listener: t3, currentTarget: n3 };
  }
  function Td(e6, t3) {
    for (var n3 = t3 + "Capture", r2 = []; e6 !== null; ) {
      var i3 = e6, a3 = i3.stateNode;
      if (i3 = i3.tag, i3 !== 5 && i3 !== 26 && i3 !== 27 || a3 === null || (i3 = tn2(e6, n3), i3 != null && r2.unshift(wd(e6, i3, a3)), i3 = tn2(e6, t3), i3 != null && r2.push(wd(e6, i3, a3))), e6.tag === 3) return r2;
      e6 = e6.return;
    }
    return [];
  }
  function Ed(e6) {
    if (e6 === null) return null;
    do
      e6 = e6.return;
    while (e6 && e6.tag !== 5 && e6.tag !== 27);
    return e6 || null;
  }
  function Dd(e6, t3, n3, r2, i3) {
    for (var a3 = t3._reactName, o3 = []; n3 !== null && n3 !== r2; ) {
      var s3 = n3, c3 = s3.alternate, l3 = s3.stateNode;
      if (s3 = s3.tag, c3 !== null && c3 === r2) break;
      s3 !== 5 && s3 !== 26 && s3 !== 27 || l3 === null || (c3 = l3, i3 ? (l3 = tn2(n3, a3), l3 != null && o3.unshift(wd(n3, l3, c3))) : i3 || (l3 = tn2(n3, a3), l3 != null && o3.push(wd(n3, l3, c3)))), n3 = n3.return;
    }
    o3.length !== 0 && e6.push({ event: t3, listeners: o3 });
  }
  var Od = /\r\n?/g, kd = /\u0000|\uFFFD/g;
  function Ad(e6) {
    return (typeof e6 == "string" ? e6 : "" + e6).replace(Od, `
`).replace(kd, "");
  }
  function jd(e6, t3) {
    return t3 = Ad(t3), Ad(e6) === t3;
  }
  function Md(e6, t3, n3, r2, i3, o3) {
    switch (n3) {
      case "children":
        typeof r2 == "string" ? t3 === "body" || t3 === "textarea" && r2 === "" || Bt2(e6, r2) : (typeof r2 == "number" || typeof r2 == "bigint") && t3 !== "body" && Bt2(e6, "" + r2);
        break;
      case "className":
        Tt2(e6, "class", r2);
        break;
      case "tabIndex":
        Tt2(e6, "tabindex", r2);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Tt2(e6, n3, r2);
        break;
      case "style":
        Ut2(e6, r2, o3);
        break;
      case "data":
        if (t3 !== "object") {
          Tt2(e6, "data", r2);
          break;
        }
      case "src":
      case "href":
        if (r2 === "" && (t3 !== "a" || n3 !== "href")) {
          e6.removeAttribute(n3);
          break;
        }
        if (r2 == null || typeof r2 == "function" || typeof r2 == "symbol" || typeof r2 == "boolean") {
          e6.removeAttribute(n3);
          break;
        }
        r2 = qt2("" + r2), e6.setAttribute(n3, r2);
        break;
      case "action":
      case "formAction":
        if (typeof r2 == "function") {
          e6.setAttribute(n3, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
          break;
        } else typeof o3 == "function" && (n3 === "formAction" ? (t3 !== "input" && Md(e6, t3, "name", i3.name, i3, null), Md(e6, t3, "formEncType", i3.formEncType, i3, null), Md(e6, t3, "formMethod", i3.formMethod, i3, null), Md(e6, t3, "formTarget", i3.formTarget, i3, null)) : (Md(e6, t3, "encType", i3.encType, i3, null), Md(e6, t3, "method", i3.method, i3, null), Md(e6, t3, "target", i3.target, i3, null)));
        if (r2 == null || typeof r2 == "symbol" || typeof r2 == "boolean") {
          e6.removeAttribute(n3);
          break;
        }
        r2 = qt2("" + r2), e6.setAttribute(n3, r2);
        break;
      case "onClick":
        r2 != null && (e6.onclick = Jt2);
        break;
      case "onScroll":
        r2 != null && $("scroll", e6);
        break;
      case "onScrollEnd":
        r2 != null && $("scrollend", e6);
        break;
      case "dangerouslySetInnerHTML":
        if (r2 != null) {
          if (typeof r2 != "object" || !("__html" in r2)) throw Error(a2(61));
          if (n3 = r2.__html, n3 != null) {
            if (i3.children != null) throw Error(a2(60));
            e6.innerHTML = n3;
          }
        }
        break;
      case "multiple":
        e6.multiple = r2 && typeof r2 != "function" && typeof r2 != "symbol";
        break;
      case "muted":
        e6.muted = r2 && typeof r2 != "function" && typeof r2 != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (r2 == null || typeof r2 == "function" || typeof r2 == "boolean" || typeof r2 == "symbol") {
          e6.removeAttribute("xlink:href");
          break;
        }
        n3 = qt2("" + r2), e6.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", n3);
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        r2 != null && typeof r2 != "function" && typeof r2 != "symbol" ? e6.setAttribute(n3, "" + r2) : e6.removeAttribute(n3);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        r2 && typeof r2 != "function" && typeof r2 != "symbol" ? e6.setAttribute(n3, "") : e6.removeAttribute(n3);
        break;
      case "capture":
      case "download":
        r2 === true ? e6.setAttribute(n3, "") : r2 !== false && r2 != null && typeof r2 != "function" && typeof r2 != "symbol" ? e6.setAttribute(n3, r2) : e6.removeAttribute(n3);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        r2 != null && typeof r2 != "function" && typeof r2 != "symbol" && !isNaN(r2) && 1 <= r2 ? e6.setAttribute(n3, r2) : e6.removeAttribute(n3);
        break;
      case "rowSpan":
      case "start":
        r2 == null || typeof r2 == "function" || typeof r2 == "symbol" || isNaN(r2) ? e6.removeAttribute(n3) : e6.setAttribute(n3, r2);
        break;
      case "popover":
        $("beforetoggle", e6), $("toggle", e6), wt2(e6, "popover", r2);
        break;
      case "xlinkActuate":
        Et2(e6, "http://www.w3.org/1999/xlink", "xlink:actuate", r2);
        break;
      case "xlinkArcrole":
        Et2(e6, "http://www.w3.org/1999/xlink", "xlink:arcrole", r2);
        break;
      case "xlinkRole":
        Et2(e6, "http://www.w3.org/1999/xlink", "xlink:role", r2);
        break;
      case "xlinkShow":
        Et2(e6, "http://www.w3.org/1999/xlink", "xlink:show", r2);
        break;
      case "xlinkTitle":
        Et2(e6, "http://www.w3.org/1999/xlink", "xlink:title", r2);
        break;
      case "xlinkType":
        Et2(e6, "http://www.w3.org/1999/xlink", "xlink:type", r2);
        break;
      case "xmlBase":
        Et2(e6, "http://www.w3.org/XML/1998/namespace", "xml:base", r2);
        break;
      case "xmlLang":
        Et2(e6, "http://www.w3.org/XML/1998/namespace", "xml:lang", r2);
        break;
      case "xmlSpace":
        Et2(e6, "http://www.w3.org/XML/1998/namespace", "xml:space", r2);
        break;
      case "is":
        wt2(e6, "is", r2);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < n3.length) || n3[0] !== "o" && n3[0] !== "O" || n3[1] !== "n" && n3[1] !== "N") && (n3 = Gt2.get(n3) || n3, wt2(e6, n3, r2));
    }
  }
  function Nd(e6, t3, n3, r2, i3, o3) {
    switch (n3) {
      case "style":
        Ut2(e6, r2, o3);
        break;
      case "dangerouslySetInnerHTML":
        if (r2 != null) {
          if (typeof r2 != "object" || !("__html" in r2)) throw Error(a2(61));
          if (n3 = r2.__html, n3 != null) {
            if (i3.children != null) throw Error(a2(60));
            e6.innerHTML = n3;
          }
        }
        break;
      case "children":
        typeof r2 == "string" ? Bt2(e6, r2) : (typeof r2 == "number" || typeof r2 == "bigint") && Bt2(e6, "" + r2);
        break;
      case "onScroll":
        r2 != null && $("scroll", e6);
        break;
      case "onScrollEnd":
        r2 != null && $("scrollend", e6);
        break;
      case "onClick":
        r2 != null && (e6.onclick = Jt2);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!_t2.hasOwnProperty(n3)) a: {
          if (n3[0] === "o" && n3[1] === "n" && (i3 = n3.endsWith("Capture"), t3 = n3.slice(2, i3 ? n3.length - 7 : void 0), o3 = e6[it2] || null, o3 = o3 == null ? null : o3[n3], typeof o3 == "function" && e6.removeEventListener(t3, o3, i3), typeof r2 == "function")) {
            typeof o3 != "function" && o3 !== null && (n3 in e6 ? e6[n3] = null : e6.hasAttribute(n3) && e6.removeAttribute(n3)), e6.addEventListener(t3, r2, i3);
            break a;
          }
          n3 in e6 ? e6[n3] = r2 : r2 === true ? e6.setAttribute(n3, "") : wt2(e6, n3, r2);
        }
    }
  }
  function Pd(e6, t3, n3) {
    switch (t3) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        $("error", e6), $("load", e6);
        var r2 = false, i3 = false, o3;
        for (o3 in n3) if (n3.hasOwnProperty(o3)) {
          var s3 = n3[o3];
          if (s3 != null) switch (o3) {
            case "src":
              r2 = true;
              break;
            case "srcSet":
              i3 = true;
              break;
            case "children":
            case "dangerouslySetInnerHTML":
              throw Error(a2(137, t3));
            default:
              Md(e6, t3, o3, s3, n3, null);
          }
        }
        i3 && Md(e6, t3, "srcSet", n3.srcSet, n3, null), r2 && Md(e6, t3, "src", n3.src, n3, null);
        return;
      case "input":
        $("invalid", e6);
        var c3 = o3 = s3 = i3 = null, l3 = null, u3 = null;
        for (r2 in n3) if (n3.hasOwnProperty(r2)) {
          var d3 = n3[r2];
          if (d3 != null) switch (r2) {
            case "name":
              i3 = d3;
              break;
            case "type":
              s3 = d3;
              break;
            case "checked":
              l3 = d3;
              break;
            case "defaultChecked":
              u3 = d3;
              break;
            case "value":
              o3 = d3;
              break;
            case "defaultValue":
              c3 = d3;
              break;
            case "children":
            case "dangerouslySetInnerHTML":
              if (d3 != null) throw Error(a2(137, t3));
              break;
            default:
              Md(e6, t3, r2, d3, n3, null);
          }
        }
        Ft2(e6, o3, c3, l3, u3, s3, i3, false);
        return;
      case "select":
        for (i3 in $("invalid", e6), r2 = s3 = o3 = null, n3) if (n3.hasOwnProperty(i3) && (c3 = n3[i3], c3 != null)) switch (i3) {
          case "value":
            o3 = c3;
            break;
          case "defaultValue":
            s3 = c3;
            break;
          case "multiple":
            r2 = c3;
          default:
            Md(e6, t3, i3, c3, n3, null);
        }
        t3 = o3, n3 = s3, e6.multiple = !!r2, t3 == null ? n3 != null && Lt2(e6, !!r2, n3, true) : Lt2(e6, !!r2, t3, false);
        return;
      case "textarea":
        for (s3 in $("invalid", e6), o3 = i3 = r2 = null, n3) if (n3.hasOwnProperty(s3) && (c3 = n3[s3], c3 != null)) switch (s3) {
          case "value":
            r2 = c3;
            break;
          case "defaultValue":
            i3 = c3;
            break;
          case "children":
            o3 = c3;
            break;
          case "dangerouslySetInnerHTML":
            if (c3 != null) throw Error(a2(91));
            break;
          default:
            Md(e6, t3, s3, c3, n3, null);
        }
        zt2(e6, r2, i3, o3);
        return;
      case "option":
        for (l3 in n3) n3.hasOwnProperty(l3) && (r2 = n3[l3], r2 != null) && (l3 === "selected" ? e6.selected = r2 && typeof r2 != "function" && typeof r2 != "symbol" : Md(e6, t3, l3, r2, n3, null));
        return;
      case "dialog":
        $("beforetoggle", e6), $("toggle", e6), $("cancel", e6), $("close", e6);
        break;
      case "iframe":
      case "object":
        $("load", e6);
        break;
      case "video":
      case "audio":
        for (r2 = 0; r2 < gd.length; r2++) $(gd[r2], e6);
        break;
      case "image":
        $("error", e6), $("load", e6);
        break;
      case "details":
        $("toggle", e6);
        break;
      case "embed":
      case "source":
      case "link":
        $("error", e6), $("load", e6);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (u3 in n3) if (n3.hasOwnProperty(u3) && (r2 = n3[u3], r2 != null)) switch (u3) {
          case "children":
          case "dangerouslySetInnerHTML":
            throw Error(a2(137, t3));
          default:
            Md(e6, t3, u3, r2, n3, null);
        }
        return;
      default:
        if (Wt2(t3)) {
          for (d3 in n3) n3.hasOwnProperty(d3) && (r2 = n3[d3], r2 !== void 0 && Nd(e6, t3, d3, r2, n3, void 0));
          return;
        }
    }
    for (c3 in n3) n3.hasOwnProperty(c3) && (r2 = n3[c3], r2 != null && Md(e6, t3, c3, r2, n3, null));
  }
  function Fd(e6, t3, n3, r2) {
    switch (t3) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var i3 = null, o3 = null, s3 = null, c3 = null, l3 = null, u3 = null, d3 = null;
        for (m3 in n3) {
          var f3 = n3[m3];
          if (n3.hasOwnProperty(m3) && f3 != null) switch (m3) {
            case "checked":
              break;
            case "value":
              break;
            case "defaultValue":
              l3 = f3;
            default:
              r2.hasOwnProperty(m3) || Md(e6, t3, m3, null, r2, f3);
          }
        }
        for (var p3 in r2) {
          var m3 = r2[p3];
          if (f3 = n3[p3], r2.hasOwnProperty(p3) && (m3 != null || f3 != null)) switch (p3) {
            case "type":
              o3 = m3;
              break;
            case "name":
              i3 = m3;
              break;
            case "checked":
              u3 = m3;
              break;
            case "defaultChecked":
              d3 = m3;
              break;
            case "value":
              s3 = m3;
              break;
            case "defaultValue":
              c3 = m3;
              break;
            case "children":
            case "dangerouslySetInnerHTML":
              if (m3 != null) throw Error(a2(137, t3));
              break;
            default:
              m3 !== f3 && Md(e6, t3, p3, m3, r2, f3);
          }
        }
        Pt2(e6, s3, c3, l3, u3, d3, o3, i3);
        return;
      case "select":
        for (o3 in m3 = s3 = c3 = p3 = null, n3) if (l3 = n3[o3], n3.hasOwnProperty(o3) && l3 != null) switch (o3) {
          case "value":
            break;
          case "multiple":
            m3 = l3;
          default:
            r2.hasOwnProperty(o3) || Md(e6, t3, o3, null, r2, l3);
        }
        for (i3 in r2) if (o3 = r2[i3], l3 = n3[i3], r2.hasOwnProperty(i3) && (o3 != null || l3 != null)) switch (i3) {
          case "value":
            p3 = o3;
            break;
          case "defaultValue":
            c3 = o3;
            break;
          case "multiple":
            s3 = o3;
          default:
            o3 !== l3 && Md(e6, t3, i3, o3, r2, l3);
        }
        t3 = c3, n3 = s3, r2 = m3, p3 == null ? !!r2 != !!n3 && (t3 == null ? Lt2(e6, !!n3, n3 ? [] : "", false) : Lt2(e6, !!n3, t3, true)) : Lt2(e6, !!n3, p3, false);
        return;
      case "textarea":
        for (c3 in m3 = p3 = null, n3) if (i3 = n3[c3], n3.hasOwnProperty(c3) && i3 != null && !r2.hasOwnProperty(c3)) switch (c3) {
          case "value":
            break;
          case "children":
            break;
          default:
            Md(e6, t3, c3, null, r2, i3);
        }
        for (s3 in r2) if (i3 = r2[s3], o3 = n3[s3], r2.hasOwnProperty(s3) && (i3 != null || o3 != null)) switch (s3) {
          case "value":
            p3 = i3;
            break;
          case "defaultValue":
            m3 = i3;
            break;
          case "children":
            break;
          case "dangerouslySetInnerHTML":
            if (i3 != null) throw Error(a2(91));
            break;
          default:
            i3 !== o3 && Md(e6, t3, s3, i3, r2, o3);
        }
        Rt2(e6, p3, m3);
        return;
      case "option":
        for (var h3 in n3) p3 = n3[h3], n3.hasOwnProperty(h3) && p3 != null && !r2.hasOwnProperty(h3) && (h3 === "selected" ? e6.selected = false : Md(e6, t3, h3, null, r2, p3));
        for (l3 in r2) p3 = r2[l3], m3 = n3[l3], r2.hasOwnProperty(l3) && p3 !== m3 && (p3 != null || m3 != null) && (l3 === "selected" ? e6.selected = p3 && typeof p3 != "function" && typeof p3 != "symbol" : Md(e6, t3, l3, p3, r2, m3));
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var g3 in n3) p3 = n3[g3], n3.hasOwnProperty(g3) && p3 != null && !r2.hasOwnProperty(g3) && Md(e6, t3, g3, null, r2, p3);
        for (u3 in r2) if (p3 = r2[u3], m3 = n3[u3], r2.hasOwnProperty(u3) && p3 !== m3 && (p3 != null || m3 != null)) switch (u3) {
          case "children":
          case "dangerouslySetInnerHTML":
            if (p3 != null) throw Error(a2(137, t3));
            break;
          default:
            Md(e6, t3, u3, p3, r2, m3);
        }
        return;
      default:
        if (Wt2(t3)) {
          for (var _3 in n3) p3 = n3[_3], n3.hasOwnProperty(_3) && p3 !== void 0 && !r2.hasOwnProperty(_3) && Nd(e6, t3, _3, void 0, r2, p3);
          for (d3 in r2) p3 = r2[d3], m3 = n3[d3], !r2.hasOwnProperty(d3) || p3 === m3 || p3 === void 0 && m3 === void 0 || Nd(e6, t3, d3, p3, r2, m3);
          return;
        }
    }
    for (var v3 in n3) p3 = n3[v3], n3.hasOwnProperty(v3) && p3 != null && !r2.hasOwnProperty(v3) && Md(e6, t3, v3, null, r2, p3);
    for (f3 in r2) p3 = r2[f3], m3 = n3[f3], !r2.hasOwnProperty(f3) || p3 === m3 || p3 == null && m3 == null || Md(e6, t3, f3, p3, r2, m3);
  }
  function Id(e6) {
    switch (e6) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return true;
      default:
        return false;
    }
  }
  function Ld() {
    if (typeof performance.getEntriesByType == "function") {
      for (var e6 = 0, t3 = 0, n3 = performance.getEntriesByType("resource"), r2 = 0; r2 < n3.length; r2++) {
        var i3 = n3[r2], a3 = i3.transferSize, o3 = i3.initiatorType, s3 = i3.duration;
        if (a3 && s3 && Id(o3)) {
          for (o3 = 0, s3 = i3.responseEnd, r2 += 1; r2 < n3.length; r2++) {
            var c3 = n3[r2], l3 = c3.startTime;
            if (l3 > s3) break;
            var u3 = c3.transferSize, d3 = c3.initiatorType;
            u3 && Id(d3) && (c3 = c3.responseEnd, o3 += u3 * (c3 < s3 ? 1 : (s3 - l3) / (c3 - l3)));
          }
          if (--r2, t3 += 8 * (a3 + o3) / (i3.duration / 1e3), e6++, 10 < e6) break;
        }
      }
      if (0 < e6) return t3 / e6 / 1e6;
    }
    return navigator.connection && (e6 = navigator.connection.downlink, typeof e6 == "number") ? e6 : 5;
  }
  var Rd = null, zd = null;
  function Bd(e6) {
    return e6.nodeType === 9 ? e6 : e6.ownerDocument;
  }
  function Vd(e6) {
    switch (e6) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function Hd(e6, t3) {
    if (e6 === 0) switch (t3) {
      case "svg":
        return 1;
      case "math":
        return 2;
      default:
        return 0;
    }
    return e6 === 1 && t3 === "foreignObject" ? 0 : e6;
  }
  function Ud(e6, t3) {
    return e6 === "textarea" || e6 === "noscript" || typeof t3.children == "string" || typeof t3.children == "number" || typeof t3.children == "bigint" || typeof t3.dangerouslySetInnerHTML == "object" && t3.dangerouslySetInnerHTML !== null && t3.dangerouslySetInnerHTML.__html != null;
  }
  var Wd = null;
  function Gd() {
    var e6 = window.event;
    return e6 && e6.type === "popstate" ? e6 === Wd ? false : (Wd = e6, true) : (Wd = null, false);
  }
  var Kd = typeof setTimeout == "function" ? setTimeout : void 0, qd = typeof clearTimeout == "function" ? clearTimeout : void 0, Jd = typeof Promise == "function" ? Promise : void 0, Yd = typeof queueMicrotask == "function" ? queueMicrotask : Jd === void 0 ? Kd : function(e6) {
    return Jd.resolve(null).then(e6).catch(Xd);
  };
  function Xd(e6) {
    setTimeout(function() {
      throw e6;
    });
  }
  function Zd(e6) {
    return e6 === "head";
  }
  function Qd(e6, t3) {
    var n3 = t3, r2 = 0;
    do {
      var i3 = n3.nextSibling;
      if (e6.removeChild(n3), i3 && i3.nodeType === 8) if (n3 = i3.data, n3 === "/$" || n3 === "/&") {
        if (r2 === 0) {
          e6.removeChild(i3), Np(t3);
          return;
        }
        r2--;
      } else if (n3 === "$" || n3 === "$?" || n3 === "$~" || n3 === "$!" || n3 === "&") r2++;
      else if (n3 === "html") pf(e6.ownerDocument.documentElement);
      else if (n3 === "head") {
        n3 = e6.ownerDocument.head, pf(n3);
        for (var a3 = n3.firstChild; a3; ) {
          var o3 = a3.nextSibling, s3 = a3.nodeName;
          a3[lt2] || s3 === "SCRIPT" || s3 === "STYLE" || s3 === "LINK" && a3.rel.toLowerCase() === "stylesheet" || n3.removeChild(a3), a3 = o3;
        }
      } else n3 === "body" && pf(e6.ownerDocument.body);
      n3 = i3;
    } while (n3);
    Np(t3);
  }
  function $d(e6, t3) {
    var n3 = e6;
    e6 = 0;
    do {
      var r2 = n3.nextSibling;
      if (n3.nodeType === 1 ? t3 ? (n3._stashedDisplay = n3.style.display, n3.style.display = "none") : (n3.style.display = n3._stashedDisplay || "", n3.getAttribute("style") === "" && n3.removeAttribute("style")) : n3.nodeType === 3 && (t3 ? (n3._stashedText = n3.nodeValue, n3.nodeValue = "") : n3.nodeValue = n3._stashedText || ""), r2 && r2.nodeType === 8) if (n3 = r2.data, n3 === "/$") {
        if (e6 === 0) break;
        e6--;
      } else n3 !== "$" && n3 !== "$?" && n3 !== "$~" && n3 !== "$!" || e6++;
      n3 = r2;
    } while (n3);
  }
  function ef(e6) {
    var t3 = e6.firstChild;
    for (t3 && t3.nodeType === 10 && (t3 = t3.nextSibling); t3; ) {
      var n3 = t3;
      switch (t3 = t3.nextSibling, n3.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          ef(n3), ut2(n3);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (n3.rel.toLowerCase() === "stylesheet") continue;
      }
      e6.removeChild(n3);
    }
  }
  function tf(e6, t3, n3, r2) {
    for (; e6.nodeType === 1; ) {
      var i3 = n3;
      if (e6.nodeName.toLowerCase() !== t3.toLowerCase()) {
        if (!r2 && (e6.nodeName !== "INPUT" || e6.type !== "hidden")) break;
      } else if (r2) {
        if (!e6[lt2]) switch (t3) {
          case "meta":
            if (!e6.hasAttribute("itemprop")) break;
            return e6;
          case "link":
            if (a3 = e6.getAttribute("rel"), a3 === "stylesheet" && e6.hasAttribute("data-precedence") || a3 !== i3.rel || e6.getAttribute("href") !== (i3.href == null || i3.href === "" ? null : i3.href) || e6.getAttribute("crossorigin") !== (i3.crossOrigin == null ? null : i3.crossOrigin) || e6.getAttribute("title") !== (i3.title == null ? null : i3.title)) break;
            return e6;
          case "style":
            if (e6.hasAttribute("data-precedence")) break;
            return e6;
          case "script":
            if (a3 = e6.getAttribute("src"), (a3 !== (i3.src == null ? null : i3.src) || e6.getAttribute("type") !== (i3.type == null ? null : i3.type) || e6.getAttribute("crossorigin") !== (i3.crossOrigin == null ? null : i3.crossOrigin)) && a3 && e6.hasAttribute("async") && !e6.hasAttribute("itemprop")) break;
            return e6;
          default:
            return e6;
        }
      } else if (t3 === "input" && e6.type === "hidden") {
        var a3 = i3.name == null ? null : "" + i3.name;
        if (i3.type === "hidden" && e6.getAttribute("name") === a3) return e6;
      } else return e6;
      if (e6 = cf(e6.nextSibling), e6 === null) break;
    }
    return null;
  }
  function nf(e6, t3, n3) {
    if (t3 === "") return null;
    for (; e6.nodeType !== 3; ) if ((e6.nodeType !== 1 || e6.nodeName !== "INPUT" || e6.type !== "hidden") && !n3 || (e6 = cf(e6.nextSibling), e6 === null)) return null;
    return e6;
  }
  function rf(e6, t3) {
    for (; e6.nodeType !== 8; ) if ((e6.nodeType !== 1 || e6.nodeName !== "INPUT" || e6.type !== "hidden") && !t3 || (e6 = cf(e6.nextSibling), e6 === null)) return null;
    return e6;
  }
  function af(e6) {
    return e6.data === "$?" || e6.data === "$~";
  }
  function of(e6) {
    return e6.data === "$!" || e6.data === "$?" && e6.ownerDocument.readyState !== "loading";
  }
  function sf(e6, t3) {
    var n3 = e6.ownerDocument;
    if (e6.data === "$~") e6._reactRetry = t3;
    else if (e6.data !== "$?" || n3.readyState !== "loading") t3();
    else {
      var r2 = function() {
        t3(), n3.removeEventListener("DOMContentLoaded", r2);
      };
      n3.addEventListener("DOMContentLoaded", r2), e6._reactRetry = r2;
    }
  }
  function cf(e6) {
    for (; e6 != null; e6 = e6.nextSibling) {
      var t3 = e6.nodeType;
      if (t3 === 1 || t3 === 3) break;
      if (t3 === 8) {
        if (t3 = e6.data, t3 === "$" || t3 === "$!" || t3 === "$?" || t3 === "$~" || t3 === "&" || t3 === "F!" || t3 === "F") break;
        if (t3 === "/$" || t3 === "/&") return null;
      }
    }
    return e6;
  }
  var lf = null;
  function uf(e6) {
    e6 = e6.nextSibling;
    for (var t3 = 0; e6; ) {
      if (e6.nodeType === 8) {
        var n3 = e6.data;
        if (n3 === "/$" || n3 === "/&") {
          if (t3 === 0) return cf(e6.nextSibling);
          t3--;
        } else n3 !== "$" && n3 !== "$!" && n3 !== "$?" && n3 !== "$~" && n3 !== "&" || t3++;
      }
      e6 = e6.nextSibling;
    }
    return null;
  }
  function df(e6) {
    e6 = e6.previousSibling;
    for (var t3 = 0; e6; ) {
      if (e6.nodeType === 8) {
        var n3 = e6.data;
        if (n3 === "$" || n3 === "$!" || n3 === "$?" || n3 === "$~" || n3 === "&") {
          if (t3 === 0) return e6;
          t3--;
        } else n3 !== "/$" && n3 !== "/&" || t3++;
      }
      e6 = e6.previousSibling;
    }
    return null;
  }
  function ff(e6, t3, n3) {
    switch (t3 = Bd(n3), e6) {
      case "html":
        if (e6 = t3.documentElement, !e6) throw Error(a2(452));
        return e6;
      case "head":
        if (e6 = t3.head, !e6) throw Error(a2(453));
        return e6;
      case "body":
        if (e6 = t3.body, !e6) throw Error(a2(454));
        return e6;
      default:
        throw Error(a2(451));
    }
  }
  function pf(e6) {
    for (var t3 = e6.attributes; t3.length; ) e6.removeAttributeNode(t3[0]);
    ut2(e6);
  }
  var mf = /* @__PURE__ */ new Map(), hf = /* @__PURE__ */ new Set();
  function gf(e6) {
    return typeof e6.getRootNode == "function" ? e6.getRootNode() : e6.nodeType === 9 ? e6 : e6.ownerDocument;
  }
  var _f = F2.d;
  F2.d = { f: vf, r: yf, D: Sf, C: Cf, L: wf, m: Tf, X: Df, S: Ef, M: Of };
  function vf() {
    var e6 = _f.f(), t3 = vu();
    return e6 || t3;
  }
  function yf(e6) {
    var t3 = ft2(e6);
    t3 !== null && t3.tag === 5 && t3.type === "form" ? xs2(t3) : _f.r(e6);
  }
  var bf = typeof document > "u" ? null : document;
  function xf(e6, t3, n3) {
    var r2 = bf;
    if (r2 && typeof t3 == "string" && t3) {
      var i3 = Nt2(t3);
      i3 = 'link[rel="' + e6 + '"][href="' + i3 + '"]', typeof n3 == "string" && (i3 += '[crossorigin="' + n3 + '"]'), hf.has(i3) || (hf.add(i3), e6 = { rel: e6, crossOrigin: n3, href: t3 }, r2.querySelector(i3) === null && (t3 = r2.createElement("link"), Pd(t3, "link", e6), ht2(t3), r2.head.appendChild(t3)));
    }
  }
  function Sf(e6) {
    _f.D(e6), xf("dns-prefetch", e6, null);
  }
  function Cf(e6, t3) {
    _f.C(e6, t3), xf("preconnect", e6, t3);
  }
  function wf(e6, t3, n3) {
    _f.L(e6, t3, n3);
    var r2 = bf;
    if (r2 && e6 && t3) {
      var i3 = 'link[rel="preload"][as="' + Nt2(t3) + '"]';
      t3 === "image" && n3 && n3.imageSrcSet ? (i3 += '[imagesrcset="' + Nt2(n3.imageSrcSet) + '"]', typeof n3.imageSizes == "string" && (i3 += '[imagesizes="' + Nt2(n3.imageSizes) + '"]')) : i3 += '[href="' + Nt2(e6) + '"]';
      var a3 = i3;
      switch (t3) {
        case "style":
          a3 = Af(e6);
          break;
        case "script":
          a3 = Pf(e6);
      }
      mf.has(a3) || (e6 = p2({ rel: "preload", href: t3 === "image" && n3 && n3.imageSrcSet ? void 0 : e6, as: t3 }, n3), mf.set(a3, e6), r2.querySelector(i3) !== null || t3 === "style" && r2.querySelector(jf(a3)) || t3 === "script" && r2.querySelector(Ff(a3)) || (t3 = r2.createElement("link"), Pd(t3, "link", e6), ht2(t3), r2.head.appendChild(t3)));
    }
  }
  function Tf(e6, t3) {
    _f.m(e6, t3);
    var n3 = bf;
    if (n3 && e6) {
      var r2 = t3 && typeof t3.as == "string" ? t3.as : "script", i3 = 'link[rel="modulepreload"][as="' + Nt2(r2) + '"][href="' + Nt2(e6) + '"]', a3 = i3;
      switch (r2) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          a3 = Pf(e6);
      }
      if (!mf.has(a3) && (e6 = p2({ rel: "modulepreload", href: e6 }, t3), mf.set(a3, e6), n3.querySelector(i3) === null)) {
        switch (r2) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (n3.querySelector(Ff(a3))) return;
        }
        r2 = n3.createElement("link"), Pd(r2, "link", e6), ht2(r2), n3.head.appendChild(r2);
      }
    }
  }
  function Ef(e6, t3, n3) {
    _f.S(e6, t3, n3);
    var r2 = bf;
    if (r2 && e6) {
      var i3 = mt2(r2).hoistableStyles, a3 = Af(e6);
      t3 ||= "default";
      var o3 = i3.get(a3);
      if (!o3) {
        var s3 = { loading: 0, preload: null };
        if (o3 = r2.querySelector(jf(a3))) s3.loading = 5;
        else {
          e6 = p2({ rel: "stylesheet", href: e6, "data-precedence": t3 }, n3), (n3 = mf.get(a3)) && Rf(e6, n3);
          var c3 = o3 = r2.createElement("link");
          ht2(c3), Pd(c3, "link", e6), c3._p = new Promise(function(e7, t4) {
            c3.onload = e7, c3.onerror = t4;
          }), c3.addEventListener("load", function() {
            s3.loading |= 1;
          }), c3.addEventListener("error", function() {
            s3.loading |= 2;
          }), s3.loading |= 4, Lf(o3, t3, r2);
        }
        o3 = { type: "stylesheet", instance: o3, count: 1, state: s3 }, i3.set(a3, o3);
      }
    }
  }
  function Df(e6, t3) {
    _f.X(e6, t3);
    var n3 = bf;
    if (n3 && e6) {
      var r2 = mt2(n3).hoistableScripts, i3 = Pf(e6), a3 = r2.get(i3);
      a3 || (a3 = n3.querySelector(Ff(i3)), a3 || (e6 = p2({ src: e6, async: true }, t3), (t3 = mf.get(i3)) && zf(e6, t3), a3 = n3.createElement("script"), ht2(a3), Pd(a3, "link", e6), n3.head.appendChild(a3)), a3 = { type: "script", instance: a3, count: 1, state: null }, r2.set(i3, a3));
    }
  }
  function Of(e6, t3) {
    _f.M(e6, t3);
    var n3 = bf;
    if (n3 && e6) {
      var r2 = mt2(n3).hoistableScripts, i3 = Pf(e6), a3 = r2.get(i3);
      a3 || (a3 = n3.querySelector(Ff(i3)), a3 || (e6 = p2({ src: e6, async: true, type: "module" }, t3), (t3 = mf.get(i3)) && zf(e6, t3), a3 = n3.createElement("script"), ht2(a3), Pd(a3, "link", e6), n3.head.appendChild(a3)), a3 = { type: "script", instance: a3, count: 1, state: null }, r2.set(i3, a3));
    }
  }
  function kf(e6, t3, n3, r2) {
    var i3 = (i3 = R2.current) ? gf(i3) : null;
    if (!i3) throw Error(a2(446));
    switch (e6) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof n3.precedence == "string" && typeof n3.href == "string" ? (t3 = Af(n3.href), n3 = mt2(i3).hoistableStyles, r2 = n3.get(t3), r2 || (r2 = { type: "style", instance: null, count: 0, state: null }, n3.set(t3, r2)), r2) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (n3.rel === "stylesheet" && typeof n3.href == "string" && typeof n3.precedence == "string") {
          e6 = Af(n3.href);
          var o3 = mt2(i3).hoistableStyles, s3 = o3.get(e6);
          if (s3 || (i3 = i3.ownerDocument || i3, s3 = { type: "stylesheet", instance: null, count: 0, state: { loading: 0, preload: null } }, o3.set(e6, s3), (o3 = i3.querySelector(jf(e6))) && !o3._p && (s3.instance = o3, s3.state.loading = 5), mf.has(e6) || (n3 = { rel: "preload", as: "style", href: n3.href, crossOrigin: n3.crossOrigin, integrity: n3.integrity, media: n3.media, hrefLang: n3.hrefLang, referrerPolicy: n3.referrerPolicy }, mf.set(e6, n3), o3 || Nf(i3, e6, n3, s3.state))), t3 && r2 === null) throw Error(a2(528, ""));
          return s3;
        }
        if (t3 && r2 !== null) throw Error(a2(529, ""));
        return null;
      case "script":
        return t3 = n3.async, n3 = n3.src, typeof n3 == "string" && t3 && typeof t3 != "function" && typeof t3 != "symbol" ? (t3 = Pf(n3), n3 = mt2(i3).hoistableScripts, r2 = n3.get(t3), r2 || (r2 = { type: "script", instance: null, count: 0, state: null }, n3.set(t3, r2)), r2) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(a2(444, e6));
    }
  }
  function Af(e6) {
    return 'href="' + Nt2(e6) + '"';
  }
  function jf(e6) {
    return 'link[rel="stylesheet"][' + e6 + "]";
  }
  function Mf(e6) {
    return p2({}, e6, { "data-precedence": e6.precedence, precedence: null });
  }
  function Nf(e6, t3, n3, r2) {
    e6.querySelector('link[rel="preload"][as="style"][' + t3 + "]") ? r2.loading = 1 : (t3 = e6.createElement("link"), r2.preload = t3, t3.addEventListener("load", function() {
      return r2.loading |= 1;
    }), t3.addEventListener("error", function() {
      return r2.loading |= 2;
    }), Pd(t3, "link", n3), ht2(t3), e6.head.appendChild(t3));
  }
  function Pf(e6) {
    return '[src="' + Nt2(e6) + '"]';
  }
  function Ff(e6) {
    return "script[async]" + e6;
  }
  function If(e6, t3, n3) {
    if (t3.count++, t3.instance === null) switch (t3.type) {
      case "style":
        var r2 = e6.querySelector('style[data-href~="' + Nt2(n3.href) + '"]');
        if (r2) return t3.instance = r2, ht2(r2), r2;
        var i3 = p2({}, n3, { "data-href": n3.href, "data-precedence": n3.precedence, href: null, precedence: null });
        return r2 = (e6.ownerDocument || e6).createElement("style"), ht2(r2), Pd(r2, "style", i3), Lf(r2, n3.precedence, e6), t3.instance = r2;
      case "stylesheet":
        i3 = Af(n3.href);
        var o3 = e6.querySelector(jf(i3));
        if (o3) return t3.state.loading |= 4, t3.instance = o3, ht2(o3), o3;
        r2 = Mf(n3), (i3 = mf.get(i3)) && Rf(r2, i3), o3 = (e6.ownerDocument || e6).createElement("link"), ht2(o3);
        var s3 = o3;
        return s3._p = new Promise(function(e7, t4) {
          s3.onload = e7, s3.onerror = t4;
        }), Pd(o3, "link", r2), t3.state.loading |= 4, Lf(o3, n3.precedence, e6), t3.instance = o3;
      case "script":
        return o3 = Pf(n3.src), (i3 = e6.querySelector(Ff(o3))) ? (t3.instance = i3, ht2(i3), i3) : (r2 = n3, (i3 = mf.get(o3)) && (r2 = p2({}, n3), zf(r2, i3)), e6 = e6.ownerDocument || e6, i3 = e6.createElement("script"), ht2(i3), Pd(i3, "link", r2), e6.head.appendChild(i3), t3.instance = i3);
      case "void":
        return null;
      default:
        throw Error(a2(443, t3.type));
    }
    else t3.type === "stylesheet" && !(t3.state.loading & 4) && (r2 = t3.instance, t3.state.loading |= 4, Lf(r2, n3.precedence, e6));
    return t3.instance;
  }
  function Lf(e6, t3, n3) {
    for (var r2 = n3.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), i3 = r2.length ? r2[r2.length - 1] : null, a3 = i3, o3 = 0; o3 < r2.length; o3++) {
      var s3 = r2[o3];
      if (s3.dataset.precedence === t3) a3 = s3;
      else if (a3 !== i3) break;
    }
    a3 ? a3.parentNode.insertBefore(e6, a3.nextSibling) : (t3 = n3.nodeType === 9 ? n3.head : n3, t3.insertBefore(e6, t3.firstChild));
  }
  function Rf(e6, t3) {
    e6.crossOrigin ??= t3.crossOrigin, e6.referrerPolicy ??= t3.referrerPolicy, e6.title ??= t3.title;
  }
  function zf(e6, t3) {
    e6.crossOrigin ??= t3.crossOrigin, e6.referrerPolicy ??= t3.referrerPolicy, e6.integrity ??= t3.integrity;
  }
  var Bf = null;
  function Vf(e6, t3, n3) {
    if (Bf === null) {
      var r2 = /* @__PURE__ */ new Map(), i3 = Bf = /* @__PURE__ */ new Map();
      i3.set(n3, r2);
    } else i3 = Bf, r2 = i3.get(n3), r2 || (r2 = /* @__PURE__ */ new Map(), i3.set(n3, r2));
    if (r2.has(e6)) return r2;
    for (r2.set(e6, null), n3 = n3.getElementsByTagName(e6), i3 = 0; i3 < n3.length; i3++) {
      var a3 = n3[i3];
      if (!(a3[lt2] || a3[rt2] || e6 === "link" && a3.getAttribute("rel") === "stylesheet") && a3.namespaceURI !== "http://www.w3.org/2000/svg") {
        var o3 = a3.getAttribute(t3) || "";
        o3 = e6 + o3;
        var s3 = r2.get(o3);
        s3 ? s3.push(a3) : r2.set(o3, [a3]);
      }
    }
    return r2;
  }
  function Hf(e6, t3, n3) {
    e6 = e6.ownerDocument || e6, e6.head.insertBefore(n3, t3 === "title" ? e6.querySelector("head > title") : null);
  }
  function Uf(e6, t3, n3) {
    if (n3 === 1 || t3.itemProp != null) return false;
    switch (e6) {
      case "meta":
      case "title":
        return true;
      case "style":
        if (typeof t3.precedence != "string" || typeof t3.href != "string" || t3.href === "") break;
        return true;
      case "link":
        if (typeof t3.rel != "string" || typeof t3.href != "string" || t3.href === "" || t3.onLoad || t3.onError) break;
        return t3.rel === "stylesheet" ? (e6 = t3.disabled, typeof t3.precedence == "string" && e6 == null) : true;
      case "script":
        if (t3.async && typeof t3.async != "function" && typeof t3.async != "symbol" && !t3.onLoad && !t3.onError && t3.src && typeof t3.src == "string") return true;
    }
    return false;
  }
  function Wf(e6) {
    return !(e6.type === "stylesheet" && !(e6.state.loading & 3));
  }
  function Gf(e6, t3, n3, r2) {
    if (n3.type === "stylesheet" && (typeof r2.media != "string" || matchMedia(r2.media).matches !== false) && !(n3.state.loading & 4)) {
      if (n3.instance === null) {
        var i3 = Af(r2.href), a3 = t3.querySelector(jf(i3));
        if (a3) {
          t3 = a3._p, typeof t3 == "object" && t3 && typeof t3.then == "function" && (e6.count++, e6 = Jf.bind(e6), t3.then(e6, e6)), n3.state.loading |= 4, n3.instance = a3, ht2(a3);
          return;
        }
        a3 = t3.ownerDocument || t3, r2 = Mf(r2), (i3 = mf.get(i3)) && Rf(r2, i3), a3 = a3.createElement("link"), ht2(a3);
        var o3 = a3;
        o3._p = new Promise(function(e7, t4) {
          o3.onload = e7, o3.onerror = t4;
        }), Pd(a3, "link", r2), n3.instance = a3;
      }
      e6.stylesheets === null && (e6.stylesheets = /* @__PURE__ */ new Map()), e6.stylesheets.set(n3, t3), (t3 = n3.state.preload) && !(n3.state.loading & 3) && (e6.count++, n3 = Jf.bind(e6), t3.addEventListener("load", n3), t3.addEventListener("error", n3));
    }
  }
  var Kf = 0;
  function qf(e6, t3) {
    return e6.stylesheets && e6.count === 0 && Xf(e6, e6.stylesheets), 0 < e6.count || 0 < e6.imgCount ? function(n3) {
      var r2 = setTimeout(function() {
        if (e6.stylesheets && Xf(e6, e6.stylesheets), e6.unsuspend) {
          var t4 = e6.unsuspend;
          e6.unsuspend = null, t4();
        }
      }, 6e4 + t3);
      0 < e6.imgBytes && Kf === 0 && (Kf = 62500 * Ld());
      var i3 = setTimeout(function() {
        if (e6.waitingForImages = false, e6.count === 0 && (e6.stylesheets && Xf(e6, e6.stylesheets), e6.unsuspend)) {
          var t4 = e6.unsuspend;
          e6.unsuspend = null, t4();
        }
      }, (e6.imgBytes > Kf ? 50 : 800) + t3);
      return e6.unsuspend = n3, function() {
        e6.unsuspend = null, clearTimeout(r2), clearTimeout(i3);
      };
    } : null;
  }
  function Jf() {
    if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
      if (this.stylesheets) Xf(this, this.stylesheets);
      else if (this.unsuspend) {
        var e6 = this.unsuspend;
        this.unsuspend = null, e6();
      }
    }
  }
  var Yf = null;
  function Xf(e6, t3) {
    e6.stylesheets = null, e6.unsuspend !== null && (e6.count++, Yf = /* @__PURE__ */ new Map(), t3.forEach(Zf, e6), Yf = null, Jf.call(e6));
  }
  function Zf(e6, t3) {
    if (!(t3.state.loading & 4)) {
      var n3 = Yf.get(e6);
      if (n3) var r2 = n3.get(null);
      else {
        n3 = /* @__PURE__ */ new Map(), Yf.set(e6, n3);
        for (var i3 = e6.querySelectorAll("link[data-precedence],style[data-precedence]"), a3 = 0; a3 < i3.length; a3++) {
          var o3 = i3[a3];
          (o3.nodeName === "LINK" || o3.getAttribute("media") !== "not all") && (n3.set(o3.dataset.precedence, o3), r2 = o3);
        }
        r2 && n3.set(null, r2);
      }
      i3 = t3.instance, o3 = i3.getAttribute("data-precedence"), a3 = n3.get(o3) || r2, a3 === r2 && n3.set(null, i3), n3.set(o3, i3), this.count++, r2 = Jf.bind(this), i3.addEventListener("load", r2), i3.addEventListener("error", r2), a3 ? a3.parentNode.insertBefore(i3, a3.nextSibling) : (e6 = e6.nodeType === 9 ? e6.head : e6, e6.insertBefore(i3, e6.firstChild)), t3.state.loading |= 4;
    }
  }
  var Qf = { $$typeof: x2, Provider: null, Consumer: null, _currentValue: ee2, _currentValue2: ee2, _threadCount: 0 };
  function $f(e6, t3, n3, r2, i3, a3, o3, s3, c3) {
    this.tag = 1, this.containerInfo = e6, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = Ke2(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Ke2(0), this.hiddenUpdates = Ke2(null), this.identifierPrefix = r2, this.onUncaughtError = i3, this.onCaughtError = a3, this.onRecoverableError = o3, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = c3, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function ep(e6, t3, n3, r2, i3, a3, o3, s3, c3, l3, u3, d3) {
    return e6 = new $f(e6, t3, n3, o3, c3, l3, u3, d3, s3), t3 = 1, a3 === true && (t3 |= 24), a3 = ei2(3, null, null, t3), e6.current = a3, a3.stateNode = e6, t3 = ea2(), t3.refCount++, e6.pooledCache = t3, t3.refCount++, a3.memoizedState = { element: r2, isDehydrated: n3, cache: t3 }, Na2(a3), e6;
  }
  function tp(e6) {
    return e6 ? (e6 = Qr2, e6) : Qr2;
  }
  function np(e6, t3, n3, r2, i3, a3) {
    i3 = tp(i3), r2.context === null ? r2.context = i3 : r2.pendingContext = i3, r2 = Fa2(t3), r2.payload = { element: n3 }, a3 = a3 === void 0 ? null : a3, a3 !== null && (r2.callback = a3), n3 = Ia2(e6, r2, t3), n3 !== null && (pu(n3, e6, t3), La2(n3, e6, t3));
  }
  function rp(e6, t3) {
    if (e6 = e6.memoizedState, e6 !== null && e6.dehydrated !== null) {
      var n3 = e6.retryLane;
      e6.retryLane = n3 !== 0 && n3 < t3 ? n3 : t3;
    }
  }
  function ip(e6, t3) {
    rp(e6, t3), (e6 = e6.alternate) && rp(e6, t3);
  }
  function ap(e6) {
    if (e6.tag === 13 || e6.tag === 31) {
      var t3 = Yr2(e6, 67108864);
      t3 !== null && pu(t3, e6, 67108864), ip(e6, 67108864);
    }
  }
  function op(e6) {
    if (e6.tag === 13 || e6.tag === 31) {
      var t3 = du();
      t3 = Qe2(t3);
      var n3 = Yr2(e6, t3);
      n3 !== null && pu(n3, e6, t3), ip(e6, t3);
    }
  }
  var sp = true;
  function cp(e6, t3, n3, r2) {
    var i3 = P2.T;
    P2.T = null;
    var a3 = F2.p;
    try {
      F2.p = 2, up(e6, t3, n3, r2);
    } finally {
      F2.p = a3, P2.T = i3;
    }
  }
  function lp(e6, t3, n3, r2) {
    var i3 = P2.T;
    P2.T = null;
    var a3 = F2.p;
    try {
      F2.p = 8, up(e6, t3, n3, r2);
    } finally {
      F2.p = a3, P2.T = i3;
    }
  }
  function up(e6, t3, n3, r2) {
    if (sp) {
      var i3 = dp(r2);
      if (i3 === null) Cd(e6, t3, r2, fp, n3), Cp(e6, r2);
      else if (Tp(i3, e6, t3, n3, r2)) r2.stopPropagation();
      else if (Cp(e6, r2), t3 & 4 && -1 < Sp.indexOf(e6)) {
        for (; i3 !== null; ) {
          var a3 = ft2(i3);
          if (a3 !== null) switch (a3.tag) {
            case 3:
              if (a3 = a3.stateNode, a3.current.memoizedState.isDehydrated) {
                var o3 = V2(a3.pendingLanes);
                if (o3 !== 0) {
                  var s3 = a3;
                  for (s3.pendingLanes |= 2, s3.entangledLanes |= 2; o3; ) {
                    var c3 = 1 << 31 - Fe2(o3);
                    s3.entanglements[1] |= c3, o3 &= ~c3;
                  }
                  nd(a3), !(Y2 & 6) && ($l = Ce2() + 500, rd(0, false));
                }
              }
              break;
            case 31:
            case 13:
              s3 = Yr2(a3, 2), s3 !== null && pu(s3, a3, 2), vu(), ip(a3, 2);
          }
          if (a3 = dp(r2), a3 === null && Cd(e6, t3, r2, fp, n3), a3 === i3) break;
          i3 = a3;
        }
        i3 !== null && r2.stopPropagation();
      } else Cd(e6, t3, r2, null, n3);
    }
  }
  function dp(e6) {
    return e6 = Xt2(e6), pp(e6);
  }
  var fp = null;
  function pp(e6) {
    if (fp = null, e6 = dt2(e6), e6 !== null) {
      var t3 = s2(e6);
      if (t3 === null) e6 = null;
      else {
        var n3 = t3.tag;
        if (n3 === 13) {
          if (e6 = c2(t3), e6 !== null) return e6;
          e6 = null;
        } else if (n3 === 31) {
          if (e6 = l2(t3), e6 !== null) return e6;
          e6 = null;
        } else if (n3 === 3) {
          if (t3.stateNode.current.memoizedState.isDehydrated) return t3.tag === 3 ? t3.stateNode.containerInfo : null;
          e6 = null;
        } else t3 !== e6 && (e6 = null);
      }
    }
    return fp = e6, null;
  }
  function mp(e6) {
    switch (e6) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (we2()) {
          case Te2:
            return 2;
          case Ee2:
            return 8;
          case De2:
          case z2:
            return 32;
          case B2:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var hp = false, gp = null, _p = null, vp = null, yp = /* @__PURE__ */ new Map(), bp = /* @__PURE__ */ new Map(), xp = [], Sp = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
  function Cp(e6, t3) {
    switch (e6) {
      case "focusin":
      case "focusout":
        gp = null;
        break;
      case "dragenter":
      case "dragleave":
        _p = null;
        break;
      case "mouseover":
      case "mouseout":
        vp = null;
        break;
      case "pointerover":
      case "pointerout":
        yp.delete(t3.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        bp.delete(t3.pointerId);
    }
  }
  function wp(e6, t3, n3, r2, i3, a3) {
    return e6 === null || e6.nativeEvent !== a3 ? (e6 = { blockedOn: t3, domEventName: n3, eventSystemFlags: r2, nativeEvent: a3, targetContainers: [i3] }, t3 !== null && (t3 = ft2(t3), t3 !== null && ap(t3)), e6) : (e6.eventSystemFlags |= r2, t3 = e6.targetContainers, i3 !== null && t3.indexOf(i3) === -1 && t3.push(i3), e6);
  }
  function Tp(e6, t3, n3, r2, i3) {
    switch (t3) {
      case "focusin":
        return gp = wp(gp, e6, t3, n3, r2, i3), true;
      case "dragenter":
        return _p = wp(_p, e6, t3, n3, r2, i3), true;
      case "mouseover":
        return vp = wp(vp, e6, t3, n3, r2, i3), true;
      case "pointerover":
        var a3 = i3.pointerId;
        return yp.set(a3, wp(yp.get(a3) || null, e6, t3, n3, r2, i3)), true;
      case "gotpointercapture":
        return a3 = i3.pointerId, bp.set(a3, wp(bp.get(a3) || null, e6, t3, n3, r2, i3)), true;
    }
    return false;
  }
  function Ep(e6) {
    var t3 = dt2(e6.target);
    if (t3 !== null) {
      var n3 = s2(t3);
      if (n3 !== null) {
        if (t3 = n3.tag, t3 === 13) {
          if (t3 = c2(n3), t3 !== null) {
            e6.blockedOn = t3, tt2(e6.priority, function() {
              op(n3);
            });
            return;
          }
        } else if (t3 === 31) {
          if (t3 = l2(n3), t3 !== null) {
            e6.blockedOn = t3, tt2(e6.priority, function() {
              op(n3);
            });
            return;
          }
        } else if (t3 === 3 && n3.stateNode.current.memoizedState.isDehydrated) {
          e6.blockedOn = n3.tag === 3 ? n3.stateNode.containerInfo : null;
          return;
        }
      }
    }
    e6.blockedOn = null;
  }
  function Dp(e6) {
    if (e6.blockedOn !== null) return false;
    for (var t3 = e6.targetContainers; 0 < t3.length; ) {
      var n3 = dp(e6.nativeEvent);
      if (n3 === null) {
        n3 = e6.nativeEvent;
        var r2 = new n3.constructor(n3.type, n3);
        Yt2 = r2, n3.target.dispatchEvent(r2), Yt2 = null;
      } else return t3 = ft2(n3), t3 !== null && ap(t3), e6.blockedOn = n3, false;
      t3.shift();
    }
    return true;
  }
  function Op(e6, t3, n3) {
    Dp(e6) && n3.delete(t3);
  }
  function kp() {
    hp = false, gp !== null && Dp(gp) && (gp = null), _p !== null && Dp(_p) && (_p = null), vp !== null && Dp(vp) && (vp = null), yp.forEach(Op), bp.forEach(Op);
  }
  function Ap(e6, n3) {
    e6.blockedOn === n3 && (e6.blockedOn = null, hp || (hp = true, t2.unstable_scheduleCallback(t2.unstable_NormalPriority, kp)));
  }
  var jp = null;
  function Mp(e6) {
    jp !== e6 && (jp = e6, t2.unstable_scheduleCallback(t2.unstable_NormalPriority, function() {
      jp === e6 && (jp = null);
      for (var t3 = 0; t3 < e6.length; t3 += 3) {
        var n3 = e6[t3], r2 = e6[t3 + 1], i3 = e6[t3 + 2];
        if (typeof r2 != "function") {
          if (pp(r2 || n3) === null) continue;
          break;
        }
        var a3 = ft2(n3);
        a3 !== null && (e6.splice(t3, 3), t3 -= 3, ys2(a3, { pending: true, data: i3, method: n3.method, action: r2 }, r2, i3));
      }
    }));
  }
  function Np(e6) {
    function t3(t4) {
      return Ap(t4, e6);
    }
    gp !== null && Ap(gp, e6), _p !== null && Ap(_p, e6), vp !== null && Ap(vp, e6), yp.forEach(t3), bp.forEach(t3);
    for (var n3 = 0; n3 < xp.length; n3++) {
      var r2 = xp[n3];
      r2.blockedOn === e6 && (r2.blockedOn = null);
    }
    for (; 0 < xp.length && (n3 = xp[0], n3.blockedOn === null); ) Ep(n3), n3.blockedOn === null && xp.shift();
    if (n3 = (e6.ownerDocument || e6).$$reactFormReplay, n3 != null) for (r2 = 0; r2 < n3.length; r2 += 3) {
      var i3 = n3[r2], a3 = n3[r2 + 1], o3 = i3[it2] || null;
      if (typeof a3 == "function") o3 || Mp(n3);
      else if (o3) {
        var s3 = null;
        if (a3 && a3.hasAttribute("formAction")) {
          if (i3 = a3, o3 = a3[it2] || null) s3 = o3.formAction;
          else if (pp(i3) !== null) continue;
        } else s3 = o3.action;
        typeof s3 == "function" ? n3[r2 + 1] = s3 : (n3.splice(r2, 3), r2 -= 3), Mp(n3);
      }
    }
  }
  function Pp() {
    function e6(e7) {
      e7.canIntercept && e7.info === "react-transition" && e7.intercept({ handler: function() {
        return new Promise(function(e8) {
          return i3 = e8;
        });
      }, focusReset: "manual", scroll: "manual" });
    }
    function t3() {
      i3 !== null && (i3(), i3 = null), r2 || setTimeout(n3, 20);
    }
    function n3() {
      if (!r2 && !navigation.transition) {
        var e7 = navigation.currentEntry;
        e7 && e7.url != null && navigation.navigate(e7.url, { state: e7.getState(), info: "react-transition", history: "replace" });
      }
    }
    if (typeof navigation == "object") {
      var r2 = false, i3 = null;
      return navigation.addEventListener("navigate", e6), navigation.addEventListener("navigatesuccess", t3), navigation.addEventListener("navigateerror", t3), setTimeout(n3, 100), function() {
        r2 = true, navigation.removeEventListener("navigate", e6), navigation.removeEventListener("navigatesuccess", t3), navigation.removeEventListener("navigateerror", t3), i3 !== null && (i3(), i3 = null);
      };
    }
  }
  function Fp(e6) {
    this._internalRoot = e6;
  }
  Ip.prototype.render = Fp.prototype.render = function(e6) {
    var t3 = this._internalRoot;
    if (t3 === null) throw Error(a2(409));
    var n3 = t3.current;
    np(n3, du(), e6, t3, null, null);
  }, Ip.prototype.unmount = Fp.prototype.unmount = function() {
    var e6 = this._internalRoot;
    if (e6 !== null) {
      this._internalRoot = null;
      var t3 = e6.containerInfo;
      np(e6.current, 2, null, e6, null, null), vu(), t3[at2] = null;
    }
  };
  function Ip(e6) {
    this._internalRoot = e6;
  }
  Ip.prototype.unstable_scheduleHydration = function(e6) {
    if (e6) {
      var t3 = et2();
      e6 = { blockedOn: null, target: e6, priority: t3 };
      for (var n3 = 0; n3 < xp.length && t3 !== 0 && t3 < xp[n3].priority; n3++) ;
      xp.splice(n3, 0, e6), n3 === 0 && Ep(e6);
    }
  };
  var Lp = n2.version;
  if (Lp !== "19.2.6") throw Error(a2(527, Lp, "19.2.6"));
  F2.findDOMNode = function(e6) {
    var t3 = e6._reactInternals;
    if (t3 === void 0) throw typeof e6.render == "function" ? Error(a2(188)) : (e6 = Object.keys(e6).join(","), Error(a2(268, e6)));
    return e6 = d2(t3), e6 = e6 === null ? null : f2(e6), e6 = e6 === null ? null : e6.stateNode, e6;
  };
  var Rp = { bundleType: 0, version: "19.2.6", rendererPackageName: "react-dom", currentDispatcherRef: P2, reconcilerVersion: "19.2.6" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var zp = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!zp.isDisabled && zp.supportsFiber) try {
      je2 = zp.inject(Rp), Ne2 = zp;
    } catch {
    }
  }
  e5.createRoot = function(e6, t3) {
    if (!o2(e6)) throw Error(a2(299));
    var n3 = false, r2 = "", i3 = Hs2, s3 = Us2, c3 = Ws2;
    return t3 != null && (t3.unstable_strictMode === true && (n3 = true), t3.identifierPrefix !== void 0 && (r2 = t3.identifierPrefix), t3.onUncaughtError !== void 0 && (i3 = t3.onUncaughtError), t3.onCaughtError !== void 0 && (s3 = t3.onCaughtError), t3.onRecoverableError !== void 0 && (c3 = t3.onRecoverableError)), t3 = ep(e6, 1, false, null, null, n3, r2, null, i3, s3, c3, Pp), e6[at2] = t3.current, xd(e6), new Fp(t3);
  };
})), Pe = l(((e5, t2) => {
  function n2() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n2);
    } catch (e6) {
      console.error(e6);
    }
  }
  n2(), t2.exports = Ne();
})), Fe = be("chevron-right", [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]]), Ie = be("circle-question-mark", [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }], ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }], ["path", { d: "M12 17h.01", key: "p32p05" }]]), Le = be("image-plus", [["path", { d: "M16 5h6", key: "1vod17" }], ["path", { d: "M19 2v6", key: "4bpg5p" }], ["path", { d: "M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5", key: "1ue2ih" }], ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }], ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]]), Re = be("thumbs-up", [["path", { d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z", key: "emmmcr" }], ["path", { d: "M7 10v12", key: "1qc93n" }]]), ze = be("upload", [["path", { d: "M12 3v12", key: "1x0j5s" }], ["path", { d: "m17 8-5-5-5 5", key: "7q97r8" }], ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }]]), Be = Pe(), Ve = { brand: "Tactale", collection: "A personal collection", about: "About this piece", title: '<span class="tactale-title-reveal"><span>MEMORIES</span></span><span class="tactale-title-reveal"><span class="tactale-title-line">YOU CAN TOUCH</span></span>', body: "Your photograph, reimagined as a tactile work of art. A familiar face. A feeling worth keeping.", closer: "Look closer", replay: "Watch it take form", product: "Desktop Portrait", style: "Fine Oil \xB7 Made from your photograph", size: "15 \xD7 15 cm", sizeLabel: "Artwork", price: "RM128", priceLabel: "Made for you", drag: "Drag to turn the piece", detail: "Explore texture", light: "Change the light", reset: "Reset view", left: "Turn left", right: "Turn right", caption: "One photograph. Your own piece.", loading: "Preparing your piece", ready: "Your piece is ready to explore.", error: "The 3D view is unavailable. Please try again.", retry: "Try 3D again", close: "Close details", aboutTitle: "A quiet keepsake,<br>close at hand", aboutBody: "Your photograph on cotton-linen canvas, with colour and raised texture. Choose a walnut or black frame, displayed on two clear acrylic supports.", process: "Your review period is 72 continuous hours from when the proof is viewable and its WhatsApp notification is delivered. Each proof round starts with one automatic WhatsApp notification, followed by up to two manual reminders within the 72-hour review period, with no fixed interval. Reminders stop when you respond. A new proof starts a new review period. Silence is not approval: overdue pieces go to manual cancellation and refund review.", productLink: "Create yours", full: "Return to full view" }, V = (e5) => e5.replaceAll("&", "&amp;").replaceAll('"', "&quot;").replaceAll("<", "&lt;").replaceAll(">", "&gt;"), He = (e5) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true">${e5}</svg>`, Ue = He('<path d="M5 12h14m-6-6 6 6-6 6"/>');
var Ge = { ...Ve, product: "Wall Portrait", style: "Impasto \xB7 Made from your photograph", size: "30 \xD7 30 cm", price: "RM168", aboutTitle: "A familiar face<br>A place on your wall", aboutBody: "Your photograph on cotton-linen canvas with raised detail. A 30 \xD7 30 cm artwork with your choice of walnut or black frame, made to hang in your own space." }, Ke = { ...Ve, product: "Memory Magnet", size: "5 \xD7 7 cm", price: "RM30", style: "Made from your photograph", aboutTitle: "A little memory<br>Part of every day", aboutBody: "Your photograph becomes a tactile keepsake, with raised detail on a softly rounded white ceramic base and a flexible magnetic backing. A 5 \xD7 7 cm piece for the moments you want to keep close." }, qe = { ...Ke, product: "Square Magnet", size: "6 \xD7 6 cm", price: "RM28", aboutTitle: "A favourite moment<br>Always close", aboutBody: "A favourite photograph, made into a tactile 6 \xD7 6 cm keepsake. Raised detail, a softly rounded white ceramic base, and a flexible magnetic backing bring a familiar face into your everyday space." };
async function Ye(e5) {
  if (/^data:image\/(jpeg|png|webp);base64,/.test(e5.url) && e5.url.length <= 24e4) return { ...e5 };
  if (!e5.url.startsWith("blob:")) throw Error("Choose your photograph again before adding this piece.");
  let t2 = new Image();
  t2.src = e5.url, await t2.decode();
  let n2 = 640;
  for (let r2 = 0; r2 < 4; r2++) {
    let r3 = Math.min(1, n2 / Math.max(t2.naturalWidth, t2.naturalHeight)), i2 = document.createElement("canvas");
    i2.width = Math.max(1, Math.round(t2.naturalWidth * r3)), i2.height = Math.max(1, Math.round(t2.naturalHeight * r3));
    let a2 = i2.getContext("2d");
    if (!a2) throw Error("This browser could not prepare the photo preview. Try another browser.");
    a2.fillStyle = "#E8DDCA", a2.fillRect(0, 0, i2.width, i2.height), a2.drawImage(t2, 0, 0, i2.width, i2.height);
    let o2 = i2.toDataURL("image/jpeg", 0.72);
    if (o2.startsWith("data:image/jpeg;base64,") && o2.length <= 24e4) return { ...e5, url: o2 };
    n2 = Math.round(n2 * 0.75);
  }
  throw Error("This photograph is too detailed to save in the demo. Try a smaller copy.");
}
function Xe(e5, t2, n2 = [0, 1, 2, 3]) {
  let r2 = new URLSearchParams(e5);
  if (r2.has("edit")) {
    let e6 = t2.find((e7) => e7.id === r2.get("edit"));
    return e6 ? n2.includes(e6.draft.product) ? { kind: "edit", item: e6 } : { kind: "unavailable" } : { kind: "missing" };
  }
  if (!r2.has("product") && !r2.has("customize")) return { kind: "gallery" };
  let i2 = r2.has("product"), a2 = I(Number(r2.get(i2 ? "product" : "customize"))), o2 = r2.get("style");
  return n2.includes(a2.product) ? { kind: "create", product: a2.product, style: o2 && A[a2.product].styles.includes(o2) ? o2 : a2.style, fresh: i2, format: a2.product === 1 && ["full", "message"].includes(r2.get("format")) ? r2.get("format") : undefined } : { kind: "unavailable" };
}
var Ze = {};
function Qe(e5, t2) {
  let n2 = z.useRef(Ze);
  return n2.current === Ze && (n2.current = e5(t2)), n2;
}
function $e() {
}
var et = Object.freeze([]), tt = Object.freeze({});
function nt(e5) {
  z.useEffect(e5, et);
}
var rt = 0, it = class e2 {
  static create() {
    return new e2();
  }
  currentId = rt;
  start(e5, t2) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = rt, t2();
    }, e5);
  }
  isStarted() {
    return this.currentId !== rt;
  }
  clear = () => {
    this.currentId !== rt && (clearTimeout(this.currentId), this.currentId = rt);
  };
  disposeEffect = () => this.clear;
};
function at() {
  let e5 = Qe(it.create).current;
  return nt(e5.disposeEffect), e5;
}
var H = typeof document < "u" ? z.useLayoutEffect : () => {
};
function ot() {
  return typeof navigator > "u" ? { userAgent: "", platform: "", maxTouchPoints: 0 } : { userAgent: navigator.userAgent, platform: navigator.platform ?? "", maxTouchPoints: navigator.maxTouchPoints ?? 0 };
}
var { userAgent: st, platform: ct, maxTouchPoints: lt } = ot(), ut = st.toLowerCase(), dt = ct.toLowerCase(), ft = /^i(os$|p)/.test(dt) || dt === "macintel" && lt > 1, pt = "android", mt = dt === pt || ut.includes(pt), ht = !ft && dt.startsWith("mac");
dt.startsWith("win"), !mt && /^(linux|chrome os)/.test(dt);
var gt = ht || ft, _t = typeof CSS < "u" && !!CSS.supports?.("-webkit-backdrop-filter:none");
!_t && ut.includes("firefox"), !_t && ut.includes("chrom");
var vt = gt, yt = /jsdom|happydom/.test(ut);
function bt(e5) {
  e5.preventDefault(), e5.stopPropagation();
}
function xt(e5) {
  return "nativeEvent" in e5;
}
function St(e5) {
  return e5.pointerType === "" && e5.isTrusted ? true : mt && e5.pointerType ? e5.type === "click" && e5.buttons === 1 : e5.detail === 0 && !e5.pointerType;
}
function Ct(e5) {
  return yt ? false : !mt && e5.width === 0 && e5.height === 0 || mt && e5.width === 1 && e5.height === 1 && e5.pressure === 0 && e5.detail === 0 && e5.pointerType === "mouse" || e5.width < 1 && e5.height < 1 && e5.pressure === 0 && e5.detail === 0 && e5.pointerType === "touch";
}
function wt(e5, t2) {
  let n2 = ["mouse", "pen"];
  return t2 || n2.push("", void 0), n2.includes(e5);
}
function Tt(e5) {
  let t2 = e5.type;
  return t2 === "click" || t2 === "mousedown" || t2 === "keydown" || t2 === "keyup";
}
function Et() {
  return typeof window < "u";
}
function Dt(e5) {
  return At(e5) ? (e5.nodeName || "").toLowerCase() : "#document";
}
function Ot(e5) {
  var t2;
  return (e5 == null || (t2 = e5.ownerDocument) == null ? void 0 : t2.defaultView) || window;
}
function kt(e5) {
  return ((At(e5) ? e5.ownerDocument : e5.document) || window.document)?.documentElement;
}
function At(e5) {
  return Et() ? e5 instanceof Node || e5 instanceof Ot(e5).Node : false;
}
function U(e5) {
  return Et() ? e5 instanceof Element || e5 instanceof Ot(e5).Element : false;
}
function jt(e5) {
  return Et() ? e5 instanceof HTMLElement || e5 instanceof Ot(e5).HTMLElement : false;
}
function Mt(e5) {
  return !Et() || typeof ShadowRoot > "u" ? false : e5 instanceof ShadowRoot || e5 instanceof Ot(e5).ShadowRoot;
}
function Nt(e5) {
  let { overflow: t2, overflowX: n2, overflowY: r2, display: i2 } = Wt(e5);
  return /auto|scroll|overlay|hidden|clip/.test(t2 + r2 + n2) && i2 !== "inline" && i2 !== "contents";
}
function Pt(e5) {
  return /^(table|td|th)$/.test(Dt(e5));
}
function Ft(e5) {
  try {
    if (e5.matches(":popover-open")) return true;
  } catch {
  }
  try {
    return e5.matches(":modal");
  } catch {
    return false;
  }
}
var It = /transform|translate|scale|rotate|perspective|filter/, Lt = /paint|layout|strict|content/, Rt = (e5) => !!e5 && e5 !== "none", zt;
function Bt(e5) {
  let t2 = U(e5) ? Wt(e5) : e5;
  return Rt(t2.transform) || Rt(t2.translate) || Rt(t2.scale) || Rt(t2.rotate) || Rt(t2.perspective) || !Ht() && (Rt(t2.backdropFilter) || Rt(t2.filter)) || It.test(t2.willChange || "") || Lt.test(t2.contain || "");
}
function Vt(e5) {
  let t2 = Kt(e5);
  for (; jt(t2) && !Ut(t2); ) {
    if (Bt(t2)) return t2;
    if (Ft(t2)) return null;
    t2 = Kt(t2);
  }
  return null;
}
function Ht() {
  return zt ??= typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none"), zt;
}
function Ut(e5) {
  return /^(html|body|#document)$/.test(Dt(e5));
}
function Wt(e5) {
  return Ot(e5).getComputedStyle(e5);
}
function Gt(e5) {
  return U(e5) ? { scrollLeft: e5.scrollLeft, scrollTop: e5.scrollTop } : { scrollLeft: e5.scrollX, scrollTop: e5.scrollY };
}
function Kt(e5) {
  if (Dt(e5) === "html") return e5;
  let t2 = e5.assignedSlot || e5.parentNode || Mt(e5) && e5.host || kt(e5);
  return Mt(t2) ? t2.host : t2;
}
function qt(e5) {
  let t2 = Kt(e5);
  return Ut(t2) ? (e5.ownerDocument || e5).body : jt(t2) && Nt(t2) ? t2 : qt(t2);
}
function Jt(e5, t2, n2) {
  t2 === void 0 && (t2 = []), n2 === void 0 && (n2 = true);
  let r2 = qt(e5), i2 = r2 === e5.ownerDocument?.body, a2 = Ot(r2);
  if (i2) {
    let e6 = Yt(a2);
    return t2.concat(a2, a2.visualViewport || [], Nt(r2) ? r2 : [], e6 && n2 ? Jt(e6) : []);
  } else return t2.concat(r2, Jt(r2, [], n2));
}
function Yt(e5) {
  return e5.parent && Object.getPrototypeOf(e5.parent) ? e5.frameElement : null;
}
var Xt = "data-base-ui-focusable", Zt = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function Qt(e5) {
  let t2 = e5.activeElement;
  for (; t2?.shadowRoot?.activeElement != null; ) t2 = t2.shadowRoot.activeElement;
  return t2;
}
function W(e5, t2) {
  if (!e5 || !t2) return false;
  let n2 = t2.getRootNode?.();
  if (e5.contains(t2)) return true;
  if (n2 && Mt(n2)) {
    let n3 = t2;
    for (; n3; ) {
      if (e5 === n3) return true;
      n3 = n3.parentNode || n3.host;
    }
  }
  return false;
}
function $t(e5) {
  return "composedPath" in e5 ? e5.composedPath()[0] : e5.target;
}
function en(e5, t2) {
  if (!U(e5)) return false;
  let n2 = e5;
  if (t2.hasElement(n2)) return !n2.hasAttribute("data-trigger-disabled");
  for (let [, e6] of t2.entries()) if (W(e6, n2)) return !e6.hasAttribute("data-trigger-disabled");
  return false;
}
function tn(e5, t2) {
  if (t2 == null) return false;
  if ("composedPath" in e5) return e5.composedPath().includes(t2);
  let n2 = e5;
  return n2.target != null && t2.contains(n2.target);
}
function nn(e5) {
  return e5.matches("html,body");
}
function rn(e5) {
  return jt(e5) && e5.matches("input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])");
}
function an(e5) {
  return e5?.closest(`button,a[href],[role="button"],select,[tabindex]:not([tabindex="-1"]),${Zt}`) != null;
}
function on(e5) {
  return e5 ? e5.getAttribute("role") === "combobox" && rn(e5) : false;
}
function sn(e5) {
  return e5 ? e5.hasAttribute("data-base-ui-focusable") ? e5 : e5.querySelector("[data-base-ui-focusable]") || e5 : null;
}
function cn(e5, t2) {
  return t2 != null && !wt(t2) ? 0 : typeof e5 == "function" ? e5() : e5;
}
function ln(e5, t2, n2) {
  let r2 = cn(e5, n2);
  return typeof r2 == "number" ? r2 : r2?.[t2];
}
function un(e5) {
  return typeof e5 == "function" ? e5() : e5;
}
function dn(e5, t2) {
  return t2 || e5 === "click" || e5 === "mousedown";
}
function fn(e5) {
  return e5?.includes("mouse") && e5 !== "mousedown";
}
var pn = "none", mn = "trigger-press", hn = "trigger-hover", gn = "outside-press", _n = "close-press", vn = "focus-out", yn = "escape-key", bn = "imperative-action";
function xn(e5, t2, n2, r2) {
  let i2 = false, a2 = false, o2 = r2 ?? tt;
  return { reason: e5, event: t2 ?? new Event("base-ui"), cancel() {
    i2 = true;
  }, allowPropagation() {
    a2 = true;
  }, get isCanceled() {
    return i2;
  }, get isPropagationAllowed() {
    return a2;
  }, trigger: n2, ...o2 };
}
function G(e5, t2, n2, r2) {
  return e5.addEventListener(t2, n2, r2), () => {
    e5.removeEventListener(t2, n2, r2);
  };
}
function Sn(...e5) {
  return () => {
    for (let t2 = 0; t2 < e5.length; t2 += 1) {
      let n2 = e5[t2];
      n2 && n2();
    }
  };
}
function Cn(e5, t2, n2, r2) {
  let i2 = Qe(Tn).current;
  return En(i2, e5, t2, n2, r2) && On(i2, [e5, t2, n2, r2]), i2.callback;
}
function wn(e5) {
  let t2 = Qe(Tn).current;
  return Dn(t2, e5) && On(t2, e5), t2.callback;
}
function Tn() {
  return { callback: null, cleanup: null, refs: [] };
}
function En(e5, t2, n2, r2, i2) {
  return e5.refs[0] !== t2 || e5.refs[1] !== n2 || e5.refs[2] !== r2 || e5.refs[3] !== i2;
}
function Dn(e5, t2) {
  return e5.refs.length !== t2.length || e5.refs.some((e6, n2) => e6 !== t2[n2]);
}
function On(e5, t2) {
  if (e5.refs = t2, t2.every((e6) => e6 == null)) {
    e5.callback = null;
    return;
  }
  e5.callback = (n2) => {
    if (e5.cleanup &&= (e5.cleanup(), null), n2 != null) {
      let r2 = Array(t2.length).fill(null);
      for (let e6 = 0; e6 < t2.length; e6 += 1) {
        let i2 = t2[e6];
        if (i2 != null) switch (typeof i2) {
          case "function": {
            let t3 = i2(n2);
            typeof t3 == "function" && (r2[e6] = t3);
            break;
          }
          case "object":
            i2.current = n2;
            break;
          default:
        }
      }
      e5.cleanup = () => {
        for (let e6 = 0; e6 < t2.length; e6 += 1) {
          let n3 = t2[e6];
          if (n3 != null) switch (typeof n3) {
            case "function": {
              let t3 = r2[e6];
              typeof t3 == "function" ? t3() : n3(null);
              break;
            }
            case "object":
              n3.current = null;
              break;
            default:
          }
        }
      };
    }
  };
}
function kn(e5) {
  let t2 = Qe(An, e5).current;
  return t2.next = e5, H(t2.effect), t2;
}
function An(e5) {
  let t2 = { current: e5, next: e5, effect: () => {
    t2.current = t2.next;
  } };
  return t2;
}
var jn = { ...z }, Mn = jn.useInsertionEffect, Nn = Mn && Mn !== jn.useLayoutEffect ? Mn : (e5) => e5();
function K(e5) {
  let t2 = Qe(Pn).current;
  return t2.next = e5, Nn(t2.effect), t2.trampoline;
}
function Pn() {
  let e5 = { next: void 0, callback: Fn, trampoline: (...t2) => e5.callback?.(...t2), effect: () => {
    e5.callback = e5.next;
  } };
  return e5;
}
function Fn() {
}
var In = null;
globalThis.requestAnimationFrame;
var Ln = new class {
  callbacks = [];
  callbacksCount = 0;
  nextId = 1;
  startId = 1;
  isScheduled = false;
  tick = (e5) => {
    this.isScheduled = false;
    let t2 = this.callbacks, n2 = this.callbacksCount;
    if (this.callbacks = [], this.callbacksCount = 0, this.startId = this.nextId, n2 > 0) for (let n3 = 0; n3 < t2.length; n3 += 1) t2[n3]?.(e5);
  };
  request(e5) {
    let t2 = this.nextId;
    return this.nextId += 1, this.callbacks.push(e5), this.callbacksCount += 1, this.isScheduled ||= (requestAnimationFrame(this.tick), true), t2;
  }
  cancel(e5) {
    let t2 = e5 - this.startId;
    t2 < 0 || t2 >= this.callbacks.length || (this.callbacks[t2] = null, --this.callbacksCount);
  }
}(), Rn = class e3 {
  static create() {
    return new e3();
  }
  static request(e5) {
    return Ln.request(e5);
  }
  static cancel(e5) {
    return Ln.cancel(e5);
  }
  currentId = In;
  request(e5) {
    this.cancel(), this.currentId = Ln.request(() => {
      this.currentId = In, e5();
    });
  }
  cancel = () => {
    this.currentId !== In && (Ln.cancel(this.currentId), this.currentId = In);
  };
  disposeEffect = () => this.cancel;
};
function zn() {
  let e5 = Qe(Rn.create).current;
  return nt(e5.disposeEffect), e5;
}
function Bn(e5) {
  return e5?.ownerDocument || document;
}
var Vn = { clipPath: "inset(50%)", overflow: "hidden", whiteSpace: "nowrap", border: 0, padding: 0, width: 1, height: 1, margin: -1 }, Hn = { ...Vn, position: "fixed", top: 0, left: 0 };
({ ...Vn });
var Un = z.forwardRef(function(e5, t2) {
  let [n2, r2] = z.useState();
  H(() => {
    vt && _t && r2("button");
  }, []);
  let i2 = { tabIndex: 0, role: n2 };
  return (0, B.jsx)("span", { ...e5, ref: t2, style: Hn, "aria-hidden": n2 ? void 0 : true, ...i2, "data-base-ui-focus-guard": "" });
}), Wn = Math.min, Gn = Math.max, Kn = Math.round, qn = Math.floor, Jn = (e5) => ({ x: e5, y: e5 }), Yn = { left: "right", right: "left", bottom: "top", top: "bottom" };
function Xn(e5, t2, n2) {
  return Gn(e5, Wn(t2, n2));
}
function Zn(e5, t2) {
  return typeof e5 == "function" ? e5(t2) : e5;
}
function Qn(e5) {
  return e5.split("-")[0];
}
function $n(e5) {
  return e5.split("-")[1];
}
function er(e5) {
  return e5 === "x" ? "y" : "x";
}
function tr(e5) {
  return e5 === "y" ? "height" : "width";
}
function nr(e5) {
  let t2 = e5[0];
  return t2 === "t" || t2 === "b" ? "y" : "x";
}
function rr(e5) {
  return er(nr(e5));
}
function ir(e5, t2, n2) {
  n2 === void 0 && (n2 = false);
  let r2 = $n(e5), i2 = rr(e5), a2 = tr(i2), o2 = i2 === "x" ? r2 === (n2 ? "end" : "start") ? "right" : "left" : r2 === "start" ? "bottom" : "top";
  return t2.reference[a2] > t2.floating[a2] && (o2 = pr(o2)), [o2, pr(o2)];
}
function ar(e5) {
  let t2 = pr(e5);
  return [or(e5), t2, or(t2)];
}
function or(e5) {
  return e5.includes("start") ? e5.replace("start", "end") : e5.replace("end", "start");
}
var sr = ["left", "right"], cr = ["right", "left"], lr = ["top", "bottom"], ur = ["bottom", "top"];
function dr(e5, t2, n2) {
  switch (e5) {
    case "top":
    case "bottom":
      return n2 ? t2 ? cr : sr : t2 ? sr : cr;
    case "left":
    case "right":
      return t2 ? lr : ur;
    default:
      return [];
  }
}
function fr(e5, t2, n2, r2) {
  let i2 = $n(e5), a2 = dr(Qn(e5), n2 === "start", r2);
  return i2 && (a2 = a2.map((e6) => e6 + "-" + i2), t2 && (a2 = a2.concat(a2.map(or)))), a2;
}
function pr(e5) {
  let t2 = Qn(e5);
  return Yn[t2] + e5.slice(t2.length);
}
function mr(e5) {
  return { top: e5.top ?? 0, right: e5.right ?? 0, bottom: e5.bottom ?? 0, left: e5.left ?? 0 };
}
function hr(e5) {
  return typeof e5 == "number" ? { top: e5, right: e5, bottom: e5, left: e5 } : mr(e5);
}
function gr(e5) {
  let { x: t2, y: n2, width: r2, height: i2 } = e5;
  return { width: r2, height: i2, top: n2, left: t2, right: t2 + r2, bottom: n2 + i2, x: t2, y: n2 };
}
function _r(e5) {
  return e5.visibility === "hidden" || e5.visibility === "collapse";
}
function vr(e5, t2 = e5 ? Wt(e5) : null) {
  return !e5 || !e5.isConnected || !t2 || _r(t2) ? false : typeof e5.checkVisibility == "function" ? e5.checkVisibility() : t2.display !== "none" && t2.display !== "contents";
}
var yr = 'a[href],button,input,select,textarea,summary,details,iframe,object,embed,[tabindex],[contenteditable]:not([contenteditable="false"]),audio[controls],video[controls]';
function br(e5) {
  let t2 = e5.assignedSlot;
  if (t2) return t2;
  if (e5.parentElement) return e5.parentElement;
  let n2 = e5.getRootNode();
  return Mt(n2) ? n2.host : null;
}
function xr(e5) {
  for (let t2 of Array.from(e5.children)) if (Dt(t2) === "summary") return t2;
  return null;
}
function Sr(e5, t2) {
  let n2 = xr(t2);
  return !!n2 && (e5 === n2 || W(n2, e5));
}
function Cr(e5) {
  let t2 = e5 ? Dt(e5) : "";
  return e5 != null && e5.matches(yr) && (t2 !== "summary" || e5.parentElement != null && Dt(e5.parentElement) === "details" && xr(e5.parentElement) === e5) && (t2 !== "details" || xr(e5) == null) && (t2 !== "input" || e5.type !== "hidden");
}
function wr(e5) {
  if (!Cr(e5) || !e5.isConnected || e5.matches(":disabled")) return false;
  for (let t2 = e5; t2; t2 = br(t2)) {
    let n2 = t2 !== e5, r2 = Dt(t2) === "slot";
    if (t2.hasAttribute("inert") || n2 && Dt(t2) === "details" && !t2.open && !Sr(e5, t2) || t2.hasAttribute("hidden") || !r2 && !Tr(t2, n2)) return false;
  }
  return true;
}
function Tr(e5, t2) {
  let n2 = Wt(e5);
  return t2 ? n2.display !== "none" : vr(e5, n2);
}
function Er(e5) {
  let t2 = e5.tabIndex;
  if (t2 < 0) {
    let t3 = Dt(e5);
    if (t3 === "details" || t3 === "audio" || t3 === "video" || jt(e5) && e5.isContentEditable) return 0;
  }
  return t2;
}
function Dr(e5) {
  if (Dt(e5) !== "input") return null;
  let t2 = e5;
  return t2.type === "radio" && t2.name !== "" ? t2 : null;
}
function Or(e5, t2) {
  let n2 = Dr(e5);
  if (!n2) return true;
  let r2 = t2.find((e6) => {
    let t3 = Dr(e6);
    return t3?.name === n2.name && t3.form === n2.form && t3.checked;
  });
  return r2 ? r2 === n2 : t2.find((e6) => {
    let t3 = Dr(e6);
    return t3?.name === n2.name && t3.form === n2.form;
  }) === n2;
}
function kr(e5) {
  if (jt(e5) && Dt(e5) === "slot") {
    let t2 = e5.assignedElements({ flatten: true });
    if (t2.length > 0) return t2;
  }
  return jt(e5) && e5.shadowRoot ? Array.from(e5.shadowRoot.children) : Array.from(e5.children);
}
function Ar(e5, t2) {
  kr(e5).forEach((e6) => {
    Cr(e6) && t2.push(e6), Ar(e6, t2);
  });
}
function jr(e5, t2, n2) {
  kr(e5).forEach((e6) => {
    jt(e6) && e6.matches(t2) && n2.push(e6), jr(e6, t2, n2);
  });
}
function Mr(e5) {
  return wr(e5) && Er(e5) >= 0;
}
function Nr(e5) {
  let t2 = [];
  return Ar(e5, t2), t2.filter(wr);
}
function Pr(e5) {
  let t2 = Nr(e5);
  return t2.filter((e6) => Er(e6) >= 0 && Or(e6, t2));
}
function Fr(e5, t2) {
  let n2 = Pr(e5), r2 = n2.length;
  if (r2 === 0) return;
  let i2 = Qt(Bn(e5)), a2 = n2.indexOf(i2);
  return n2[a2 === -1 ? t2 === 1 ? 0 : r2 - 1 : a2 + t2];
}
function Ir(e5) {
  return Fr(Bn(e5).body, 1) || e5;
}
function Lr(e5) {
  return Fr(Bn(e5).body, -1) || e5;
}
function Rr(e5, t2) {
  if (!e5) return null;
  let n2 = Pr(Bn(e5).body), r2 = n2.length;
  if (r2 === 0) return null;
  let i2 = n2.indexOf(e5);
  return i2 === -1 ? null : n2[(i2 + t2 + r2) % r2];
}
function zr(e5) {
  return Rr(e5, 1);
}
function Br(e5) {
  return Rr(e5, -1);
}
function Vr(e5, t2) {
  let n2 = t2 || e5.currentTarget, r2 = e5.relatedTarget;
  return !r2 || !W(n2, r2);
}
function Hr(e5) {
  Pr(e5).forEach((e6) => {
    e6.dataset.tabindex = e6.getAttribute("tabindex") || "", e6.setAttribute("tabindex", "-1");
  });
}
function Ur(e5) {
  let t2 = [];
  jr(e5, "[data-tabindex]", t2), t2.forEach((e6) => {
    let t3 = e6.dataset.tabindex;
    delete e6.dataset.tabindex, t3 ? e6.setAttribute("tabindex", t3) : e6.removeAttribute("tabindex");
  });
}
function Wr(e5, t2, n2 = true) {
  return e5.filter((e6) => e6.parentId === t2).flatMap((t3) => [...!n2 || t3.context?.open ? [t3] : [], ...Wr(e5, t3.id, n2)]);
}
function Gr(e5, t2) {
  let n2 = [], r2 = e5.find((e6) => e6.id === t2)?.parentId;
  for (; r2; ) {
    let t3 = e5.find((e6) => e6.id === r2);
    r2 = t3?.parentId, t3 && (n2 = n2.concat(t3));
  }
  return n2;
}
function Kr(e5) {
  return `data-base-ui-${e5}`;
}
var qr = 0;
function Jr(e5, t2 = {}) {
  let { preventScroll: n2 = false, sync: r2 = false, shouldFocus: i2 } = t2;
  cancelAnimationFrame(qr);
  function a2() {
    i2 && !i2() || e5?.focus({ preventScroll: n2 });
  }
  if (r2) return a2(), $e;
  let o2 = requestAnimationFrame(a2);
  return qr = o2, () => {
    qr === o2 && (cancelAnimationFrame(o2), qr = 0);
  };
}
var Yr = { inert: /* @__PURE__ */ new WeakMap(), "aria-hidden": /* @__PURE__ */ new WeakMap() }, Xr = "data-base-ui-inert", Zr = { inert: /* @__PURE__ */ new WeakSet(), "aria-hidden": /* @__PURE__ */ new WeakSet() }, Qr = /* @__PURE__ */ new WeakMap(), $r = 0;
function ei(e5) {
  return Zr[e5];
}
function ti(e5) {
  return e5 ? Mt(e5) ? e5.host : ti(e5.parentNode) : null;
}
var ni = (e5, t2) => t2.map((t3) => {
  if (e5.contains(t3)) return t3;
  let n2 = ti(t3);
  return e5.contains(n2) ? n2 : null;
}).filter((e6) => e6 != null), ri = (e5) => {
  let t2 = /* @__PURE__ */ new Set();
  return e5.forEach((e6) => {
    let n2 = e6;
    for (; n2 && !t2.has(n2); ) t2.add(n2), n2 = n2.parentNode;
  }), t2;
}, ii = (e5, t2, n2) => {
  let r2 = [], i2 = (e6) => {
    !e6 || n2.has(e6) || Array.from(e6.children).forEach((e7) => {
      Dt(e7) !== "script" && (t2.has(e7) ? i2(e7) : r2.push(e7));
    });
  };
  return i2(e5), r2;
};
function ai(e5, t2, n2, r2, { mark: i2 = true }) {
  let a2 = null;
  r2 ? a2 = "inert" : n2 && (a2 = "aria-hidden");
  let o2 = null, s2 = null, c2 = ni(t2, e5), l2 = i2 ? ii(t2, ri(c2), new Set(c2)) : [], u2 = [], d2 = [];
  if (a2) {
    let e6 = Yr[a2], n3 = ei(a2);
    s2 = n3, o2 = e6;
    let r3 = ni(t2, Array.from(t2.querySelectorAll("[aria-live]"))), i3 = c2.concat(r3);
    ii(t2, ri(i3), new Set(i3)).forEach((t3) => {
      let r4 = t3.getAttribute(a2), i4 = r4 !== null && r4 !== "false", o3 = (e6.get(t3) || 0) + 1;
      e6.set(t3, o3), u2.push(t3), o3 === 1 && i4 && n3.add(t3), i4 || t3.setAttribute(a2, a2 === "inert" ? "" : "true");
    });
  }
  return i2 && l2.forEach((e6) => {
    let t3 = (Qr.get(e6) || 0) + 1;
    Qr.set(e6, t3), d2.push(e6), t3 === 1 && e6.setAttribute(Xr, "");
  }), $r += 1, () => {
    o2 && u2.forEach((e6) => {
      let t3 = (o2.get(e6) || 0) - 1;
      o2.set(e6, t3), t3 || (!s2?.has(e6) && a2 && e6.removeAttribute(a2), s2?.delete(e6));
    }), i2 && d2.forEach((e6) => {
      let t3 = (Qr.get(e6) || 0) - 1;
      Qr.set(e6, t3), t3 || e6.removeAttribute(Xr);
    }), --$r, $r || (Yr.inert = /* @__PURE__ */ new WeakMap(), Yr["aria-hidden"] = /* @__PURE__ */ new WeakMap(), Zr.inert = /* @__PURE__ */ new WeakSet(), Zr["aria-hidden"] = /* @__PURE__ */ new WeakSet(), Qr = /* @__PURE__ */ new WeakMap());
  };
}
function oi(e5, t2 = {}) {
  let { ariaHidden: n2 = false, inert: r2 = false, mark: i2 = true } = t2, a2 = Bn(e5[0]).body;
  return ai(e5, a2, n2, r2, { mark: i2 });
}
var si = 0;
function ci(e5, t2 = "mui") {
  let [n2, r2] = z.useState(e5), i2 = e5 || n2;
  return z.useEffect(() => {
    n2 ?? (si += 1, r2(`${t2}-${si}`));
  }, [n2, t2]), i2;
}
var li = jn.useId;
function ui(e5, t2) {
  if (li !== void 0) {
    let n2 = li();
    return e5 ?? (t2 ? `${t2}-${n2}` : n2);
  }
  return ci(e5, t2);
}
function di(e5, t2) {
  return function(n2, ...r2) {
    let i2 = new URL(e5);
    return i2.searchParams.set("code", n2.toString()), r2.forEach((e6) => i2.searchParams.append("args[]", e6)), `${t2} error #${n2}; visit ${i2} for the full message.`;
  };
}
var fi = di("https://base-ui.com/production-error", "Base UI"), pi = 19;
function mi(e5) {
  return pi >= e5;
}
function hi(e5) {
  if (!z.isValidElement(e5)) return null;
  let t2 = e5, n2 = t2.props;
  return (mi(19) ? n2?.ref : t2.ref) ?? null;
}
function gi(e5, t2) {
  if (e5 && !t2) return e5;
  if (!e5 && t2) return t2;
  if (e5 || t2) return { ...e5, ...t2 };
}
function _i(e5, t2) {
  let n2 = {};
  for (let r2 in e5) {
    let i2 = e5[r2];
    if (t2?.hasOwnProperty(r2)) {
      let e6 = t2[r2](i2);
      e6 != null && Object.assign(n2, e6);
      continue;
    }
    i2 === true ? n2[`data-${r2.toLowerCase()}`] = "" : i2 && (n2[`data-${r2.toLowerCase()}`] = i2.toString());
  }
  return n2;
}
function vi(e5, t2) {
  return typeof e5 == "function" ? e5(t2) : e5;
}
function yi(e5, t2) {
  return typeof e5 == "function" ? e5(t2) : e5;
}
var bi = {};
function xi(e5, t2, n2, r2, i2) {
  if (!n2 && !r2 && !i2 && !e5) return Ci(t2);
  let a2 = Ci(e5);
  return t2 && (a2 = wi(a2, t2)), n2 && (a2 = wi(a2, n2)), r2 && (a2 = wi(a2, r2)), i2 && (a2 = wi(a2, i2)), a2;
}
function Si(e5) {
  if (e5.length === 0) return bi;
  if (e5.length === 1) return Ci(e5[0]);
  let t2 = Ci(e5[0]);
  for (let n2 = 1; n2 < e5.length; n2 += 1) t2 = wi(t2, e5[n2]);
  return t2;
}
function Ci(e5) {
  return Di(e5) ? { ...Oi(e5, bi) } : Ti(e5);
}
function wi(e5, t2) {
  return Di(t2) ? Oi(t2, e5) : Ei(e5, t2);
}
function Ti(e5) {
  let t2 = { ...e5 };
  for (let e6 in t2) {
    let n2 = t2[e6];
    q(e6, n2) && (t2[e6] = Ai(n2));
  }
  return t2;
}
function Ei(e5, t2) {
  if (!t2) return e5;
  for (let n2 in t2) {
    let r2 = t2[n2];
    switch (n2) {
      case "style":
        e5[n2] = gi(e5.style, r2);
        break;
      case "className":
        e5[n2] = Mi(e5.className, r2);
        break;
      default:
        q(n2, r2) ? e5[n2] = ki(e5[n2], r2) : e5[n2] = r2;
    }
  }
  return e5;
}
function q(e5, t2) {
  let n2 = e5.charCodeAt(0), r2 = e5.charCodeAt(1), i2 = e5.charCodeAt(2);
  return n2 === 111 && r2 === 110 && i2 >= 65 && i2 <= 90 && (typeof t2 == "function" || t2 === void 0);
}
function Di(e5) {
  return typeof e5 == "function";
}
function Oi(e5, t2) {
  return Di(e5) ? e5(t2) : e5 ?? bi;
}
function ki(e5, t2) {
  return t2 ? e5 ? (...n2) => {
    let r2 = n2[0];
    if (Ni(r2)) {
      let i3 = r2;
      ji(i3);
      let a2 = t2(...n2);
      return i3.baseUIHandlerPrevented || e5?.(...n2), a2;
    }
    let i2 = t2(...n2);
    return e5?.(...n2), i2;
  } : Ai(t2) : e5;
}
function Ai(e5) {
  return e5 && ((...t2) => {
    let n2 = t2[0];
    return Ni(n2) && ji(n2), e5(...t2);
  });
}
function ji(e5) {
  return e5.preventBaseUIHandler = () => {
    e5.baseUIHandlerPrevented = true;
  }, e5;
}
function Mi(e5, t2) {
  return t2 ? e5 ? t2 + " " + e5 : t2 : e5;
}
function Ni(e5) {
  return typeof e5 == "object" && !!e5 && "nativeEvent" in e5;
}
function Pi(e5, t2, n2 = {}) {
  let r2 = t2.render, i2 = Fi(t2, n2);
  return n2.enabled === false ? null : Ri(e5, r2, i2, n2.state ?? tt);
}
function Fi(e5, t2 = {}) {
  let { className: n2, style: r2, render: i2 } = e5, { state: a2 = tt, ref: o2, props: s2, stateAttributesMapping: c2, enabled: l2 = true } = t2, u2 = l2 ? vi(n2, a2) : void 0, d2 = l2 ? yi(r2, a2) : void 0, f2 = l2 ? _i(a2, c2) : tt, p2 = l2 && s2 ? Ii(s2) : void 0, m2 = l2 ? gi(f2, p2) ?? {} : tt;
  return typeof document < "u" && (l2 ? Array.isArray(o2) ? m2.ref = wn([m2.ref, hi(i2), ...o2]) : m2.ref = Cn(m2.ref, hi(i2), o2) : Cn(null, null)), l2 ? (u2 !== void 0 && (m2.className = Mi(m2.className, u2)), d2 !== void 0 && (m2.style = gi(m2.style, d2)), m2) : tt;
}
function Ii(e5) {
  return Array.isArray(e5) ? Si(e5) : xi(void 0, e5);
}
var Li = /* @__PURE__ */ Symbol.for("react.lazy");
function Ri(e5, t2, n2, r2) {
  if (t2) {
    if (typeof t2 == "function") return t2(n2, r2);
    let e6 = xi(n2, t2.props);
    e6.ref = n2.ref;
    let i2 = t2;
    return i2?.$$typeof === Li && (i2 = z.Children.toArray(t2)[0]), z.cloneElement(i2, e6);
  }
  if (e5 && typeof e5 == "string") return zi(e5, n2);
  throw Error(fi(8));
}
function zi(e5, t2) {
  return e5 === "button" ? (0, z.createElement)("button", { type: "button", ...t2, key: t2.key }) : e5 === "img" ? (0, z.createElement)("img", { alt: "", ...t2, key: t2.key }) : z.createElement(e5, t2);
}
var Bi = { style: { transition: "none" } }, Vi = "data-base-ui-click-trigger", Hi = { fallbackAxisSide: "end" }, Ui = { clipPath: "inset(50%)", position: "fixed", top: 0, left: 0 }, Wi = o(Me(), 1), Gi = z.createContext(null), Ki = () => z.useContext(Gi), qi = Kr("portal");
function Ji(e5 = {}) {
  let { ref: t2, container: n2, componentProps: r2 = tt, elementProps: i2 } = e5, a2 = ui(), o2 = Ki()?.portalNode, [s2, c2] = z.useState(null), [l2, u2] = z.useState(null), d2 = K((e6) => {
    e6 !== null && u2(e6);
  }), f2 = z.useRef(null);
  H(() => {
    if (n2 === null) {
      f2.current && (f2.current = null, u2(null), c2(null));
      return;
    }
    let e6 = (n2 && (At(n2) ? n2 : n2.current)) ?? o2 ?? document.body;
    if (e6 == null) {
      f2.current && (f2.current = null, u2(null), c2(null));
      return;
    }
    f2.current !== e6 && (f2.current = e6, u2(null), c2(e6));
  }, [n2, o2]);
  let p2 = Pi("div", r2, { ref: [t2, d2], props: [{ id: a2, [qi]: "" }, i2] }), m2 = s2 && p2 ? Wi.createPortal(p2, s2) : null;
  return { node: l2, nodeId: z.isValidElement(p2) ? p2.props.id : void 0, subtree: m2 };
}
var Yi = z.forwardRef(function(e5, t2) {
  let { render: n2, className: r2, style: i2, children: a2, container: o2, ...s2 } = e5, { node: c2, nodeId: l2, subtree: u2 } = Ji({ container: o2, ref: t2, componentProps: e5, elementProps: s2 }), d2 = z.useRef(null), f2 = z.useRef(null), p2 = z.useRef(null), m2 = z.useRef(null), [h2, g2] = z.useState(null), _2 = z.useRef(false), v2 = h2?.modal, y2 = h2?.open, b2 = !!h2 && !h2.modal && h2.open && !!c2;
  z.useEffect(() => {
    if (!c2 || v2) return;
    function e6(e7) {
      c2 && e7.relatedTarget && Vr(e7) && (e7.type === "focusin" ? _2.current &&= (Ur(c2), false) : (Hr(c2), _2.current = true));
    }
    return Sn(G(c2, "focusin", e6, true), G(c2, "focusout", e6, true));
  }, [c2, v2]), H(() => {
    !c2 || y2 !== true || !_2.current || (Ur(c2), _2.current = false);
  }, [y2, c2]);
  let x2 = z.useMemo(() => ({ beforeOutsideRef: d2, afterOutsideRef: f2, beforeInsideRef: p2, afterInsideRef: m2, portalNode: c2, setFocusManagerState: g2 }), [c2]);
  return (0, B.jsxs)(z.Fragment, { children: [u2, (0, B.jsxs)(Gi.Provider, { value: x2, children: [b2 && c2 && (0, B.jsx)(Un, { "data-type": "outside", ref: d2, onFocus: (e6) => {
    Vr(e6, c2) ? p2.current?.focus() : Lr(h2 ? h2.domReference : null)?.focus();
  } }), b2 && c2 && (0, B.jsx)("span", { "aria-owns": l2, style: Ui }), c2 && Wi.createPortal(a2, c2), b2 && c2 && (0, B.jsx)(Un, { "data-type": "outside", ref: f2, onFocus: (e6) => {
    Vr(e6, c2) ? m2.current?.focus() : (Ir(h2 ? h2.domReference : null)?.focus(), h2?.closeOnFocusOut && h2?.onOpenChange(false, xn("focus-out", e6.nativeEvent)));
  } })] })] });
});
function Xi() {
  let e5 = /* @__PURE__ */ new Map();
  return { emit(t2, n2) {
    e5.get(t2)?.forEach((e6) => e6(n2));
  }, on(t2, n2) {
    e5.has(t2) || e5.set(t2, /* @__PURE__ */ new Set()), e5.get(t2).add(n2);
  }, off(t2, n2) {
    e5.get(t2)?.delete(n2);
  } };
}
var Zi = class {
  nodesRef = { current: [] };
  events = Xi();
  addNode(e5) {
    this.nodesRef.current.push(e5);
  }
  removeNode(e5) {
    let t2 = this.nodesRef.current.findIndex((t3) => t3 === e5);
    t2 !== -1 && this.nodesRef.current.splice(t2, 1);
  }
}, Qi = z.createContext(null), $i = z.createContext(null), ea = () => z.useContext(Qi)?.id || null, ta = (e5) => {
  let t2 = z.useContext($i);
  return e5 ?? t2;
};
function na(e5) {
  let t2 = ui(), n2 = ta(e5), r2 = ea();
  return H(() => {
    if (!t2) return;
    let e6 = { id: t2, parentId: r2 };
    return n2?.addNode(e6), () => {
      n2?.removeNode(e6);
    };
  }, [n2, t2, r2]), t2;
}
function ra(e5) {
  let { children: t2, id: n2 } = e5, r2 = ea();
  return (0, B.jsx)(Qi.Provider, { value: z.useMemo(() => ({ id: n2, parentId: r2 }), [n2, r2]), children: t2 });
}
function ia(e5) {
  let { children: t2, externalTree: n2 } = e5, r2 = Qe(() => n2 ?? new Zi()).current;
  return (0, B.jsx)($i.Provider, { value: r2, children: t2 });
}
function aa(e5) {
  return e5 == null ? e5 : "current" in e5 ? e5.current : e5;
}
function oa(e5, t2) {
  let n2 = Ot($t(e5));
  return e5 instanceof n2.KeyboardEvent ? "keyboard" : e5 instanceof n2.FocusEvent ? t2 || "keyboard" : "pointerType" in e5 ? e5.pointerType || "keyboard" : "touches" in e5 ? "touch" : e5 instanceof n2.MouseEvent ? t2 || (e5.detail === 0 ? "keyboard" : "mouse") : "";
}
var sa = 20, ca = [];
function la() {
  ca = ca.filter((e5) => e5.deref()?.isConnected);
}
function ua(e5) {
  la(), e5 && Dt(e5) !== "body" && (ca.push(new WeakRef(e5)), ca.length > sa && (ca = ca.slice(-sa)));
}
function da() {
  return la(), ca[ca.length - 1]?.deref();
}
function fa(e5) {
  return e5 ? Mr(e5) ? e5 : Pr(e5)[0] || e5 : null;
}
function pa(e5) {
  if (e5.hasAttribute("tabindex") && !e5.hasAttribute("data-tabindex") || !e5.getAttribute("role")?.includes("dialog")) return;
  let t2 = Nr(e5).filter((e6) => {
    let t3 = e6.getAttribute("data-tabindex") || "";
    return Mr(e6) || e6.hasAttribute("data-tabindex") && !t3.startsWith("-");
  }), n2 = e5.getAttribute("tabindex");
  t2.length === 0 ? n2 !== "0" && (e5.setAttribute("tabindex", "0"), e5.setAttribute("data-tabindex", "0")) : (n2 !== "-1" || e5.hasAttribute("data-tabindex") && e5.getAttribute("data-tabindex") !== "-1") && (e5.setAttribute("tabindex", "-1"), e5.setAttribute("data-tabindex", "-1"));
}
function ma(e5) {
  let { context: t2, children: n2, disabled: r2 = false, initialFocus: i2 = true, returnFocus: a2 = true, restoreFocus: o2 = false, modal: s2 = true, closeOnFocusOut: c2 = true, openInteractionType: l2 = "", nextFocusableElement: u2, previousFocusableElement: d2, beforeContentFocusGuardRef: f2, externalTree: p2, getInsideElements: m2 } = e5, h2 = "rootStore" in t2 ? t2.rootStore : t2, g2 = h2.useState("open"), _2 = h2.useState("domReferenceElement"), v2 = h2.useState("floatingElement"), { events: y2, dataRef: b2 } = h2.context, x2 = K(() => b2.current.floatingContext?.nodeId), S2 = i2 === false, C2 = on(_2) && S2, w2 = kn(i2), T2 = kn(a2), E2 = kn(l2), D2 = kn(g2), O2 = ta(p2), k2 = Ki(), A2 = z.useRef(false), j2 = z.useRef(false), M2 = z.useRef(false), N2 = z.useRef(null), P2 = z.useRef(""), F2 = z.useRef(""), ee2 = z.useRef(null), te2 = z.useRef(null), I2 = Cn(ee2, f2, k2?.beforeInsideRef), ne2 = Cn(te2, k2?.afterInsideRef), re2 = at(), L2 = at(), ie2 = zn(), ae2 = k2 != null, R2 = sn(v2), oe2 = K((e6 = R2) => e6 ? Pr(e6) : []), se2 = K(() => m2?.().filter((e6) => e6 != null) ?? []);
  z.useEffect(() => {
    if (r2 || !s2) return;
    function e6(e7) {
      e7.key === "Tab" && W(R2, Qt(Bn(R2))) && oe2().length === 0 && !C2 && bt(e7);
    }
    return G(Bn(R2), "keydown", e6);
  }, [r2, R2, s2, C2, oe2]), z.useEffect(() => {
    if (r2 || !g2) return;
    let e6 = Bn(R2);
    function t3() {
      M2.current = false;
    }
    function n3(e7) {
      let t4 = $t(e7), n4 = se2();
      M2.current = !(W(v2, t4) || W(_2, t4) || W(k2?.portalNode, t4) || n4.some((e8) => e8 === t4 || W(e8, t4))), F2.current = e7.pointerType || "keyboard", t4?.closest("[data-base-ui-click-trigger]") && (j2.current = true, L2.start(0, () => {
        j2.current = false;
      }));
    }
    function i3() {
      F2.current = "keyboard";
    }
    return Sn(G(e6, "pointerdown", n3, true), G(e6, "pointerup", t3, true), G(e6, "pointercancel", t3, true), G(e6, "keydown", i3, true), t3);
  }, [r2, v2, _2, R2, g2, k2, L2, se2]), z.useEffect(() => {
    if (r2 || !c2) return;
    let e6 = Bn(R2);
    function t3() {
      j2.current = true, L2.start(0, () => {
        j2.current = false;
      });
    }
    function n3(e7) {
      let t4 = $t(e7);
      Mr(t4) && (N2.current = t4);
    }
    function i3(t4) {
      let n4 = t4.relatedTarget, r3 = t4.currentTarget, i4 = $t(t4);
      s2 && n4 == null && i4 != null && W(v2, i4) && ua(i4), queueMicrotask(() => {
        let a4 = x2(), c3 = h2.context.triggerElements, l4 = se2(), f3 = n4?.hasAttribute(Kr("focus-guard")) && [ee2.current, te2.current, k2?.beforeInsideRef.current, k2?.afterInsideRef.current, k2?.beforeOutsideRef.current, k2?.afterOutsideRef.current, aa(d2), aa(u2)].includes(n4), p3 = !(W(_2, n4) || W(v2, n4) || W(n4, v2) || W(k2?.portalNode, n4) || l4.some((e7) => e7 === n4 || W(e7, n4)) || c3.hasMatchingElement((e7) => W(e7, n4)) || f3 || O2 && (Wr(O2.nodesRef.current, a4).find((e7) => W(e7.context?.elements.floating, n4) || W(e7.context?.elements.domReference, n4)) || Gr(O2.nodesRef.current, a4).find((e7) => [e7.context?.elements.floating, sn(e7.context?.elements.floating)].includes(n4) || e7.context?.elements.domReference === n4)));
        if (r3 === _2 && R2 && pa(R2), o2 && r3 !== _2 && !vr(i4) && Qt(e6) === e6.body) {
          if (jt(R2) && (R2.focus(), o2 === "popup")) {
            ie2.request(() => {
              R2.focus();
            });
            return;
          }
          let e7 = oe2(), t5 = N2.current, n5 = (t5 && e7.includes(t5) ? t5 : null) || e7[e7.length - 1] || R2;
          jt(n5) && n5.focus();
        }
        if (b2.current.insideReactTree) {
          b2.current.insideReactTree = false;
          return;
        }
        (C2 || !s2) && n4 && p3 && !j2.current && (C2 || n4 !== da()) && (A2.current = true, h2.setOpen(false, xn(vn, t4)));
      });
    }
    function a3() {
      M2.current || (b2.current.insideReactTree = true, re2.start(0, () => {
        b2.current.insideReactTree = false;
      }));
    }
    let l3 = jt(_2) ? _2 : null;
    if (!(!v2 && !l3)) return Sn(l3 && G(l3, "focusout", i3), l3 && G(l3, "pointerdown", t3), v2 && G(v2, "focusin", n3), v2 && G(v2, "focusout", i3), v2 && k2 && G(v2, "focusout", a3, true));
  }, [r2, _2, v2, R2, s2, O2, k2, h2, c2, o2, oe2, C2, x2, b2, re2, L2, ie2, u2, d2, se2]), z.useEffect(() => {
    if (r2 || !v2 || !g2) return;
    let e6 = Array.from(k2?.portalNode?.querySelectorAll(`[${Kr("portal")}]`) || []), t3 = (O2 ? Gr(O2.nodesRef.current, x2()) : []).find((e7) => on(e7.context?.elements.domReference || null))?.context?.elements.domReference, n3 = oi([v2, ...e6, ee2.current, te2.current, k2?.beforeOutsideRef.current, k2?.afterOutsideRef.current, ...se2(), t3, aa(d2), aa(u2), C2 ? _2 : null].filter((e7) => e7 != null), { ariaHidden: s2 || C2, mark: false }), i3 = oi([v2, ...e6].filter((e7) => e7 != null));
    return () => {
      i3(), n3();
    };
  }, [g2, r2, _2, v2, s2, k2, C2, O2, x2, u2, d2, se2]), H(() => {
    if (!g2 || r2 || !jt(R2)) return;
    P2.current = "", F2.current = "";
    let e6 = Bn(R2), t3 = Qt(e6);
    queueMicrotask(() => {
      let n3 = w2.current, r3 = typeof n3 == "function" ? n3(E2.current || "") : n3;
      if (r3 === void 0 || r3 === false || W(R2, t3)) return;
      let i3 = null, a3 = () => (i3 ??= oe2(R2), i3[0] || R2), o3;
      o3 = r3 === true || r3 === null ? a3() : aa(r3), o3 ||= a3();
      let s3 = W(R2, Qt(e6));
      Jr(o3, { preventScroll: o3 === R2, shouldFocus() {
        if (!D2.current) return false;
        if (s3) return true;
        let t4 = Qt(e6);
        return !(t4 !== o3 && W(R2, t4));
      } });
    });
  }, [r2, g2, R2, oe2, w2, E2, D2]), H(() => {
    if (r2 || !R2) return;
    let e6 = Bn(R2), t3 = Qt(e6), n3 = E2.current == null;
    ua(t3);
    function i3(e7) {
      if (e7.open || (P2.current = oa(e7.nativeEvent, F2.current)), e7.reason === "trigger-hover" && e7.nativeEvent.type === "mouseleave" && (A2.current = true), e7.reason === "outside-press") if (e7.nested) A2.current = false;
      else if (St(e7.nativeEvent) || Ct(e7.nativeEvent)) A2.current = false;
      else {
        let e8 = false;
        Bn(R2).createElement("div").focus({ get preventScroll() {
          return e8 = true, false;
        } }), e8 ? A2.current = false : A2.current = true;
      }
    }
    y2.on("openchange", i3);
    function a3(e7) {
      let r3 = T2.current, i4 = typeof r3 == "function" ? r3(e7) : r3;
      if (i4 === void 0 || i4 === false) return null;
      i4 === null && (i4 = true);
      let a4 = _2?.isConnected ? _2 : null, o3 = t3?.isConnected && Dt(t3) !== "body" ? t3 : null, s3 = n3 ? o3 || a4 : a4 || o3;
      return s3 ||= da() || null, typeof i4 == "boolean" ? s3 : aa(i4) || s3 || null;
    }
    return () => {
      y2.off("openchange", i3);
      let t4 = Qt(e6), n4 = se2(), r3 = W(v2, t4) || n4.some((e7) => e7 === t4 || W(e7, t4)) || O2 && Wr(O2.nodesRef.current, x2(), false).some((e7) => W(e7.context?.elements.floating, t4)), o3 = T2.current, s3 = P2.current, c3 = a3(s3);
      queueMicrotask(() => {
        let n5 = fa(c3), i4 = typeof o3 != "boolean";
        if (o3 && !A2.current && jt(n5) && (!(!i4 && n5 !== t4 && t4 !== e6.body) || r3)) {
          let e7 = { preventScroll: true };
          s3 === "keyboard" && (e7.focusVisible = true), n5.focus(e7);
        }
        A2.current = false;
      });
    };
  }, [r2, v2, R2, T2, E2, y2, O2, _2, x2, se2]), H(() => {
    if (!_t || g2 || !v2) return;
    let e6 = Qt(Bn(v2));
    !jt(e6) || !rn(e6) || W(v2, e6) && e6.blur();
  }, [g2, v2]), H(() => {
    if (!(r2 || !k2)) return k2.setFocusManagerState({ modal: s2, closeOnFocusOut: c2, open: g2, onOpenChange: h2.setOpen, domReference: _2 }), () => {
      k2.setFocusManagerState(null);
    };
  }, [r2, k2, s2, g2, h2, c2, _2]), H(() => {
    if (!(r2 || !R2)) return pa(R2), () => {
      queueMicrotask(la);
    };
  }, [r2, R2]);
  let ce2 = !r2 && (s2 ? !C2 : true) && (ae2 || s2);
  return (0, B.jsxs)(z.Fragment, { children: [ce2 && (0, B.jsx)(Un, { "data-type": "inside", ref: I2, onFocus: (e6) => {
    if (s2) {
      let e7 = oe2();
      Jr(e7[e7.length - 1]);
    } else k2?.portalNode && (A2.current = false, Vr(e6, k2.portalNode) ? Ir(_2)?.focus() : aa(d2 ?? k2.beforeOutsideRef)?.focus());
  } }), n2, ce2 && (0, B.jsx)(Un, { "data-type": "inside", ref: ne2, onFocus: (e6) => {
    s2 ? Jr(oe2()[0]) : k2?.portalNode && (c2 && (A2.current = true), Vr(e6, k2.portalNode) ? Lr(_2)?.focus() : aa(u2 ?? k2.afterOutsideRef)?.focus());
  } })] });
}
function ha(e5, t2 = {}) {
  let { enabled: n2 = true, event: r2 = "click", toggle: i2 = true, ignoreMouse: a2 = false, stickIfOpen: o2 = true, touchOpenDelay: s2 = 0, reason: c2 = mn } = t2, l2 = "rootStore" in e5 ? e5.rootStore : e5, u2 = l2.context.dataRef, d2 = z.useRef(void 0), f2 = zn(), p2 = at(), m2 = z.useMemo(() => {
    function e6(e7, t4, n3, r3) {
      let i3 = xn(c2, t4, n3);
      e7 && r3 === "touch" && s2 > 0 ? p2.start(s2, () => {
        l2.setOpen(true, i3);
      }) : l2.setOpen(e7, i3);
    }
    function t3(e7, t4, n3) {
      let r3 = u2.current.openEvent, a3 = l2.select("domReferenceElement") !== t4;
      return e7 && a3 || !e7 || !i2 ? true : r3 && o2 ? !n3(r3.type) : false;
    }
    return { onPointerDown(e7) {
      d2.current = wt(e7.pointerType, true) && Ct(e7.nativeEvent) ? "virtual" : e7.pointerType;
    }, onMouseDown(n3) {
      let i3 = d2.current, o3 = n3.nativeEvent, s3 = l2.select("open");
      if (n3.button !== 0 || r2 === "click" || wt(i3, true) && a2) return;
      let c3 = t3(s3, n3.currentTarget, (e7) => e7 === "click" || e7 === "mousedown"), u3 = $t(o3);
      if (rn(u3)) {
        e6(c3, o3, u3, i3);
        return;
      }
      let p3 = n3.currentTarget;
      f2.request(() => {
        e6(c3, o3, p3, i3);
      });
    }, onClick(n3) {
      if (r2 === "mousedown-only") return;
      let i3 = d2.current;
      if (r2 === "mousedown" && i3) {
        d2.current = void 0;
        return;
      }
      wt(i3, true) && a2 || e6(t3(l2.select("open"), n3.currentTarget, (e7) => e7 === "click" || e7 === "mousedown" || e7 === "keydown" || e7 === "keyup"), n3.nativeEvent, n3.currentTarget, i3);
    }, onKeyDown() {
      d2.current = void 0;
    } };
  }, [u2, r2, a2, c2, l2, o2, i2, f2, p2, s2]);
  return z.useMemo(() => n2 ? { reference: m2 } : tt, [n2, m2]);
}
function ga() {
  return false;
}
function _a(e5) {
  return { escapeKey: typeof e5 == "boolean" ? e5 : e5?.escapeKey ?? false, outsidePress: typeof e5 == "boolean" ? e5 : e5?.outsidePress ?? true };
}
function va(e5, t2 = {}) {
  let { enabled: n2 = true, escapeKey: r2 = true, outsidePress: i2 = true, outsidePressEvent: a2 = "sloppy", referencePress: o2 = ga, bubbles: s2, externalTree: c2 } = t2, l2 = "rootStore" in e5 ? e5.rootStore : e5, u2 = l2.useState("open"), d2 = l2.useState("floatingElement"), { dataRef: f2 } = l2.context, p2 = ta(c2), m2 = K(typeof i2 == "function" ? i2 : () => false), h2 = typeof i2 == "function" ? m2 : i2, g2 = h2 !== false, _2 = K(() => a2), { escapeKey: v2, outsidePress: y2 } = _a(s2), b2 = z.useRef(false), x2 = z.useRef(false), S2 = z.useRef(false), C2 = z.useRef(false), w2 = z.useRef(""), T2 = z.useRef(null), E2 = at(), D2 = at(), O2 = K(() => {
    D2.clear(), f2.current.insideReactTree = false;
  }), k2 = K((e6) => {
    let t3 = f2.current.floatingContext?.nodeId;
    return (p2 ? Wr(p2.nodesRef.current, t3) : []).some((t4) => t4.context?.open && !t4.context.dataRef.current[e6]);
  }), A2 = K((e6) => tn(e6, l2.select("floatingElement")) || tn(e6, l2.select("domReferenceElement"))), j2 = K((e6) => {
    o2() && l2.setOpen(false, xn(mn, e6.nativeEvent));
  }), M2 = K((e6) => {
    if (!u2 || !n2 || !r2 || e6.key !== "Escape" || C2.current || !v2 && k2("__escapeKeyBubbles")) return;
    let t3 = xn(yn, xt(e6) ? e6.nativeEvent : e6);
    l2.setOpen(false, t3), t3.isCanceled || e6.preventDefault(), !v2 && !t3.isPropagationAllowed && e6.stopPropagation();
  }), N2 = K(() => {
    f2.current.insideReactTree = true, D2.start(0, O2);
  }), P2 = K((e6) => {
    if (!u2 || !n2 || e6.button !== 0) return;
    let t3 = $t(e6.nativeEvent);
    W(l2.select("floatingElement"), t3) && (b2.current || (b2.current = true, x2.current = false));
  }), F2 = K((e6) => {
    !u2 || !n2 || (e6.defaultPrevented || e6.nativeEvent.defaultPrevented) && b2.current && (x2.current = true);
  });
  z.useEffect(() => {
    if (!u2 || !n2) return O2;
    f2.current.__escapeKeyBubbles = v2, f2.current.__outsidePressBubbles = y2;
    let e6 = new it(), t3 = new it();
    function i3() {
      e6.clear(), C2.current = true;
    }
    function a3() {
      e6.start(_t ? 5 : 0, () => {
        C2.current = false;
      });
    }
    function o3() {
      S2.current = true, t3.start(0, () => {
        S2.current = false;
      });
    }
    function s3() {
      b2.current = false, x2.current = false;
    }
    function c3() {
      let e7 = w2.current, t4 = e7 === "pen" || !e7 ? "mouse" : e7, n3 = _2(), r3 = typeof n3 == "function" ? n3() : n3;
      return typeof r3 == "string" ? r3 : r3[t4];
    }
    function m3(e7) {
      let t4 = c3();
      return t4 === "intentional" && e7.type !== "click" || t4 === "sloppy" && e7.type === "click";
    }
    function D3(e7) {
      let t4 = f2.current.floatingContext?.nodeId, n3 = p2 && Wr(p2.nodesRef.current, t4).some((t5) => tn(e7, t5.context?.elements.floating));
      return A2(e7) || n3;
    }
    function j3(e7) {
      if (m3(e7)) {
        e7.type !== "click" && !A2(e7) && (t3.clear(), S2.current = false), O2();
        return;
      }
      if (f2.current.insideReactTree) {
        O2();
        return;
      }
      let n3 = $t(e7), r3 = `[${Kr("inert")}]`, i4 = U(n3) ? n3.getRootNode() : null, a4 = Array.from((Mt(i4) ? i4 : Bn(l2.select("floatingElement"))).querySelectorAll(r3)), o4 = l2.context.triggerElements;
      if (n3 && (o4.hasElement(n3) || o4.hasMatchingElement((e8) => W(e8, n3)))) return;
      let s4 = U(n3) ? n3 : null;
      for (; s4 && !Ut(s4); ) {
        let e8 = Kt(s4);
        if (Ut(e8) || !U(e8)) break;
        s4 = e8;
      }
      if (!(a4.length && U(n3) && !nn(n3) && !W(n3, l2.select("floatingElement")) && a4.every((e8) => !W(s4, e8)))) {
        if (jt(n3) && !("touches" in e7)) {
          let t4 = Ut(n3), r4 = Wt(n3), i5 = /auto|scroll/, a5 = t4 || i5.test(r4.overflowX), o5 = t4 || i5.test(r4.overflowY), s5 = a5 && n3.clientWidth > 0 && n3.scrollWidth > n3.clientWidth, c4 = o5 && n3.clientHeight > 0 && n3.scrollHeight > n3.clientHeight, l3 = r4.direction === "rtl", u3 = c4 && (l3 ? e7.offsetX <= n3.offsetWidth - n3.clientWidth : e7.offsetX > n3.clientWidth), d3 = s5 && e7.offsetY > n3.clientHeight;
          if (u3 || d3) return;
        }
        if (!D3(e7)) {
          if (c3() === "intentional" && S2.current) {
            t3.clear(), S2.current = false;
            return;
          }
          typeof h2 == "function" && !h2(e7) || k2("__outsidePressBubbles") || (l2.setOpen(false, xn(gn, e7)), O2());
        }
      }
    }
    function N3(e7) {
      c3() !== "sloppy" || e7.pointerType === "touch" || !l2.select("open") || !n2 || A2(e7) || j3(e7);
    }
    function P3(e7) {
      if (c3() !== "sloppy" || !l2.select("open") || !n2 || A2(e7)) return;
      let t4 = e7.touches[0];
      t4 && (T2.current = { startTime: Date.now(), startX: t4.clientX, startY: t4.clientY, dismissOnTouchEnd: false, dismissOnMouseDown: true }, E2.start(1e3, () => {
        T2.current && (T2.current.dismissOnTouchEnd = false, T2.current.dismissOnMouseDown = false);
      }));
    }
    function F3(e7, t4) {
      let n3 = $t(e7);
      if (!n3) return;
      let r3 = G(n3, e7.type, () => {
        t4(e7), r3();
      });
    }
    function ee3(e7) {
      w2.current = "touch", F3(e7, P3);
    }
    function te3(e7) {
      E2.clear(), e7.type === "pointerdown" && (w2.current = e7.pointerType), !(e7.type === "mousedown" && T2.current && !T2.current.dismissOnMouseDown) && F3(e7, (e8) => {
        e8.type === "pointerdown" ? N3(e8) : j3(e8);
      });
    }
    function I2(e7) {
      if (!b2.current) return;
      let n3 = x2.current;
      if (s3(), c3() === "intentional") {
        if (e7.type === "pointercancel") {
          n3 && o3();
          return;
        }
        if (!D3(e7)) {
          if (n3) {
            o3();
            return;
          }
          typeof h2 == "function" && !h2(e7) || (t3.clear(), S2.current = true, O2());
        }
      }
    }
    function ne2(e7) {
      if (c3() !== "sloppy" || !T2.current || A2(e7)) return;
      let t4 = e7.touches[0];
      if (!t4) return;
      let n3 = Math.abs(t4.clientX - T2.current.startX), r3 = Math.abs(t4.clientY - T2.current.startY), i4 = Math.sqrt(n3 * n3 + r3 * r3);
      i4 > 5 && (T2.current.dismissOnTouchEnd = true), i4 > 10 && (j3(e7), E2.clear(), T2.current = null);
    }
    function re2(e7) {
      F3(e7, ne2);
    }
    function L2(e7) {
      c3() !== "sloppy" || !T2.current || A2(e7) || (T2.current.dismissOnTouchEnd && j3(e7), E2.clear(), T2.current = null);
    }
    function ie2(e7) {
      F3(e7, L2);
    }
    let ae2 = Bn(d2), R2 = Sn(r2 && Sn(G(ae2, "keydown", M2), G(ae2, "compositionstart", i3), G(ae2, "compositionend", a3)), g2 && Sn(G(ae2, "click", te3, true), G(ae2, "pointerdown", te3, true), G(ae2, "pointerup", I2, true), G(ae2, "pointercancel", I2, true), G(ae2, "mousedown", te3, true), G(ae2, "mouseup", I2, true), G(ae2, "touchstart", ee3, true), G(ae2, "touchmove", re2, true), G(ae2, "touchend", ie2, true)));
    return () => {
      R2(), e6.clear(), t3.clear(), s3(), S2.current = false, O2();
    };
  }, [f2, d2, r2, g2, h2, u2, n2, v2, y2, M2, O2, _2, k2, A2, p2, l2, E2]);
  let ee2 = z.useMemo(() => ({ onKeyDown: M2, onPointerDown: j2, onClick: j2 }), [M2, j2]), te2 = z.useMemo(() => ({ onKeyDown: M2, onPointerDown: F2, onMouseDown: F2, onClickCapture: N2, onMouseDownCapture(e6) {
    N2(), P2(e6);
  }, onPointerDownCapture(e6) {
    N2(), P2(e6);
  }, onMouseUpCapture: N2, onTouchEndCapture: N2, onTouchMoveCapture: N2 }), [M2, N2, P2, F2]);
  return z.useMemo(() => n2 ? { reference: ee2, floating: te2, trigger: ee2 } : {}, [n2, ee2, te2]);
}
function ya(e5, t2, n2) {
  let { reference: r2, floating: i2 } = e5, a2 = nr(t2), o2 = rr(t2), s2 = tr(o2), c2 = Qn(t2), l2 = a2 === "y", u2 = r2.x + r2.width / 2 - i2.width / 2, d2 = r2.y + r2.height / 2 - i2.height / 2, f2 = r2[s2] / 2 - i2[s2] / 2, p2;
  switch (c2) {
    case "top":
      p2 = { x: u2, y: r2.y - i2.height };
      break;
    case "bottom":
      p2 = { x: u2, y: r2.y + r2.height };
      break;
    case "right":
      p2 = { x: r2.x + r2.width, y: d2 };
      break;
    case "left":
      p2 = { x: r2.x - i2.width, y: d2 };
      break;
    default:
      p2 = { x: r2.x, y: r2.y };
  }
  let m2 = $n(t2);
  return m2 && (p2[o2] += f2 * (m2 === "end" ? 1 : -1) * (n2 && l2 ? -1 : 1)), p2;
}
async function ba(e5, t2) {
  t2 === void 0 && (t2 = {});
  let { x: n2, y: r2, platform: i2, rects: a2, elements: o2, strategy: s2 } = e5, { boundary: c2 = "clippingAncestors", rootBoundary: l2 = "viewport", elementContext: u2 = "floating", altBoundary: d2 = false, padding: f2 = 0 } = Zn(t2, e5), p2 = hr(f2), m2 = o2[d2 ? u2 === "floating" ? "reference" : "floating" : u2], h2 = gr(await i2.getClippingRect({ element: await (i2.isElement == null ? void 0 : i2.isElement(m2)) ?? true ? m2 : m2.contextElement || await (i2.getDocumentElement == null ? void 0 : i2.getDocumentElement(o2.floating)), boundary: c2, rootBoundary: l2, strategy: s2 })), g2 = u2 === "floating" ? { x: n2, y: r2, width: a2.floating.width, height: a2.floating.height } : a2.reference, _2 = await (i2.getOffsetParent == null ? void 0 : i2.getOffsetParent(o2.floating)), v2 = await (i2.isElement == null ? void 0 : i2.isElement(_2)) && await (i2.getScale == null ? void 0 : i2.getScale(_2)) || { x: 1, y: 1 }, y2 = gr(i2.convertOffsetParentRelativeRectToViewportRelativeRect ? await i2.convertOffsetParentRelativeRectToViewportRelativeRect({ elements: o2, rect: g2, offsetParent: _2, strategy: s2 }) : g2);
  return { top: (h2.top - y2.top + p2.top) / v2.y, bottom: (y2.bottom - h2.bottom + p2.bottom) / v2.y, left: (h2.left - y2.left + p2.left) / v2.x, right: (y2.right - h2.right + p2.right) / v2.x };
}
var xa = 50, Sa = async (e5, t2, n2) => {
  let { placement: r2 = "bottom", strategy: i2 = "absolute", middleware: a2 = [], platform: o2 } = n2, s2 = o2.detectOverflow ? o2 : { ...o2, detectOverflow: ba }, c2 = await (o2.isRTL == null ? void 0 : o2.isRTL(t2)), l2 = await o2.getElementRects({ reference: e5, floating: t2, strategy: i2 }), { x: u2, y: d2 } = ya(l2, r2, c2), f2 = r2, p2 = 0, m2 = {};
  for (let n3 = 0; n3 < a2.length; n3++) {
    let h2 = a2[n3];
    if (!h2) continue;
    let { name: g2, fn: _2 } = h2, { x: v2, y: y2, data: b2, reset: x2 } = await _2({ x: u2, y: d2, initialPlacement: r2, placement: f2, strategy: i2, middlewareData: m2, rects: l2, platform: s2, elements: { reference: e5, floating: t2 } });
    u2 = v2 ?? u2, d2 = y2 ?? d2, m2[g2] = { ...m2[g2], ...b2 }, x2 && p2 < xa && (p2++, typeof x2 == "object" && (x2.placement && (f2 = x2.placement), x2.rects && (l2 = x2.rects === true ? await o2.getElementRects({ reference: e5, floating: t2, strategy: i2 }) : x2.rects), { x: u2, y: d2 } = ya(l2, f2, c2)), n3 = -1);
  }
  return { x: u2, y: d2, placement: f2, strategy: i2, middlewareData: m2 };
}, Ca = function(e5) {
  return e5 === void 0 && (e5 = {}), { name: "flip", options: e5, async fn(t2) {
    var n2;
    let { placement: r2, middlewareData: i2, rects: a2, initialPlacement: o2, platform: s2, elements: c2 } = t2, { mainAxis: l2 = true, crossAxis: u2 = true, fallbackPlacements: d2, fallbackStrategy: f2 = "bestFit", fallbackAxisSideDirection: p2 = "none", flipAlignment: m2 = true, ...h2 } = Zn(e5, t2);
    if ((n2 = i2.arrow) != null && n2.alignmentOffset) return {};
    let g2 = Qn(r2), _2 = nr(o2), v2 = Qn(o2) === o2, y2 = await (s2.isRTL == null ? void 0 : s2.isRTL(c2.floating)), b2 = d2 || (v2 || !m2 ? [pr(o2)] : ar(o2)), x2 = p2 !== "none";
    !d2 && x2 && b2.push(...fr(o2, m2, p2, y2));
    let S2 = [o2, ...b2], C2 = await s2.detectOverflow(t2, h2), w2 = [], T2 = i2.flip?.overflows || [];
    if (l2 && w2.push(C2[g2]), u2) {
      let e6 = ir(r2, a2, y2);
      w2.push(C2[e6[0]], C2[e6[1]]);
    }
    if (T2 = [...T2, { placement: r2, overflows: w2 }], !w2.every((e6) => e6 <= 0)) {
      let e6 = (i2.flip?.index || 0) + 1, t3 = S2[e6];
      if (t3 && (!(u2 === "alignment" && _2 !== nr(t3)) || T2.every((e7) => nr(e7.placement) === _2 ? e7.overflows[0] > 0 : true))) return { data: { index: e6, overflows: T2 }, reset: { placement: t3 } };
      let n3 = T2.filter((e7) => e7.overflows[0] <= 0).sort((e7, t4) => e7.overflows[1] - t4.overflows[1])[0]?.placement;
      if (!n3) switch (f2) {
        case "bestFit": {
          let e7 = T2.filter((e8) => {
            if (x2) {
              let t4 = nr(e8.placement);
              return t4 === _2 || t4 === "y";
            }
            return true;
          }).map((e8) => [e8.placement, e8.overflows.filter((e9) => e9 > 0).reduce((e9, t4) => e9 + t4, 0)]).sort((e8, t4) => e8[1] - t4[1])[0]?.[0];
          e7 && (n3 = e7);
          break;
        }
        case "initialPlacement":
          n3 = o2;
          break;
      }
      if (r2 !== n3) return { reset: { placement: n3 } };
    }
    return {};
  } };
}, wa = /* @__PURE__ */ new Set(["left", "top"]);
async function Ta(e5, t2) {
  let { placement: n2, platform: r2, elements: i2 } = e5, a2 = await (r2.isRTL == null ? void 0 : r2.isRTL(i2.floating)), o2 = Qn(n2), s2 = $n(n2), c2 = nr(n2) === "y", l2 = wa.has(o2) ? -1 : 1, u2 = a2 && c2 ? -1 : 1, d2 = Zn(t2, e5), { mainAxis: f2, crossAxis: p2, alignmentAxis: m2 } = typeof d2 == "number" ? { mainAxis: d2, crossAxis: 0, alignmentAxis: null } : { mainAxis: d2.mainAxis || 0, crossAxis: d2.crossAxis || 0, alignmentAxis: d2.alignmentAxis };
  return s2 && typeof m2 == "number" && (p2 = s2 === "end" ? m2 * -1 : m2), c2 ? { x: p2 * u2, y: f2 * l2 } : { x: f2 * l2, y: p2 * u2 };
}
var Ea = function(e5) {
  return e5 === void 0 && (e5 = 0), { name: "offset", options: e5, async fn(t2) {
    var n2;
    let { x: r2, y: i2, placement: a2, middlewareData: o2 } = t2, s2 = await Ta(t2, e5);
    return a2 === o2.offset?.placement && (n2 = o2.arrow) != null && n2.alignmentOffset ? {} : { x: r2 + s2.x, y: i2 + s2.y, data: { ...s2, placement: a2 } };
  } };
}, Da = function(e5) {
  return e5 === void 0 && (e5 = {}), { name: "shift", options: e5, async fn(t2) {
    let { x: n2, y: r2, placement: i2, platform: a2 } = t2, { mainAxis: o2 = true, crossAxis: s2 = false, limiter: c2 = { fn: (e6) => {
      let { x: t3, y: n3 } = e6;
      return { x: t3, y: n3 };
    } }, ...l2 } = Zn(e5, t2), u2 = { x: n2, y: r2 }, d2 = await a2.detectOverflow(t2, l2), f2 = nr(i2), p2 = er(f2), m2 = u2[p2], h2 = u2[f2], g2 = (e6, t3) => Xn(t3 + d2[e6 === "y" ? "top" : "left"], t3, t3 - d2[e6 === "y" ? "bottom" : "right"]);
    o2 && (m2 = g2(p2, m2)), s2 && (h2 = g2(f2, h2));
    let _2 = c2.fn({ ...t2, [p2]: m2, [f2]: h2 });
    return { ..._2, data: { x: _2.x - n2, y: _2.y - r2, enabled: { [p2]: o2, [f2]: s2 } } };
  } };
}, Oa = function(e5) {
  return e5 === void 0 && (e5 = {}), { options: e5, fn(t2) {
    let { x: n2, y: r2, placement: i2, rects: a2, middlewareData: o2 } = t2, { offset: s2 = 0, mainAxis: c2 = true, crossAxis: l2 = true } = Zn(e5, t2), u2 = { x: n2, y: r2 }, d2 = nr(i2), f2 = er(d2), p2 = u2[f2], m2 = u2[d2], h2 = Zn(s2, t2), g2 = typeof h2 == "number" ? { mainAxis: h2, crossAxis: 0 } : { mainAxis: h2.mainAxis ?? 0, crossAxis: h2.crossAxis ?? 0 };
    if (c2) {
      let e6 = f2 === "y" ? "height" : "width", t3 = a2.reference[f2] - a2.floating[e6] + g2.mainAxis, n3 = a2.reference[f2] + a2.reference[e6] - g2.mainAxis;
      p2 < t3 ? p2 = t3 : p2 > n3 && (p2 = n3);
    }
    if (l2) {
      let e6 = f2 === "y" ? "width" : "height", t3 = wa.has(Qn(i2)), n3 = a2.reference[d2] - a2.floating[e6] + (t3 && o2.offset?.[d2] || 0) + (t3 ? 0 : g2.crossAxis), r3 = a2.reference[d2] + a2.reference[e6] + (t3 ? 0 : o2.offset?.[d2] || 0) - (t3 ? g2.crossAxis : 0);
      m2 < n3 ? m2 = n3 : m2 > r3 && (m2 = r3);
    }
    return { [f2]: p2, [d2]: m2 };
  } };
}, ka = function(e5) {
  return e5 === void 0 && (e5 = {}), { name: "size", options: e5, async fn(t2) {
    let { placement: n2, rects: r2, platform: i2, elements: a2 } = t2, { apply: o2 = () => {
    }, ...s2 } = Zn(e5, t2), c2 = await i2.detectOverflow(t2, s2), l2 = Qn(n2), u2 = $n(n2), d2 = nr(n2) === "y", { width: f2, height: p2 } = r2.floating, m2, h2;
    l2 === "top" || l2 === "bottom" ? (m2 = l2, h2 = u2 === (await (i2.isRTL == null ? void 0 : i2.isRTL(a2.floating)) ? "start" : "end") ? "left" : "right") : (h2 = l2, m2 = u2 === "end" ? "top" : "bottom");
    let g2 = p2 - c2.top - c2.bottom, _2 = f2 - c2.left - c2.right, v2 = Wn(p2 - c2[m2], g2), y2 = Wn(f2 - c2[h2], _2), b2 = t2.middlewareData.shift, x2 = !b2, S2 = v2, C2 = y2;
    b2 != null && b2.enabled.x && (C2 = _2), b2 != null && b2.enabled.y && (S2 = g2), x2 && !u2 && (d2 ? C2 = f2 - 2 * Gn(c2.left, c2.right) : S2 = p2 - 2 * Gn(c2.top, c2.bottom)), await o2({ ...t2, availableWidth: C2, availableHeight: S2 });
    let w2 = await i2.getDimensions(a2.floating);
    return f2 !== w2.width || p2 !== w2.height ? { reset: { rects: true } } : {};
  } };
};
function Aa(e5) {
  let t2 = Wt(e5), n2 = parseFloat(t2.width) || 0, r2 = parseFloat(t2.height) || 0, i2 = jt(e5), a2 = i2 ? e5.offsetWidth : n2, o2 = i2 ? e5.offsetHeight : r2, s2 = Kn(n2) !== a2 || Kn(r2) !== o2;
  return s2 && (n2 = a2, r2 = o2), { width: n2, height: r2, $: s2 };
}
function ja(e5) {
  return U(e5) ? e5 : e5.contextElement;
}
function Ma(e5) {
  let t2 = ja(e5);
  if (!jt(t2)) return Jn(1);
  let n2 = t2.getBoundingClientRect(), { width: r2, height: i2, $: a2 } = Aa(t2), o2 = (a2 ? Kn(n2.width) : n2.width) / r2, s2 = (a2 ? Kn(n2.height) : n2.height) / i2;
  return (!o2 || !Number.isFinite(o2)) && (o2 = 1), (!s2 || !Number.isFinite(s2)) && (s2 = 1), { x: o2, y: s2 };
}
var Na = Jn(0);
function Pa(e5) {
  let t2 = Ot(e5);
  return !Ht() || !t2.visualViewport ? Na : { x: t2.visualViewport.offsetLeft, y: t2.visualViewport.offsetTop };
}
function Fa(e5, t2, n2) {
  return t2 === void 0 && (t2 = false), !!n2 && t2 && n2 === Ot(e5);
}
function Ia(e5, t2, n2, r2) {
  t2 === void 0 && (t2 = false), n2 === void 0 && (n2 = false);
  let i2 = e5.getBoundingClientRect(), a2 = ja(e5), o2 = Jn(1);
  t2 && (r2 ? U(r2) && (o2 = Ma(r2)) : o2 = Ma(e5));
  let s2 = Fa(a2, n2, r2) ? Pa(a2) : Jn(0), c2 = (i2.left + s2.x) / o2.x, l2 = (i2.top + s2.y) / o2.y, u2 = i2.width / o2.x, d2 = i2.height / o2.y;
  if (a2 && r2) {
    let e6 = Ot(a2), t3 = U(r2) ? Ot(r2) : r2, n3 = e6, i3 = Yt(n3);
    for (; i3 && t3 !== n3; ) {
      let e7 = Ma(i3), t4 = i3.getBoundingClientRect(), r3 = Wt(i3), a3 = t4.left + (i3.clientLeft + parseFloat(r3.paddingLeft)) * e7.x, o3 = t4.top + (i3.clientTop + parseFloat(r3.paddingTop)) * e7.y;
      c2 *= e7.x, l2 *= e7.y, u2 *= e7.x, d2 *= e7.y, c2 += a3, l2 += o3, n3 = Ot(i3), i3 = Yt(n3);
    }
  }
  return gr({ width: u2, height: d2, x: c2, y: l2 });
}
function La(e5, t2) {
  let n2 = Gt(e5).scrollLeft;
  return t2 ? t2.left + n2 : Ia(kt(e5)).left + n2;
}
function Ra(e5, t2) {
  let n2 = e5.getBoundingClientRect();
  return { x: n2.left + t2.scrollLeft - La(e5, n2), y: n2.top + t2.scrollTop };
}
function za(e5) {
  let { elements: t2, rect: n2, offsetParent: r2, strategy: i2 } = e5, a2 = i2 === "fixed", o2 = kt(r2), s2 = t2 ? Ft(t2.floating) : false;
  if (r2 === o2 || s2 && a2) return n2;
  let c2 = { scrollLeft: 0, scrollTop: 0 }, l2 = Jn(1), u2 = Jn(0), d2 = jt(r2);
  if ((d2 || !a2) && ((Dt(r2) !== "body" || Nt(o2)) && (c2 = Gt(r2)), d2)) {
    let e6 = Ia(r2);
    l2 = Ma(r2), u2.x = e6.x + r2.clientLeft, u2.y = e6.y + r2.clientTop;
  }
  let f2 = o2 && !d2 && !a2 ? Ra(o2, c2) : Jn(0);
  return { width: n2.width * l2.x, height: n2.height * l2.y, x: n2.x * l2.x - c2.scrollLeft * l2.x + u2.x + f2.x, y: n2.y * l2.y - c2.scrollTop * l2.y + u2.y + f2.y };
}
function Ba(e5) {
  return e5.getClientRects ? Array.from(e5.getClientRects()) : [];
}
function Va(e5) {
  let t2 = Gt(e5), n2 = e5.ownerDocument.body, r2 = Gn(e5.scrollWidth, e5.clientWidth, n2.scrollWidth, n2.clientWidth), i2 = Gn(e5.scrollHeight, e5.clientHeight, n2.scrollHeight, n2.clientHeight), a2 = -t2.scrollLeft + La(e5), o2 = -t2.scrollTop;
  return Wt(n2).direction === "rtl" && (a2 += Gn(e5.clientWidth, n2.clientWidth) - r2), { width: r2, height: i2, x: a2, y: o2 };
}
var Ha = 25;
function Ua(e5, t2, n2) {
  n2 === void 0 && (n2 = "viewport");
  let r2 = n2 === "layoutViewport", i2 = Ot(e5), a2 = kt(e5), o2 = i2.visualViewport, s2 = a2.clientWidth, c2 = a2.clientHeight, l2 = 0, u2 = 0;
  if (o2) {
    let e6 = !Ht() || t2 === "fixed";
    r2 ? e6 || (l2 = -o2.offsetLeft, u2 = -o2.offsetTop) : (s2 = o2.width, c2 = o2.height, e6 && (l2 = o2.offsetLeft, u2 = o2.offsetTop));
  }
  if (La(a2) <= 0) {
    let e6 = a2.ownerDocument, t3 = e6.body, n3 = getComputedStyle(t3), r3 = e6.compatMode === "CSS1Compat" && parseFloat(n3.marginLeft) + parseFloat(n3.marginRight) || 0, i3 = Math.abs(a2.clientWidth - t3.clientWidth - r3), o3 = getComputedStyle(a2).scrollbarGutter === "stable both-edges" ? i3 / 2 : i3;
    o3 <= Ha && (s2 -= o3);
  }
  return { width: s2, height: c2, x: l2, y: u2 };
}
function Wa(e5, t2) {
  let n2 = Ia(e5, true, t2 === "fixed"), r2 = n2.top + e5.clientTop, i2 = n2.left + e5.clientLeft, a2 = Ma(e5);
  return { width: e5.clientWidth * a2.x, height: e5.clientHeight * a2.y, x: i2 * a2.x, y: r2 * a2.y };
}
function Ga(e5, t2, n2) {
  let r2;
  if (t2 === "viewport" || t2 === "layoutViewport") r2 = Ua(e5, n2, t2);
  else if (t2 === "document") r2 = Va(kt(e5));
  else if (U(t2)) r2 = Wa(t2, n2);
  else {
    let n3 = Pa(e5);
    r2 = { x: t2.x - n3.x, y: t2.y - n3.y, width: t2.width, height: t2.height };
  }
  return gr(r2);
}
function Ka(e5, t2) {
  let n2 = t2.get(e5);
  if (n2) return n2;
  let r2 = Jt(e5, [], false).filter((e6) => U(e6) && Dt(e6) !== "body"), i2 = null, a2 = Wt(e5).position === "fixed", o2 = a2 ? Kt(e5) : e5;
  for (; U(o2) && !Ut(o2); ) {
    let e6 = Wt(o2), t3 = Bt(o2), n3 = i2 ? i2.position : a2 ? "fixed" : "";
    !t3 && (n3 === "fixed" || n3 === "absolute" && e6.position === "static") ? r2 = r2.filter((e7) => e7 !== o2) : i2 = e6, o2 = Kt(o2);
  }
  return t2.set(e5, r2), r2;
}
function qa(e5) {
  let { element: t2, boundary: n2, rootBoundary: r2, strategy: i2 } = e5, a2 = [...n2 === "clippingAncestors" ? Ft(t2) ? [] : Ka(t2, this._c) : [].concat(n2), r2], o2 = Ga(t2, a2[0], i2), s2 = o2.top, c2 = o2.right, l2 = o2.bottom, u2 = o2.left;
  for (let e6 = 1; e6 < a2.length; e6++) {
    let n3 = Ga(t2, a2[e6], i2);
    s2 = Gn(n3.top, s2), c2 = Wn(n3.right, c2), l2 = Wn(n3.bottom, l2), u2 = Gn(n3.left, u2);
  }
  return { width: c2 - u2, height: l2 - s2, x: u2, y: s2 };
}
function Ja(e5) {
  let { width: t2, height: n2 } = Aa(e5);
  return { width: t2, height: n2 };
}
function Ya(e5, t2, n2) {
  let r2 = jt(t2), i2 = kt(t2), a2 = n2 === "fixed", o2 = Ia(e5, true, a2, t2), s2 = { scrollLeft: 0, scrollTop: 0 }, c2 = Jn(0);
  if ((r2 || !a2) && ((Dt(t2) !== "body" || Nt(i2)) && (s2 = Gt(t2)), r2)) {
    let e6 = Ia(t2, true, a2, t2);
    c2.x = e6.x + t2.clientLeft, c2.y = e6.y + t2.clientTop;
  }
  !r2 && i2 && (c2.x = La(i2));
  let l2 = i2 && !r2 && !a2 ? Ra(i2, s2) : Jn(0);
  return { x: o2.left + s2.scrollLeft - c2.x - l2.x, y: o2.top + s2.scrollTop - c2.y - l2.y, width: o2.width, height: o2.height };
}
function Xa(e5) {
  return Wt(e5).position === "static";
}
function Za(e5, t2) {
  if (!jt(e5) || Wt(e5).position === "fixed") return null;
  if (t2) return t2(e5);
  let n2 = e5.offsetParent;
  return kt(e5) === n2 && (n2 = n2.ownerDocument.body), n2;
}
function Qa(e5, t2) {
  let n2 = Ot(e5);
  if (Ft(e5)) return n2;
  if (!jt(e5)) {
    let t3 = Kt(e5);
    for (; t3 && !Ut(t3); ) {
      if (U(t3) && !Xa(t3)) return t3;
      t3 = Kt(t3);
    }
    return n2;
  }
  let r2 = Za(e5, t2);
  for (; r2 && Pt(r2) && Xa(r2); ) r2 = Za(r2, t2);
  return r2 && Ut(r2) && Xa(r2) && !Bt(r2) ? n2 : r2 || Vt(e5) || n2;
}
var $a = async function(e5) {
  let t2 = this.getOffsetParent || Qa, n2 = this.getDimensions, r2 = await n2(e5.floating);
  return { reference: Ya(e5.reference, await t2(e5.floating), e5.strategy), floating: { x: 0, y: 0, width: r2.width, height: r2.height } };
};
function eo(e5) {
  return Wt(e5).direction === "rtl";
}
var to = { convertOffsetParentRelativeRectToViewportRelativeRect: za, getDocumentElement: kt, getClippingRect: qa, getOffsetParent: Qa, getElementRects: $a, getClientRects: Ba, getDimensions: Ja, getScale: Ma, isElement: U, isRTL: eo };
function no(e5, t2) {
  return e5.x === t2.x && e5.y === t2.y && e5.width === t2.width && e5.height === t2.height;
}
function ro(e5, t2, n2) {
  let r2 = null, i2, a2 = kt(e5);
  function o2() {
    var e6;
    clearTimeout(i2), (e6 = r2) == null || e6.disconnect(), r2 = null;
  }
  function s2(n3, c3) {
    n3 === void 0 && (n3 = false), c3 === void 0 && (c3 = 1), o2();
    let l3 = e5.getBoundingClientRect(), { left: u2, top: d2, width: f2, height: p2 } = l3;
    if (n3 || t2(), !f2 || !p2) return;
    let m2 = qn(d2), h2 = qn(a2.clientWidth - (u2 + f2)), g2 = qn(a2.clientHeight - (d2 + p2)), _2 = qn(u2), v2 = { rootMargin: -m2 + "px " + -h2 + "px " + -g2 + "px " + -_2 + "px", threshold: Gn(0, Wn(1, c3)) || 1 }, y2 = true;
    function b2(t3) {
      let n4 = t3[0].intersectionRatio;
      if (!no(l3, e5.getBoundingClientRect())) return s2();
      if (n4 !== c3) {
        if (!y2) return s2();
        n4 ? s2(false, n4) : i2 = setTimeout(() => {
          s2(false, 1e-7);
        }, 1e3);
      }
      y2 = false;
    }
    try {
      r2 = new IntersectionObserver(b2, { ...v2, root: a2.ownerDocument });
    } catch {
      r2 = new IntersectionObserver(b2, v2);
    }
    r2.observe(e5);
  }
  let c2 = Ot(e5), l2 = () => s2(n2);
  return c2.addEventListener("resize", l2), s2(true), () => {
    c2.removeEventListener("resize", l2), o2();
  };
}
function io(e5, t2, n2, r2) {
  r2 === void 0 && (r2 = {});
  let { ancestorScroll: i2 = true, ancestorResize: a2 = true, elementResize: o2 = typeof ResizeObserver == "function", layoutShift: s2 = typeof IntersectionObserver == "function", animationFrame: c2 = false } = r2, l2 = ja(e5), u2 = i2 || a2 ? [...l2 ? Jt(l2) : [], ...t2 ? Jt(t2) : []] : [];
  u2.forEach((e6) => {
    i2 && e6.addEventListener("scroll", n2), a2 && e6.addEventListener("resize", n2);
  });
  let d2 = l2 && s2 ? ro(l2, n2, a2) : null, f2 = -1, p2 = null;
  o2 && (p2 = new ResizeObserver((e6) => {
    let [r3] = e6;
    r3 && r3.target === l2 && p2 && t2 && (p2.unobserve(t2), cancelAnimationFrame(f2), f2 = requestAnimationFrame(() => {
      var e7;
      (e7 = p2) == null || e7.observe(t2);
    })), n2();
  }), l2 && !c2 && p2.observe(l2), t2 && p2.observe(t2));
  let m2, h2 = c2 ? Ia(e5) : null;
  c2 && g2();
  function g2() {
    let t3 = Ia(e5);
    h2 && !no(h2, t3) && n2(), h2 = t3, m2 = requestAnimationFrame(g2);
  }
  return n2(), () => {
    var e6;
    u2.forEach((e7) => {
      i2 && e7.removeEventListener("scroll", n2), a2 && e7.removeEventListener("resize", n2);
    }), d2?.(), (e6 = p2) == null || e6.disconnect(), p2 = null, c2 && cancelAnimationFrame(m2);
  };
}
var J = Ea, ao = Da, oo = Ca, so = ka, co = Oa, lo = (e5, t2, n2) => {
  let r2 = /* @__PURE__ */ new Map(), i2 = n2 ?? {}, a2 = { ...to, ...i2.platform, _c: r2 };
  return Sa(e5, t2, { ...i2, platform: a2 });
}, uo = typeof document < "u" ? z.useLayoutEffect : function() {
};
function fo(e5, t2) {
  if (e5 === t2) return true;
  if (typeof e5 != typeof t2) return false;
  if (typeof e5 == "function" && e5.toString() === t2.toString()) return true;
  let n2, r2, i2;
  if (e5 && t2 && typeof e5 == "object") {
    if (Array.isArray(e5)) {
      if (n2 = e5.length, n2 !== t2.length) return false;
      for (r2 = n2; r2-- !== 0; ) if (!fo(e5[r2], t2[r2])) return false;
      return true;
    }
    if (i2 = Object.keys(e5), n2 = i2.length, n2 !== Object.keys(t2).length) return false;
    for (r2 = n2; r2-- !== 0; ) if (!{}.hasOwnProperty.call(t2, i2[r2])) return false;
    for (r2 = n2; r2-- !== 0; ) {
      let n3 = i2[r2];
      if (!(n3 === "_owner" && e5.$$typeof) && !fo(e5[n3], t2[n3])) return false;
    }
    return true;
  }
  return e5 !== e5 && t2 !== t2;
}
function po(e5) {
  return typeof window > "u" ? 1 : (e5.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function mo(e5, t2) {
  let n2 = po(e5);
  return Math.round(t2 * n2) / n2;
}
function ho(e5) {
  let t2 = z.useRef(e5);
  return uo(() => {
    t2.current = e5;
  }), t2;
}
function go(e5) {
  e5 === void 0 && (e5 = {});
  let { placement: t2 = "bottom", strategy: n2 = "absolute", middleware: r2 = [], platform: i2, elements: { reference: a2, floating: o2 } = {}, transform: s2 = true, whileElementsMounted: c2, open: l2 } = e5, [u2, d2] = z.useState({ x: 0, y: 0, strategy: n2, placement: t2, middlewareData: {}, isPositioned: false }), [f2, p2] = z.useState(r2);
  fo(f2, r2) || p2(r2);
  let [m2, h2] = z.useState(null), [g2, _2] = z.useState(null), v2 = z.useCallback((e6) => {
    e6 !== S2.current && (S2.current = e6, h2(e6));
  }, []), y2 = z.useCallback((e6) => {
    e6 !== C2.current && (C2.current = e6, _2(e6));
  }, []), b2 = a2 || m2, x2 = o2 || g2, S2 = z.useRef(null), C2 = z.useRef(null), w2 = z.useRef(u2), T2 = c2 != null, E2 = ho(c2), D2 = ho(i2), O2 = ho(l2), k2 = z.useCallback(() => {
    if (!S2.current || !C2.current) return;
    let e6 = { placement: t2, strategy: n2, middleware: f2 };
    D2.current && (e6.platform = D2.current), lo(S2.current, C2.current, e6).then((e7) => {
      let t3 = { ...e7, isPositioned: O2.current !== false };
      A2.current && !fo(w2.current, t3) && (w2.current = t3, Wi.flushSync(() => {
        d2(t3);
      }));
    });
  }, [f2, t2, n2, D2, O2]);
  uo(() => {
    l2 === false && w2.current.isPositioned && (w2.current.isPositioned = false, d2((e6) => ({ ...e6, isPositioned: false })));
  }, [l2]);
  let A2 = z.useRef(false);
  uo(() => (A2.current = true, () => {
    A2.current = false;
  }), []), uo(() => {
    if (b2 && (S2.current = b2), x2 && (C2.current = x2), b2 && x2) {
      if (E2.current) return E2.current(b2, x2, k2);
      k2();
    }
  }, [b2, x2, k2, E2, T2]);
  let j2 = z.useMemo(() => ({ reference: S2, floating: C2, setReference: v2, setFloating: y2 }), [v2, y2]), M2 = z.useMemo(() => ({ reference: b2, floating: x2 }), [b2, x2]), N2 = z.useMemo(() => {
    let e6 = { position: n2, left: 0, top: 0 };
    if (!M2.floating) return e6;
    let t3 = mo(M2.floating, u2.x), r3 = mo(M2.floating, u2.y);
    return s2 ? { ...e6, transform: "translate(" + t3 + "px, " + r3 + "px)", ...po(M2.floating) >= 1.5 && { willChange: "transform" } } : { position: n2, left: t3, top: r3 };
  }, [n2, s2, M2.floating, u2.x, u2.y]);
  return z.useMemo(() => ({ ...u2, update: k2, refs: j2, elements: M2, floatingStyles: N2 }), [u2, k2, j2, M2, N2]);
}
var _o = (e5, t2) => {
  let n2 = J(e5);
  return { name: n2.name, fn: n2.fn, options: [e5, t2] };
}, vo = (e5, t2) => {
  let n2 = ao(e5);
  return { name: n2.name, fn: n2.fn, options: [e5, t2] };
}, yo = (e5, t2) => ({ fn: co(e5).fn, options: [e5, t2] }), bo = (e5, t2) => {
  let n2 = oo(e5);
  return { name: n2.name, fn: n2.fn, options: [e5, t2] };
}, xo = (e5, t2) => {
  let n2 = so(e5);
  return { name: n2.name, fn: n2.fn, options: [e5, t2] };
}, So = l(((e5) => {
  var t2 = r();
  function n2(e6, t3) {
    return e6 === t3 && (e6 !== 0 || 1 / e6 == 1 / t3) || e6 !== e6 && t3 !== t3;
  }
  var i2 = typeof Object.is == "function" ? Object.is : n2, a2 = t2.useState, o2 = t2.useEffect, s2 = t2.useLayoutEffect, c2 = t2.useDebugValue;
  function l2(e6, t3) {
    var n3 = t3(), r2 = a2({ inst: { value: n3, getSnapshot: t3 } }), i3 = r2[0].inst, l3 = r2[1];
    return s2(function() {
      i3.value = n3, i3.getSnapshot = t3, u2(i3) && l3({ inst: i3 });
    }, [e6, n3, t3]), o2(function() {
      return u2(i3) && l3({ inst: i3 }), e6(function() {
        u2(i3) && l3({ inst: i3 });
      });
    }, [e6]), c2(n3), n3;
  }
  function u2(e6) {
    var t3 = e6.getSnapshot;
    e6 = e6.value;
    try {
      var n3 = t3();
      return !i2(e6, n3);
    } catch {
      return true;
    }
  }
  function d2(e6, t3) {
    return t3();
  }
  var f2 = typeof window > "u" || window.document === void 0 || window.document.createElement === void 0 ? d2 : l2;
  e5.useSyncExternalStore = t2.useSyncExternalStore === void 0 ? f2 : t2.useSyncExternalStore;
})), Co = l(((e5, t2) => {
  t2.exports = So();
})), wo = l(((e5) => {
  var t2 = r(), n2 = Co();
  function i2(e6, t3) {
    return e6 === t3 && (e6 !== 0 || 1 / e6 == 1 / t3) || e6 !== e6 && t3 !== t3;
  }
  var a2 = typeof Object.is == "function" ? Object.is : i2, o2 = n2.useSyncExternalStore, s2 = t2.useRef, c2 = t2.useEffect, l2 = t2.useMemo, u2 = t2.useDebugValue;
  e5.useSyncExternalStoreWithSelector = function(e6, t3, n3, r2, i3) {
    var d2 = s2(null);
    if (d2.current === null) {
      var f2 = { hasValue: false, value: null };
      d2.current = f2;
    } else f2 = d2.current;
    d2 = l2(function() {
      function e7(e8) {
        if (!o3) {
          if (o3 = true, s3 = e8, e8 = r2(e8), i3 !== void 0 && f2.hasValue) {
            var t4 = f2.value;
            if (i3(t4, e8)) return c3 = t4;
          }
          return c3 = e8;
        }
        if (t4 = c3, a2(s3, e8)) return t4;
        var n4 = r2(e8);
        return i3 !== void 0 && i3(t4, n4) ? (s3 = e8, t4) : (s3 = e8, c3 = n4);
      }
      var o3 = false, s3, c3, l3 = n3 === void 0 ? null : n3;
      return [function() {
        return e7(t3());
      }, l3 === null ? void 0 : function() {
        return e7(l3());
      }];
    }, [t3, n3, r2, i3]);
    var p2 = o2(e6, d2[0], d2[1]);
    return c2(function() {
      f2.hasValue = true, f2.value = p2;
    }, [p2]), u2(p2), p2;
  };
})), To = l(((e5, t2) => {
  t2.exports = wo();
})), Eo = [], Do = void 0;
function Oo() {
  return Do;
}
function ko(e5) {
  Eo.push(e5);
}
var Ao = Co(), jo = To(), Mo = mi(19) ? Fo : Io;
function No(e5, t2, n2, r2, i2) {
  return Mo(e5, t2, n2, r2, i2);
}
function Po(e5, t2, n2, r2, i2) {
  let a2 = z.useCallback(() => t2(e5.getSnapshot(), n2, r2, i2), [e5, t2, n2, r2, i2]);
  return (0, Ao.useSyncExternalStore)(e5.subscribe, a2, a2);
}
ko({ before(e5) {
  e5.syncIndex = 0, e5.didInitialize || (e5.syncTick = 1, e5.syncHooks = [], e5.didChangeStore = true, e5.getSnapshot = () => {
    let t2 = false;
    for (let n2 = 0; n2 < e5.syncHooks.length; n2 += 1) {
      let r2 = e5.syncHooks[n2], i2 = r2.selector(r2.store.state, r2.a1, r2.a2, r2.a3);
      Object.is(r2.value, i2) || (t2 = true, r2.value = i2);
    }
    return t2 && (e5.syncTick += 1), e5.syncTick;
  });
}, after(e5) {
  e5.syncHooks.length > 0 && (e5.didChangeStore && (e5.didChangeStore = false, e5.subscribe = (t2) => {
    let n2 = /* @__PURE__ */ new Set();
    for (let t3 of e5.syncHooks) n2.add(t3.store);
    let r2 = [];
    for (let e6 of n2) r2.push(e6.subscribe(t2));
    return () => {
      for (let e6 of r2) e6();
    };
  }), (0, Ao.useSyncExternalStore)(e5.subscribe, e5.getSnapshot, e5.getSnapshot));
} });
function Fo(e5, t2, n2, r2, i2) {
  let a2 = Oo();
  if (!a2) return Po(e5, t2, n2, r2, i2);
  let o2 = a2.syncIndex;
  a2.syncIndex += 1;
  let s2;
  return a2.didInitialize ? (s2 = a2.syncHooks[o2], (s2.store !== e5 || s2.selector !== t2 || !Object.is(s2.a1, n2) || !Object.is(s2.a2, r2) || !Object.is(s2.a3, i2)) && (s2.store !== e5 && (a2.didChangeStore = true), s2.store = e5, s2.selector = t2, s2.a1 = n2, s2.a2 = r2, s2.a3 = i2, s2.value = t2(e5.getSnapshot(), n2, r2, i2))) : (s2 = { store: e5, selector: t2, a1: n2, a2: r2, a3: i2, value: t2(e5.getSnapshot(), n2, r2, i2) }, a2.syncHooks.push(s2)), s2.value;
}
function Io(e5, t2, n2, r2, i2) {
  return (0, jo.useSyncExternalStoreWithSelector)(e5.subscribe, e5.getSnapshot, e5.getSnapshot, (e6) => t2(e6, n2, r2, i2));
}
var Lo = class {
  constructor(e5) {
    this.state = e5, this.listeners = /* @__PURE__ */ new Set(), this.updateTick = 0;
  }
  subscribe = (e5) => (this.listeners.add(e5), () => {
    this.listeners.delete(e5);
  });
  getSnapshot = () => this.state;
  setState(e5) {
    if (this.state === e5) return;
    this.state = e5, this.updateTick += 1;
    let t2 = this.updateTick;
    for (let n2 of this.listeners) {
      if (t2 !== this.updateTick) return;
      n2(e5);
    }
  }
  update(e5) {
    for (let t2 in e5) if (!Object.is(this.state[t2], e5[t2])) {
      this.setState({ ...this.state, ...e5 });
      return;
    }
  }
  set(e5, t2) {
    Object.is(this.state[e5], t2) || this.setState({ ...this.state, [e5]: t2 });
  }
  notifyAll() {
    let e5 = { ...this.state };
    this.setState(e5);
  }
  use(e5, t2, n2, r2) {
    return No(this, e5, t2, n2, r2);
  }
}, Ro = class extends Lo {
  constructor(e5, t2 = {}, n2) {
    super(e5), this.context = t2, this.selectors = n2;
  }
  useSyncedValue(e5, t2) {
    z.useDebugValue(e5);
    let n2 = this;
    H(() => {
      n2.state[e5] !== t2 && n2.set(e5, t2);
    }, [n2, e5, t2]);
  }
  useSyncedValueWithCleanup(e5, t2) {
    let n2 = this;
    H(() => (n2.state[e5] !== t2 && n2.set(e5, t2), () => {
      n2.set(e5, void 0);
    }), [n2, e5, t2]);
  }
  useSyncedValues(e5) {
    let t2 = this;
    H(() => {
      t2.update(e5);
    }, [t2, ...Object.values(e5)]);
  }
  useControlledProp(e5, t2) {
    z.useDebugValue(e5);
    let n2 = this, r2 = t2 !== void 0;
    H(() => {
      r2 && !Object.is(n2.state[e5], t2) && n2.setState({ ...n2.state, [e5]: t2 });
    }, [n2, e5, t2, r2]);
  }
  select(e5, t2, n2, r2) {
    let i2 = this.selectors[e5];
    return i2(this.state, t2, n2, r2);
  }
  useState(e5, t2, n2, r2) {
    return z.useDebugValue(e5), No(this, this.selectors[e5], t2, n2, r2);
  }
  useContextCallback(e5, t2) {
    z.useDebugValue(e5);
    let n2 = K(t2 ?? $e);
    this.context[e5] = n2;
  }
  useStateSetter(e5) {
    let t2 = z.useRef(void 0);
    return t2.current === void 0 && (t2.current = (t3) => {
      this.set(e5, t3);
    }), t2.current;
  }
  observe(e5, t2) {
    let n2;
    n2 = typeof e5 == "function" ? e5 : this.selectors[e5];
    let r2 = n2(this.state);
    return t2(r2, r2, this), this.subscribe((e6) => {
      let i2 = n2(e6);
      if (!Object.is(r2, i2)) {
        let e7 = r2;
        r2 = i2, t2(i2, e7, this);
      }
    });
  }
}, zo = { open: (e5) => e5.open, transitionStatus: (e5) => e5.transitionStatus, domReferenceElement: (e5) => e5.domReferenceElement, referenceElement: (e5) => e5.positionReference ?? e5.referenceElement, floatingElement: (e5) => e5.floatingElement, floatingId: (e5) => e5.floatingId }, Bo = class extends Ro {
  constructor(e5) {
    let { syncOnly: t2, nested: n2, onOpenChange: r2, triggerElements: i2, ...a2 } = e5;
    super({ ...a2, positionReference: a2.referenceElement, domReferenceElement: a2.referenceElement }, { onOpenChange: r2, dataRef: { current: {} }, events: Xi(), nested: n2, triggerElements: i2 }, zo), this.syncOnly = t2;
  }
  syncOpenEvent = (e5, t2) => {
    (!e5 || !this.state.open || t2 != null && Tt(t2)) && (this.context.dataRef.current.openEvent = e5 ? t2 : void 0);
  };
  dispatchOpenChange = (e5, t2) => {
    this.syncOpenEvent(e5, t2.event);
    let n2 = { open: e5, reason: t2.reason, nativeEvent: t2.event, nested: this.context.nested, triggerElement: t2.trigger };
    this.context.events.emit("openchange", n2);
  };
  setOpen = (e5, t2) => {
    if (this.syncOnly) {
      this.context.onOpenChange?.(e5, t2);
      return;
    }
    this.dispatchOpenChange(e5, t2), this.context.onOpenChange?.(e5, t2);
  };
};
function Vo(e5) {
  let { popupStore: t2, treatPopupAsFloatingElement: n2 = false, floatingRootContext: r2, floatingId: i2, nested: a2, onOpenChange: o2 } = e5, s2 = t2.useState("open"), c2 = t2.useState("activeTriggerElement"), l2 = t2.useState(n2 ? "popupElement" : "positionerElement"), u2 = t2.context.triggerElements, d2 = o2, f2 = z.useRef(null);
  r2 === void 0 && f2.current === null && (f2.current = new Bo({ open: s2, transitionStatus: void 0, referenceElement: c2, floatingElement: l2, triggerElements: u2, onOpenChange: d2, floatingId: i2, syncOnly: true, nested: a2 }));
  let p2 = r2 ?? f2.current;
  return t2.useSyncedValue("floatingId", i2), H(() => {
    let e6 = { open: s2, floatingId: i2, referenceElement: c2, floatingElement: l2 };
    U(c2) && (e6.domReferenceElement = c2), p2.state.positionReference === p2.state.referenceElement && (e6.positionReference = c2), p2.update(e6);
  }, [s2, i2, c2, l2, p2]), p2.context.onOpenChange = d2, p2.context.nested = a2, p2;
}
function Ho(e5, t2 = false, n2 = false) {
  let [r2, i2] = z.useState(e5 && t2 ? "idle" : void 0), [a2, o2] = z.useState(e5);
  return e5 && !a2 && (o2(true), i2("starting")), !e5 && a2 && r2 !== "ending" && !n2 && i2("ending"), !e5 && !a2 && r2 === "ending" && i2(void 0), H(() => {
    if (!e5 && a2 && r2 !== "ending" && n2) {
      let e6 = Rn.request(() => {
        i2("ending");
      });
      return () => {
        Rn.cancel(e6);
      };
    }
  }, [e5, a2, r2, n2]), H(() => {
    if (!e5 || t2) return;
    let n3 = Rn.request(() => {
      i2(void 0);
    });
    return () => {
      Rn.cancel(n3);
    };
  }, [t2, e5]), H(() => {
    if (!e5 || !t2) return;
    e5 && a2 && r2 !== "idle" && i2("starting");
    let n3 = Rn.request(() => {
      i2("idle");
    });
    return () => {
      Rn.cancel(n3);
    };
  }, [t2, e5, a2, r2]), { mounted: a2, setMounted: o2, transitionStatus: r2 };
}
function Uo(e5, t2 = false) {
  let n2 = zn();
  return K((r2, i2 = null) => {
    n2.cancel();
    let a2 = aa(e5);
    if (a2 == null) return;
    let o2 = a2, s2 = () => {
      Wi.flushSync(r2);
    };
    if (typeof o2.getAnimations != "function" || globalThis.BASE_UI_ANIMATIONS_DISABLED) {
      r2();
      return;
    }
    function c2() {
      Promise.all(o2.getAnimations().map((e6) => e6.finished)).then(() => {
        i2?.aborted || s2();
      }, () => {
        if (!i2?.aborted) {
          if (o2.getAnimations().some((e6) => e6.pending || e6.playState !== "finished")) {
            c2();
            return;
          }
          s2();
        }
      });
    }
    if (t2) {
      let e6 = "data-starting-style";
      if (!o2.hasAttribute(e6)) {
        n2.request(c2);
        return;
      }
      let t3 = new MutationObserver(() => {
        o2.hasAttribute(e6) || (t3.disconnect(), c2());
      });
      t3.observe(o2, { attributes: true, attributeFilter: [e6] }), i2?.addEventListener("abort", () => t3.disconnect(), { once: true });
      return;
    }
    n2.request(c2);
  });
}
function Wo(e5) {
  let { enabled: t2 = true, open: n2, ref: r2, onComplete: i2 } = e5, a2 = K(i2), o2 = Uo(r2, n2);
  z.useEffect(() => {
    if (!t2) return;
    let e6 = new AbortController();
    return o2(a2, e6.signal), () => {
      e6.abort();
    };
  }, [t2, n2, a2, o2]);
}
var Go = { tabIndex: -1, [Xt]: "" };
function Ko(e5) {
  return (t2) => t2 === "touch" ? e5.current : true;
}
function qo(e5, t2 = false) {
  let n2 = ui(), r2 = ea() != null, i2 = Qe(() => e5(n2, r2)).current;
  return Vo({ popupStore: i2, treatPopupAsFloatingElement: t2, floatingRootContext: i2.state.floatingRootContext, floatingId: n2, nested: r2, onOpenChange: i2.setOpen }), i2;
}
function Jo({ handle: e5, store: t2 }) {
  return H(() => e5.attachStore(t2), [e5, t2]), null;
}
function Yo(e5, t2) {
  let n2 = z.useRef(null), r2 = z.useRef(null);
  return z.useCallback((i2) => {
    if (e5 === void 0) return;
    let a2 = false;
    if (n2.current !== null) {
      let e6 = n2.current, i3 = r2.current, o2 = t2.context.triggerElements.getById(e6);
      i3 && o2 === i3 && (t2.context.triggerElements.delete(e6), a2 = true), n2.current = null, r2.current = null;
    }
    if (i2 !== null && (n2.current = e5, r2.current = i2, t2.context.triggerElements.add(e5, i2), a2 = true), a2) {
      let e6 = t2.context.triggerElements.size;
      t2.select("open") && t2.state.triggerCount !== e6 && t2.set("triggerCount", e6);
    }
  }, [t2, e5]);
}
function Xo(e5, t2, n2, r2 = false) {
  t2 ? e5.preventUnmountingOnClose = false : r2 && (e5.preventUnmountingOnClose = true);
  let i2 = n2?.id ?? null;
  (i2 || t2) && (e5.activeTriggerId = i2, e5.activeTriggerElement = n2 ?? null);
}
function Zo(e5) {
  let t2 = false;
  return e5.preventUnmountOnClose = () => {
    t2 = true;
  }, () => t2;
}
function Qo(e5, t2, n2, r2) {
  let i2 = n2.useState("isMountedByTrigger", e5), a2 = Yo(e5, n2), o2 = K((t3) => {
    let i3 = n2.select("open"), a3 = n2.select("activeTriggerId");
    if (a3 === e5) {
      n2.update({ activeTriggerElement: t3, ...i3 ? r2 : null });
      return;
    }
    a3 == null && i3 && n2.update({ activeTriggerId: e5, activeTriggerElement: t3, ...r2 });
  }), s2 = z.useCallback((e6) => {
    a2(e6), e6 && o2(e6);
  }, [a2, o2]);
  return H(() => {
    i2 && n2.update({ activeTriggerElement: t2.current, ...r2 });
  }, [i2, n2, t2, ...Object.values(r2)]), { registerTrigger: s2, isMountedByThisTrigger: i2 };
}
function $o(e5, t2 = {}) {
  let { closeOnActiveTriggerUnmount: n2 = false } = t2, r2 = z.useRef(null), i2 = e5.useState("open");
  H(() => {
    if (!i2) {
      r2.current = null, e5.state.triggerCount !== 0 && e5.set("triggerCount", 0);
      return;
    }
    let t3 = e5.context.triggerElements.size, a2 = {};
    e5.state.triggerCount !== t3 && (a2.triggerCount = t3);
    let o2 = e5.select("activeTriggerId"), s2 = null;
    if (o2) {
      let t4 = e5.context.triggerElements.getById(o2);
      if (t4) r2.current = o2, t4 !== e5.state.activeTriggerElement && (a2.activeTriggerElement = t4);
      else {
        for (let [t5, n3] of e5.context.triggerElements.entries()) if (n3 === e5.state.activeTriggerElement) {
          a2.activeTriggerId = t5, a2.activeTriggerElement = n3, r2.current = t5;
          break;
        }
        a2.activeTriggerId === void 0 && (r2.current === o2 ? s2 = o2 : r2.current = null);
      }
    } else r2.current = null;
    if (!s2 && !o2 && t3 === 1) {
      let t4 = e5.context.triggerElements.entries().next();
      if (!t4.done) {
        let [e6, n3] = t4.value;
        a2.activeTriggerId = e6, a2.activeTriggerElement = n3, r2.current = e6;
      }
    }
    (a2.triggerCount !== void 0 || a2.activeTriggerId !== void 0 || a2.activeTriggerElement !== void 0) && e5.update(a2), s2 && n2 && queueMicrotask(() => {
      if (e5.select("open") && e5.select("activeTriggerId") === s2 && !e5.context.triggerElements.getById(s2)) {
        let t4 = xn(pn);
        e5.setOpen(false, t4), t4.isCanceled || e5.update({ activeTriggerId: null, activeTriggerElement: null });
      }
    });
  }, [i2, e5, e5.useState("triggerCount"), e5.useState("activeTriggerId"), e5.useState("activeTriggerElement"), n2]);
}
function es(e5, t2, n2) {
  let { mounted: r2, setMounted: i2, transitionStatus: a2 } = Ho(e5), o2 = t2.useState("preventUnmountingOnClose"), s2 = e5 ? false : o2;
  t2.useSyncedValues({ mounted: r2, transitionStatus: a2, preventUnmountingOnClose: s2 });
  let c2 = K(() => {
    i2(false), t2.update({ activeTriggerId: null, activeTriggerElement: null, mounted: false, preventUnmountingOnClose: false }), n2?.(), t2.context.onOpenChangeComplete?.(false);
  });
  return Wo({ enabled: r2 && !e5 && !s2, open: e5, ref: t2.context.popupRef, onComplete() {
    e5 || c2();
  } }), { forceUnmount: c2, transitionStatus: a2 };
}
function ts(e5, t2) {
  e5.useSyncedValues(t2), H(() => () => {
    e5.update({ activeTriggerProps: tt, inactiveTriggerProps: tt, popupProps: tt });
  }, [e5]);
}
function ns(e5, t2) {
  H(() => {
    !t2 && e5.state.openMethod !== null && e5.set("openMethod", null);
  }, [t2, e5]), H(() => () => {
    e5.state.openMethod !== null && e5.set("openMethod", null);
  }, [e5]);
}
var rs = class {
  constructor() {
    this.idMap = /* @__PURE__ */ new Map();
  }
  add(e5, t2) {
    this.idMap.set(e5, t2);
  }
  delete(e5) {
    this.idMap.delete(e5);
  }
  hasElement(e5) {
    for (let t2 of this.idMap.values()) if (t2 === e5) return true;
    return false;
  }
  hasMatchingElement(e5) {
    for (let t2 of this.idMap.values()) if (e5(t2)) return true;
    return false;
  }
  getById(e5) {
    return this.idMap.get(e5);
  }
  entries() {
    return this.idMap.entries();
  }
  elements() {
    return this.idMap.values();
  }
  get size() {
    return this.idMap.size;
  }
};
function is() {
  return new Bo({ open: false, transitionStatus: void 0, floatingElement: null, referenceElement: null, triggerElements: new rs(), floatingId: void 0, syncOnly: false, nested: false, onOpenChange: void 0 });
}
function as() {
  return { open: false, openProp: void 0, mounted: false, transitionStatus: void 0, floatingRootContext: is(), floatingId: void 0, triggerCount: 0, preventUnmountingOnClose: false, payload: void 0, activeTriggerId: null, activeTriggerElement: null, triggerIdProp: void 0, popupElement: null, positionerElement: null, activeTriggerProps: tt, inactiveTriggerProps: tt, popupProps: tt };
}
function os(e5, t2, n2 = false) {
  return new Bo({ open: false, transitionStatus: void 0, floatingElement: null, referenceElement: null, triggerElements: e5, floatingId: t2, syncOnly: true, nested: n2, onOpenChange: void 0 });
}
var ss = (e5) => e5.triggerIdProp ?? e5.activeTriggerId, cs = (e5) => e5.openProp ?? e5.open, ls = (e5) => (e5.popupElement?.id ?? e5.floatingId) || void 0;
function us(e5, t2) {
  return t2 !== void 0 && cs(e5) && ss(e5) === t2;
}
function ds(e5, t2) {
  return us(e5, t2) ? true : t2 !== void 0 && cs(e5) && ss(e5) == null && e5.triggerCount === 1;
}
var fs = { open: cs, mounted: (e5) => e5.mounted, transitionStatus: (e5) => e5.transitionStatus, floatingRootContext: (e5) => e5.floatingRootContext, triggerCount: (e5) => e5.triggerCount, preventUnmountingOnClose: (e5) => e5.preventUnmountingOnClose, payload: (e5) => e5.payload, activeTriggerId: ss, activeTriggerElement: (e5) => e5.mounted ? e5.activeTriggerElement : null, popupId: ls, isTriggerActive: (e5, t2) => t2 !== void 0 && ss(e5) === t2, isOpenedByTrigger: (e5, t2) => us(e5, t2), isMountedByTrigger: (e5, t2) => t2 !== void 0 && ss(e5) === t2 && e5.mounted, triggerProps: (e5, t2) => t2 ? e5.activeTriggerProps : e5.inactiveTriggerProps, triggerPopupId: (e5, t2) => ds(e5, t2) ? ls(e5) : void 0, popupProps: (e5) => e5.popupProps, popupElement: (e5) => e5.popupElement, positionerElement: (e5) => e5.positionerElement };
function ps(e5) {
  return (0, Ao.useSyncExternalStore)(z.useCallback((t2) => e5 === void 0 ? $e : e5.subscribeStore(t2), [e5]), z.useCallback(() => e5 === void 0 ? void 0 : e5.store, [e5]), () => e5?.serverStore);
}
function ms(e5) {
  return hs(e5, e5.rootContext);
}
function hs(e5, t2) {
  let { nodeId: n2, externalTree: r2 } = e5, i2 = t2.useState("referenceElement"), a2 = t2.useState("floatingElement"), o2 = t2.useState("domReferenceElement"), s2 = t2.useState("open"), c2 = t2.useState("floatingId"), [l2, u2] = z.useState(null), [d2, f2] = z.useState(void 0), [p2, m2] = z.useState(void 0), h2 = z.useRef(null), g2 = ta(r2), _2 = z.useMemo(() => ({ reference: i2, floating: a2, domReference: o2 }), [i2, a2, o2]), v2 = go({ ...e5, elements: { ..._2, ...l2 && { reference: l2 } } }), y2 = U(d2) ? d2 : null, b2 = p2 === void 0 ? t2.state.floatingElement : p2;
  t2.useSyncedValue("referenceElement", d2 ?? null), t2.useSyncedValue("domReferenceElement", d2 === void 0 ? o2 : y2), t2.useSyncedValue("floatingElement", b2);
  let x2 = z.useCallback((e6) => {
    let t3 = U(e6) ? { getBoundingClientRect: () => e6.getBoundingClientRect(), getClientRects: () => e6.getClientRects(), contextElement: e6 } : e6;
    u2(t3), v2.refs.setReference(t3);
  }, [v2.refs]), S2 = z.useCallback((e6) => {
    (U(e6) || e6 === null) && (h2.current = e6, f2(e6)), (U(v2.refs.reference.current) || v2.refs.reference.current === null || e6 !== null && !U(e6)) && v2.refs.setReference(e6);
  }, [v2.refs, f2]), C2 = z.useCallback((e6) => {
    m2(e6), v2.refs.setFloating(e6);
  }, [v2.refs]), w2 = z.useMemo(() => ({ ...v2.refs, setReference: S2, setFloating: C2, setPositionReference: x2, domReference: h2 }), [v2.refs, S2, C2, x2]), T2 = z.useMemo(() => ({ ...v2.elements, domReference: o2 }), [v2.elements, o2]), E2 = z.useMemo(() => ({ ...v2, dataRef: t2.context.dataRef, open: s2, onOpenChange: t2.setOpen, events: t2.context.events, floatingId: c2, refs: w2, elements: T2, nodeId: n2, rootStore: t2 }), [v2, w2, T2, n2, t2, s2, c2]);
  return H(() => {
    o2 && (h2.current = o2);
  }, [o2]), H(() => {
    t2.context.dataRef.current.floatingContext = E2;
    let e6 = g2?.nodesRef.current.find((e7) => e7.id === n2);
    e6 && (e6.context = E2);
  }), z.useMemo(() => ({ ...v2, context: E2, refs: w2, elements: T2, rootStore: t2 }), [v2, w2, T2, E2, t2]);
}
var gs = class e4 {
  constructor() {
    this.pointerType = void 0, this.interactedInside = false, this.handler = void 0, this.blockMouseMove = true, this.performedPointerEventsMutation = false, this.pointerEventsScopeElement = null, this.pointerEventsReferenceElement = null, this.pointerEventsFloatingElement = null, this.restTimeoutPending = false, this.openChangeTimeout = new it(), this.restTimeout = new it(), this.handleCloseOptions = void 0;
  }
  static create() {
    return new e4();
  }
  dispose = () => {
    this.openChangeTimeout.clear(), this.restTimeout.clear();
  };
  disposeEffect = () => this.dispose;
}, _s = /* @__PURE__ */ new WeakMap();
function vs(e5) {
  if (!e5.performedPointerEventsMutation) return;
  let t2 = e5.pointerEventsScopeElement;
  t2 && _s.get(t2) === e5 && (e5.pointerEventsScopeElement?.style.removeProperty("pointer-events"), e5.pointerEventsReferenceElement?.style.removeProperty("pointer-events"), e5.pointerEventsFloatingElement?.style.removeProperty("pointer-events"), _s.delete(t2)), e5.performedPointerEventsMutation = false, e5.pointerEventsScopeElement = null, e5.pointerEventsReferenceElement = null, e5.pointerEventsFloatingElement = null;
}
function ys(e5, t2) {
  let { scopeElement: n2, referenceElement: r2, floatingElement: i2 } = t2, a2 = _s.get(n2);
  a2 && a2 !== e5 && vs(a2), vs(e5), e5.performedPointerEventsMutation = true, e5.pointerEventsScopeElement = n2, e5.pointerEventsReferenceElement = r2, e5.pointerEventsFloatingElement = i2, _s.set(n2, e5), n2.style.pointerEvents = "none", r2.style.pointerEvents = "auto", i2.style.pointerEvents = "auto";
}
function bs(e5) {
  let t2 = e5.context.dataRef.current, n2 = Qe(() => t2.hoverInteractionState ?? gs.create()).current;
  return t2.hoverInteractionState ||= n2, nt(t2.hoverInteractionState.disposeEffect), t2.hoverInteractionState;
}
function xs(e5, t2 = {}) {
  let { enabled: n2 = true, closeDelay: r2 = 0, nodeId: i2 } = t2, a2 = "rootStore" in e5 ? e5.rootStore : e5, o2 = a2.useState("open"), s2 = a2.useState("floatingElement"), c2 = a2.useState("domReferenceElement"), { dataRef: l2 } = a2.context, u2 = ta(), d2 = ea(), f2 = bs(a2), p2 = at(), m2 = K(() => dn(l2.current.openEvent?.type, f2.interactedInside)), h2 = K(() => fn(l2.current.openEvent?.type)), g2 = K(() => {
    vs(f2);
  });
  H(() => {
    o2 || (f2.pointerType = void 0, f2.restTimeoutPending = false, f2.interactedInside = false, g2());
  }, [o2, f2, g2]), z.useEffect(() => g2, [g2]), H(() => {
    if (n2 && o2 && f2.handleCloseOptions?.blockPointerEvents && h2() && U(c2) && s2) {
      let e6 = c2, t3 = s2, n3 = Bn(s2), r3 = u2?.nodesRef.current.find((e7) => e7.id === d2)?.context?.elements.floating;
      r3 && (r3.style.pointerEvents = "");
      let i3 = f2.pointerEventsScopeElement === t3 ? null : f2.pointerEventsScopeElement, a3 = r3 === t3 ? null : r3;
      return ys(f2, { scopeElement: f2.handleCloseOptions?.getScope?.() ?? i3 ?? a3 ?? e6.closest("[data-rootownerid]") ?? n3.body, referenceElement: e6, floatingElement: t3 }), () => {
        g2();
      };
    }
  }, [n2, o2, c2, s2, f2, h2, u2, d2, g2]), z.useEffect(() => {
    if (!n2) return;
    function e6() {
      return !!(u2 && d2 && Wr(u2.nodesRef.current, d2).length > 0);
    }
    function t3(e7) {
      let t4 = ln(r2, "close", f2.pointerType), n3 = () => {
        a2.setOpen(false, xn(hn, e7)), u2?.events.emit("floating.closed", e7);
      };
      t4 ? f2.openChangeTimeout.start(t4, n3) : (f2.openChangeTimeout.clear(), n3());
    }
    function o3(e7) {
      let t4 = $t(e7);
      if (!an(t4)) {
        f2.interactedInside = false;
        return;
      }
      f2.interactedInside = t4?.closest("[aria-haspopup]") != null;
    }
    function c3() {
      f2.openChangeTimeout.clear(), p2.clear(), u2?.events.off("floating.closed", v2), g2();
    }
    function _2(n3) {
      if (e6() && u2) {
        u2.events.on("floating.closed", v2);
        return;
      }
      if (en(n3.relatedTarget, a2.context.triggerElements)) return;
      let r3 = l2.current.floatingContext?.nodeId ?? i2, o4 = n3.relatedTarget;
      if (!(u2 && r3 && U(o4) && Wr(u2.nodesRef.current, r3, false).some((e7) => W(e7.context?.elements.floating, o4)))) {
        if (f2.handler) {
          f2.handler(n3);
          return;
        }
        g2(), h2() && !m2() && t3(n3);
      }
    }
    function v2(t4) {
      !u2 || !d2 || e6() || p2.start(0, () => {
        u2.events.off("floating.closed", v2), a2.setOpen(false, xn(hn, t4)), u2.events.emit("floating.closed", t4);
      });
    }
    let y2 = s2;
    return Sn(y2 && G(y2, "mouseenter", c3), y2 && G(y2, "mouseleave", _2), y2 && G(y2, "pointerdown", o3, true), () => {
      u2?.events.off("floating.closed", v2);
    });
  }, [n2, s2, a2, l2, r2, i2, h2, m2, g2, f2, u2, d2, p2]);
}
var Ss = { current: null };
function Cs(e5, t2 = {}) {
  let { enabled: n2 = true, delay: r2 = 0, handleClose: i2 = null, mouseOnly: a2 = false, restMs: o2 = 0, move: s2 = true, triggerElementRef: c2 = Ss, externalTree: l2, isActiveTrigger: u2 = true, getHandleCloseContext: d2, isClosing: f2, shouldOpen: p2, guardStaleOpen: m2 = false } = t2, h2 = "rootStore" in e5 ? e5.rootStore : e5, { dataRef: g2, events: _2 } = h2.context, v2 = ta(l2), y2 = bs(h2), b2 = z.useRef(false), x2 = kn(i2), S2 = kn(r2), C2 = kn(o2), w2 = kn(n2), T2 = kn(p2), E2 = kn(f2), D2 = K(() => dn(g2.current.openEvent?.type, y2.interactedInside)), O2 = K(() => T2.current?.() !== false), k2 = K((e6, t3, n3) => {
    let r3 = h2.context.triggerElements;
    if (r3.hasElement(t3)) return !e6 || !W(e6, t3);
    if (!U(n3)) return false;
    let i3 = n3;
    return r3.hasMatchingElement((e7) => W(e7, i3)) && (!e6 || !W(e6, i3));
  }), A2 = K(() => {
    y2.handler &&= (Bn(h2.select("domReferenceElement")).removeEventListener("mousemove", y2.handler), void 0);
  }), j2 = K(() => {
    vs(y2);
  });
  return u2 && (y2.handleCloseOptions = x2.current?.__options), z.useEffect(() => A2, [A2]), z.useEffect(() => {
    if (!n2) return;
    function e6(e7) {
      e7.open ? b2.current = false : (b2.current = e7.reason === hn, A2(), y2.openChangeTimeout.clear(), y2.restTimeout.clear(), y2.blockMouseMove = true, y2.restTimeoutPending = false);
    }
    return _2.on("openchange", e6), () => {
      _2.off("openchange", e6);
    };
  }, [n2, _2, y2, A2]), z.useEffect(() => {
    if (!n2) return;
    function e6(e7, t4 = true) {
      let n3 = ln(S2.current, "close", y2.pointerType);
      n3 ? y2.openChangeTimeout.start(n3, () => {
        h2.setOpen(false, xn(hn, e7)), v2?.events.emit("floating.closed", e7);
      }) : t4 && (y2.openChangeTimeout.clear(), h2.setOpen(false, xn(hn, e7)), v2?.events.emit("floating.closed", e7));
    }
    let t3 = c2.current ?? (u2 ? h2.select("domReferenceElement") : null);
    if (!U(t3)) return;
    function r3(e7) {
      if (y2.openChangeTimeout.clear(), y2.blockMouseMove = false, a2 && !wt(y2.pointerType)) return;
      let t4 = un(C2.current), n3 = ln(S2.current, "open", y2.pointerType), r4 = $t(e7), i4 = e7.currentTarget ?? null, o4 = h2.select("domReferenceElement"), s3 = i4;
      if (U(r4) && !h2.context.triggerElements.hasElement(r4)) {
        for (let e8 of h2.context.triggerElements.elements()) if (W(e8, r4)) {
          s3 = e8;
          break;
        }
      }
      U(i4) && U(o4) && !h2.context.triggerElements.hasElement(i4) && W(i4, o4) && (s3 = o4);
      let c3 = s3 == null ? false : k2(o4, s3, r4), l4 = h2.select("open"), u3 = E2.current?.() ?? h2.select("transitionStatus") === "ending", d3 = !l4 && u3 && b2.current, f3 = !c3 && U(s3) && U(o4) && W(o4, s3) && d3, p3 = t4 > 0 && !n3, m3 = c3 && (l4 || d3) || f3, g3 = !l4 || c3;
      if (m3) {
        O2() && h2.setOpen(true, xn(hn, e7, s3));
        return;
      }
      p3 || (n3 ? y2.openChangeTimeout.start(n3, () => {
        g3 && O2() && h2.setOpen(true, xn(hn, e7, s3));
      }) : g3 && O2() && h2.setOpen(true, xn(hn, e7, s3)));
    }
    function i3(t4) {
      if (D2()) {
        j2();
        return;
      }
      A2();
      let n3 = Bn(h2.select("domReferenceElement"));
      y2.restTimeout.clear(), y2.restTimeoutPending = false;
      let r4 = g2.current.floatingContext ?? d2?.();
      if (!en(t4.relatedTarget, h2.context.triggerElements)) {
        if (x2.current && r4) {
          h2.select("open") || y2.openChangeTimeout.clear();
          let i4 = c2.current;
          y2.handler = x2.current({ ...r4, tree: v2, x: t4.clientX, y: t4.clientY, onClose() {
            j2(), A2(), w2.current && !D2() && i4 === h2.select("domReferenceElement") && e6(t4, true);
          } }), n3.addEventListener("mousemove", y2.handler), y2.handler(t4);
          return;
        }
        (y2.pointerType !== "touch" || !W(h2.select("floatingElement"), t4.relatedTarget)) && e6(t4);
      }
    }
    function o3(e7) {
      W(t3, e7.relatedTarget) || (y2.openChangeTimeout.clear(), y2.restTimeout.clear(), y2.restTimeoutPending = false);
    }
    let l3 = m2 ? G(t3, "mouseout", o3) : void 0;
    return s2 ? Sn(G(t3, "mousemove", r3, { once: true }), G(t3, "mouseenter", r3), G(t3, "mouseleave", i3), l3) : Sn(G(t3, "mouseenter", r3), G(t3, "mouseleave", i3), l3);
  }, [A2, j2, g2, S2, h2, n2, x2, y2, u2, k2, D2, a2, s2, C2, c2, v2, w2, d2, E2, O2, m2]), z.useMemo(() => {
    if (!n2) return;
    function e6(e7) {
      y2.pointerType = e7.pointerType;
    }
    return { onPointerDown: e6, onPointerEnter: e6, onMouseMove(e7) {
      let { nativeEvent: t3 } = e7, n3 = e7.currentTarget, r3 = h2.select("domReferenceElement"), i3 = h2.select("open"), o3 = k2(r3, n3, e7.target);
      if (a2 && !wt(y2.pointerType)) return;
      if (i3 && o3 && y2.handleCloseOptions?.blockPointerEvents) {
        let e8 = h2.select("floatingElement");
        e8 && ys(y2, { scopeElement: y2.handleCloseOptions?.getScope?.() ?? n3.ownerDocument.body, referenceElement: n3, floatingElement: e8 });
      }
      let s3 = un(C2.current);
      if (i3 && !o3 || s3 === 0 || !o3 && y2.restTimeoutPending && e7.movementX ** 2 + e7.movementY ** 2 < 2) return;
      y2.restTimeout.clear();
      function c3() {
        if (y2.restTimeoutPending = false, D2()) return;
        let e8 = h2.select("open");
        !y2.blockMouseMove && (!e8 || o3) && O2() && h2.setOpen(true, xn(hn, t3, n3));
      }
      y2.pointerType === "touch" ? Wi.flushSync(() => {
        c3();
      }) : o3 && i3 ? c3() : (y2.restTimeoutPending = true, y2.restTimeout.start(s3, c3));
    } };
  }, [n2, y2, D2, k2, a2, h2, C2, O2]);
}
var ws = 0.1, Ts = ws * ws, Es = 0.5;
function Ds(e5, t2, n2, r2, i2, a2) {
  return r2 >= t2 != a2 >= t2 && e5 <= (i2 - n2) * (t2 - r2) / (a2 - r2) + n2;
}
function Os(e5, t2, n2, r2, i2, a2, o2, s2, c2, l2) {
  let u2 = false;
  return Ds(e5, t2, n2, r2, i2, a2) && (u2 = !u2), Ds(e5, t2, i2, a2, o2, s2) && (u2 = !u2), Ds(e5, t2, o2, s2, c2, l2) && (u2 = !u2), Ds(e5, t2, c2, l2, n2, r2) && (u2 = !u2), u2;
}
function ks(e5, t2, n2) {
  return e5 >= n2.x && e5 <= n2.x + n2.width && t2 >= n2.y && t2 <= n2.y + n2.height;
}
function As(e5, t2, n2, r2, i2, a2) {
  return e5 >= Math.min(n2, i2) && e5 <= Math.max(n2, i2) && t2 >= Math.min(r2, a2) && t2 <= Math.max(r2, a2);
}
function js(e5 = {}) {
  let { blockPointerEvents: t2 = false } = e5, n2 = new it(), r2 = ({ x: e6, y: t3, placement: r3, elements: i2, onClose: a2, nodeId: o2, tree: s2 }) => {
    let c2 = r3?.split("-")[0], l2 = false, u2 = null, d2 = null, f2 = typeof performance < "u" ? performance.now() : 0;
    function p2(e7, t4) {
      let n3 = performance.now(), r4 = n3 - f2;
      if (u2 === null || d2 === null || r4 === 0) return u2 = e7, d2 = t4, f2 = n3, false;
      let i3 = e7 - u2, a3 = t4 - d2, o3 = i3 * i3 + a3 * a3, s3 = r4 * r4 * Ts;
      return u2 = e7, d2 = t4, f2 = n3, o3 < s3;
    }
    function m2() {
      n2.clear(), a2();
    }
    return function(r4) {
      n2.clear();
      let a3 = i2.domReference, u3 = i2.floating;
      if (!a3 || !u3 || c2 == null || e6 == null || t3 == null) return;
      let { clientX: d3, clientY: f3 } = r4, h2 = $t(r4), g2 = r4.type === "mouseleave", _2 = W(u3, h2), v2 = W(a3, h2);
      if (_2 && (l2 = true, !g2)) return;
      if (v2 && (l2 = false, !g2)) {
        l2 = true;
        return;
      }
      if (g2 && U(r4.relatedTarget) && W(u3, r4.relatedTarget)) return;
      function y2() {
        return !!(s2 && Wr(s2.nodesRef.current, o2).length > 0);
      }
      function b2() {
        y2() || m2();
      }
      if (y2()) return;
      let x2 = a3.getBoundingClientRect(), S2 = u3.getBoundingClientRect(), C2 = e6 > S2.right - S2.width / 2, w2 = t3 > S2.bottom - S2.height / 2, T2 = S2.width > x2.width, E2 = S2.height > x2.height, D2 = (T2 ? x2 : S2).left, O2 = (T2 ? x2 : S2).right, k2 = (E2 ? x2 : S2).top, A2 = (E2 ? x2 : S2).bottom;
      if (c2 === "top" && t3 >= x2.bottom - 1 || c2 === "bottom" && t3 <= x2.top + 1 || c2 === "left" && e6 >= x2.right - 1 || c2 === "right" && e6 <= x2.left + 1) {
        b2();
        return;
      }
      let j2 = false;
      switch (c2) {
        case "top":
          j2 = As(d3, f3, D2, x2.top + 1, O2, S2.bottom - 1);
          break;
        case "bottom":
          j2 = As(d3, f3, D2, S2.top + 1, O2, x2.bottom - 1);
          break;
        case "left":
          j2 = As(d3, f3, S2.right - 1, A2, x2.left + 1, k2);
          break;
        case "right":
          j2 = As(d3, f3, x2.right - 1, A2, S2.left + 1, k2);
          break;
        default:
      }
      if (j2) return;
      if (l2 && !ks(d3, f3, x2)) {
        b2();
        return;
      }
      if (!g2 && p2(d3, f3)) {
        b2();
        return;
      }
      let M2 = false;
      switch (c2) {
        case "top": {
          let n3 = T2 ? Es / 2 : Es * 4, r5 = T2 || C2 ? e6 + n3 : e6 - n3, i3 = T2 ? e6 - n3 : C2 ? e6 + n3 : e6 - n3, a4 = t3 + Es + 1, o3 = C2 || T2 ? S2.bottom - Es : S2.top, s3 = C2 ? T2 ? S2.bottom - Es : S2.top : S2.bottom - Es;
          M2 = Os(d3, f3, r5, a4, i3, a4, S2.left, o3, S2.right, s3);
          break;
        }
        case "bottom": {
          let n3 = T2 ? Es / 2 : Es * 4, r5 = T2 || C2 ? e6 + n3 : e6 - n3, i3 = T2 ? e6 - n3 : C2 ? e6 + n3 : e6 - n3, a4 = t3 - Es, o3 = C2 || T2 ? S2.top + Es : S2.bottom, s3 = C2 ? T2 ? S2.top + Es : S2.bottom : S2.top + Es;
          M2 = Os(d3, f3, r5, a4, i3, a4, S2.left, o3, S2.right, s3);
          break;
        }
        case "left": {
          let n3 = E2 ? Es / 2 : Es * 4, r5 = E2 || w2 ? t3 + n3 : t3 - n3, i3 = E2 ? t3 - n3 : w2 ? t3 + n3 : t3 - n3, a4 = e6 + Es + 1, o3 = w2 || E2 ? S2.right - Es : S2.left, s3 = w2 ? E2 ? S2.right - Es : S2.left : S2.right - Es;
          M2 = Os(d3, f3, o3, S2.top, s3, S2.bottom, a4, r5, a4, i3);
          break;
        }
        case "right": {
          let n3 = E2 ? Es / 2 : Es * 4, r5 = E2 || w2 ? t3 + n3 : t3 - n3, i3 = E2 ? t3 - n3 : w2 ? t3 + n3 : t3 - n3, a4 = e6 - Es, o3 = w2 || E2 ? S2.left + Es : S2.right, s3 = w2 ? E2 ? S2.left + Es : S2.right : S2.left + Es;
          M2 = Os(d3, f3, a4, r5, a4, i3, o3, S2.top, s3, S2.bottom);
          break;
        }
        default:
      }
      M2 ? l2 || n2.start(40, b2) : b2();
    };
  };
  return r2.__options = { ...e5, blockPointerEvents: t2 }, r2;
}
var Ms = z.createContext(void 0);
function Ns(e5) {
  let t2 = z.useContext(Ms);
  if (t2 === void 0 && !e5) throw Error(fi(47));
  return t2;
}
var Ps = { ...fs, disabled: (e5) => e5.disabled, instantType: (e5) => e5.instantType, openMethod: (e5) => e5.openMethod, openChangeReason: (e5) => e5.openChangeReason, modal: (e5) => e5.modal, focusManagerModal: (e5) => e5.focusManagerModal, stickIfOpen: (e5) => e5.stickIfOpen, titleElementId: (e5) => e5.titleElementId, descriptionElementId: (e5) => e5.descriptionElementId, openOnHover: (e5) => e5.openOnHover, closeDelay: (e5) => e5.closeDelay, adaptiveOrigin: (e5) => e5.adaptiveOrigin }, Fs = class extends Ro {
  constructor(e5, t2, n2) {
    let r2 = new rs();
    super(Is(e5, r2, t2, n2), Ls(r2), Ps);
  }
  setOpen = (e5, t2) => {
    let n2 = t2.reason === hn, r2 = t2.reason === "trigger-press" && t2.event.detail === 0, i2 = !e5 && (t2.reason === "escape-key" || t2.reason == null), a2 = Zo(t2), o2 = this.select("activeTriggerId");
    if (!e5 && t2.reason === "close-press" && t2.trigger == null && o2 != null && (t2.trigger = this.context.triggerElements.getById(o2) ?? this.select("activeTriggerElement") ?? void 0), this.context.onOpenChange?.(e5, t2), t2.isCanceled) return;
    this.state.floatingRootContext.dispatchOpenChange(e5, t2);
    let s2 = () => {
      let n3 = { open: e5, openChangeReason: t2.reason };
      Xo(n3, e5, t2.trigger, a2()), this.update(n3);
    };
    n2 ? (this.set("stickIfOpen", true), this.context.stickIfOpenTimeout.start(500, () => {
      this.set("stickIfOpen", false);
    }), Wi.flushSync(s2)) : s2();
    let c2;
    r2 ? c2 = "click" : i2 ? c2 = "dismiss" : t2.reason === "focus-out" && (c2 = "focus"), this.set("instantType", c2);
  };
};
function Is(e5, t2, n2, r2 = false) {
  let i2 = { ...as(), disabled: false, modal: false, focusManagerModal: false, instantType: void 0, openMethod: null, openChangeReason: null, titleElementId: void 0, descriptionElementId: void 0, stickIfOpen: true, openOnHover: false, closeDelay: 0, adaptiveOrigin: void 0, ...e5 };
  return i2.open && e5?.mounted === void 0 && (i2.mounted = true), i2.floatingRootContext = os(t2, n2, r2), i2;
}
function Ls(e5) {
  return { popupRef: z.createRef(), onOpenChange: void 0, onOpenChangeComplete: void 0, triggerFocusTargetRef: z.createRef(), beforeContentFocusGuardRef: z.createRef(), stickIfOpenTimeout: new it(), triggerElements: e5 };
}
function Rs({ props: e5 }) {
  let { children: t2, open: n2, defaultOpen: r2 = false, onOpenChange: i2, onOpenChangeComplete: a2, modal: o2 = false, handle: s2, triggerId: c2, defaultTriggerId: l2 = null } = e5, u2 = Bs(s2, { modal: o2, open: r2, openProp: n2, activeTriggerId: l2, triggerIdProp: c2 });
  u2.useControlledProp("openProp", n2), u2.useControlledProp("triggerIdProp", c2);
  let d2 = u2.useState("open"), f2 = u2.useState("mounted"), p2 = u2.useState("payload");
  u2.useContextCallback("onOpenChange", i2), u2.useContextCallback("onOpenChangeComplete", a2), ns(u2, d2), $o(u2);
  let { forceUnmount: m2 } = es(d2, u2, () => {
    u2.update({ stickIfOpen: true, openChangeReason: null });
  });
  u2.useSyncedValues({ modal: o2 }), z.useEffect(() => {
    d2 || u2.context.stickIfOpenTimeout.clear();
  }, [u2, d2]), z.useImperativeHandle(e5.actionsRef, () => ({ unmount: m2, close: () => u2.setOpen(false, xn(bn)) }), [m2, u2]);
  let h2 = d2 || f2;
  return (0, B.jsxs)(Ms.Provider, { value: u2, children: [s2 && (0, B.jsx)(Jo, { handle: s2, store: u2 }), h2 && (0, B.jsx)(Vs, { store: u2, modal: o2 }), typeof t2 == "function" ? t2({ payload: p2 }) : t2] });
}
function zs(e5) {
  return Ns(true) ? (0, B.jsx)(Rs, { props: e5 }) : (0, B.jsx)(ia, { children: (0, B.jsx)(Rs, { props: e5 }) });
}
function Bs(e5, t2) {
  let n2 = qo((e6, n3) => new Fs(t2, e6, n3));
  return z.useEffect(() => n2.context.stickIfOpenTimeout.disposeEffect(), [n2]), n2;
}
function Vs({ store: e5, modal: t2 }) {
  let n2 = va(e5.useState("floatingRootContext"), { outsidePressEvent: { mouse: t2 === "trap-focus" ? "sloppy" : "intentional", touch: "sloppy" } }), r2 = n2.reference, i2 = n2.floating;
  return ts(e5, { activeTriggerProps: r2, inactiveTriggerProps: r2, popupProps: i2 }), null;
}
var Hs = z.createContext(void 0);
function Us(e5 = false) {
  let t2 = z.useContext(Hs);
  if (t2 === void 0 && !e5) throw Error(fi(16));
  return t2;
}
function Ws(e5) {
  let { focusableWhenDisabled: t2, disabled: n2, composite: r2 = false, tabIndex: i2 = 0, isNativeButton: a2 } = e5, o2 = r2 && t2 !== false, s2 = r2 && t2 === false;
  return { props: z.useMemo(() => {
    let e6 = { onKeyDown(e7) {
      n2 && t2 && e7.key !== "Tab" && e7.preventDefault();
    } };
    return r2 || (e6.tabIndex = i2, !a2 && n2 && (e6.tabIndex = t2 ? i2 : -1)), (a2 && (t2 || o2) || !a2 && n2) && (e6["aria-disabled"] = n2), a2 && (!t2 || s2) && (e6.disabled = n2), e6;
  }, [r2, n2, t2, o2, s2, a2, i2]) };
}
function Gs(e5, t2, { detail: n2 = 0 } = {}) {
  e5.dispatchEvent(new (Ot(e5)).PointerEvent("click", { bubbles: true, cancelable: true, composed: true, detail: n2, shiftKey: t2.shiftKey, ctrlKey: t2.ctrlKey, altKey: t2.altKey, metaKey: t2.metaKey }));
}
function Ks(e5 = {}) {
  let { disabled: t2 = false, focusableWhenDisabled: n2, tabIndex: r2 = 0, native: i2 = true, composite: a2 } = e5, o2 = z.useRef(null), s2 = Us(true), c2 = a2 ?? s2 !== void 0, { props: l2 } = Ws({ focusableWhenDisabled: n2, disabled: t2, composite: c2, tabIndex: r2, isNativeButton: i2 }), u2 = z.useCallback(() => {
    let e6 = o2.current;
    qs(e6) && c2 && t2 && l2.disabled === void 0 && e6.disabled && (e6.disabled = false);
  }, [t2, l2.disabled, c2]);
  return H(u2, [u2]), { getButtonProps: z.useCallback((e6 = {}) => {
    let { onClick: n3, onMouseDown: r3, onKeyUp: a3, onKeyDown: o3, onPointerDown: s3, ...u3 } = e6;
    return xi({ onClick(e7) {
      if (t2) {
        e7.preventDefault();
        return;
      }
      n3?.(e7);
    }, onMouseDown(e7) {
      t2 || r3?.(e7);
    }, onKeyDown(e7) {
      if (t2 || (ji(e7), o3?.(e7), e7.baseUIHandlerPrevented)) return;
      let n4 = e7.target === e7.currentTarget, r4 = e7.currentTarget, a4 = qs(r4), s4 = !i2 && Js(r4), l3 = n4 && (i2 ? a4 : !s4), u4 = e7.key === "Enter", d2 = e7.key === " ", f2 = r4.getAttribute("role"), p2 = f2?.startsWith("menuitem") || f2 === "option" || f2 === "gridcell";
      if (n4 && c2 && d2) {
        if (e7.defaultPrevented && p2) return;
        e7.preventDefault(), (!i2 || a4) && (e7.preventBaseUIHandler(), Gs(r4, e7));
        return;
      }
      if (!l3 || i2 || !d2 && !u4) {
        n4 && s4 && d2 && e7.preventDefault();
        return;
      }
      e7.defaultPrevented || (e7.preventDefault(), u4 && (e7.preventBaseUIHandler(), Gs(r4, e7)));
    }, onKeyUp(e7) {
      if (!t2) {
        if (ji(e7), a3?.(e7), e7.target === e7.currentTarget && i2 && c2 && qs(e7.currentTarget) && e7.key === " ") {
          e7.preventDefault();
          return;
        }
        e7.baseUIHandlerPrevented || e7.target === e7.currentTarget && !i2 && !c2 && !e7.defaultPrevented && e7.key === " " && (e7.preventBaseUIHandler(), Gs(e7.currentTarget, e7));
      }
    }, onPointerDown(e7) {
      if (t2) {
        e7.preventDefault();
        return;
      }
      s3?.(e7);
    } }, i2 ? { type: "button" } : { role: "button" }, l2, u3);
  }, [t2, l2, c2, i2]), buttonRef: K((e6) => {
    o2.current = e6, u2();
  }) };
}
function qs(e5) {
  return jt(e5) && e5.tagName === "BUTTON";
}
function Js(e5) {
  return jt(e5) && e5.tagName === "A" && !!e5.href;
}
var Ys = (function(e5) {
  return e5.startingStyle = "data-starting-style", e5.endingStyle = "data-ending-style", e5;
})({}), Xs = { "data-starting-style": "" }, Zs = { "data-ending-style": "" }, Qs = { transitionStatus(e5) {
  return e5 === "starting" ? Xs : e5 === "ending" ? Zs : null;
} };
(function(e5) {
  return e5.open = "data-open", e5.closed = "data-closed", e5[e5.startingStyle = Ys.startingStyle] = "startingStyle", e5[e5.endingStyle = Ys.endingStyle] = "endingStyle", e5.anchorHidden = "data-anchor-hidden", e5.side = "data-side", e5.align = "data-align", e5;
})({});
var $s = { "data-popup-open": "" }, ec = { "data-popup-open": "", "data-pressed": "" }, tc = { "data-open": "" }, nc = { "data-closed": "" }, rc = { "data-anchor-hidden": "" }, ic = { open(e5) {
  return e5 ? $s : null;
} }, ac = { open(e5) {
  return e5 ? ec : null;
} }, oc = { open(e5) {
  return e5 ? tc : nc;
}, anchorHidden(e5) {
  return e5 ? rc : null;
} }, sc = { ...oc, ...Qs };
function cc(e5) {
  return ui(e5, "base-ui");
}
function lc(e5, t2) {
  let n2 = z.useRef(null);
  function r2(t3) {
    Wi.flushSync(() => {
      e5.setOpen(false, xn(vn, t3.nativeEvent, t3.currentTarget));
    }), Br(n2.current)?.focus();
  }
  function i2(n3) {
    let r3 = e5.select("positionerElement");
    if (r3 && Vr(n3, r3)) e5.context.beforeContentFocusGuardRef.current?.focus();
    else {
      Wi.flushSync(() => {
        e5.setOpen(false, xn(vn, n3.nativeEvent, n3.currentTarget));
      });
      let i3 = zr(e5.context.triggerFocusTargetRef.current || t2.current);
      for (; i3 !== null && W(r3, i3); ) {
        let e6 = i3;
        if (i3 = Ir(i3), i3 === e6) break;
      }
      i3?.focus();
    }
  }
  return { preFocusGuardRef: n2, handlePreFocusGuardFocus: r2, handleFocusTargetFocus: i2 };
}
function uc(e5) {
  let t2 = z.useRef(""), n2 = z.useCallback((n3) => {
    n3.defaultPrevented || (t2.current = n3.pointerType, e5(n3, n3.pointerType));
  }, [e5]);
  return { onClick: z.useCallback((n3) => {
    if (n3.detail === 0) {
      e5(n3, "keyboard");
      return;
    }
    "pointerType" in n3 ? e5(n3, n3.pointerType) : e5(n3, t2.current), t2.current = "";
  }, [e5]), onPointerDown: n2 };
}
function dc(e5, t2) {
  let { onClick: n2, onPointerDown: r2 } = uc(K((n3, r3) => {
    (typeof e5 == "function" ? e5() : e5) || t2(r3 || (ft ? "touch" : ""));
  }));
  return z.useMemo(() => ({ onClick: n2, onPointerDown: r2 }), [n2, r2]);
}
var fc = z.forwardRef(function(e5, t2) {
  let { render: n2, className: r2, style: i2, disabled: a2 = false, nativeButton: o2 = true, handle: s2, payload: c2, openOnHover: l2 = false, delay: u2 = 300, closeDelay: d2 = 0, id: f2, ...p2 } = e5, m2 = Ns(true), h2 = ps(s2) ?? m2;
  if (!h2) throw Error(fi(74));
  let g2 = cc(f2), _2 = h2.useState("isTriggerActive", g2), v2 = h2.useState("floatingRootContext"), y2 = h2.useState("isOpenedByTrigger", g2), b2 = h2.useState("triggerPopupId", g2), x2 = z.useRef(null), { registerTrigger: S2, isMountedByThisTrigger: C2 } = Qo(g2, x2, h2, { payload: c2, disabled: a2, openOnHover: l2, closeDelay: d2 }), w2 = h2.useState("openChangeReason"), T2 = h2.useState("stickIfOpen"), E2 = h2.useState("openMethod"), D2 = h2.useState("focusManagerModal"), O2 = Cs(v2, { enabled: !a2 && l2 && (E2 !== "touch" || w2 !== "trigger-press"), mouseOnly: true, move: false, handleClose: js(), restMs: u2, delay: { close: d2 }, triggerElementRef: x2, isActiveTrigger: _2, isClosing: () => h2.select("transitionStatus") === "ending" }), k2 = ha(v2, { stickIfOpen: T2 }), A2 = dc(() => h2.select("open"), (e6) => {
    h2.set("openMethod", e6);
  }), j2 = h2.useState("triggerProps", C2), { getButtonProps: M2, buttonRef: N2 } = Ks({ disabled: a2, native: o2 }), P2 = { open(e6) {
    return e6 && w2 === "trigger-press" ? ac.open(e6) : ic.open(e6);
  } }, { preFocusGuardRef: F2, handlePreFocusGuardFocus: ee2, handleFocusTargetFocus: te2 } = lc(h2, x2), I2 = Pi("button", e5, { state: { disabled: a2, open: y2 }, ref: [N2, t2, S2, x2], props: [k2.reference, O2, j2, A2, { [Vi]: "", id: g2, "aria-haspopup": "dialog", "aria-expanded": y2, "aria-controls": b2 }, p2, M2], stateAttributesMapping: P2 }), ne2 = (0, B.jsx)(z.Fragment, { children: I2 }, g2);
  return C2 && !D2 ? (0, B.jsxs)(z.Fragment, { children: [(0, B.jsx)(Un, { ref: F2, onFocus: ee2 }), ne2, (0, B.jsx)(Un, { ref: h2.context.triggerFocusTargetRef, onFocus: te2 })] }) : ne2;
}), pc = z.createContext(void 0);
function mc() {
  let e5 = z.useContext(pc);
  if (e5 === void 0) throw Error(fi(45));
  return e5;
}
var hc = z.forwardRef(function(e5, t2) {
  let { keepMounted: n2 = false, ...r2 } = e5;
  return Ns().useState("mounted") || n2 ? (0, B.jsx)(pc.Provider, { value: n2, children: (0, B.jsx)(Yi, { ref: t2, ...r2 }) }) : null;
});
function gc(e5) {
  return mi(19) ? e5 : e5 ? "true" : void 0;
}
var _c = z.createContext(void 0);
function vc() {
  let e5 = z.useContext(_c);
  if (!e5) throw Error(fi(46));
  return e5;
}
var yc = z.createContext(void 0);
function bc() {
  return z.useContext(yc)?.direction ?? "ltr";
}
var xc = (e5) => ({ name: "arrow", options: e5, async fn(t2) {
  let { x: n2, y: r2, placement: i2, rects: a2, platform: o2, elements: s2, middlewareData: c2 } = t2, { element: l2, padding: u2 = 0, offsetParent: d2 = "real" } = Zn(e5, t2) || {};
  if (l2 == null) return {};
  let f2 = hr(u2), p2 = { x: n2, y: r2 }, m2 = rr(i2), h2 = tr(m2), g2 = await o2.getDimensions(l2), _2 = m2 === "y", v2 = _2 ? "top" : "left", y2 = _2 ? "bottom" : "right", b2 = _2 ? "clientHeight" : "clientWidth", x2 = a2.reference[h2] + a2.reference[m2] - p2[m2] - a2.floating[h2], S2 = p2[m2] - a2.reference[m2], C2 = d2 === "real" ? await o2.getOffsetParent?.(l2) : s2.floating, w2 = s2.floating[b2] || a2.floating[h2];
  (!w2 || !await o2.isElement?.(C2)) && (w2 = s2.floating[b2] || a2.floating[h2]);
  let T2 = x2 / 2 - S2 / 2, E2 = w2 / 2 - g2[h2] / 2 - 1, D2 = Math.min(f2[v2], E2), O2 = Math.min(f2[y2], E2), k2 = D2, A2 = w2 - g2[h2] - O2, j2 = w2 / 2 - g2[h2] / 2 + T2, M2 = Xn(k2, j2, A2), N2 = !c2.arrow && $n(i2) != null && j2 !== M2 && a2.reference[h2] / 2 - (j2 < k2 ? D2 : O2) - g2[h2] / 2 < 0, P2 = N2 ? j2 < k2 ? j2 - k2 : j2 - A2 : 0;
  return { [m2]: p2[m2] + P2, data: { [m2]: M2, centerOffset: j2 - M2 - P2, ...N2 && { alignmentOffset: P2 } }, reset: N2 };
} }), Sc = (e5, t2) => ({ ...xc(e5), options: [e5, t2] }), Cc = { name: "hide", async fn(e5) {
  let { width: t2, height: n2, x: r2, y: i2 } = e5.rects.reference, a2 = t2 === 0 && n2 === 0 && r2 === 0 && i2 === 0, o2 = await e5.platform.detectOverflow(e5, { elementContext: "reference" });
  return { data: { referenceHidden: o2.top - n2 >= 0 || o2.right - t2 >= 0 || o2.bottom - n2 >= 0 || o2.left - t2 >= 0 || a2 } };
} }, wc = { sideX: "left", sideY: "top" }, Tc = "--available-width", Ec = "--available-height";
function Dc(e5, t2, n2) {
  let r2 = e5 === "inline-start" || e5 === "inline-end";
  return { top: "top", right: r2 ? n2 ? "inline-start" : "inline-end" : "right", bottom: "bottom", left: r2 ? n2 ? "inline-end" : "inline-start" : "left" }[t2];
}
function Oc(e5, t2, n2) {
  let { rects: r2, placement: i2 } = e5;
  return { side: Dc(t2, Qn(i2), n2), align: $n(i2) || "center", anchor: { width: r2.reference.width, height: r2.reference.height }, positioner: { width: r2.floating.width, height: r2.floating.height } };
}
function kc(e5) {
  return Ac(e5, ms);
}
function Ac(e5, t2) {
  let { anchor: n2, positionMethod: r2 = "absolute", side: i2 = "bottom", sideOffset: a2 = 0, align: o2 = "center", alignOffset: s2 = 0, collisionBoundary: c2, collisionPadding: l2 = 5, sticky: u2 = false, arrowPadding: d2 = 5, disableAnchorTracking: f2 = false, inline: p2, keepMounted: m2 = false, floatingRootContext: h2, mounted: g2, collisionAvoidance: _2, shift: v2, nodeId: y2, adaptiveOrigin: b2, lazyFlip: x2 = false, externalTree: S2 } = e5, [C2, w2] = z.useState(null);
  !g2 && C2 !== null && w2(null);
  let T2 = _2.side || "flip", E2 = _2.align || "flip", D2 = _2.fallbackAxisSide || "end", O2 = v2?.crossAxis ?? false, k2 = v2?.rootBoundary, A2 = typeof n2 == "function" ? n2 : void 0, j2 = K(A2), M2 = A2 ? j2 : n2, N2 = kn(n2), P2 = kn(g2), F2 = bc() === "rtl", ee2 = C2 || { top: "top", right: "right", bottom: "bottom", left: "left", "inline-end": F2 ? "left" : "right", "inline-start": F2 ? "right" : "left" }[i2], te2 = o2 === "center" ? ee2 : `${ee2}-${o2}`, I2 = l2;
  typeof I2 == "number" ? I2 = { top: I2, right: I2, bottom: I2, left: I2 } : I2 &&= { top: I2.top || 0, right: I2.right || 0, bottom: I2.bottom || 0, left: I2.left || 0 };
  let ne2 = +(i2 === "bottom"), re2 = +(i2 === "top"), L2 = +(i2 === "right"), ie2 = +(i2 === "left"), ae2 = { boundary: c2 === "clipping-ancestors" ? "clippingAncestors" : c2, padding: I2 }, R2 = z.useRef(null), oe2 = kn(a2), se2 = kn(s2), ce2 = typeof a2 == "function" ? 0 : a2, le2 = typeof s2 == "function" ? 0 : s2, ue2 = [];
  p2 && ue2.push(p2), ue2.push(_o((e6) => {
    let t3 = Oc(e6, i2, F2), n3 = typeof oe2.current == "function" ? oe2.current(t3) : oe2.current, r3 = typeof se2.current == "function" ? se2.current(t3) : se2.current;
    return { mainAxis: n3, crossAxis: r3, alignmentAxis: r3 };
  }, [ce2, le2, F2, i2]));
  let de2 = E2 === "none" && T2 !== "shift", fe2 = !de2 && (u2 || O2 || T2 === "shift"), pe2 = T2 === "none" ? null : bo({ ...ae2, padding: { top: I2.top + 1 + ne2, right: I2.right + 1 + ie2, bottom: I2.bottom + 1 + re2, left: I2.left + 1 + L2 }, mainAxis: !O2 && T2 === "flip", crossAxis: E2 === "flip" ? "alignment" : false, fallbackAxisSideDirection: D2 }), me2 = de2 ? null : vo({ ...ae2, rootBoundary: k2, mainAxis: E2 !== "none", crossAxis: fe2, limiter: u2 || O2 ? void 0 : yo((e6) => {
    if (!R2.current) return {};
    let { width: t3, height: n3 } = R2.current.getBoundingClientRect(), r3 = nr(Qn(e6.placement)), i3 = r3 === "y" ? t3 : n3, a3 = r3 === "y" ? I2.left + I2.right : I2.top + I2.bottom;
    return { offset: i3 / 2 + a3 / 2 };
  }) }, [ae2, u2, O2, k2, I2, E2]);
  T2 === "shift" || E2 === "shift" || o2 === "center" ? ue2.push(me2, pe2) : ue2.push(pe2, me2), ue2.push(xo({ ...ae2, apply({ elements: { floating: e6 }, availableWidth: t3, availableHeight: n3, rects: r3 }) {
    if (!P2.current) return;
    let i3 = e6.style;
    i3.setProperty(Tc, `${t3}px`), i3.setProperty(Ec, `${n3}px`);
    let a3 = Ot(e6).devicePixelRatio || 1, { x: o3, y: s3, width: c3, height: l3 } = r3.reference, u3 = (Math.round((o3 + c3) * a3) - Math.round(o3 * a3)) / a3, d3 = (Math.round((s3 + l3) * a3) - Math.round(s3 * a3)) / a3;
    i3.setProperty("--anchor-width", `${u3}px`), i3.setProperty("--anchor-height", `${d3}px`);
  } }), Sc((e6) => ({ element: R2.current || Bn(e6.elements.floating).createElement("div"), padding: d2, offsetParent: "floating" }), [d2]), { name: "transformOrigin", fn(e6) {
    let { elements: t3, middlewareData: n3, placement: r3, rects: o3, y: s3 } = e6, c3 = Qn(r3), l3 = nr(c3), u3 = R2.current, d3 = n3.arrow?.x || 0, f3 = n3.arrow?.y || 0, p3 = u3?.clientWidth || 0, m3 = u3?.clientHeight || 0, h3 = d3 + p3 / 2, g3 = f3 + m3 / 2, _3 = Math.abs(n3.shift?.y || 0), v3 = o3.reference.height / 2, y3 = typeof a2 == "function" ? a2(Oc(e6, i2, F2)) : a2, b3 = _3 > y3, x3 = { top: `${h3}px calc(100% + ${y3}px)`, bottom: `${h3}px ${-y3}px`, left: `calc(100% + ${y3}px) ${g3}px`, right: `${-y3}px ${g3}px` }[c3], S3 = `${h3}px ${o3.reference.y + v3 - s3}px`;
    return t3.floating.style.setProperty("--transform-origin", fe2 && l3 === "y" && b3 ? S3 : x3), {};
  } }, Cc, b2), H(() => {
    !g2 && h2 && h2.update({ referenceElement: null, floatingElement: null, domReferenceElement: null, positionReference: null });
  }, [g2, h2]);
  let he2 = z.useMemo(() => ({ elementResize: !f2 && typeof ResizeObserver < "u", layoutShift: !f2 && typeof IntersectionObserver < "u" }), [f2]), { refs: ge2, elements: _e2, x: ve2, y: ye2, middlewareData: be2, update: xe2, placement: Se2, context: Ce2, isPositioned: we2, floatingStyles: Te2 } = t2({ rootContext: h2, open: m2 ? g2 : void 0, placement: te2, middleware: ue2, strategy: r2, whileElementsMounted: m2 ? void 0 : (...e6) => io(...e6, he2), nodeId: y2, externalTree: S2 }), { sideX: Ee2, sideY: De2 } = be2.adaptiveOrigin || wc, B2 = we2 ? r2 : "fixed", Oe2 = z.useMemo(() => {
    let e6;
    return e6 = we2 ? b2 ? { position: B2, [Ee2]: ve2, [De2]: ye2 } : { ...Te2, position: B2 } : { position: B2, top: 0, left: 0 }, e6[Tc] = "100vw", e6[Ec] = "100vh", we2 || (e6.opacity = 0), e6;
  }, [b2, B2, Ee2, ve2, De2, ye2, Te2, we2]), ke2 = z.useRef(null);
  H(() => {
    if (!g2) return;
    let e6 = N2.current, t3 = typeof e6 == "function" ? e6() : e6, n3 = (jc(t3) ? t3.current : t3) || null;
    n3 !== ke2.current && (ge2.setPositionReference(n3), ke2.current = n3);
  }, [g2, ge2, M2, N2]), z.useEffect(() => {
    if (!g2) return;
    let e6 = N2.current;
    typeof e6 != "function" && jc(e6) && e6.current !== ke2.current && (ge2.setPositionReference(e6.current), ke2.current = e6.current);
  }, [g2, ge2, M2, N2]), z.useEffect(() => {
    if (m2 && g2 && _e2.reference && _e2.floating) return io(_e2.reference, _e2.floating, xe2, he2);
  }, [m2, g2, _e2, xe2, he2]);
  let Ae2 = Qn(Se2), je2 = Dc(i2, Ae2, F2), Me2 = $n(Se2) || "center", Ne2 = !!be2.hide?.referenceHidden;
  H(() => {
    x2 && g2 && we2 && Ae2 !== ee2 && w2(Ae2);
  }, [x2, g2, we2, Ae2, ee2]);
  let Pe2 = z.useMemo(() => ({ position: "absolute", top: be2.arrow?.y, left: be2.arrow?.x }), [be2.arrow]), Fe2 = be2.arrow?.centerOffset !== 0;
  return z.useMemo(() => ({ positionerStyles: Oe2, arrowStyles: Pe2, arrowRef: R2, arrowUncentered: Fe2, side: je2, align: Me2, physicalSide: Ae2, anchorHidden: Ne2, refs: ge2, context: Ce2, isPositioned: we2, update: xe2 }), [Oe2, Pe2, R2, Fe2, je2, Me2, Ae2, Ne2, ge2, Ce2, we2, xe2]);
}
function jc(e5) {
  return e5 != null && "current" in e5;
}
var Mc = z.forwardRef(function(e5, t2) {
  let { cutout: n2, ...r2 } = e5, i2;
  if (n2) {
    let e6 = n2.getBoundingClientRect();
    i2 = `polygon(0% 0%,100% 0%,100% 100%,0% 100%,0% 0%,${e6.left}px ${e6.top}px,${e6.left}px ${e6.bottom}px,${e6.right}px ${e6.bottom}px,${e6.right}px ${e6.top}px,${e6.left}px ${e6.top}px)`;
  }
  return (0, B.jsx)("div", { ref: t2, role: "presentation", "data-base-ui-inert": "", ...r2, style: { position: "fixed", inset: 0, userSelect: "none", WebkitUserSelect: "none", clipPath: i2 } });
});
function Nc(e5) {
  return e5 === "starting" ? Bi : tt;
}
function Pc(e5, t2, { styles: n2, transitionStatus: r2, props: i2, refs: a2, hidden: o2, inert: s2 = false }) {
  let c2 = { ...n2 };
  return s2 && (c2.pointerEvents = "none"), Pi("div", e5, { state: t2, ref: a2, props: [{ role: "presentation", hidden: o2, style: c2 }, Nc(r2), i2], stateAttributesMapping: oc });
}
var Fc = {}, Ic = {}, Lc = "";
function Rc(e5, t2) {
  return Nt(e5) ? e5 : t2;
}
function zc(e5, t2, n2) {
  return /hidden|clip/.test(e5.getComputedStyle(Rc(t2, n2)).overflowY);
}
function Bc(e5) {
  if (typeof document > "u") return false;
  let t2 = Bn(e5);
  return Ot(t2).innerWidth - t2.documentElement.clientWidth > 0;
}
function Vc(e5) {
  if (!(typeof CSS < "u" && CSS.supports && CSS.supports("scrollbar-gutter", "stable")) || typeof document > "u") return false;
  let t2 = Bn(e5), n2 = t2.documentElement, r2 = t2.body, i2 = Rc(n2, r2), a2 = i2.style.overflowY, o2 = n2.style.scrollbarGutter;
  n2.style.scrollbarGutter = "stable", i2.style.overflowY = "scroll";
  let s2 = i2.offsetWidth;
  i2.style.overflowY = "hidden";
  let c2 = i2.offsetWidth;
  return i2.style.overflowY = a2, n2.style.scrollbarGutter = o2, s2 === c2;
}
function Hc(e5) {
  let t2 = Bn(e5), n2 = t2.documentElement, r2 = t2.body, i2 = Rc(n2, r2), a2 = { overflowY: i2.style.overflowY, overflowX: i2.style.overflowX };
  return Object.assign(i2.style, { overflowY: "hidden", overflowX: "hidden" }), () => {
    Object.assign(i2.style, a2);
  };
}
function Uc(e5) {
  let t2 = Bn(e5), n2 = t2.documentElement, r2 = t2.body, i2 = Ot(n2), a2 = 0, o2 = 0, s2 = false, c2 = Rn.create();
  if (_t && (i2.visualViewport?.scale ?? 1) !== 1) return () => {
  };
  function l2() {
    let t3 = i2.getComputedStyle(n2), c3 = i2.getComputedStyle(r2), l3 = (t3.scrollbarGutter || "").includes("both-edges") ? "stable both-edges" : "stable";
    a2 = n2.scrollTop, o2 = n2.scrollLeft, Fc = { scrollbarGutter: n2.style.scrollbarGutter, overflowY: n2.style.overflowY, overflowX: n2.style.overflowX }, Lc = n2.style.scrollBehavior, Ic = { position: r2.style.position, height: r2.style.height, width: r2.style.width, boxSizing: r2.style.boxSizing, overflowY: r2.style.overflowY, overflowX: r2.style.overflowX, scrollBehavior: r2.style.scrollBehavior };
    let u3 = n2.scrollHeight > n2.clientHeight, d3 = n2.scrollWidth > n2.clientWidth, f3 = t3.overflowY === "scroll" || c3.overflowY === "scroll", p2 = t3.overflowX === "scroll" || c3.overflowX === "scroll", m2 = Math.max(0, i2.innerWidth - r2.clientWidth), h2 = Math.max(0, i2.innerHeight - r2.clientHeight), g2 = parseFloat(c3.marginTop) + parseFloat(c3.marginBottom), _2 = parseFloat(c3.marginLeft) + parseFloat(c3.marginRight), v2 = Rc(n2, r2);
    if (s2 = Vc(e5), s2) {
      n2.style.scrollbarGutter = l3, v2.style.overflowY = "hidden", v2.style.overflowX = "hidden";
      return;
    }
    Object.assign(n2.style, { scrollbarGutter: l3, overflowY: "hidden", overflowX: "hidden" }), (u3 || f3) && (n2.style.overflowY = "scroll"), (d3 || p2) && (n2.style.overflowX = "scroll"), Object.assign(r2.style, { position: "relative", height: g2 || h2 ? `calc(100dvh - ${g2 + h2}px)` : "100dvh", width: _2 || m2 ? `calc(100vw - ${_2 + m2}px)` : "100vw", boxSizing: "border-box", overflowY: "hidden", overflowX: "hidden", scrollBehavior: "unset" }), r2.scrollTop = a2, r2.scrollLeft = o2, n2.setAttribute("data-base-ui-scroll-locked", ""), n2.style.scrollBehavior = "unset";
  }
  function u2() {
    Object.assign(n2.style, Fc), Object.assign(r2.style, Ic), s2 || (n2.scrollTop = a2, n2.scrollLeft = o2, n2.removeAttribute("data-base-ui-scroll-locked"), n2.style.scrollBehavior = Lc);
  }
  function d2() {
    u2(), c2.request(l2);
  }
  l2();
  let f2 = G(i2, "resize", d2);
  return () => {
    c2.cancel(), u2(), typeof i2.removeEventListener == "function" && f2();
  };
}
var Wc = new class {
  lockCount = 0;
  restore = null;
  timeoutLock = it.create();
  timeoutUnlock = it.create();
  acquire(e5) {
    return this.lockCount += 1, this.lockCount === 1 && this.restore === null && this.timeoutLock.start(0, () => this.lock(e5)), this.release;
  }
  release = () => {
    --this.lockCount, this.lockCount === 0 && this.restore && this.timeoutUnlock.start(0, this.unlock);
  };
  unlock = () => {
    this.lockCount === 0 && this.restore && (this.restore?.(), this.restore = null);
  };
  lock(e5) {
    if (this.lockCount === 0 || this.restore !== null) return;
    let t2 = Bn(e5), n2 = t2.documentElement, r2 = t2.body, i2 = Ot(n2);
    if (zc(i2, n2, r2)) {
      let t3 = new i2.MutationObserver(() => {
        zc(i2, n2, r2) || (t3.disconnect(), this.restore = null, this.lock(e5));
      }), a3 = { attributes: true };
      t3.observe(n2, a3), t3.observe(r2, a3), this.restore = () => t3.disconnect();
      return;
    }
    let a2 = ft || !Bc(e5);
    this.restore = a2 ? Hc(e5) : Uc(e5);
  }
}();
function Gc(e5 = true, t2 = null) {
  H(() => {
    if (e5) return Wc.acquire(t2);
  }, [e5, t2]);
}
var Kc = 20;
function qc(e5, t2, n2, r2) {
  let [i2, a2] = z.useState(false);
  H(() => {
    if (!e5 || !t2 || n2 == null) {
      a2(false);
      return;
    }
    let r3 = Bn(n2).documentElement.clientWidth, i3 = n2.offsetWidth;
    a2(r3 > 0 && i3 > 0 && i3 >= r3 - Kc);
  }, [e5, t2, n2]), Gc(e5 && (!t2 || i2), r2);
}
var Jc = z.forwardRef(function(e5, t2) {
  let { render: n2, className: r2, style: i2, anchor: a2, positionMethod: o2, side: s2, align: c2, sideOffset: l2, alignOffset: u2, collisionBoundary: d2 = "clipping-ancestors", collisionPadding: f2, arrowPadding: p2, sticky: m2, disableAnchorTracking: h2 = false, collisionAvoidance: g2 = Hi, ..._2 } = e5, v2 = Ns(), y2 = mc(), b2 = na(), x2 = v2.useState("floatingRootContext"), S2 = v2.useState("mounted"), C2 = v2.useState("open"), w2 = v2.useState("openChangeReason"), T2 = v2.useState("activeTriggerElement"), E2 = v2.useState("modal"), D2 = v2.useState("openMethod"), O2 = v2.useState("positionerElement"), k2 = v2.useState("instantType"), A2 = v2.useState("transitionStatus"), j2 = v2.useState("adaptiveOrigin"), M2 = z.useRef(null), N2 = Uo(O2), P2 = kc({ anchor: a2, floatingRootContext: x2, positionMethod: o2, mounted: S2, side: s2, sideOffset: l2, align: c2, alignOffset: u2, arrowPadding: p2, collisionBoundary: d2, collisionPadding: f2, sticky: m2, disableAnchorTracking: h2, keepMounted: y2, nodeId: b2, collisionAvoidance: g2, adaptiveOrigin: j2 }), F2 = x2.useState("domReferenceElement");
  H(() => {
    let e6 = F2, t3 = M2.current;
    if (e6 && (M2.current = e6), t3 && e6 && e6 !== t3) {
      v2.set("instantType", void 0);
      let e7 = new AbortController();
      return N2(() => {
        v2.set("instantType", "trigger-change");
      }, e7.signal), () => {
        e7.abort();
      };
    }
  }, [F2, N2, v2]);
  let ee2 = E2 === true && w2 !== "trigger-hover";
  qc(C2 && ee2, D2 === "touch", O2, T2);
  let te2 = v2.useStateSetter("positionerElement"), I2 = Pc(e5, { open: C2, side: P2.side, align: P2.align, anchorHidden: P2.anchorHidden, instant: k2 }, { styles: P2.positionerStyles, transitionStatus: A2, props: _2, refs: [t2, te2], hidden: !S2, inert: !C2 });
  return (0, B.jsxs)(_c.Provider, { value: P2, children: [S2 && ee2 && (0, B.jsx)(Mc, { inert: gc(!C2), cutout: T2 }), (0, B.jsx)(ra, { id: b2, children: I2 })] });
}), Yc = /* @__PURE__ */ new Set(["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End"]), Xc = z.createContext(void 0);
function Zc(e5) {
  let t2 = z.useContext(Xc);
  if (t2 === void 0 && !e5) throw Error(fi(69));
  return t2;
}
var Qc = z.createContext(void 0);
function $c() {
  let [e5, t2] = z.useState(0), n2 = K(() => (t2((e6) => e6 + 1), () => {
    t2((e6) => Math.max(0, e6 - 1));
  }));
  return { context: z.useMemo(() => ({ register: n2 }), [n2]), hasClosePart: e5 > 0 };
}
function el() {
  let e5 = z.useContext(Qc);
  H(() => e5?.register(), [e5]);
}
var tl = z.forwardRef(function(e5, t2) {
  let { render: n2, className: r2, style: i2, initialFocus: a2, finalFocus: o2, ...s2 } = e5, c2 = Ns(), l2 = vc(), u2 = Zc(true) != null, { context: d2, hasClosePart: f2 } = $c(), p2 = c2.useState("open"), m2 = c2.useState("openMethod"), h2 = c2.useState("instantType"), g2 = c2.useState("transitionStatus"), _2 = c2.useState("popupProps"), v2 = c2.useState("titleElementId"), y2 = c2.useState("descriptionElementId"), b2 = c2.useState("modal"), x2 = c2.useState("mounted"), S2 = c2.useState("openChangeReason"), C2 = c2.useState("activeTriggerElement"), w2 = c2.useState("floatingRootContext"), T2 = w2.useState("floatingId"), E2 = c2.useState("disabled"), D2 = c2.useState("openOnHover"), O2 = c2.useState("closeDelay");
  Wo({ open: p2, ref: c2.context.popupRef, onComplete() {
    p2 && c2.context.onOpenChangeComplete?.(true);
  } }), xs(w2, { enabled: D2 && !E2, closeDelay: O2 });
  let k2 = a2 === void 0 ? Ko(c2.context.popupRef) : a2, A2 = b2 !== false && f2;
  c2.useSyncedValue("focusManagerModal", A2);
  let j2 = c2.useStateSetter("popupElement"), M2 = Pi("div", e5, { state: { open: p2, side: l2.side, align: l2.align, instant: h2, transitionStatus: g2 }, ref: [t2, c2.context.popupRef, j2], props: [_2, { id: T2, role: "dialog", ...Go, "aria-labelledby": v2, "aria-describedby": y2, onKeyDown(e6) {
    u2 && Yc.has(e6.key) && e6.stopPropagation();
  } }, Nc(g2), s2], stateAttributesMapping: sc });
  return (0, B.jsx)(ma, { context: w2, openInteractionType: m2, modal: A2, disabled: !x2 || S2 === "trigger-hover", initialFocus: k2, returnFocus: o2, restoreFocus: "popup", previousFocusableElement: jt(C2) ? C2 : void 0, nextFocusableElement: c2.context.triggerFocusTargetRef, beforeContentFocusGuardRef: c2.context.beforeContentFocusGuardRef, children: (0, B.jsx)(Qc.Provider, { value: d2, children: M2 }) });
}), nl = z.forwardRef(function(e5, t2) {
  let { render: n2, className: r2, style: i2, ...a2 } = e5, o2 = Ns(), s2 = cc(a2.id);
  return o2.useSyncedValueWithCleanup("titleElementId", s2), Pi("h2", e5, { ref: t2, props: [{ id: s2 }, a2] });
}), rl = z.forwardRef(function(e5, t2) {
  let { render: n2, className: r2, style: i2, ...a2 } = e5, o2 = Ns(), s2 = cc(a2.id);
  return o2.useSyncedValueWithCleanup("descriptionElementId", s2), Pi("p", e5, { ref: t2, props: [{ id: s2 }, a2] });
}), il = z.forwardRef(function(e5, t2) {
  let { render: n2, className: r2, style: i2, disabled: a2 = false, nativeButton: o2 = true, ...s2 } = e5, { buttonRef: c2, getButtonProps: l2 } = Ks({ disabled: a2, focusableWhenDisabled: false, native: o2 }), u2 = Ns();
  return el(), Pi("button", e5, { ref: [t2, c2], props: [{ onClick(e6) {
    u2.setOpen(false, xn(_n, e6.nativeEvent));
  } }, s2, l2] });
});
function al({ title: e5, image: t2, alt: r2, note: i2, preview: a2 }) {
  return n(), (0, B.jsxs)(zs, { children: [(0, B.jsx)(fc, { type: "button", className: "reference-trigger", "aria-label": m("View {title} reference", { title: m(e5) }), openOnHover: true, delay: 200, closeDelay: 150, children: (0, B.jsx)(Ie, { size: 16, "aria-hidden": "true" }) }), (0, B.jsx)(hc, { children: (0, B.jsx)(Jc, { className: "reference-positioner", side: "top", align: "center", sideOffset: 8, collisionPadding: 12, children: (0, B.jsxs)(tl, { className: "reference-popup", children: [(0, B.jsxs)("div", { className: "reference-heading", children: [(0, B.jsx)(nl, { children: m(e5) }), (0, B.jsx)(il, { type: "button", "aria-label": m("Close reference"), children: (0, B.jsx)(fe, { size: 17, "aria-hidden": "true" }) })] }), a2 ?? (0, B.jsx)("img", { src: t2, alt: r2, width: "600", height: "600", loading: "lazy" }), (0, B.jsx)(rl, { children: m(i2 ?? "Background reference only; your proof is composed around your photograph.") })] }) }) })] });
}
function ol({ draft: e5, setDraft: t2, onBusy: r2 }) {
  n();
  let [i2, a2] = (0, z.useState)(null), [o2, s2] = (0, z.useState)(""), c2 = (0, z.useRef)(0), l2 = (0, z.useRef)([]);
  (0, z.useEffect)(() => () => {
    c2.current++, r2(false);
  }, [r2]);
  async function u2(n2, i3) {
    if (!i3) return;
    let o3 = e5.references || [];
    if (!o3.find((e6) => e6.slot === n2) && !["style", "background", "both"].some((e6) => L(o3, n2, e6))) {
      s2("Change the first reference use before adding another reference image.");
      return;
    }
    let u3 = ue(i3);
    if (u3) {
      s2(u3);
      return;
    }
    let d2 = ++c2.current;
    a2(n2), r2(true), s2("");
    let f2 = "";
    try {
      i3 = await preparePhotoUpload(i3);
      f2 = URL.createObjectURL(i3);
      let e6 = new Uint8Array(await i3.slice(0, 12).arrayBuffer()), r3 = e6[0] === 255 && e6[1] === 216, a3 = e6[0] === 137 && e6[1] === 80 && e6[2] === 78 && e6[3] === 71, o4 = String.fromCharCode(...e6.slice(0, 4)) === "RIFF" && String.fromCharCode(...e6.slice(8, 12)) === "WEBP";
      if (!(i3.type === "image/jpeg" && r3 || i3.type === "image/png" && a3 || i3.type === "image/webp" && o4)) throw Error("Choose a valid JPEG, PNG or WebP image.");
      let l3 = new Image();
      if (l3.src = f2, await l3.decode(), !l3.naturalWidth || !l3.naturalHeight) throw Error("We could not open this reference image.");
      if (l3.naturalWidth * l3.naturalHeight > 6e6) throw Error("Choose a reference image of 6 megapixels or less.");
      if (d2 !== c2.current) {
        URL.revokeObjectURL(f2);
        return;
      }
      t2((e7) => {
        let t3 = (e7.references || []).find((e8) => e8.slot === n2), r4 = t3?.role || ["style", "background", "both"].find((t4) => L(e7.references || [], n2, t4));
        if (!r4) return URL.revokeObjectURL(f2), s2("Change the first reference use before adding another reference image."), e7;
        t3 && URL.revokeObjectURL(t3.photo.url);
        let a4 = { slot: n2, role: r4, photo: { url: f2, name: i3.name, width: l3.naturalWidth, height: l3.naturalHeight } };
        return { ...e7, references: [...(e7.references || []).filter((e8) => e8.slot !== n2), a4].sort((e8, t4) => e8.slot - t4.slot) };
      });
    } catch (e6) {
      URL.revokeObjectURL(f2), d2 === c2.current && s2(e6 instanceof Error ? e6.message : "We could not open this reference image.");
    } finally {
      d2 === c2.current && (a2(null), r2(false));
      let e6 = l2.current[n2 - 1];
      e6 && (e6.value = "");
    }
  }
  return (0, B.jsxs)("fieldset", { className: "custom-references", children: [(0, B.jsxs)("legend", { children: [(0, B.jsx)(p, { children: "Reference images" }), " ", (0, B.jsx)("small", { children: (0, B.jsx)(p, { children: "Optional \xB7 up to 2" }) })] }), (0, B.jsx)("p", { children: (0, B.jsx)(p, { children: "Show us an art style or background you like. Your main photograph remains the subject of your piece. Each direction can use one reference image." }) }), (0, B.jsx)("div", { className: "custom-reference-grid", children: [1, 2].map((n2) => {
    let r3 = e5.references || [], a3 = r3.find((e6) => e6.slot === n2);
    return (0, B.jsxs)("div", { className: "custom-reference", children: [(0, B.jsx)("input", { className: "sr-only", type: "file", disabled: i2 !== null, accept: "image/jpeg,image/png,image/webp", "aria-label": `Choose reference ${n2}`, ref: (e6) => {
      l2.current[n2 - 1] = e6;
    }, onChange: (e6) => {
      u2(n2, e6.target.files?.[0]);
    } }), a3 ? (0, B.jsx)("img", { src: a3.photo.url, alt: `Reference ${n2}: ${a3.photo.name}` }) : (0, B.jsxs)("div", { className: "custom-reference-empty", children: [(0, B.jsx)(Le, { size: 24 }), (0, B.jsxs)("span", { children: [(0, B.jsx)(p, { children: "Reference" }), " ", n2] })] }), a3 && (0, B.jsxs)(B.Fragment, { children: [(0, B.jsx)("span", { className: "custom-file-name", children: a3.photo.name }), (0, B.jsxs)("label", { className: "custom-field", children: [(0, B.jsx)("span", { children: (0, B.jsx)(p, { children: "Use as" }) }), (0, B.jsx)("select", { "aria-label": `Reference ${n2} purpose`, value: a3.role, disabled: i2 !== null, onChange: (e6) => {
      let i3 = e6.target.value;
      if (!L(r3, n2, i3)) {
        s2(`Reference ${n2 === 1 ? 2 : 1} already guides that direction. Choose another use first.`);
        return;
      }
      t2((e7) => ({ ...e7, references: (e7.references || []).map((e8) => e8.slot === n2 ? { ...e8, role: i3 } : e8) })), s2("");
    }, children: Object.entries(le).map(([e6, t3]) => (0, B.jsx)("option", { value: e6, disabled: !L(r3, n2, e6), children: m(t3) }, e6)) })] })] }), (0, B.jsx)("button", { type: "button", className: "custom-upload-button", disabled: i2 !== null, onClick: () => l2.current[n2 - 1]?.click(), children: m(i2 === n2 ? "Opening reference\u2026" : a3 ? "Replace reference" : "Add reference") }), a3 && (0, B.jsx)("button", { type: "button", className: "custom-text-button", disabled: i2 !== null, onClick: () => {
      URL.revokeObjectURL(a3.photo.url), t2((e6) => ({ ...e6, references: (e6.references || []).filter((e7) => e7.slot !== n2) })), s2("");
    }, children: (0, B.jsx)(p, { children: "Remove reference" }) })] }, n2);
  }) }), (0, B.jsx)("small", { children: (0, B.jsx)(p, { children: "JPEG, PNG or WebP \xB7 each up to 10 MB" }) }), o2 && (0, B.jsx)("p", { className: "custom-reference-error", role: "alert", children: m(o2) })] });
}
function magnetBlankReference(draft){return (0,B.jsx)("div",{className:"custom-blank-reference"+(draft.product===1&&draft.orientation==="landscape"?" is-landscape":""),children:(0,B.jsx)("img",{src:draft.product===0?"https://cdn.shopify.com/s/files/1/0693/3918/5211/files/tactale-square-blank-20261021.png?v=1792553598":"https://cdn.shopify.com/s/files/1/0693/3918/5211/files/tactale-rectangular-blank-20261021.png?v=1792553608",alt:draft.product===0?"Square blank ceramic magnet":draft.orientation==="landscape"?"Landscape rectangular blank ceramic magnet":"Portrait rectangular blank ceramic magnet",width:1254,height:1254,decoding:"async"})});}
function sl({ draft: e5, sample: t2 = false }) {
  if(!e5.photo&&!t2)return magnetBlankReference(e5);
  n();
  if (!e5.photo) return (0, B.jsx)("img", {className:e5.format === "full" ? "memory-real-sample" : "memory-real-frame-sample", src:C(e5.format === "full" ? "/art/real-full-photo-1015.jpg" : "/art/real-memory-1015.jpg"), alt:m(e5.format === "full" ? "Full Photo" : "European Romantic"), width:"1350", height:e5.format === "full" ? "964" : "1800"});
  return (0, B.jsxs)("div", { className: `memory-layout is-${e5.orientation} is-${e5.format}${e5.format === "message" ? ` border-${e5.messageBorder}` : ""}`, children: [(0, B.jsx)("img", { src: e5.photo?.url || C("/art/memory-wedding-original-v20260923.png"), alt: e5.photo ? m("Your photograph in the selected layout") : m("Wedding photograph showing a couple adjusting the bridal veil") }), e5.format === "message" && (0, B.jsx)("span", { className: "memory-layout-text", children: t2 ? m("Our favourite day") : e5.inscription || m("Your words, kept close") })] });
}
function cl({ draft: e5, onChange: t2 }) {
  n();
  (0, z.useEffect)(()=>{if(e5.format === "message" && e5.messageBorder !== "romantic") t2({messageBorder:"romantic"});},[e5.format,e5.messageBorder,t2]);
  let r2 = { ...e5, photo: null, inscription: "Our favourite day" };
  return (0, B.jsxs)("div", { className: "memory-options", children: [(0,B.jsxs)("div",{className:"memory-selected-format",children:[(0,B.jsx)("strong",{children:m(e5.format === "full" ? "Full Photo" : "European Romantic")}), (0,B.jsx)(al,{title:m(e5.format === "full" ? "Full Photo" : "European Romantic"),preview:(0,B.jsx)(sl,{draft:r2,sample:true}),note:e5.format === "full" ? "Full Photo · No text or border. Available in portrait or landscape." : "Your text will be added during production."})]}), (0, B.jsxs)("fieldset", { className: "memory-choice-set", children: [(0, B.jsx)("legend", { children: (0, B.jsx)(p, { children: "Orientation" }) }), (0, B.jsx)("div", { className: "memory-choice-grid", children: ["portrait", "landscape"].map((n2) => (0, B.jsx)("div", { className: "memory-choice", children: (0, B.jsxs)("label", { children: [(0, B.jsx)("input", { type: "radio", name: "memory-orientation", checked: e5.orientation === n2, onChange: () => t2({ orientation: n2 }) }), (0, B.jsx)("span", { className: `memory-orientation-icon is-${n2}`, "aria-hidden": "true" }), (0, B.jsxs)("span", { children: [(0, B.jsx)("strong", { children: m(n2 === "portrait" ? "Portrait" : "Landscape") }), (0, B.jsx)("small", { children: m(n2 === "portrait" ? "5 \xD7 7 cm \xB7 5:7" : "7 \xD7 5 cm \xB7 7:5") })] })] }) }, n2)) })] })] });
}

var ll = ["Piece", "Photo", "Expression", "Review"], ul = ["Choose the form of your memory", "Add the moment", "Find its expression", "Your memory, thoughtfully considered"];
function customizerStepIndices(product) { return product === 0 ? [1, 2, 3] : [0, 1, 2, 3]; }
function dl({ draft: e5, setDraft: rawSetDraft, onClose: r2, onAdd: i2, editing: a2 = false, catalog: o2 = false, cartReady: cartIsReady = true }) {
  const t2=change=>rawSetDraft(previous=>reconcileFloralDraft(previous,typeof change==="function"?change(previous):change));
  (0,z.useEffect)(()=>{t2(previous=>previous);},[]);
  const {locale:productLocale}=n();
  const requestProductSignIn = productSelectSignIn(), productSelectDraft = e5, visibleSteps = customizerStepIndices(e5.product), firstStep = visibleSteps[0];
  let [s2, c2] = (0, z.useState)(false), [l2, u2] = (0, z.useState)(false), [d2, h2] = (0, z.useState)(firstStep), [g2, _2] = (0, z.useState)(""), [v2, b2] = (0, z.useState)(false), [x2, S2] = (0, z.useState)(false), [C2, w2] = (0, z.useState)(false), [T2, E2] = (0, z.useState)(false), [D2, I2] = (0, z.useState)(false), L2 = (0, z.useRef)(null), ae2 = (0, z.useRef)(null), le2 = (0, z.useRef)(0), fe2 = (0, z.useRef)(null), me2 = {...A[e5.product], ...(memoryProductCopy(e5,productLocale) ? {name:memoryProductCopy(e5,productLocale).title} : {})}, [ve2, ye2] = (0, z.useState)(null), be2 = he(e5, pe(y()?.products ?? []));
  (0, z.useEffect)(() => {
    let e6 = true;
    return ye2(null), be2?.tracked && be2.denyOversell && ge([be2.id]).then((t3) => {
      e6 && ye2({ ...be2, ...t3.get(be2.id) });
    }).catch(() => {
      e6 && ye2(null);
    }), () => {
      e6 = false;
    };
  }, [be2?.id, be2?.tracked, be2?.denyOversell]);
  let we2 = _e(ve2), Te2 = ie(e5), Oe2 = e5.references?.find((e6) => M(e6.role, "style")), ke2 = e5.references?.find((e6) => M(e6.role, "background")), Ae2 = ce(e5) ? null : me2.expressionRecommendation, je2 = C2 || T2 || D2;
  (0, z.useEffect)(() => {
    ae2.current?.focus({ preventScroll: true }), window.scrollTo(0, 0);
  }, [d2]), (0, z.useEffect)(() => () => {
    le2.current++;
  }, []), (0, z.useEffect)(() => {
    function e6() {
      w2(false), E2(false), I2(false);
    }
    function t3(t4) {
      t4.key === "Escape" && e6();
    }
    function n2(t4) {
      fe2.current?.contains(t4.target) || e6();
    }
    return document.addEventListener("keydown", t3), document.addEventListener("pointerdown", n2), () => {
      document.removeEventListener("keydown", t3), document.removeEventListener("pointerdown", n2);
    };
  }, []);
  function Me2(e6) {
    t2((t3) => O(t3, e6)), _2("");
  }
  function Ne2(next) {
    if (next > 0 && d2 === 0 && y()?.accountCartEnabled && !productSelectAccount({ storage: sessionStorage }).hasSession()) {
      const target = new URL(location.href);
      target.searchParams.set("customize", String(productSelectDraft.product)), history.replaceState(history.state, "", target.href), requestProductSignIn("create");
      return;
    }
    const e6 = Math.max(firstStep, next);
    _2(""), h2(e6);
  }
  async function Pe2(e6) {
    if (!e6) return;
    let n2 = ++le2.current, r3 = ue(e6);
    if (r3) {
      b2(false), _2(r3);
      return;
    }
    _2(""), b2(true);
    let i3 = "";
    try {
      e6 = await preparePhotoUpload(e6);
      i3 = URL.createObjectURL(e6);
      let r4 = new Uint8Array(await e6.slice(0, 12).arrayBuffer());
      if (!(r4[0] === 255 && r4[1] === 216 || r4[0] === 137 && r4[1] === 80 && r4[2] === 78 && r4[3] === 71 || String.fromCharCode(...r4.slice(0, 4)) === "RIFF" && String.fromCharCode(...r4.slice(8, 12)) === "WEBP")) throw Error("Invalid image");
      let a3 = new Image();
      if (a3.src = i3, await a3.decode(), !a3.naturalWidth || !a3.naturalHeight) throw Error("Invalid image");
      if (a3.naturalWidth * a3.naturalHeight > 6e6) throw Error("Choose a photograph of 6 megapixels or less.");
      if (n2 !== le2.current) {
        URL.revokeObjectURL(i3);
        return;
      }
      let o3 = { url: i3, name: e6.name, width: a3.naturalWidth, height: a3.naturalHeight };
      t2((e7) => (e7.photo && URL.revokeObjectURL(e7.photo.url), { ...e7, photo: o3 })), _2("");
    } catch (e7) {
      URL.revokeObjectURL(i3), n2 === le2.current && _2(e7 instanceof Error && e7.message.includes("megapixels") ? e7.message : "We could not open this photograph. Try another JPEG, PNG or WebP image.");
    } finally {
      n2 === le2.current && b2(false), L2.current && (L2.current.value = "");
    }
  }
  function Be2() {
    le2.current++, b2(false), e5.photo && URL.revokeObjectURL(e5.photo.url), Me2({ photo: null });
  }
  function Ve2() {
    if (!(v2 || l2)) {
      if (d2 === 1 || d2 === 2) {
        let t3 = de({...e5,selectionContractVersion:d2===1?undefined:1});
        if (t3.length) {
          _2(t3.join(" "));
          return;
        }
      }
      Ne2(Math.min(3, d2 + 1));
    }
  }
  async function V2() {
    if (s2 || v2 || l2 || !o2 && !cartIsReady) return;
    let t3 = de(e5);
    if (t3.length) {
      _2(t3.join(" "));
      return;
    }
    c2(true), _2("");
    try {
      await i2() || _2("Your piece was not saved. Please check the message above and try again.");
    } catch (e6) {
      _2(e6 instanceof Error ? e6.message : "We could not save this photo preview. Please try again.");
    } finally {
      c2(false);
    }
  }
  return (0, B.jsxs)("section", { className: "tactale-custom", "aria-labelledby": "custom-heading", children: [(0, B.jsxs)("header", { className: "custom-header", children: [(0, B.jsxs)(f, { className: "custom-back", href: a2 && !o2 ? "/cart" : "/products", "aria-disabled": s2 || undefined, onClick: (event) => { if(s2) event.preventDefault(); else r2(); }, children: [(0, B.jsx)(Se, { size: 17 }), " ", m(a2 && !o2 ? "Back to cart" : "Products")] }), (0, B.jsx)("span", { className: "custom-wordmark", "aria-label": m("Tactale") }), (0, B.jsx)("span", { className: "custom-header-note", children: (0, B.jsx)(p, { children: "Made from your photograph" }) })] }), (0, B.jsxs)("div", { className: "custom-layout", inert: s2, children: [(0, B.jsx)("aside", { className: "custom-preview", "aria-label": m("Your selected piece"), children: (0, B.jsxs)("div", { className: "custom-preview-inner", children: [(0, B.jsx)("div", { className: "custom-preview-art", children: e5.product === 1 && (e5.photo || d2 > 0 || e5.format === "full") ? (0, B.jsxs)("figure", { className: "custom-source", children: [(0, B.jsx)(sl, { draft: e5 }), (0, B.jsx)("figcaption", { children: e5.photo ? m("Layout preview \xB7 your photograph") : m("Example layout \xB7 your photograph comes next") }), e5.format === "message" && (0, B.jsx)("span", { className: "memory-layout-note", children: (0, B.jsx)(p, { children: "Border style shown in the question-mark reference. Your final design comes in the proof." }) })] }) : e5.photo ? (0, B.jsxs)("figure", { className: "custom-source", children: [(0, B.jsx)("div", { className: "custom-photo-mount", children: (0, B.jsx)("img", { src: e5.photo.url, alt: m("Your original photograph") }) }), (0, B.jsx)("figcaption", { children: (0, B.jsx)(p, { children: "Your source photograph" }) })] }) : (0, B.jsxs)("figure", { className: "custom-example", children: [(e5.product===0||e5.product===1)?magnetBlankReference(e5):(0, B.jsx)("img", { src: me2.poster, alt: `${me2.name} example` }), (0, B.jsx)("figcaption", { children: (0, B.jsx)(p, { children: "Example piece \xB7 yours begins with your photograph" }) })] }) }), (0, B.jsxs)("div", { className: "custom-preview-label", children: [(0, B.jsxs)("div", { children: [(0, B.jsx)("h2", { children: m(me2.name) }), (0, B.jsxs)("p", { children: [te(e5), " ", (0, B.jsx)("span", { "aria-hidden": "true", children: "\xB7" }), " ", m(Te2.style)] })] }), (0,B.jsx)("span",{className:"custom-price",children:(0,B.jsx)(SalePrice,{product:e5.product,current:ee(e5)})})] }), (0, B.jsxs)("p", { className: "custom-material", children: [m(P(e5.product)), ne(e5.product) && ` \xB7 ${m("{color} frame", { color: m(N(e5.frameColor)) })}`] }), e5.product === 1 && (0, B.jsxs)("p", { className: "custom-material", children: [m(re(e5.orientation)), " \xB7", " ", e5.format === "message" ? m(F(e5.messageBorder)) : m("No text or border")] }), (0, B.jsx)("p", { className: "custom-preview-note", children: e5.photo ? m(o2 ? "Your photo stays in your browser." : "Your original photo stays visible here. We prepare the artwork proof after payment.") : m("One photograph. A feeling worth keeping.") })] }) }), (0, B.jsxs)("div", { className: "custom-form", "aria-busy": s2, children: [(0, B.jsx)("nav", { className: "custom-steps", "aria-label": m("Customisation steps"), children: visibleSteps.map((t3, stepIndex) => { const e6 = ll[t3]; return (0, B.jsxs)("button", { "aria-current": d2 === t3 ? "step" : void 0, disabled: t3 > d2, onClick: () => {
    Ne2(t3);
  }, children: [(0, B.jsx)("span", { children: t3 < d2 ? (0, B.jsx)(Ce, { size: 12 }) : stepIndex + 1 }), m(e6), t3 < 3 && (0, B.jsx)(Fe, { size: 12 })] }, e6); }) }), (0, B.jsx)("h1", { id: "custom-heading", ref: ae2, tabIndex: -1, children: m(d2 === 0 ? me2.name : ul[d2]) }), d2 === 0 && (0, B.jsxs)(B.Fragment, { children: [(0, B.jsx)("p", { className: "custom-intro", children: De() ? m("A favourite memory, made into a magnet for every day.") : m("A small everyday keepsake, or a piece that makes a room feel yours.") }), ne(e5.product) && (0, B.jsxs)("fieldset", { className: "custom-frame-options", children: [(0, B.jsx)("legend", { children: (0, B.jsx)(p, { children: "Frame color" }) }), (0, B.jsx)("div", { children: oe.map((t3) => (0, B.jsxs)("div", { className: "custom-frame-option", children: [(0, B.jsxs)("label", { children: [(0, B.jsx)("input", { type: "radio", name: "frame-color", checked: e5.frameColor === t3.id, onChange: () => Me2({ frameColor: t3.id }) }), (0, B.jsx)("span", { className: "custom-frame-swatch", style: { backgroundColor: t3.swatch }, "aria-hidden": "true" }), (0, B.jsx)("span", { children: m(t3.name) })] }), (0, B.jsx)(al, { title: `${m(t3.name)} frame`, preview: (0, B.jsx)("div", { className: "reference-frame-detail", children: (0, B.jsx)("img", { src: t3.image, alt: `Magnified upper-right corner of the ${t3.name.toLowerCase()} frame, showing the join, finish and canvas weave`, width: "600", height: "600", loading: "lazy" }) }), note: "Frame color reference \xB7 Cotton-linen canvas" })] }, t3.id)) }), (0, B.jsx)("p", { children: (0, B.jsx)(p, { children: "Cotton-linen canvas \xB7 Both frame colors included in the piece price" }) })] }), y() && !o2 && (0, B.jsx)("p", { className: "custom-stock-notice", role: "status", "aria-live": "polite", children: we2.status === "low" ? m("Only {count} left", { count: we2.count ?? 0 }) : we2.status === "sold_out" ? m("Currently out of stock. Save your piece and return when it is available.") : we2.status === "unknown" ? m("Stock cannot be confirmed right now. You can still save your piece.") : null }), (0,B.jsx)("p",{className:"custom-dispatch-note",children:(0,B.jsx)(p,{children:"After you approve your proof, your piece is dispatched in 2–5 days."})}), e5.product === 1 && (0, B.jsx)(cl, { draft: e5, onChange: Me2 })] }), d2 === 1 && (0, B.jsxs)(B.Fragment, { children: [(0, B.jsx)("p", { className: "custom-intro", children: (0, B.jsx)(p, { children: "Choose a clear, well-lit original with the faces and details you want to keep." }) }), (0, B.jsxs)("div", { className: `custom-upload ${x2 ? "is-dragging" : ""}`, onDragOver: (e6) => {
    e6.preventDefault(), S2(true);
  }, onDragLeave: () => S2(false), onDrop: (e6) => {
    if (e6.preventDefault(), S2(false), e6.dataTransfer.files.length !== 1) {
      _2("Choose one photograph for this piece.");
      return;
    }
    Pe2(e6.dataTransfer.files[0]);
  }, children: [(0, B.jsx)("input", { ref: L2, type: "file", accept: "image/jpeg,image/png,image/webp", className: "sr-only", "aria-label": m("Choose your photograph"), onChange: (e6) => {
    Pe2(e6.target.files?.[0]);
  } }), e5.photo ? (0, B.jsxs)(B.Fragment, { children: [(0, B.jsx)(Ce, { size: 22 }), (0, B.jsx)("strong", { className: "custom-file-name", children: e5.photo.name }), (0, B.jsxs)("span", { children: [e5.photo.width, " \xD7 ", e5.photo.height, " ", (0, B.jsx)(p, { children: "pixels" })] })] }) : (0, B.jsxs)(B.Fragment, { children: [(0, B.jsx)(Le, { size: 29 }), (0, B.jsx)("strong", { children: (0, B.jsx)(p, { children: "A photograph to begin with." }) }), (0, B.jsx)("span", { children: (0, B.jsx)(p, { children: "Drop it here, or choose from your device." }) })] }), (0, B.jsxs)("button", { className: "custom-upload-button", onClick: () => L2.current?.click(), disabled: v2, children: [(0, B.jsx)(ze, { size: 15 }), v2 ? m("Opening photograph\u2026") : e5.photo ? m("Replace photo") : m("Choose photo")] }), (0, B.jsx)("small", { children: (0, B.jsx)(p, { children: "JPEG, PNG or WebP \xB7 up to 10 MB" }) }), (0, B.jsx)(f, { href: "/policies/privacy-policy", target: "_blank", rel: "noopener", children: (0, B.jsx)(p, { children: "Privacy Policy" }) }), e5.photo && (0, B.jsx)("button", { className: "custom-text-button", onClick: Be2, children: (0, B.jsx)(p, { children: "Remove photo" }) })] }), (0, B.jsx)("p", { className: "custom-private-note", children: o2 ? m("Your photo stays in your browser.") : y()?.checkoutIntegrationEnabled ? m("Your original photograph and any references will be saved privately to prepare your proof.") : m("For this preview, your photo stays in this browser.") }), e5.product === 1 && e5.format === "message" && (0, B.jsxs)("label", { className: "custom-field", children: [(0, B.jsxs)("span", { children: [(0, B.jsx)(p, { children: "Product text" }), " ", (0, B.jsxs)("small", { children: [(0, B.jsx)(p, { children: "Required \xB7" }), " ", Array.from(e5.inscription).length, "/40"] })] }), (0, B.jsx)("input", { value: e5.inscription, onChange: (e6) => Me2({ inscription: Array.from(e6.target.value).slice(0, 40).join("") }), placeholder: m("A name, a date, a few meaningful words"), required: true, "aria-describedby": "inscription-help" }), (0, B.jsx)("small", { id: "inscription-help", children: (0, B.jsx)(p, { children: "These words appear below the artwork." }) })] }), (0, B.jsxs)("div", { className: "custom-fields", children: [(0, B.jsxs)("label", { className: "custom-field", children: [(0, B.jsxs)("span", { children: [(0, B.jsx)(p, { children: "Occasion" }), " ", (0, B.jsx)("small", { children: (0, B.jsx)(p, { children: "Optional" }) })] }), (0, B.jsxs)("select", { value: e5.occasion, onChange: (e6) => Me2({ occasion: e6.target.value }), children: [(0, B.jsx)("option", { value: "", children: (0, B.jsx)(p, { children: "Choose an occasion" }) }), ["Pet portrait", "Wedding / Memory", "Birthday / Celebration", "Travel / Landmark", "Couple / Anniversary", "Family / Group", "Other"].map((e6) => (0, B.jsx)("option", { value: e6, children: m(e6) }, e6))] })] }), (0, B.jsxs)("label", { className: "custom-field", children: [(0, B.jsxs)("span", { children: [(0, B.jsx)(p, { children: "Notes" }), " ", (0, B.jsx)("small", { children: (0, B.jsx)(p, { children: "Optional" }) })] }), (0, B.jsx)("textarea", { value: e5.notes, maxLength: 1e3, onChange: (e6) => Me2({ notes: e6.target.value }), rows: 2, placeholder: m("Tell us what to preserve from your photo or borrow from a reference.") })] })] })] }), d2 === 2 && (0, B.jsxs)(B.Fragment, { children: [(0, B.jsx)("p", { className: "custom-intro", children: (0, B.jsx)(p, { children: "Choose the expression that feels most like the memory. Add reference images here if you would like us to follow a particular style or setting." }) }), (0, B.jsxs)("fieldset", { className: "custom-style-options", children: [(0, B.jsx)("legend", { children: (0, B.jsx)(p, { children: "Art style" }) }), Oe2 ? (0, B.jsxs)("div", { className: "custom-expression-reference", children: [(0, B.jsx)("img", { src: Oe2.photo.url, alt: `Reference ${Oe2.slot}: ${Oe2.photo.name}` }), (0, B.jsxs)("span", { children: [(0, B.jsxs)("strong", { children: [(0, B.jsx)(p, { children: "Using Reference image" }), " ", Oe2.slot, " ", (0, B.jsx)(p, { children: "for art style" })] }), (0, B.jsx)("small", { children: (0, B.jsx)(p, { children: "Remove or change this reference below to choose an art-style preset." }) })] })] }) : (0, B.jsx)("div", { children: k.filter((e6) => me2.styles.includes(e6.id)).map((t3) => (0, B.jsxs)("label", { className: t3.id === e5.style ? "is-selected" : "", children: [(0, B.jsx)("input", { type: "radio", name: "style", checked: t3.id === e5.style, onChange: () => Me2({ style: t3.id }) }), (0, B.jsx)("img", { src: t3.image, alt: m("{style} style reference", { style: m(t3.name) }) }), (0, B.jsxs)("span", { className: "custom-style-name", children: [(0, B.jsxs)("span", { className: "custom-style-title", children: [(0, B.jsx)("span", { children: m(t3.name) }), t3.id === Ae2?.style && (0, B.jsx)("span", { className: "custom-recommendation-mark", role: "img", "aria-label": m("Recommended"), title: m("Recommended"), children: (0, B.jsx)(Re, { size: 14, strokeWidth: 1.5, "aria-hidden": "true" }) })] }), t3.id === e5.style && (0, B.jsx)(Ce, { size: 14 })] }), (0, B.jsx)("small", { children: m(t3.description) })] }, t3.id)) })] }), (0,B.jsxs)(B.Fragment,{children:[(0, B.jsxs)("fieldset", { className: "custom-background-options", children: [(0, B.jsx)("legend", { children: (0, B.jsx)(p, { children: "Background direction" }) }), ke2 ? (0, B.jsxs)("div", { className: "custom-expression-reference", children: [(0, B.jsx)("img", { src: ke2.photo.url, alt: `Reference ${ke2.slot}: ${ke2.photo.name}` }), (0, B.jsxs)("span", { children: [(0, B.jsxs)("strong", { children: [(0, B.jsx)(p, { children: "Using Reference image" }), " ", ke2.slot, " ", (0, B.jsx)(p, { children: "for background" })] }), (0, B.jsx)("small", { children: (0, B.jsx)(p, { children: "Remove or change this reference below to choose a background preset." }) })] })] }) : (0, B.jsx)("div", { children: se.filter((t3) => !ce(e5) || t3.id === "scene").map((t3) => (0, B.jsxs)("div", { className: "custom-background-option", children: [(0, B.jsxs)("label", { children: [(0, B.jsx)("input", { type: "radio", name: "background", checked: t3.id === e5.background, onChange: () => Me2({ background: t3.id }) }), (0, B.jsx)("span", { className: "custom-radio" }), (0, B.jsxs)("span", { className: "custom-background-copy", children: [(0, B.jsxs)("span", { className: "custom-background-heading", children: [(0, B.jsx)("strong", { children: m(t3.name) }), t3.id === Ae2?.background && (0, B.jsx)("span", { className: "custom-recommendation-mark", role: "img", "aria-label": m("Recommended"), title: m("Recommended"), children: (0, B.jsx)(Re, { size: 14, strokeWidth: 1.5, "aria-hidden": "true" }) })] }), (0, B.jsx)("small", { children: ce(e5) ? m("Keep the original setting from your photograph.") : m(t3.description) })] })] }), !ce(e5) && (0, B.jsx)(al, { title: m(t3.name), image: t3.image, alt: `${m(t3.name)} background without a portrait subject` })] }, t3.id)) })] }),e5.background==="floral"&&!ke2&&(0,B.jsx)(B03FloralPicker,{locale:productLocale,value:e5.floralTemplateSelection??null,onChange:selection=>Me2({floralTemplateSelection:selection})})]}), (0, B.jsx)(ol, { draft: e5, setDraft: t2, onBusy: u2 }), (0, B.jsx)("p", { className: "custom-private-note", children: ke2 ? `Reference image ${ke2.slot} guides the background in your proof.` : ce(e5) ? m("Your photograph\u2019s original scene is kept as part of the memory, whether it is a wedding, a trip or a birthday.") : m("The background will be composed around your subject in the proof.") })] }), d2 === 3 && (0, B.jsxs)(B.Fragment, { children: [(0, B.jsx)("p", { className: "custom-intro", children: (0, B.jsx)(p, { children: "A last look at the choices for your piece." }) }), (0, B.jsx)("dl", { className: "custom-review", children: j(e5).map(([e6, t3]) => (0, B.jsxs)("div", { children: [(0, B.jsx)("dt", { children: m(e6) }), (0, B.jsx)("dd", { children: ["Notes", "Product text"].includes(e6) ? t3 : m(t3) })] }, e6)) }), (0, B.jsxs)("div", { className: "custom-review-links", children: [firstStep === 0 && (0, B.jsx)("button", { onClick: () => Ne2(0), children: (0, B.jsx)(p, { children: "Edit piece" }) }), (0, B.jsx)("button", { onClick: () => Ne2(1), children: (0, B.jsx)(p, { children: "Edit photo & notes" }) }), (0, B.jsx)("button", { onClick: () => Ne2(2), children: (0, B.jsx)(p, { children: "Edit expression" }) })] }), (0, B.jsxs)("div", { className: "custom-proof", children: [(0, B.jsx)("h2", { children: (0, B.jsx)(p, { children: "Your proof comes first" }) }), (0, B.jsx)("p", { children: (0, B.jsx)(p, { children: "Each piece includes 5 free revision requests. From the 6th revision, each costs RM5, paid before work begins. That fee is refundable before you receive its proof, but not afterwards, subject to legal rights. A new proof starts a fresh 72-hour review period; waiting for us to revise does not count as failing to reply." }) }), (0, B.jsx)("p", { children: (0, B.jsx)(p, { children: "Your review period is 72 continuous hours from when the proof is viewable and its WhatsApp notification is delivered. Each proof round starts with one automatic WhatsApp notification, followed by up to two manual reminders within the 72-hour review period, with no fixed interval. Reminders stop when you respond. A new proof starts a new review period. Silence is not approval: overdue pieces go to manual cancellation and refund review." }) })] }), (0, B.jsxs)("div", { className: "custom-delivery", children: [(0, B.jsx)("h2", { children: (0, B.jsx)(p, { children: "Delivery in Malaysia" }) }), (0, B.jsxs)("dl", { children: [(0, B.jsxs)("div", { children: [(0, B.jsx)("dt", { children: (0, B.jsx)(p, { children: "West Malaysia" }) }), (0, B.jsx)("dd", { children: (0, B.jsx)(p, { children: "Free delivery, no minimum spend" }) })] }), (0, B.jsxs)("div", { children: [(0, B.jsx)("dt", { children: (0, B.jsx)(p, { children: "East Malaysia" }) }), (0, B.jsx)("dd", { children: (0, B.jsx)(p, { children: "shown at checkout" }) })] })] }), (0, B.jsx)("p", { children: (0, B.jsx)(p, { children: "West Malaysia delivery is free with no minimum spend. East Malaysia delivery is calculated at checkout." }) })] }), (0, B.jsx)("p", { className: "custom-private-note", children: o2 ? m("Review your choices, then start a WhatsApp consultation. Your photo stays in your browser.") : y()?.checkoutIntegrationEnabled ? m("Add this piece to your cart. Your original photograph and any references will be saved privately to prepare your proof.") : y() ? m("Your photo stays in this browser while ordering is unavailable. Keep the original photograph to upload when ordering opens.") : m("Add this piece to your demo cart to try checkout. A small photo preview stays in this browser tab; keep your original photograph. No real order or payment is created.") })] }), g2 && (0, B.jsx)("p", { className: "custom-error", role: "alert", children: m(g2) }), (0, B.jsxs)("footer", { className: "custom-form-footer", children: [d2 > firstStep ? (0, B.jsxs)("button", { className: "custom-back", disabled: s2, onClick: () => Ne2(d2 - 1), children: [(0, B.jsx)(Se, { size: 16 }), " ", (0, B.jsx)(p, { children: "Back" })] }) : (0, B.jsx)("span", { className: "custom-footer-note", children: (0, B.jsx)(p, { children: "Made after proof approval" }) }), (0, B.jsxs)("button", { className: "custom-primary", disabled: v2 || l2 || s2 || !o2 && d2 === 3 && !cartIsReady, onClick: d2 === 3 ? () => {
    V2();
  } : Ve2, children: [!o2 && d2 === 3 && !cartIsReady ? (productLocale === "zh-CN" ? "\u6b63\u5728\u52a0\u8f7d\u8d2d\u7269\u8f66\u2026" : productLocale === "ms" ? "Memuatkan troli\u2026" : "Loading your saved cart\u2026") : m(s2 ? "Saving your piece\u2026" : ["Continue to photo", "Choose expression", "Review your piece", o2 ? "Discuss this piece on WhatsApp" : a2 ? "Save cart changes" : "Add to cart"][d2]), (0, B.jsx)(xe, { size: 17 })] })] })] })] })] });
}
var fl = `
attribute vec2 position;
attribute vec2 uv;
varying vec2 vUv;
void main() {
    vUv = uv;
    gl_Position = vec4(position, 0.0, 1.0);
}`, pl = `
precision highp float;

uniform sampler2D tDiffuse;
uniform float uTime;
uniform vec2  uResolution;
uniform float uEdgeWidth;
uniform float uNoiseSpeed;
uniform float uGrainScale;
uniform float uGrainAmount;

varying vec2 vUv;

vec3 permute(vec3 x) { return mod(((x * 34.0) + 1.0) * x, 289.0); }

float snoise(vec2 v) {
  const vec4 C = vec4(0.211324865405187, 0.366025403784439, -0.577350269189626, 0.024390243902439);
  vec2 i  = floor(v + dot(v, C.yy));
  vec2 x0 = v - i + dot(i, C.xx);
  vec2 i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
  vec4 x12 = x0.xyxy + C.xxzz;
  x12.xy -= i1;
  i = mod(i, 289.0);
  vec3 p = permute(permute(i.y + vec3(0.0, i1.y, 1.0)) + i.x + vec3(0.0, i1.x, 1.0));
  vec3 m  = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy), dot(x12.zw,x12.zw)), 0.0);
  m = m * m * m * m;
  vec3 x  = 2.0 * fract(p * C.www) - 1.0;
  vec3 h  = abs(x) - 0.5;
  vec3 ox = floor(x + 0.5);
  vec3 a0 = x - ox;
  m *= 1.79284291400159 - 0.85373472095314 * (a0*a0 + h*h);
  vec3 g;
  g.x  = a0.x  * x0.x  + h.x  * x0.y;
  g.yz = a0.yz * x12.xz + h.yz * x12.yw;
  return 130.0 * dot(m, g);
}

float fbm(vec2 p) {
  float v = 0.0;
  float a = 0.5;
  for (int i = 0; i < 4; i++) {
    v += a * snoise(p);
    p  = p * 2.1 + vec2(1.7, 9.2);
    a *= 0.5;
  }
  return v;
}

void main() {
  float leftBand  = 1.0 - smoothstep(0.0, uEdgeWidth, vUv.x);
  float rightBand = smoothstep(1.0 - uEdgeWidth, 1.0, vUv.x);
  float xMask     = max(leftBand, rightBand);

  if (xMask <= 0.001) {
      gl_FragColor = texture2D(tDiffuse, vUv);
      return;
  }

  float mask = pow(xMask, 3.0) * 3.0;
  float ar = uResolution.x / max(uResolution.y, 1.0);

  float t = uTime * uNoiseSpeed * (uGrainScale * 0.015);

  vec2 noiseUV = vec2(vUv.x * ar, vUv.y) * uGrainScale;

  float dx = fbm(noiseUV + vec2(t, t * 0.5)) * uGrainAmount;
  float dy = fbm(noiseUV + vec2(-t * 0.3, t * 0.8)) * uGrainAmount;

  vec2 warpedUV = vUv + vec2(dx, dy) * mask;

  vec4 col = vec4(0.0);
  if (warpedUV.x >= 0.0 && warpedUV.x <= 1.0 && warpedUV.y >= 0.0 && warpedUV.y <= 1.0) {
      col = texture2D(tDiffuse, warpedUV);
  }

  float colorDecay = max(smoothstep(1.0, 0.1, mask / 6.0), 0.1);

  gl_FragColor = vec4(col.rgb * colorDecay, col.a);
}`;
function ml(e5, t2, n2, r2, i2, a2, o2) {
  let s2 = Math.max(0, Math.min(100, o2)) / 100, c2 = Math.min(i2, a2), l2 = n2 + s2 * (i2 - c2) / 2, u2 = r2 + s2 * (a2 - c2) / 2, d2 = i2 - s2 * (i2 - c2), f2 = a2 - s2 * (a2 - c2), p2 = s2 * c2 / 2;
  if (!t2.complete || !t2.naturalWidth) return;
  let m2 = t2.naturalWidth / t2.naturalHeight, h2 = d2 / f2, g2, _2, v2, y2;
  m2 > h2 ? (y2 = t2.naturalHeight, v2 = y2 * h2, g2 = (t2.naturalWidth - v2) / 2, _2 = 0) : (v2 = t2.naturalWidth, y2 = v2 / h2, g2 = 0, _2 = (t2.naturalHeight - y2) / 2);
  let b2 = Math.max(0, Math.min(p2, d2 / 2, f2 / 2));
  e5.save(), e5.beginPath(), e5.moveTo(l2 + b2, u2), e5.lineTo(l2 + d2 - b2, u2), e5.quadraticCurveTo(l2 + d2, u2, l2 + d2, u2 + b2), e5.lineTo(l2 + d2, u2 + f2 - b2), e5.quadraticCurveTo(l2 + d2, u2 + f2, l2 + d2 - b2, u2 + f2), e5.lineTo(l2 + b2, u2 + f2), e5.quadraticCurveTo(l2, u2 + f2, l2, u2 + f2 - b2), e5.lineTo(l2, u2 + b2), e5.quadraticCurveTo(l2, u2, l2 + b2, u2), e5.closePath(), e5.clip(), e5.drawImage(t2, g2, _2, v2, y2, l2, u2, d2, f2), e5.restore();
}
function hl(e5, t2, n2) {
  let r2 = e5.createShader(t2);
  return e5.shaderSource(r2, n2), e5.compileShader(r2), e5.getShaderParameter(r2, e5.COMPILE_STATUS) || console.warn("GrainyCarousel shader:", e5.getShaderInfoLog(r2)), r2;
}
var gl = [["moment-photo-01.jpg", "moment-photo-05.jpg", "moment-photo-07.jpg", "moment-photo-03.jpg", "moment-photo-04.jpg", "moment-photo-12.jpg", "moment-photo-13.jpg"], ["moment-photo-02.jpg", "moment-photo-06.jpg", "moment-photo-08.jpg", "moment-photo-09.jpg", "moment-photo-10.jpg", "moment-photo-11.jpg", "moment-photo-14.jpg"]];
function _l({ images: e5, direction: t2 }) {
  n();
  let r2 = (0, z.useRef)(null), i2 = (0, z.useRef)(null), a2 = (0, z.useRef)(null);
  return (0, z.useEffect)(() => {
    let n2 = r2.current, o2 = i2.current, s2 = a2.current;
    if (!n2 || !o2 || !s2) return;
    let c2 = document.createElement("canvas"), l2 = c2.getContext("2d"), u2 = s2.getContext("2d");
    if (!l2 || !u2) return;
    let d2 = o2.getContext("webgl", { alpha: true, premultipliedAlpha: false }), f2 = null, p2 = [], m2 = [], h2 = null;
    if (d2) {
      if (f2 = d2.createProgram(), f2) {
        for (let [e6, t3] of [[d2.VERTEX_SHADER, fl], [d2.FRAGMENT_SHADER, pl]]) {
          let n3 = hl(d2, e6, t3);
          m2.push(n3), d2.attachShader(f2, n3);
        }
        d2.linkProgram(f2), d2.getProgramParameter(f2, d2.LINK_STATUS) || (d2.deleteProgram(f2), f2 = null);
      }
      if (f2) {
        d2.useProgram(f2);
        for (let [e6, t3] of [["position", [-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]], ["uv", [0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1]]]) {
          let n3 = d2.createBuffer();
          p2.push(n3), d2.bindBuffer(d2.ARRAY_BUFFER, n3), d2.bufferData(d2.ARRAY_BUFFER, new Float32Array(t3), d2.STATIC_DRAW);
          let r3 = d2.getAttribLocation(f2, e6);
          d2.enableVertexAttribArray(r3), d2.vertexAttribPointer(r3, 2, d2.FLOAT, false, 0, 0);
        }
        h2 = d2.createTexture(), d2.bindTexture(d2.TEXTURE_2D, h2), d2.texParameteri(d2.TEXTURE_2D, d2.TEXTURE_MIN_FILTER, d2.LINEAR), d2.texParameteri(d2.TEXTURE_2D, d2.TEXTURE_MAG_FILTER, d2.LINEAR), d2.texParameteri(d2.TEXTURE_2D, d2.TEXTURE_WRAP_S, d2.CLAMP_TO_EDGE), d2.texParameteri(d2.TEXTURE_2D, d2.TEXTURE_WRAP_T, d2.CLAMP_TO_EDGE), d2.pixelStorei(d2.UNPACK_FLIP_Y_WEBGL, true);
      }
    }
    o2.hidden = !f2, s2.hidden = !!f2;
    let g2 = Object.fromEntries(["uTime", "uResolution", "uEdgeWidth", "uNoiseSpeed", "uGrainScale", "uGrainAmount"].map((e6) => [e6, f2 && d2 ? d2.getUniformLocation(f2, e6) : null])), _2 = true, v2 = false, y2 = 1, b2 = 1, x2 = 1, S2 = 0, w2 = 0, T2 = 0, E2 = 0, D2 = window.matchMedia("(prefers-reduced-motion: reduce)"), O2 = e5.map((e6) => {
      let t3 = new Image();
      return t3.crossOrigin = "anonymous", t3.onload = () => {
        _2 = true;
      }, t3.src = C(`/art/${e6}`), t3;
    }), k2 = () => {
      y2 = n2.clientWidth, b2 = n2.clientHeight, x2 = Math.min(window.devicePixelRatio || 1, 1.5);
      for (let e6 of [c2, o2, s2]) e6.width = Math.round(y2 * x2), e6.height = Math.round(b2 * x2);
      d2?.viewport(0, 0, o2.width, o2.height), _2 = true;
    }, A2 = new ResizeObserver(k2);
    A2.observe(n2), k2();
    let j2 = new IntersectionObserver(([e6]) => {
      v2 = e6.isIntersecting, _2 = true;
    }, { rootMargin: "60px" });
    j2.observe(n2);
    let M2 = () => {
      _2 = true;
    };
    D2.addEventListener("change", M2);
    let N2 = null, P2 = (e6) => {
      N2 = { id: e6.pointerId, x: e6.clientX }, n2.setPointerCapture(e6.pointerId);
    }, F2 = (e6) => {
      !N2 || N2.id !== e6.pointerId || (S2 -= e6.clientX - N2.x, N2.x = e6.clientX, _2 = true);
    }, ee2 = () => {
      N2 = null;
    };
    n2.addEventListener("pointerdown", P2), n2.addEventListener("pointermove", F2), n2.addEventListener("pointerup", ee2), n2.addEventListener("pointercancel", ee2);
    let te2 = (e6) => {
      if (w2 = requestAnimationFrame(te2), e6 - T2 < 1e3 / 30) return;
      let r3 = Math.min((e6 - T2) / 1e3, 0.06);
      if (T2 = e6, !v2 || document.hidden) return;
      let i3 = !D2.matches && !N2;
      if (!i3 && !_2) return;
      i3 && (S2 += t2 * 18 * r3, E2 += r3), _2 = false;
      let a3 = b2 * 0.75, p3 = a3 + (y2 < 700 ? 12 : 20), m3 = p3 * O2.length, C2 = (S2 % m3 + m3) % m3;
      l2.setTransform(x2, 0, 0, x2, 0, 0), l2.clearRect(0, 0, y2, b2);
      for (let e7 = 0; e7 * p3 - C2 < y2; e7++) {
        let t3 = e7 * p3 - C2;
        t3 + a3 > 0 && ml(l2, O2[e7 % O2.length], t3, 0, a3, b2, 0);
      }
      d2 && f2 ? (d2.bindTexture(d2.TEXTURE_2D, h2), d2.texImage2D(d2.TEXTURE_2D, 0, d2.RGBA, d2.RGBA, d2.UNSIGNED_BYTE, c2), d2.clearColor(0, 0, 0, 0), d2.clear(d2.COLOR_BUFFER_BIT), d2.uniform1f(g2.uTime, E2), d2.uniform2f(g2.uResolution, o2.width, o2.height), d2.uniform1f(g2.uEdgeWidth, y2 < 700 ? 0.16 : 0.2), d2.uniform1f(g2.uNoiseSpeed, 0.12), d2.uniform1f(g2.uGrainScale, 180), d2.uniform1f(g2.uGrainAmount, 0.045), d2.drawArrays(d2.TRIANGLES, 0, 6)) : (u2.clearRect(0, 0, s2.width, s2.height), u2.drawImage(c2, 0, 0)), n2.dataset.direction = t2 === 1 ? "left" : "right", n2.dataset.offset = S2.toFixed(2), n2.dataset.moving = String(i3);
    };
    return w2 = requestAnimationFrame(te2), () => {
      cancelAnimationFrame(w2), A2.disconnect(), j2.disconnect(), D2.removeEventListener("change", M2), n2.removeEventListener("pointerdown", P2), n2.removeEventListener("pointermove", F2), n2.removeEventListener("pointerup", ee2), n2.removeEventListener("pointercancel", ee2), O2.forEach((e6) => {
        e6.onload = null;
      }), d2 && (p2.forEach((e6) => d2.deleteBuffer(e6)), m2.forEach((e6) => d2.deleteShader(e6)), h2 && d2.deleteTexture(h2), f2 && d2.deleteProgram(f2));
    };
  }, [e5, t2]), (0, B.jsxs)("div", { ref: r2, className: "moments-grain-row", role: "img", "aria-label": m("Wedding, family, travel, graduation and pet photographs"), children: [(0, B.jsx)("canvas", { ref: i2, "aria-hidden": "true" }), (0, B.jsx)("canvas", { ref: a2, "aria-hidden": "true" })] });
}
function vl() {
  return n(), (0, B.jsxs)("section", { id: "small-moments-carousel", className: "moments-carousel", "aria-labelledby": "moments-carousel-title", children: [(0, B.jsxs)("header", { className: "moments-carousel-heading", children: [(0, B.jsxs)("h2", { id: "moments-carousel-title", children: [(0, B.jsx)(p, { children: "Small moments" }), (0, B.jsx)("br", {}), (0, B.jsx)("em", { children: (0, B.jsx)(p, { children: "Memories, made tangible" }) })] }), (0, B.jsx)("p", { children: (0, B.jsx)(p, { children: "From a photograph you love to a piece you can hold." }) })] }), (0, B.jsx)("div", { className: "moments-carousel-rows", children: gl.map((e5, t2) => (0, B.jsx)(_l, { images: e5, direction: t2 === 0 ? 1 : -1 }, t2)) })] });
}
var yl = (e5, t2, n2) => {
  let r2 = Math.max(0, Math.min(1, (n2 - e5) / (t2 - e5)));
  return r2 * r2 * (3 - 2 * r2);
};
function bl(e5) {
  let t2 = Math.max(0, Math.min(1, e5)), n2 = yl(0.14, 0.3, t2), r2 = yl(0.4, 0.56, t2), i2 = yl(0.7, 0.82, t2), a2 = yl(0.82, 1, t2);
  return { papers: [{ x: 0, depth: n2 + r2 }, { x: 120 * (1 - n2), depth: r2 }, { x: 120 * (1 - r2), depth: 0 }], current: i2 >= 0.5 ? 3 : r2 >= 0.5 ? 2 : +(n2 >= 0.5), detail: i2, angle: a2 === 0 || a2 === 1 ? 0 : 3 * Math.sin(a2 * Math.PI * 2), scale: 1 + 0.045 * Math.sin(a2 * Math.PI), light: -45 + 90 * a2 };
}
var xl = [{ title: "The photograph", copy: "A familiar face. The expression, the little details, the moment you want to keep.", image: "home-cat-original-v74.webp", width: 1442, height: 1600, alt: "Original photograph of a silver tabby cat sitting indoors.", caption: "Original photograph" }, { title: "The artwork proof", copy: "Check the likeness, colours and composition of your photograph in your chosen art style.", image: "home-cat-proof-v74.webp", width: 1254, height: 1254, alt: "Oil-style artwork of the same silver tabby cat against a pale floral background.", caption: "Artwork proof" }, { title: "Your finished keepsake", copy: "Colour and shallow raised detail bring the approved design into your everyday space.", image: "desktop-portrait-photo-v77.webp", width: 1254, height: 1254, alt: "Desktop Portrait cat artwork in a walnut-colour frame on clear acrylic supports, displayed on a wooden table in soft daylight.", caption: "Desktop Portrait \xB7 product render" }], Sl = { title: "Your finished keepsake", copy: "Colour and shallow raised detail bring the approved design into your everyday space.", image: "square-magnet-photo-v77.webp", width: 1254, height: 1254, alt: "The same silver tabby cat artwork on a white ceramic Square Magnet.", caption: "Square Magnet \xB7 product render" }, Cl = [["Choose & upload", "Choose your piece and style, upload a clear photograph, then complete payment."], ["See your first proof", "30 minutes\u20136 hours, usually around 1 hour during our working hours."], ["Make it yours", "5 free change requests per piece. This includes changing the art style or background, within your piece\u2019s available options. From the 6th, RM5 per request, confirmed before submission."], ["Review, then make", "Your review period is 72 continuous hours from when the proof is viewable and its WhatsApp notification is delivered. Each proof round starts with one automatic WhatsApp notification, followed by up to two manual reminders within the 72-hour review period, with no fixed interval. Reminders stop when you respond. A new proof starts a new review period. Silence is not approval: overdue pieces go to manual cancellation and refund review."]], wl = [["Which photograph should I use?", "Choose a clear, well-lit original with the faces and details you want to keep. Upload JPEG, PNG or WebP, up to 10 MB."], ["Can I change the design?", "Each piece includes 5 free revision requests. From the 6th revision, each costs RM5, paid before work begins. That fee is refundable before you receive its proof, but not afterwards, subject to legal rights. A new proof starts a fresh 72-hour review period; waiting for us to revise does not count as failing to reply."], ["When will my piece be dispatched?", "After you approve your proof, your piece is dispatched in 2–5 days. Dispatch is when we hand your parcel to the courier, not its arrival date."], ["What if I need a refund, or my piece arrives damaged?", "Before physical production, cancellation before receiving the second proof receives a full product refund; after receiving the second or later proof, a single RM10 design fee is deducted per piece. During production and before dispatch, 40% of the product amount paid is refunded, without another RM10 deduction. These personal-cancellation rules do not limit legal remedies or apply to our errors."]], Tl = [["Choose & preview", "Choose your piece and style, then preview a clear photograph."], ["Start a conversation", "Message Tactale with the piece and style you have in mind."], ["Discuss the details", "We will confirm availability, timing and the next steps with you."], ["Made for you", "Once details are confirmed, your piece is made with care."]], El = [["Which photograph should I use?", "Choose a clear, well-lit original with the faces and details you want to keep. Preview JPEG, PNG or WebP, up to 10 MB."], ["Can I change the design?", "We will discuss the available style and background options with you."], ["When will my piece be dispatched?", "Production and delivery timing are confirmed personally when your piece is arranged."], ["What if I need help?", "Contact Tactale on WhatsApp and we will help with your question."]];
function Dl({ catalog: e5 = false }) {
  n();
  let t2 = De(), r2 = t2 && !y()?.checkoutEnabled ? [["Choose & save", "Sign in, choose your piece and style, upload your photograph, and save it to your cart."], ["Return in October", "Checkout opens in October. Return to your saved cart when sales open to complete payment."], ["See your proof", "Proof preparation begins after payment. Each piece includes 5 free change requests."], Cl[3]] : Cl, i2 = t2 ? [...xl.slice(0, 2), Sl] : xl, a2 = (0, z.useRef)(null), o2 = (0, z.useRef)(null), [s2, c2] = (0, z.useState)(false), [l2, u2] = (0, z.useState)(0);
  return (0, z.useEffect)(() => {
    let e6 = a2.current, t3 = e6?.querySelector(" .home-transform-inner > header");
    if (!e6 || !t3) return;
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) {
      delete e6.dataset.paperEntry, delete e6.dataset.paperReady;
      return;
    }
    e6.dataset.paperEntry = "true", delete e6.dataset.paperReady;
    let n2 = 0, r3 = new IntersectionObserver((t4) => {
      t4.some((e7) => e7.isIntersecting) && (n2 = requestAnimationFrame(() => {
        e6.dataset.paperReady = "true";
      }), r3.disconnect());
    }, { threshold: 0.65, rootMargin: "0px 0px -8% 0px" });
    return r3.observe(t3), () => {
      r3.disconnect(), cancelAnimationFrame(n2);
    };
  }, []), (0, z.useEffect)(() => {
    let e6 = a2.current, t3 = o2.current;
    if (!e6 || !t3) return;
    let n2 = window.matchMedia("(max-width: 700px) and (min-height: 600px) and (prefers-reduced-motion: no-preference)"), r3 = 0, i3 = () => {
      if (r3 = 0, !n2.matches) {
        e6.removeAttribute("data-motion"), c2(false);
        return;
      }
      e6.dataset.motion = "true", c2(true);
      let i4 = t3.getBoundingClientRect(), a3 = bl(Math.max(0, Math.min(1, -i4.top / Math.max(1, i4.height - window.innerHeight))));
      t3.querySelectorAll(".home-paper").forEach((e7, t4) => {
        if (e7.style.setProperty("--paper-x", `${a3.papers[t4].x.toFixed(4)}%`), t4 > 0) {
          let n3 = 1 - a3.papers[t4].x / 120;
          e7.style.setProperty("--paper-roll", `${(100 * n3).toFixed(3)}%`), e7.style.setProperty("--curl-alpha", Math.max(0, Math.min(1, (1 - n3) / 0.12)).toFixed(3));
        }
        e7.style.setProperty("--paper-depth", a3.papers[t4].depth.toFixed(4));
      }), t3.style.setProperty("--home-detail", a3.detail.toFixed(4)), t3.style.setProperty("--home-angle", `${a3.angle.toFixed(3)}deg`), t3.style.setProperty("--home-scale", a3.scale.toFixed(4)), t3.style.setProperty("--home-light", `${a3.light.toFixed(3)}%`), u2(a3.current);
    }, s3 = () => {
      r3 ||= requestAnimationFrame(i3);
    }, l3 = new IntersectionObserver((e7) => e7.forEach((e8) => {
      e8.isIntersecting && (e8.target.classList.add("home-seen"), l3.unobserve(e8.target));
    }), { threshold: 0.12 });
    return e6.querySelectorAll("[data-reveal], [data-origin-reveal]").forEach((e7) => l3.observe(e7)), i3(), window.addEventListener("scroll", s3, { passive: true }), window.addEventListener("resize", s3), n2.addEventListener("change", s3), () => {
      cancelAnimationFrame(r3), l3.disconnect(), window.removeEventListener("scroll", s3), window.removeEventListener("resize", s3), n2.removeEventListener("change", s3);
    };
  }, []), (0, B.jsxs)("div", { ref: a2, className: `home-story${t2 ? " home-magnets" : ""}`, children: [(0, B.jsx)("div", { className: "home-motion-chapter", ref: o2, "data-current": l2, children: (0, B.jsxs)("div", { className: "home-chapter-stage", children: [(0, B.jsx)("section", { className: "home-transformation", id: "photo-to-piece", "aria-labelledby": "home-transformation-title", inert: s2 && l2 === 3, "aria-hidden": s2 && l2 === 3 ? true : void 0, children: (0, B.jsxs)("div", { className: "home-transform-inner", children: [(0, B.jsx)("header", { children: (0, B.jsxs)("h2", { id: "home-transformation-title", children: [(0, B.jsx)("span", { className: "home-title-line", children: (0, B.jsx)("span", { children: (0, B.jsx)(p, { children: "Your photo" }) }) }), (0, B.jsx)("span", { className: "home-title-line", children: (0, B.jsx)("em", { children: (0, B.jsx)(p, { children: "A keepsake to hold" }) }) })] }) }), (0, B.jsx)("div", { className: "home-stages", children: i2.map((e6, t3) => (0, B.jsxs)("article", { className: `home-paper${l2 === t3 ? " is-current" : ""}`, inert: s2 && l2 !== t3, "aria-hidden": s2 && l2 !== t3 ? true : void 0, children: [(0, B.jsx)("span", { className: "home-paper-curl", "aria-hidden": "true", children: (0, B.jsx)("span", {}) }), (0, B.jsxs)("div", { className: "home-stage-copy", children: [(0, B.jsxs)("span", { className: "home-step-number", children: [(0, B.jsx)(p, { children: "Step 0" }), t3 + 1] }), (0, B.jsx)("h3", { children: m(e6.title) }), (0, B.jsx)("p", { children: m(e6.copy) })] }), (0, B.jsxs)("figure", { children: [(0, B.jsx)("img", { className: "home-cutout", src: C(`/art/${e6.image}`), width: e6.width, height: e6.height, alt: m(e6.alt), loading: "lazy", decoding: "async" }), (0, B.jsx)("figcaption", { children: m(e6.caption) })] })] }, e6.title)) })] }) }), (0, B.jsxs)("section", { className: "home-texture", "aria-labelledby": "home-texture-title", inert: s2 && l2 !== 3, children: [(0, B.jsxs)("figure", { children: [(0, B.jsx)("img", { src: C(t2 ? "/art/square-magnet-photo-v77.webp" : "/art/home-desktop-detail-v81.webp"), width: "1254", height: "1254", alt: m(t2 ? "Square Magnet cat artwork with raised detail on a white ceramic base." : "Desktop Portrait cat artwork in a walnut-colour frame, seen at a gentle angle under soft side light."), loading: "lazy" }), (0, B.jsx)("figcaption", { children: m(t2 ? "Square Magnet \xB7 rendered detail" : "Desktop Portrait \xB7 rendered detail") })] }), (0, B.jsxs)("div", { className: "home-texture-copy", children: [(0, B.jsxs)("h2", { id: "home-texture-title", children: [(0, B.jsx)(p, { children: "Let the light" }), (0, B.jsx)("br", {}), (0, B.jsx)("em", { children: (0, B.jsx)(p, { children: "find the details" }) })] }), (0, B.jsx)("p", { children: (0, B.jsx)(p, { children: "Look from the side and small shadows reveal a new layer. The image has texture, depth, and a presence beyond the screen." }) }), (0, B.jsxs)(f, { href: "/styles", className: "home-link", children: [(0, B.jsx)(p, { children: "Explore the art styles" }), " ", (0, B.jsx)(xe, { size: 18 })] })] })] })] }) }), (0, B.jsx)(vl, {}), (0, B.jsxs)("section", { className: "home-process home-section", "aria-labelledby": "home-process-title", children: [(0, B.jsxs)("header", { className: "home-section-heading", children: [(0, B.jsx)("div", { children: (0, B.jsxs)("h2", { id: "home-process-title", children: [(0, B.jsx)(p, { children: "A little guidance" }), (0, B.jsx)("br", {}), (0, B.jsx)("em", { children: (0, B.jsx)(p, { children: "Room to make it yours" }) })] }) }), (0, B.jsxs)(f, { href: "/how-it-works", className: "home-link", children: [(0, B.jsx)(p, { children: "The full process" }), " ", (0, B.jsx)(xe, { size: 18 })] })] }), (0, B.jsx)("ol", { children: (e5 ? Tl : r2).map(([e6, t3], n2) => (0, B.jsxs)("li", { "data-reveal": true, children: [(0, B.jsxs)("span", { children: ["0", n2 + 1] }), (0, B.jsx)("h3", { children: m(e6) }), (0, B.jsx)("p", { children: m(t3) })] }, e6)) }), (0, B.jsx)("p", { className: "home-process-note", children: (0, B.jsx)(p, { children: "Working hours: Monday\u2013Saturday, 9am\u20136pm (Malaysia time). Proof preparation is separate from production and delivery." }) })] }), (0, B.jsxs)("section", { className: "home-care", "aria-labelledby": "home-care-title", children: [(0, B.jsxs)("div", { className: "home-care-copy", children: [(0, B.jsxs)("h2", { id: "home-care-title", children: [(0, B.jsx)(p, { children: "Checked with care" }), (0, B.jsx)("br", {}), (0, B.jsx)("em", { children: (0, B.jsx)(p, { children: "Wrapped for keeping" }) })] }), (0, B.jsx)("p", { children: (0, B.jsx)(p, { children: "Every piece is checked before packing. If it fails our quality check, we make it again." }) }), (0, B.jsx)("p", { children: (0, B.jsx)(p, { children: "Contact us about defects, transit damage or an incorrect piece. Depending on the issue and applicable law, remedies may include repair, a remake, replacement or refund. Report damage promptly, preferably within 24 hours, with available evidence. Missing packaging or an unboxing video, or a later report, does not by itself remove legal rights." }) }), (0, B.jsxs)("dl", { children: [(0, B.jsxs)("div", { children: [(0, B.jsx)("dt", { children: (0, B.jsx)(p, { children: "Magnets" }) }), (0, B.jsx)("dd", { children: (0, B.jsx)(p, { children: "2–5 days" }) })] }), !t2 && (0, B.jsxs)("div", { children: [(0, B.jsx)("dt", { children: (0, B.jsx)(p, { children: "Portraits" }) }), (0, B.jsx)("dd", { children: (0, B.jsx)(p, { children: "2–5 days" }) })] })] }), (0, B.jsx)("p", { className: "home-note", children: (0, B.jsx)(p, { children: "Dispatch after proof approval. Courier transit time is additional." }) }), (0, B.jsxs)(f, { href: "/faq#delivery-details", className: "home-link", children: [(0, B.jsx)(p, { children: "Delivery & care details" }), " ", (0, B.jsx)(xe, { size: 18 })] })] }), (0, B.jsxs)("figure", { children: [(0, B.jsx)("img", { src: C("/art/faq-packaging-mobile-v28.webp"), width: "981", height: "820", alt: m("Illustration of Tactale\u2019s closed white drawer gift box and pale mailer with centred logos."), loading: "lazy" }), (0, B.jsx)("figcaption", { children: (0, B.jsx)(p, { children: "Packaging illustration" }) })] })] }), (0, B.jsxs)("section", { className: "home-origin home-section", "aria-labelledby": "home-origin-title", children: [(0, B.jsxs)("h2", { id: "home-origin-title", "data-origin-reveal": true, children: [(0, B.jsx)("span", { className: "home-origin-title-line", children: (0, B.jsx)("span", { children: (0, B.jsx)(p, { children: "Some photographs deserve" }) }) }), (0, B.jsx)("span", { className: "home-origin-title-line", children: (0, B.jsx)("em", { children: (0, B.jsx)(p, { children: "to be part of the room" }) }) })] }), (0, B.jsx)("p", { children: (0, B.jsx)(p, { children: "A companion\u2019s familiar face. A day you keep coming back to. Tactale began with a simple idea: give the memories on our screens a place in everyday life, where we can see them, hold them, and keep them close." }) }), (0, B.jsxs)(f, { href: "/our-story", className: "home-link", children: [(0, B.jsx)(p, { children: "Read our story" }), " ", (0, B.jsx)(xe, { size: 18 })] })] }), (0, B.jsxs)("section", { className: "home-finish home-section", "aria-labelledby": "home-faq-title", children: [(0, B.jsxs)("div", { className: "home-faq-heading", children: [(0, B.jsxs)("h2", { id: "home-faq-title", children: [(0, B.jsx)(p, { children: "A few things" }), (0, B.jsx)("br", {}), (0, B.jsx)("em", { children: (0, B.jsx)(p, { children: "you might be wondering" }) })] }), (0, B.jsxs)(f, { href: "/faq", className: "home-link", children: [(0, B.jsx)(p, { children: "All questions & delivery" }), " ", (0, B.jsx)(xe, { size: 18 })] })] }), (0, B.jsx)("div", { className: "home-faq", children: (e5 ? El : wl).map(([e6, t3]) => (0, B.jsxs)("details", { children: [(0, B.jsxs)("summary", { children: [m(e6), (0, B.jsx)(we, { size: 18 })] }), (0, B.jsxs)("p", { children: [m(t3), " ", e6.startsWith("What if") && (0, B.jsx)(f, { href: "/faq#delivery-details", children: (0, B.jsx)(p, { children: "Read the full policy." }) })] })] }, e6)) }), (0, B.jsxs)("div", { className: "home-final-cta", children: [t2 ? (0, B.jsxs)("div", { className: "home-magnet-pair", "aria-label": m("Our two photo magnets"), children: [(0, B.jsx)("img", { src: C("/art/square-magnet-photo-v77.webp"), width: "1254", height: "1254", alt: m("Square Magnet with silver tabby cat artwork"), loading: "lazy" }), (0, B.jsx)("img", { src: C("/art/memory-magnet-photo-v77.webp"), width: "1254", height: "1254", alt: m("Memory Magnet with wedding couple artwork"), loading: "lazy" })] }) : (0, B.jsx)("img", { className: "home-collection-background", src: C(t2 ? "/art/home-magnets-v30.webp" : "/art/four-products-still-life-v83.webp"), width: "1536", height: "1024", alt: "", loading: "lazy", "aria-hidden": "true" }), (0, B.jsxs)("div", { className: "home-final-glass", children: [(0, B.jsxs)("h2", { children: [(0, B.jsx)(p, { children: "A photograph you love" }), (0, B.jsx)("br", {}), (0, B.jsx)("em", { children: (0, B.jsx)(p, { children: "A piece that\u2019s yours" }) })] }), (0, B.jsxs)(f, { href: "/products", className: "home-button", children: [(0, B.jsx)(p, { children: "Choose your piece" }), " ", (0, B.jsx)(xe, { size: 19 })] }), (0, B.jsxs)(f, { href: "/styles", className: "home-link", children: [(0, B.jsx)(p, { children: "Find your art style" }), " ", (0, B.jsx)(xe, { size: 17 })] })] })] })] })] });
}
var Ol = StaticHero;
function kl() {
  n();
  let t2 = E(), { state: r2, ready: a2, commit: o2, prepareCartPiece: s2 } = me(), c2 = i(), l2 = e().toString(), u2 = (0, z.useRef)(null), d2 = (0, z.useRef)(true), [f2, p2] = (0, z.useState)(), [h2, g2] = (0, z.useState)(""), _2 = (0, z.useRef)(null), v2 = (0, z.useRef)(I()), [b2, x2] = (0, z.useState)(false), [S2, C2] = (0, z.useState)(v2.current), w2 = (0, z.useRef)(0), D2 = (0, z.useRef)(null);
  v2.current = S2, (0, z.useEffect)(() => {
    let e5 = Xe(l2, r2.cart, Ee());
    if (!a2 && (e5.kind !== "create" || y()?.accountCartEnabled && !T({ storage: sessionStorage }).hasSession())) return;
    if ((e5.kind === "edit" || e5.kind === "create" && new URLSearchParams(l2).get("browse-products") !== "1") && y()?.accountCartEnabled && !T({ storage: sessionStorage }).hasSession()) {
      x2(false), t2("create");
      return;
    }
    if (u2.current === l2) return;
    u2.current = l2, g2("");
    if (e5.kind === "edit") {
      O2(), C2(structuredClone(e5.item.draft)), p2(e5.item.id), x2(true);
      return;
    }
    if (p2(void 0), e5.kind === "create") {
      let t3 = e5.fresh ? I(e5.product) : R(v2.current, e5.product);
      e5.fresh && (O2(), t3.style = e5.style), e5.format && (t3 = {...t3, format:e5.format, messageBorder:"romantic", ...(e5.fresh ? {orientation:e5.format === "full" ? "landscape" : "portrait", inscription:""} : {})}), C2(t3), x2(true);
    } else x2(false), e5.kind === "unavailable" && g2("This piece is not currently available. Explore our two magnets below."), e5.kind === "missing" && g2("That piece is no longer in your cart. Choose a piece below to start a new design.");
  }, [a2, l2, r2.cart, t2]), (0, z.useEffect)(() => (d2.current = true, () => {
    d2.current = false, v2.current.photo && URL.revokeObjectURL(v2.current.photo.url);
    for (let e5 of v2.current.references || []) URL.revokeObjectURL(e5.photo.url);
  }), []);
  function O2() {
    v2.current.photo && URL.revokeObjectURL(v2.current.photo.url);
    for (let e5 of v2.current.references || []) URL.revokeObjectURL(e5.photo.url);
  }
  function k2() {
    if (f2) { c2.push("/cart"); return; }
    x2(false), c2.push("/products");
  }
  async function A2() {
    if (!a2 || !S2.photo || !Te(S2.product)) return false;
    let e5 = s2 ? await s2(S2, f2) : void 0, t3 = { ...S2, photo: await Ye(S2.photo), references: await Promise.all((S2.references || []).map(async (e6) => ({ ...e6, photo: await Ye(e6.photo) }))) };
    return !d2.current || !o2((n2) => ye(n2, t3, f2, void 0, e5)) ? false : (c2.push("/cart"), true);
  }
  return (0, B.jsxs)("main", { id: "page-content", children: [h2 && (0, B.jsx)("p", { className: "store-save-error", role: "status", children: m(h2) }), (0, B.jsxs)("div", { className: "store-gallery", hidden: b2, onClick: (e5) => {
    let t3 = e5.target.closest('[data-action="create"]');
    if (!t3) return;
    c2.push("/products");
  }, children: [(0, B.jsx)(EditorialHome, {})] }), b2 && (0, B.jsx)(dl, { draft: S2, setDraft: C2, onClose: k2, onAdd: A2, editing: !!f2, cartReady: a2 }, f2 || String(S2.product)+":"+S2.format)] });
}
var Al = { en: { home_title: "Tactale Studio \u2014 Custom Photo Magnets in Malaysia", home_heading: "Memories you can touch", home_description: "Turn your photograph into a tactile keepsake with Tactale Studio in Malaysia. Explore Square Magnet 6 \xD7 6 cm and Memory Magnet 5 \xD7 7 cm, with colour and raised detail.", square_title: "Square Magnet 6 \xD7 6 cm \u2014 Tactale Studio Malaysia", square_name: "Square Magnet", square_description: "A personalised 6 \xD7 6 cm photo magnet by Tactale Studio in Malaysia. Your favourite face or moment, with colour and raised detail on a white ceramic base and magnetic backing.", memory_title: "Memory Magnet 5 \xD7 7 cm \u2014 Tactale Studio Malaysia", memory_name: "Memory Magnet", memory_description: "A personalised 5 \xD7 7 cm photo magnet by Tactale Studio in Malaysia. Keep a favourite moment close with the Storybook expression, raised detail and a white ceramic magnetic base.", collection: "The magnet collection", material: "Softly rounded white ceramic base \xB7 Flexible magnetic backing.", proof: "Made from your photograph. Review and approve your artwork before production.", customize: "Start customising", interactive: "Enable JavaScript to explore the interactive gallery and customise your piece." }, "zh-CN": { home_title: "Tactale Studio \u2014 \u9A6C\u6765\u897F\u4E9A\u5B9A\u5236\u7167\u7247\u78C1\u8D34", home_heading: "\u89E6\u624B\u53EF\u53CA\u7684\u56DE\u5FC6", home_description: "Tactale Studio \u5C06\u4F60\u7684\u7167\u7247\u5236\u4F5C\u6210\u53EF\u89E6\u6478\u7684\u7EAA\u5FF5\u4F5C\u54C1\u3002\u63A2\u7D22 6 \xD7 6 cm \u65B9\u5F62\u78C1\u8D34\u548C 5 \xD7 7 cm \u56DE\u5FC6\u78C1\u8D34\uFF0C\u4EE5\u8272\u5F69\u4E0E\u6D6E\u96D5\u7EC6\u8282\u7559\u4F4F\u73CD\u8D35\u65F6\u523B\uFF0C\u4E3A\u9A6C\u6765\u897F\u4E9A\u7684\u65E5\u5E38\u751F\u6D3B\u589E\u6DFB\u56DE\u5FC6\u3002", square_title: "\u65B9\u5F62\u78C1\u8D34 6 \xD7 6 cm \u2014 Tactale Studio \u9A6C\u6765\u897F\u4E9A", square_name: "\u65B9\u5F62\u78C1\u8D34", square_description: "Tactale Studio \u7684 6 \xD7 6 cm \u5B9A\u5236\u7167\u7247\u78C1\u8D34\u3002\u5C06\u719F\u6089\u7684\u9762\u5B54\u6216\u73CD\u8D35\u65F6\u523B\uFF0C\u4EE5\u8272\u5F69\u4E0E\u6D6E\u96D5\u7EC6\u8282\u5448\u73B0\u5728\u767D\u8272\u9676\u74F7\u5E95\u5EA7\u4E0A\uFF0C\u914D\u67D4\u6027\u78C1\u6027\u80CC\u8D34\u3002", memory_title: "\u56DE\u5FC6\u78C1\u8D34 5 \xD7 7 cm \u2014 Tactale Studio \u9A6C\u6765\u897F\u4E9A", memory_name: "\u56DE\u5FC6\u78C1\u8D34", memory_description: "Tactale Studio \u7684 5 \xD7 7 cm \u5B9A\u5236\u7167\u7247\u78C1\u8D34\u3002\u4EE5\u6545\u4E8B\u4E66\u753B\u98CE\u3001\u6D6E\u96D5\u7EC6\u8282\u548C\u767D\u8272\u9676\u74F7\u78C1\u8D34\u5E95\u5EA7\uFF0C\u7559\u4F4F\u4F60\u559C\u7231\u7684\u65F6\u523B\u3002", collection: "\u78C1\u8D34\u7CFB\u5217", material: "\u67D4\u548C\u5706\u89D2\u767D\u8272\u9676\u74F7\u5E95\u5EA7 \xB7 \u67D4\u6027\u78C1\u6027\u80CC\u8D34\u3002", proof: "\u6839\u636E\u4F60\u7684\u7167\u7247\u5236\u4F5C\u3002\u5236\u4F5C\u524D\u7531\u4F60\u67E5\u770B\u5E76\u786E\u8BA4\u6548\u679C\u56FE\u3002", customize: "\u5F00\u59CB\u5B9A\u5236", interactive: "\u8BF7\u542F\u7528 JavaScript\uFF0C\u63A2\u7D22\u4E92\u52A8\u5C55\u9986\u5E76\u5B9A\u5236\u4F60\u7684\u4F5C\u54C1\u3002" }, ms: { home_title: "Tactale Studio \u2014 Magnet Foto Peribadi di Malaysia", home_heading: "Kenangan yang boleh disentuh", home_description: "Jadikan foto anda kenangan bertekstur bersama Tactale Studio di Malaysia. Terokai Square Magnet 6 \xD7 6 cm dan Memory Magnet 5 \xD7 7 cm dengan warna dan butiran timbul.", square_title: "Square Magnet 6 \xD7 6 cm \u2014 Tactale Studio Malaysia", square_name: "Square Magnet", square_description: "Magnet foto peribadi 6 \xD7 6 cm oleh Tactale Studio di Malaysia. Wajah atau detik kegemaran anda, dengan warna dan butiran timbul pada tapak seramik putih serta pelapik magnet fleksibel.", memory_title: "Memory Magnet 5 \xD7 7 cm \u2014 Tactale Studio Malaysia", memory_name: "Memory Magnet", memory_description: "Magnet foto peribadi 5 \xD7 7 cm oleh Tactale Studio di Malaysia. Simpan detik kegemaran dengan gaya Storybook, butiran timbul dan tapak magnet seramik putih.", collection: "Koleksi magnet", material: "Tapak seramik putih dengan bucu lembut \xB7 Pelapik magnet fleksibel.", proof: "Dihasilkan daripada foto anda. Semak dan luluskan karya anda sebelum pengeluaran.", customize: "Mula menyesuaikan", interactive: "Aktifkan JavaScript untuk meneroka galeri interaktif dan menyesuaikan karya anda." } }, jl = (0, z.lazy)(() => import("./tactale-page-CUmPA2qA-sale1003-benefits1006b.js")), Ml = (0, z.lazy)(() => import("./tactale-page-BG_pb8JM-sale1003-benefits1006b.js")), Nl = (0, z.lazy)(() => import("./tactale-page-ruXp-z3R-sale1003-benefits1006b.js")), Pl = (0, z.lazy)(() => import("./tactale-page-Dle05mXv-sale1003-benefits1006b.js")), Fl = (0, z.lazy)(() => import("./tactale-cart-whatsapp1012.js?v=20261012b")), Y = (0, z.lazy)(() => import("./tactale-editorial-about1019.js?v=2")), Il = (0, z.lazy)(() => import("./tactale-editorial-styles1019.js?v=2")), X = (0, z.lazy)(() => import("./tactale-page-CZpZLIx2-sale1003-benefits1006b.js")), Z = (0, z.lazy)(() => import("./tactale-page-DOoJRGrO-sale1003-benefits1006b.js")), Q = (0, z.lazy)(() => import("./tactale-page-Cqzin_9E-sale1003-benefits1006b.js")), Ll = (0, z.lazy)(() => import("./tactale-page-CGqYjb99-sale1003-benefits1006b.js")), Rl = (0, z.lazy)(() => import("./tactale-account-delivery1012.js?v=20261012b"));
function zl() {
  let e5 = E(), [t2] = (0, z.useState)(() => {
    let e6 = new URL(location.href);
    return e6.searchParams.has("code") || e6.searchParams.has("error") || T({ storage: sessionStorage }).hasSession();
  });
  return (0, z.useEffect)(() => {
    if (t2) return;
    let n2 = sessionStorage.getItem("tactale.shopify.customer.just-signed-out") === "1";
    sessionStorage.removeItem("tactale.shopify.customer.just-signed-out"), s("/", { replace: true, scroll: false }), n2 || e5("account");
  }, [t2, e5]), t2 ? (0, B.jsx)(Rl, {}) : null;
}
var Bl = { "/products": ProductCatalog, "/policies/refund-policy": jl, "/policies/privacy-policy": Ml, "/policies/terms-of-service": Nl, "/policies/shipping-policy": Pl, "/": kl, "/cart": Fl, "/our-story": Y, "/styles": Il, "/how-it-works": X, "/faq": Z, "/products/square-magnet": Q, "/products/pet-magnet": Q, "/products/memory-magnet": Ll, "/account": zl, "/account/profile": zl, "/account/addresses": zl, "/account/preferences": zl, "/account/privacy": zl, "/order-confirmation": zl };
for (let e5 of y()?.products || []) A[e5.product] && Number.isInteger(e5.price) && e5.price > 0 && (A[e5.product].price = e5.price / 100, [qe, Ke, Ve, Ge][e5.product].price = `RM${(e5.price / 100).toFixed(e5.price % 100 ? 2 : 0)}`);
function Vl() {
  let { locale: e5, t: t2 } = n(), r2 = u(), i2 = Bl[r2] || kl;
  return (0, z.useEffect)(() => {
    let n2 = () => {
      let n3 = { "/products": "Products", "/products/square-magnet": "Square Magnet", "/products/memory-magnet": "Memory Magnet", "/products/pet-magnet": "Square Magnet", "/our-story": "Our Story", "/faq": "FAQ & Delivery", "/how-it-works": "How It Works", "/cart": "Your collection", "/styles": "Styles" }, i3 = Al[e5], a2 = r2 === "/products/square-magnet" ? "square" : r2 === "/products/memory-magnet" ? "memory" : "home";
      document.title = r2 === "/" ? i3.home_title : a2 === "square" ? i3.square_title : a2 === "memory" ? i3.memory_title : `${t2(n3[r2] || "Tactale")} \u2014 Tactale`;
      let o2 = a2 === "square" ? i3.square_description : a2 === "memory" ? i3.memory_description : i3.home_description;
      document.querySelector('meta[name="description"]')?.setAttribute("content", o2), document.querySelector('meta[property="og:title"]')?.setAttribute("content", document.title), document.querySelector('meta[property="og:description"]')?.setAttribute("content", o2);
      let s2 = document.querySelector('link[rel="canonical"]');
      s2 && (s2.href = r2 === "/products" ? new URL(d("/products", {...y(),themeId:void 0}), location.origin).href : `${location.origin}${location.pathname.replace(/\/$/, "") || "/"}`), s2 && document.querySelector('meta[property="og:url"]')?.setAttribute("content", s2.href);
      let c2 = document.getElementById("tactale-seo-schema");
      if (c2 && s2) {
        let e6 = a2 === "home" ? { "@context": "https://schema.org", "@graph": [{ "@type": "Organization", "@id": `${location.origin}/#organization`, name: "Tactale Studio", url: location.origin }, { "@type": "WebSite", "@id": `${location.origin}/#website`, name: "Tactale Studio", url: location.origin, publisher: { "@id": `${location.origin}/#organization` } }] } : { "@context": "https://schema.org", "@type": "Product", name: a2 === "square" ? i3.square_name : i3.memory_name, description: o2, url: s2.href, image: [new URL(A[a2 === "square" ? 0 : 1].poster, location.origin).href], brand: { "@type": "Brand", name: "Tactale" } };
        if (a2 !== "home") {
          let previous = {};
          try {
            previous = JSON.parse(c2.textContent || "{}");
          } catch {
          }
          let existingOffer = previous.url === s2.href ? previous.offers : void 0, item = (y()?.products || []).find((item2) => item2.product === (a2 === "square" ? 0 : 1));
          existingOffer && (e6.offers = existingOffer), item && Number.isInteger(item.price) && item.price > 0 && typeof item.available == "boolean" && (e6.offers = { ...existingOffer || {}, "@type": "Offer", url: s2.href, price: item.price / 100, priceCurrency: existingOffer?.priceCurrency || "MYR", availability: `https://schema.org/${item.available ? "InStock" : "OutOfStock"}` });
        }
        c2.textContent = JSON.stringify(e6), document.querySelector('meta[property="og:type"]')?.setAttribute("content", a2 === "home" ? "website" : "product");
      }
    };
    return n2(), window.addEventListener("tactale:language", n2), () => window.removeEventListener("tactale:language", n2);
  }, [r2, e5]), (0, z.useEffect)(() => {
    let t3 = () => document.querySelectorAll("#tactale-shopify-root a[data-tactale-route]").forEach((t4) => {
      let n3 = d(t4.dataset.tactaleRoute, { ...y(), locale: e5 });
      t4.getAttribute("href") !== n3 && t4.setAttribute("href", n3);
    }), n2 = new MutationObserver(t3), r3 = document.getElementById("tactale-shopify-root");
    return r3 && n2.observe(r3, { childList: true, subtree: true }), t3(), () => n2.disconnect();
  }, [e5]), (0, z.useEffect)(() => {
    let e6 = (e7) => {
      if (e7.defaultPrevented || e7.button !== 0 || e7.metaKey || e7.ctrlKey || e7.altKey || e7.shiftKey) return;
      let t3 = e7.target?.closest("#tactale-shopify-root a[href]");
      if (!t3 || t3.target === "_blank" || t3.hasAttribute("download")) return;
      let n2 = t3.getAttribute("href") || "";
      if (!n2.startsWith("/") || n2.startsWith("//")) return;
      let r3 = new URL(n2, location.origin);
      r3.pathname !== "/" && r3.pathname !== "/cart" && !c.has(r3.pathname) || (e7.preventDefault(), s(n2));
    };
    return document.addEventListener("click", e6), () => document.removeEventListener("click", e6);
  }, []), (0, B.jsx)(Oe, { active: r2 === "/" || r2 === "/products", children: (0, B.jsx)(D, { children: (0, B.jsx)(ve, { children: (0, B.jsx)(z.Suspense, { fallback: (0, B.jsx)("main", { id: "page-content", "aria-busy": true, style: { minHeight: "100svh" }, children: (0, B.jsx)("p", { role: "status", children: t2("Opening your page\u2026") }) }), children: (0, B.jsx)(i2, {}) }) }) }) });
}
var Hl = y(), Ul = new URL(location.href), Wl = h(Ul.searchParams.get("lang"));
if (Hl?.localeRoots && Wl && Wl !== g(Ul, Hl.locale) && Hl?.localeRoots && Wl) location.replace(v(Ul, Wl, Hl.localeRoots).href);
else {
  let e5 = document.getElementById("tactale-shopify-root");
  e5 && !w() && (0, Be.createRoot)(e5).render((0, B.jsx)(a, { children: (0, B.jsx)(Vl, {}) }));
}
